// Auto-generated static services fallback
export const STATIC_SERVICES = [
  {
    "slug": "private-limited-company",
    "category": "Registration",
    "sub_category": "Company Registration",
    "icon": "Building2",
    "title": "Private Limited Company Registration in India",
    "subtitle": "Register Your Private Limited Company with Confidence",
    "read_time": "9 min read",
    "image": "https://images.unsplash.com/photo-1554224154-26032ffc0d07?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
    "intro": "A Private Limited Company is one of the most preferred business structures in India for startups, growing businesses and professionally managed enterprises. Registered under the Companies Act, 2013, it provides a separate legal identity, limited liability protection to shareholders and greater credibility with customers, banks and investors. A Private Limited Company can own assets, enter into contracts, raise funds, hire employees and continue its existence irrespective of changes in ownership — an ideal choice for businesses looking for long-term growth and expansion. At Biz360 Compliance, we simplify the incorporation process by handling documentation, regulatory filings and compliance requirements, allowing you to focus on building your business.",
    "sections": {
      "whoNeedsIt": {
        "heading": "Who Should Register a Private Limited Company?",
        "items": [
          "Startups seeking external funding",
          "Technology and software companies",
          "Manufacturing & trading businesses",
          "Service providers and consultants",
          "E-commerce and export-import businesses",
          "Businesses planning rapid expansion",
          "Family-owned businesses seeking structured governance"
        ]
      },
      "eligibility": {
        "heading": "Eligibility Criteria",
        "items": [
          "Minimum two Directors and two Shareholders",
          "At least one Director must be an Indian resident",
          "Registered office address in India",
          "Valid identity and address proof of Directors and Shareholders",
          "Digital Signature Certificate (DSC) for proposed Directors",
          "Proposed company name complying with applicable naming guidelines"
        ]
      },
      "documents": {
        "heading": "Documents Required",
        "groups": [
          {
            "title": "Directors & Shareholders",
            "items": [
              "PAN Card",
              "Aadhaar Card",
              "Passport-size photograph",
              "Mobile number & email ID",
              "Address proof (bank statement / electricity bill)"
            ]
          },
          {
            "title": "Registered Office (Owned)",
            "items": [
              "Property tax receipt or ownership document",
              "Recent utility bill"
            ]
          },
          {
            "title": "Registered Office (Rented)",
            "items": [
              "Rent / Leave & Licence Agreement",
              "No Objection Certificate (NOC) from owner",
              "Recent utility bill"
            ]
          }
        ]
      },
      "process": {
        "heading": "Registration Process",
        "steps": [
          {
            "title": "Initial Consultation",
            "desc": "Understand your business model and recommend the most suitable structure."
          },
          {
            "title": "Name Selection",
            "desc": "Identify and evaluate proposed company names for compliance and availability."
          },
          {
            "title": "Documentation",
            "desc": "Collect and verify all required documents from Directors and Shareholders."
          },
          {
            "title": "Digital Signature & DIN",
            "desc": "Obtain Digital Signature Certificates and Director Identification Numbers."
          },
          {
            "title": "Incorporation Filing",
            "desc": "Prepare and submit incorporation documents through the MCA portal."
          },
          {
            "title": "Certificate of Incorporation",
            "desc": "The Registrar issues the Certificate of Incorporation with the CIN."
          },
          {
            "title": "PAN, TAN & Other Registrations",
            "desc": "Complete statutory registrations and post-incorporation compliances."
          }
        ]
      },
      "timeline": {
        "heading": "Estimated Timeline",
        "body": "Incorporation is generally completed within 7–15 working days, subject to government approvals, name availability and document readiness."
      },
      "fees": {
        "heading": "Government Fees & Professional Fees",
        "note": "Contact Biz360 Compliance for a customised quotation based on your business requirements."
      },
      "benefits": {
        "heading": "Why Choose a Private Limited Company?",
        "items": [
          "Separate legal entity recognised by law",
          "Limited liability protection for shareholders",
          "Higher credibility among customers, vendors and financial institutions",
          "Easier access to bank finance and investment",
          "Eligible for startup recognition and government schemes, subject to eligibility",
          "Perpetual succession irrespective of ownership changes",
          "Easier transfer of ownership through share transfers",
          "Preferred structure for venture capital and angel investments"
        ]
      },
      "afterService": {
        "heading": "Post Incorporation Compliance",
        "items": [
          "Opening a company bank account",
          "Appointment of first auditor (where applicable)",
          "Maintenance of statutory registers",
          "Issue of share certificates",
          "Accounting & bookkeeping",
          "Annual financial statements & ROC filings",
          "Income Tax and TDS compliance",
          "GST registration (where applicable)"
        ]
      },
      "whyUs": {
        "heading": "Why Choose Biz360 Compliance?",
        "items": [
          "Experienced professionals handling every engagement",
          "End-to-end documentation support",
          "Transparent pricing with no hidden charges",
          "Dedicated relationship manager",
          "Regular compliance reminders",
          "Fast turnaround, PAN India service delivery"
        ]
      },
      "faqs": [
        {
          "q": "How many people are required to register a Private Limited Company?",
          "a": "A minimum of two Directors and two Shareholders are generally required."
        },
        {
          "q": "Can one person be both Director and Shareholder?",
          "a": "Yes, subject to the minimum statutory requirements."
        },
        {
          "q": "Is a physical office mandatory?",
          "a": "A registered office address in India is mandatory. It may be owned or rented."
        },
        {
          "q": "Can NRIs or foreign nationals become shareholders?",
          "a": "Yes, subject to applicable laws and regulatory requirements."
        },
        {
          "q": "Is GST registration compulsory after incorporation?",
          "a": "GST registration depends on the nature of business, turnover and applicable legal provisions."
        },
        {
          "q": "Can I convert my LLP into a Private Limited Company?",
          "a": "Yes, subject to applicable legal procedures and eligibility."
        },
        {
          "q": "Is annual compliance mandatory?",
          "a": "Yes. Every Private Limited Company must comply with annual filing and other statutory requirements."
        }
      ],
      "extra": null,
      "related": [
        "llp",
        "one-person-company",
        "partnership-firm"
      ]
    }
  },
  {
    "slug": "llp",
    "category": "Registration",
    "sub_category": "Company Registration",
    "icon": "Landmark",
    "title": "LLP Registration in India",
    "subtitle": "Register Your Limited Liability Partnership (LLP) with Ease",
    "read_time": "8 min read",
    "image": "https://images.unsplash.com/photo-1735825764485-93a381fd5779?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODF8MHwxfHNlYXJjaHwzfHxwcm9mZXNzaW9uYWwlMjBmaW5hbmNlJTIwd29ya3NwYWNlfGVufDB8fHx8MTc4MzE3MDIyNHww&ixlib=rb-4.1.0&q=85",
    "intro": "A Limited Liability Partnership (LLP) combines the operational flexibility of a traditional partnership with the legal protection of a corporate entity. Governed by the Limited Liability Partnership Act, 2008, an LLP is a separate legal entity with perpetual succession, and unlike a traditional partnership, it protects partners' personal assets from business liabilities. It is widely preferred by professionals, consultants, service providers and family businesses due to its simplified management and comparatively lower compliance requirements than a company. Biz360 Compliance assists throughout the LLP registration process, ensuring timely incorporation, accurate documentation and continued compliance support.",
    "sections": {
      "whoNeedsIt": {
        "heading": "Who Should Register an LLP?",
        "items": [
          "Chartered Accountants, Company Secretaries and Consultants",
          "Architects, Engineers and legal professionals",
          "IT / software companies & digital agencies",
          "Family-owned businesses",
          "Startups not immediately seeking equity investment",
          "SMEs and joint ventures between businesses"
        ]
      },
      "eligibility": {
        "heading": "Eligibility Criteria",
        "items": [
          "Minimum two Designated Partners",
          "At least one Designated Partner must be an Indian resident",
          "Valid registered office address in India",
          "Digital Signature Certificate for Designated Partners",
          "Proposed LLP name complying with naming guidelines",
          "No prescribed minimum capital contribution"
        ]
      },
      "documents": {
        "heading": "Documents Required",
        "groups": [
          {
            "title": "Indian Partners",
            "items": [
              "PAN Card",
              "Aadhaar Card",
              "Passport-size photograph",
              "Mobile number & email address",
              "Address proof"
            ]
          },
          {
            "title": "Registered Office (Owned)",
            "items": [
              "Ownership proof",
              "Latest utility bill"
            ]
          },
          {
            "title": "Registered Office (Rented)",
            "items": [
              "Rent / Leave & Licence Agreement",
              "NOC from owner",
              "Latest utility bill"
            ]
          }
        ]
      },
      "process": {
        "heading": "LLP Registration Process",
        "steps": [
          {
            "title": "Business Consultation",
            "desc": "Confirm whether an LLP is the appropriate structure for your objectives."
          },
          {
            "title": "Name Reservation",
            "desc": "Identify suitable names and apply for reservation through the MCA portal."
          },
          {
            "title": "Document Collection",
            "desc": "Collect and verify documents of all Designated Partners and the registered office."
          },
          {
            "title": "Digital Signature & Partner ID",
            "desc": "Obtain Digital Signature Certificates and Partner Identification."
          },
          {
            "title": "Incorporation Filing",
            "desc": "Prepare and submit incorporation documents with the Registrar."
          },
          {
            "title": "Certificate of Incorporation",
            "desc": "The Registrar issues the Certificate along with the LLPIN."
          },
          {
            "title": "LLP Agreement",
            "desc": "Draft and file the LLP Agreement within the prescribed timeline."
          },
          {
            "title": "Post Registration Support",
            "desc": "PAN, TAN, GST (if applicable), bank account and other registrations."
          }
        ]
      },
      "timeline": {
        "heading": "Estimated Timeline",
        "body": "LLP registration is generally completed within 7–12 working days, subject to government processing and document verification."
      },
      "fees": {
        "heading": "Government Fees & Professional Fees",
        "note": "Contact Biz360 Compliance for a customised quotation based on your business requirements."
      },
      "benefits": {
        "heading": "Why Choose an LLP?",
        "items": [
          "Separate legal entity recognised by law",
          "Limited liability protection for partners",
          "Perpetual succession irrespective of partner changes",
          "Flexible internal management through the LLP Agreement",
          "Lower compliance burden than corporate structures",
          "No minimum capital contribution requirement",
          "Easy admission or retirement of partners"
        ]
      },
      "afterService": {
        "heading": "Post Registration Compliance",
        "items": [
          "Execution and filing of the LLP Agreement",
          "PAN and TAN",
          "GST registration (where applicable)",
          "Accounting and bookkeeping",
          "Statement of Account & Solvency",
          "Annual Return filing",
          "TDS compliance (where applicable)"
        ]
      },
      "whyUs": {
        "heading": "Why Choose Biz360 Compliance?",
        "items": [
          "Experienced professionals handling every engagement",
          "Complete documentation assistance",
          "Transparent pricing",
          "Dedicated relationship manager",
          "Fast processing with regular updates",
          "Single platform for taxation, accounting and regulatory services"
        ]
      },
      "faqs": [
        {
          "q": "What is the minimum number of partners required for an LLP?",
          "a": "A minimum of two Designated Partners is required."
        },
        {
          "q": "Is there any minimum capital requirement?",
          "a": "No. There is presently no mandatory minimum capital contribution for LLP registration."
        },
        {
          "q": "Is an LLP different from a Partnership Firm?",
          "a": "Yes. An LLP has a separate legal identity and provides limited liability protection, whereas a traditional partnership firm does not."
        },
        {
          "q": "Can an LLP have foreign partners?",
          "a": "Yes, subject to applicable laws and regulatory approvals."
        },
        {
          "q": "Can an LLP be converted into a Company?",
          "a": "Yes, subject to applicable legal procedures and eligibility."
        },
        {
          "q": "Is annual filing compulsory?",
          "a": "Yes. Every LLP must comply with prescribed annual filing requirements, irrespective of turnover."
        }
      ],
      "extra": null,
      "related": [
        "private-limited-company",
        "one-person-company",
        "partnership-firm"
      ]
    }
  },
  {
    "slug": "one-person-company",
    "category": "Registration",
    "sub_category": "Company Registration",
    "icon": "UserCheck",
    "title": "One Person Company (OPC) Registration in India",
    "subtitle": "Start Your Business with the Advantage of a One Person Company",
    "read_time": "7 min read",
    "image": "https://images.unsplash.com/photo-1554224155-6726b3ff858f?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
    "intro": "A One Person Company (OPC) is a unique form of company introduced under the Companies Act, 2013, enabling a single entrepreneur to establish a corporate entity with limited liability and a separate legal identity. An OPC bridges the gap between a sole proprietorship and a private limited company by allowing one individual to own and manage the company while enjoying the legal and financial benefits of a registered corporate structure — ideal for professionals, consultants, freelancers and first-time entrepreneurs who wish to operate independently while enhancing business credibility.",
    "sections": {
      "whoNeedsIt": {
        "heading": "Who Should Register an OPC?",
        "items": [
          "Individual entrepreneurs and freelancers",
          "Consultants and IT professionals",
          "Designers and creative agencies",
          "Online businesses and e-commerce sellers",
          "Small manufacturers",
          "Professionals starting an independent practice"
        ]
      },
      "eligibility": {
        "heading": "Eligibility Criteria",
        "items": [
          "Only one individual (a natural person) can incorporate an OPC",
          "A nominee must be appointed at the time of incorporation",
          "Registered office address in India required",
          "Digital Signature Certificate (DSC) required",
          "Proposed company name must comply with MCA naming guidelines"
        ]
      },
      "documents": {
        "heading": "Documents Required",
        "groups": [
          {
            "title": "Promoter",
            "items": [
              "PAN Card",
              "Aadhaar Card",
              "Passport-size photograph",
              "Mobile number & email address",
              "Address proof"
            ]
          },
          {
            "title": "Registered Office",
            "items": [
              "Ownership proof or rent agreement",
              "NOC (if rented)",
              "Latest utility bill"
            ]
          },
          {
            "title": "Other",
            "items": [
              "Consent of nominee",
              "Declaration and incorporation documents"
            ]
          }
        ]
      },
      "process": {
        "heading": "Registration Process",
        "steps": [
          {
            "title": "Initial Consultation",
            "desc": "Confirm whether an OPC is the most suitable structure for your business."
          },
          {
            "title": "Name Selection",
            "desc": "Select and reserve a unique company name through the MCA portal."
          },
          {
            "title": "Documentation",
            "desc": "Collect and verify documents from the promoter and nominee."
          },
          {
            "title": "Digital Signature & DIN",
            "desc": "Obtain the required DSC and Director Identification Number."
          },
          {
            "title": "Incorporation Filing",
            "desc": "Submit the incorporation application with the Registrar of Companies."
          },
          {
            "title": "Certificate of Incorporation",
            "desc": "The Registrar issues the Certificate along with the CIN."
          },
          {
            "title": "Post Registration Assistance",
            "desc": "PAN, TAN, bank account and GST registration (where applicable)."
          }
        ]
      },
      "timeline": {
        "heading": "Estimated Timeline",
        "body": "An OPC can generally be incorporated within 7–15 working days, subject to MCA processing timelines."
      },
      "fees": {
        "heading": "Government Fees & Professional Fees",
        "note": "Contact Biz360 Compliance for a customised quotation based on your business requirements."
      },
      "benefits": {
        "heading": "Why Choose an OPC?",
        "items": [
          "Separate legal identity and limited liability protection",
          "Single ownership and complete control",
          "Enhanced business credibility",
          "Better access to banking and financial services",
          "Perpetual succession through nomination provisions",
          "Opportunity to convert into a Private Limited Company as the business expands"
        ]
      },
      "afterService": {
        "heading": "Post Registration Compliance",
        "items": [
          "Opening a company bank account",
          "Accounting & bookkeeping, statutory records",
          "Annual financial statements & ROC filings",
          "Income Tax Return filing",
          "GST & TDS compliance (where applicable)"
        ]
      },
      "whyUs": {
        "heading": "Why Choose Biz360 Compliance?",
        "items": [
          "Experienced professionals and end-to-end incorporation support",
          "Transparent pricing and dedicated relationship manager",
          "Secure document management, fast turnaround",
          "Single platform for registration, taxation, accounting and support"
        ]
      },
      "faqs": [
        {
          "q": "Who can register an OPC?",
          "a": "A single eligible individual can incorporate an OPC, subject to applicable legal requirements."
        },
        {
          "q": "Is a nominee mandatory?",
          "a": "Yes. Appointment of a nominee is generally required during incorporation."
        },
        {
          "q": "Can an OPC have more than one shareholder?",
          "a": "No. An OPC is designed for a single member."
        },
        {
          "q": "Can an OPC hire employees?",
          "a": "Yes. An OPC can appoint employees and operate like any other company."
        },
        {
          "q": "Can an OPC be converted into a Private Limited Company?",
          "a": "Yes, in accordance with the applicable legal framework and business requirements."
        },
        {
          "q": "Does an OPC require annual compliance?",
          "a": "Yes. Annual statutory compliances apply even with limited business activity."
        }
      ],
      "extra": null,
      "related": [
        "private-limited-company",
        "llp",
        "sole-proprietorship"
      ]
    }
  },
  {
    "slug": "partnership-firm",
    "category": "Registration",
    "sub_category": "Traditional Structures",
    "icon": "Users",
    "title": "Partnership Firm Registration in India",
    "subtitle": "Register Your Partnership Firm with Confidence",
    "read_time": "7 min read",
    "image": "https://images.unsplash.com/photo-1450101499163-c8848c66ca85?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
    "intro": "A Partnership Firm is one of the most widely adopted business structures in India for small and medium-sized businesses operated by two or more individuals. Governed by the Indian Partnership Act, 1932, it enables partners to jointly own, manage and operate a business while sharing profits and responsibilities on mutually agreed terms. While registration is generally optional, it provides significant legal advantages when enforcing contractual rights or resolving disputes. Biz360 Compliance assists with drafting the Partnership Deed, obtaining registration and securing PAN, GST, Shop & Establishment and Udyam registrations.",
    "sections": {
      "whoNeedsIt": {
        "heading": "Who Should Register a Partnership Firm?",
        "items": [
          "Family businesses",
          "Retail & wholesale traders, manufacturers",
          "Consultants and contractors",
          "Restaurants, cafés and educational institutions",
          "Local trading businesses, agencies and distributors"
        ]
      },
      "eligibility": {
        "heading": "Eligibility Criteria",
        "items": [
          "Minimum two partners, legally competent to contract",
          "A mutually agreed Partnership Deed",
          "Registered office or business address",
          "No prescribed minimum capital requirement"
        ]
      },
      "documents": {
        "heading": "Documents Required",
        "groups": [
          {
            "title": "Partners",
            "items": [
              "PAN Card",
              "Aadhaar Card",
              "Passport-size photograph",
              "Mobile number & email address",
              "Address proof"
            ]
          },
          {
            "title": "Business Address",
            "items": [
              "Ownership proof or rent agreement + NOC",
              "Latest utility bill"
            ]
          },
          {
            "title": "Additional",
            "items": [
              "Partnership Deed",
              "Affidavits or declarations, wherever required"
            ]
          }
        ]
      },
      "process": {
        "heading": "Registration Process",
        "steps": [
          {
            "title": "Business Consultation",
            "desc": "Confirm whether a Partnership Firm is the most suitable structure."
          },
          {
            "title": "Drafting the Partnership Deed",
            "desc": "Business objectives, capital contribution, profit-sharing, rights and dissolution provisions."
          },
          {
            "title": "Execution of the Deed",
            "desc": "The deed is executed on appropriate stamp paper as per the State Stamp Act."
          },
          {
            "title": "Firm Registration",
            "desc": "Submit the registration application before the Registrar of Firms."
          },
          {
            "title": "Certificate of Registration",
            "desc": "The Registrar issues the Certificate of Registration, where applicable."
          },
          {
            "title": "Post Registration Assistance",
            "desc": "PAN, GST, Shop & Establishment, Udyam and bank account opening."
          }
        ]
      },
      "timeline": {
        "heading": "Estimated Timeline",
        "body": "Partnership Firm registration is generally completed within 5–15 working days, subject to state processing."
      },
      "fees": {
        "heading": "Government Fees & Professional Fees",
        "note": "Contact Biz360 Compliance for a customised quotation based on your business requirements."
      },
      "benefits": {
        "heading": "Why Choose a Partnership Firm?",
        "items": [
          "Simple and economical to establish",
          "Easy decision-making and management",
          "Flexible profit-sharing arrangements",
          "Minimal incorporation formalities",
          "Lower compliance requirements compared to companies",
          "Easy admission and retirement of partners",
          "Option to convert into an LLP or Company later"
        ]
      },
      "afterService": {
        "heading": "Recommended Ongoing Compliance",
        "items": [
          "Income Tax Return filing",
          "GST registration & returns (where applicable)",
          "TDS and Professional Tax compliance",
          "Accounting & bookkeeping",
          "Business licence renewals"
        ]
      },
      "whyUs": {
        "heading": "Why Choose Biz360 Compliance?",
        "items": [
          "Professionally drafted Partnership Deed",
          "State-specific registration expertise",
          "Transparent pricing and dedicated relationship manager",
          "Ongoing accounting, taxation and compliance services"
        ]
      },
      "faqs": [
        {
          "q": "Is Partnership Firm registration mandatory?",
          "a": "Registration is generally optional, but it provides important legal advantages, particularly in enforcing contractual rights and resolving disputes."
        },
        {
          "q": "How many partners are required?",
          "a": "A minimum of two partners is required."
        },
        {
          "q": "Is a written Partnership Deed compulsory?",
          "a": "It's strongly recommended — it records rights and obligations and is generally required for registrations, banking and taxation."
        },
        {
          "q": "Can a Partnership Firm obtain GST Registration?",
          "a": "Yes, subject to the applicable provisions of GST law."
        },
        {
          "q": "Can a Partnership Firm be converted into an LLP?",
          "a": "Yes, subject to applicable legal procedures and eligibility conditions."
        }
      ],
      "extra": null,
      "related": [
        "sole-proprietorship",
        "llp",
        "private-limited-company"
      ]
    }
  },
  {
    "slug": "sole-proprietorship",
    "category": "Registration",
    "sub_category": "Traditional Structures",
    "icon": "User",
    "title": "Sole Proprietorship Registration & Business Setup",
    "subtitle": "Start Your Business Quickly with a Sole Proprietorship",
    "read_time": "7 min read",
    "image": "https://images.unsplash.com/photo-1554224154-26032ffc0d07?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
    "intro": "A Sole Proprietorship is the simplest and most commonly adopted form of business in India, owned and managed by a single individual. It's particularly suitable for entrepreneurs who want to start a business with minimal regulatory formalities and complete operational control. Unlike companies and LLPs, a proprietorship has no separate legal identity from its owner — the proprietor is solely responsible for all business decisions, profits, liabilities and statutory compliances. Biz360 Compliance assists entrepreneurs in obtaining all necessary registrations to establish and operate a Proprietorship legally.",
    "sections": {
      "whoNeedsIt": {
        "heading": "Who Should Register a Proprietorship?",
        "items": [
          "First-time entrepreneurs and retail shops",
          "Traders and small manufacturers",
          "Freelancers, consultants and digital service providers",
          "E-commerce sellers and home-based businesses",
          "Local service providers and commission agents"
        ]
      },
      "eligibility": {
        "heading": "Registrations Typically Required",
        "items": [
          "GST Registration",
          "Udyam (MSME) Registration",
          "Shop & Establishment Registration",
          "Professional Tax Registration",
          "Trade Licence / FSSAI Registration",
          "Import Export Code (IEC), where applicable"
        ]
      },
      "documents": {
        "heading": "Documents Required",
        "groups": [
          {
            "title": "Proprietor",
            "items": [
              "PAN Card",
              "Aadhaar Card",
              "Passport-size photograph",
              "Mobile number & email address",
              "Address proof"
            ]
          },
          {
            "title": "Business Address",
            "items": [
              "Ownership proof or rent agreement + NOC",
              "Latest utility bill"
            ]
          }
        ]
      },
      "process": {
        "heading": "Registration Process",
        "steps": [
          {
            "title": "Business Consultation",
            "desc": "Determine the registrations applicable to your business activity."
          },
          {
            "title": "Documentation",
            "desc": "Collect and verify identity, address and business documents."
          },
          {
            "title": "Registration Planning",
            "desc": "Identify mandatory and optional registrations for your business model."
          },
          {
            "title": "Application Filing",
            "desc": "Prepare and submit applications before the respective authorities."
          },
          {
            "title": "Registration Approval",
            "desc": "Obtain registration certificates, licences or approvals."
          },
          {
            "title": "Business Setup Support",
            "desc": "GST, Udyam, Bank Account, Shop Act and Professional Tax assistance."
          }
        ]
      },
      "timeline": {
        "heading": "Estimated Timeline",
        "body": "Most proprietorship businesses can commence operations within 2–10 working days, depending on the applicable registrations (Udyam is typically same-day)."
      },
      "fees": {
        "heading": "Government Fees & Professional Fees",
        "note": "Contact Biz360 Compliance for a customised quotation based on your business requirements."
      },
      "benefits": {
        "heading": "Why Choose a Proprietorship?",
        "items": [
          "Simple and quick to establish",
          "Single ownership and complete control",
          "Minimal legal formalities and lower compliance",
          "Cost-effective business structure",
          "Quick decision-making",
          "Easy business closure compared to corporate entities"
        ]
      },
      "afterService": {
        "heading": "Ongoing Compliance",
        "items": [
          "Income Tax Return and GST Returns",
          "Accounting & bookkeeping",
          "TDS compliance (where applicable)",
          "Shop & Establishment renewal",
          "Labour law compliance, if employees are engaged"
        ]
      },
      "whyUs": {
        "heading": "Why Choose Biz360 Compliance?",
        "items": [
          "Guidance on the most suitable registrations",
          "Complete documentation support and transparent pricing",
          "Fast processing and dedicated relationship manager",
          "Ongoing taxation, accounting and compliance support"
        ]
      },
      "faqs": [
        {
          "q": "Is Proprietorship Registration mandatory?",
          "a": "There is no separate incorporation law — the business is generally recognised through applicable registrations such as GST, Udyam or Shop & Establishment."
        },
        {
          "q": "Is Udyam Registration compulsory?",
          "a": "It's optional but recommended for eligible MSMEs to avail benefits under government schemes."
        },
        {
          "q": "Can I convert my Proprietorship into an LLP or Company?",
          "a": "Yes, subject to applicable legal procedures and business requirements."
        },
        {
          "q": "Can I employ staff under a Proprietorship?",
          "a": "Yes. Applicable labour law compliances must be followed wherever required."
        },
        {
          "q": "How much does Proprietorship Registration cost?",
          "a": "The cost depends upon the registrations required and applicable government fees."
        }
      ],
      "extra": null,
      "related": [
        "partnership-firm",
        "one-person-company",
        "llp"
      ]
    }
  },
  {
    "slug": "section-8-company",
    "category": "Registration",
    "sub_category": "Non-Profit",
    "icon": "HeartHandshake",
    "title": "Section 8 Company Registration in India",
    "subtitle": "Register a Section 8 Company with Expert Professional Guidance",
    "read_time": "9 min read",
    "image": "https://images.unsplash.com/photo-1554224155-6726b3ff858f?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
    "intro": "A Section 8 Company is a non-profit company incorporated under the Companies Act, 2013 for promoting charitable and socially beneficial objectives — education, healthcare, rural development, women empowerment, environmental protection, skill development, research, culture and other public welfare initiatives. Unlike commercial companies, profits must be applied solely towards its stated objectives; dividends cannot be distributed. Many charitable organisations, CSR implementation agencies and social enterprises prefer this model for its transparent governance and wider institutional acceptance. Biz360 Compliance assists with incorporation as well as building a strong legal, financial and compliance framework for long-term sustainability.",
    "sections": {
      "whoNeedsIt": {
        "heading": "Who Should Register a Section 8 Company?",
        "items": [
          "NGOs and charitable foundations",
          "Educational and healthcare institutions",
          "CSR implementation agencies",
          "Social enterprises focused on women empowerment, skill development, environment, arts or research"
        ]
      },
      "eligibility": {
        "heading": "Eligibility Criteria",
        "items": [
          "Proposed objectives must be charitable or not-for-profit in nature",
          "Profits must be applied solely towards the organisation's objectives",
          "Members must not intend to receive dividends",
          "Registered office address in India",
          "Minimum prescribed Directors/Members under the Companies Act"
        ]
      },
      "documents": {
        "heading": "Documents Required",
        "groups": [
          {
            "title": "Identity Documents",
            "items": [
              "PAN Card",
              "Aadhaar Card",
              "Passport-size photograph",
              "Mobile number & email address",
              "Address proof"
            ]
          },
          {
            "title": "Registered Office",
            "items": [
              "Ownership proof or rent agreement + NOC",
              "Latest utility bill"
            ]
          },
          {
            "title": "Incorporation Documents",
            "items": [
              "Proposed main objects",
              "Estimated income & expenditure statement",
              "Declarations and consent letters"
            ]
          }
        ]
      },
      "process": {
        "heading": "Registration Process",
        "steps": [
          {
            "title": "Initial Consultation",
            "desc": "Determine whether a Section 8 Company is the most suitable legal structure."
          },
          {
            "title": "Planning & Documentation",
            "desc": "Prepare proposed objects, financial projections and incorporation documents."
          },
          {
            "title": "Name Reservation",
            "desc": "Reserve an appropriate name through the MCA portal."
          },
          {
            "title": "Incorporation & Licence Application",
            "desc": "Submit incorporation together with the Section 8 licence application."
          },
          {
            "title": "Government Review",
            "desc": "The Registrar examines the application and may seek clarifications."
          },
          {
            "title": "Certificate of Incorporation",
            "desc": "Certificate of Incorporation along with the Section 8 licence is issued."
          },
          {
            "title": "Post Incorporation Support",
            "desc": "PAN, TAN, bank account and other statutory registrations."
          }
        ]
      },
      "timeline": {
        "heading": "Estimated Timeline",
        "body": "Incorporation generally takes 10–20 working days, depending on documentation and regulatory approvals."
      },
      "fees": {
        "heading": "Government Fees & Professional Fees",
        "note": "Contact Biz360 Compliance for a customised quotation based on your organisation's requirements."
      },
      "benefits": {
        "heading": "Why Choose a Section 8 Company?",
        "items": [
          "Separate legal identity and limited liability for members",
          "Higher institutional credibility and transparent governance",
          "Perpetual succession",
          "Improved eligibility for grants and CSR collaborations, subject to law",
          "Better acceptance among government authorities, donors and institutions"
        ]
      },
      "afterService": {
        "heading": "Beyond Incorporation — Building a Compliance Framework",
        "items": [
          "Maintenance of statutory registers, board/members' meetings",
          "Books of account and annual financial statements",
          "ROC annual filings and Income Tax Return",
          "Statutory audit and GST compliance, where applicable",
          "12AB and 80G registration for tax exemption / donor benefits, subject to eligibility"
        ]
      },
      "whyUs": {
        "heading": "Why Choose Biz360 Compliance?",
        "items": [
          "Section 8 incorporation, MOA/AOA drafting",
          "12AB & 80G registration assistance",
          "CSR compliance advisory and financial reporting",
          "Ongoing governance support"
        ]
      },
      "faqs": [
        {
          "q": "What is a Section 8 Company?",
          "a": "A non-profit company incorporated under the Companies Act, 2013 for promoting charitable and socially beneficial objectives."
        },
        {
          "q": "Can a Section 8 Company earn income?",
          "a": "Yes, but income must be utilised for the organisation's objectives and cannot be distributed as dividends."
        },
        {
          "q": "Is 12AB registration mandatory?",
          "a": "It's a separate registration under the Income-tax law, required for organisations seeking tax exemptions, subject to eligibility."
        },
        {
          "q": "Is 80G registration automatic?",
          "a": "No. It requires a separate application and approval under the Income-tax law."
        },
        {
          "q": "Is statutory audit compulsory?",
          "a": "Audit requirements are governed by the applicable provisions of the Companies Act and other relevant laws."
        }
      ],
      "extra": null,
      "related": [
        "trust-registration",
        "producer-company",
        "private-limited-company"
      ]
    }
  },
  {
    "slug": "producer-company",
    "category": "Registration",
    "sub_category": "Agri & Producer",
    "icon": "Sprout",
    "title": "Producer Company Registration in India",
    "subtitle": "Build a Stronger Future for Farmers Through a Producer Company",
    "read_time": "8 min read",
    "image": "https://images.unsplash.com/photo-1450101499163-c8848c66ca85?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
    "intro": "A Producer Company is a specialised corporate structure incorporated under the Companies Act, 2013, designed to promote the collective interests of primary producers — farmers, agriculturists, dairy producers, fishermen, artisans, weavers and other primary producers. It enables members to improve production, processing, storage, marketing and distribution of agricultural and allied products while enhancing bargaining power and access to markets, technology and financial resources. Unlike traditional cooperative societies, a Producer Company operates under a corporate governance framework, offering greater operational flexibility, transparency and long-term sustainability. Biz360 Compliance assists producer groups through incorporation and ongoing regulatory compliance, accounting and advisory services.",
    "sections": {
      "whoNeedsIt": {
        "heading": "Who Should Register a Producer Company?",
        "items": [
          "Farmer Producer Organisations (FPOs)",
          "Dairy, poultry and fisheries producers",
          "Horticulture, sericulture and beekeeping collectives",
          "Tribal producer groups and organic farming collectives",
          "Agricultural cooperatives transitioning to a corporate structure"
        ]
      },
      "eligibility": {
        "heading": "Eligibility Criteria",
        "items": [
          "Incorporated by eligible primary producers per the prescribed constitution requirements",
          "Organisation must primarily engage in production, harvesting, procurement, grading, processing, marketing or export of primary produce"
        ]
      },
      "documents": {
        "heading": "Documents Required",
        "groups": [
          {
            "title": "Directors & Members",
            "items": [
              "PAN Card",
              "Aadhaar Card",
              "Passport-size photograph",
              "Mobile number & email address",
              "Address proof"
            ]
          },
          {
            "title": "Registered Office",
            "items": [
              "Ownership proof or rent agreement + NOC",
              "Latest utility bill"
            ]
          },
          {
            "title": "Organisation Documents",
            "items": [
              "Details of proposed business activities",
              "Identity details of eligible producer members",
              "Declarations and incorporation documents"
            ]
          }
        ]
      },
      "process": {
        "heading": "Registration Process",
        "steps": [
          {
            "title": "Business Consultation",
            "desc": "Understand the proposed agricultural activities and evaluate eligibility."
          },
          {
            "title": "Documentation",
            "desc": "Collect and verify documents of Directors and producer members."
          },
          {
            "title": "Name Reservation",
            "desc": "Apply for reservation of the proposed Producer Company name."
          },
          {
            "title": "Incorporation Documents",
            "desc": "Draft MOA, AOA and other statutory incorporation documents."
          },
          {
            "title": "Incorporation Filing",
            "desc": "Submit the incorporation application through the MCA portal."
          },
          {
            "title": "Certificate of Incorporation",
            "desc": "Receive the Certificate of Incorporation and CIN upon approval."
          },
          {
            "title": "Post Registration Support",
            "desc": "PAN, TAN, GST (where applicable) and bank account opening."
          }
        ]
      },
      "timeline": {
        "heading": "Estimated Timeline",
        "body": "Incorporation generally takes 10–20 working days, depending on documentation, regulatory approvals and government processing timelines."
      },
      "fees": {
        "heading": "Government Fees & Professional Fees",
        "note": "Contact Biz360 Compliance for a customised quotation based on your Producer Company's requirements."
      },
      "benefits": {
        "heading": "Why Choose a Producer Company?",
        "items": [
          "Separate legal identity and limited liability for members",
          "Professional corporate governance",
          "Better access to institutional finance and improved market access",
          "Collective procurement and marketing, enhanced bargaining power",
          "Perpetual succession and opportunities for value addition"
        ]
      },
      "afterService": {
        "heading": "Beyond Registration — Supporting Producer Organisations",
        "items": [
          "Accounting & bookkeeping, annual financial statements",
          "ROC annual compliance and statutory audit",
          "Income Tax and GST compliance, where applicable",
          "Payroll & labour law compliance",
          "Project report preparation for bank finance and schemes"
        ]
      },
      "whyUs": {
        "heading": "Why Choose Biz360 Compliance?",
        "items": [
          "Producer Company registration and MOA/AOA drafting",
          "GST registration and accounting & bookkeeping",
          "Annual ROC and Income Tax compliance",
          "Project report preparation and business advisory"
        ]
      },
      "faqs": [
        {
          "q": "What is a Producer Company?",
          "a": "A corporate entity formed by eligible primary producers to carry out production, processing, marketing and related activities connected with primary produce."
        },
        {
          "q": "Is a Producer Company different from a Cooperative Society?",
          "a": "Yes. A Producer Company is governed under the Companies Act, 2013 and follows a corporate governance framework."
        },
        {
          "q": "Can a Producer Company obtain bank finance?",
          "a": "Yes, financial institutions may extend credit based on eligibility and lending policies."
        },
        {
          "q": "Can a Producer Company export agricultural products?",
          "a": "Yes, subject to compliance with applicable laws and necessary registrations such as IEC."
        },
        {
          "q": "How long does incorporation take?",
          "a": "Generally 10–20 working days, subject to government approvals."
        }
      ],
      "extra": null,
      "related": [
        "section-8-company",
        "private-limited-company",
        "trust-registration"
      ]
    }
  },
  {
    "slug": "trust-registration",
    "category": "Registration",
    "sub_category": "Non-Profit",
    "icon": "Scale",
    "title": "Trust Registration in India",
    "subtitle": "Register a Public or Private Trust with Professional Guidance",
    "read_time": "8 min read",
    "image": "https://images.unsplash.com/photo-1735825764485-93a381fd5779?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODF8MHwxfHNlYXJjaHwzfHxwcm9mZXNzaW9uYWwlMjBmaW5hbmNlJTIwd29ya3NwYWNlfGVufDB8fHx8MTc4MzE3MDIyNHww&ixlib=rb-4.1.0&q=85",
    "intro": "A Trust is one of the most widely recognised legal structures in India for managing property or funds for charitable, religious, educational, social or private purposes. A trust is created when the author (settlor) transfers property to trustees, who hold and manage it for the benefit of beneficiaries or specified charitable objectives. Depending on its objectives, a trust may be established as a Public Charitable Trust, Religious Trust or Private Trust. Biz360 Compliance assists with drafting the Trust Deed, completing registration formalities and establishing a sound legal and compliance framework.",
    "sections": {
      "whoNeedsIt": {
        "heading": "Who Should Register a Trust?",
        "items": [
          "Charitable organisations and NGOs",
          "Educational and healthcare institutions",
          "Religious organisations",
          "Family trusts and philanthropic foundations",
          "Community development organisations"
        ]
      },
      "eligibility": {
        "heading": "Eligibility",
        "items": [
          "A Settlor (Author of the Trust)",
          "Minimum number of Trustees as applicable under state law",
          "Trust property (movable or immovable)",
          "Registered office / Trust address",
          "A Trust Deed with identity & address proof of Settlor and Trustees"
        ]
      },
      "documents": {
        "heading": "Documents Required",
        "groups": [
          {
            "title": "Settlor & Trustees",
            "items": [
              "PAN Card",
              "Aadhaar Card",
              "Passport-size photograph",
              "Mobile number & email address",
              "Address proof"
            ]
          },
          {
            "title": "Trust Address",
            "items": [
              "Ownership proof or rent agreement + NOC",
              "Latest utility bill"
            ]
          },
          {
            "title": "Trust Documents",
            "items": [
              "Draft Trust Deed",
              "Identity & address proofs of Trustees",
              "Proof of registered office"
            ]
          }
        ]
      },
      "process": {
        "heading": "Registration Process",
        "steps": [
          {
            "title": "Initial Consultation",
            "desc": "Understand the objectives of the proposed trust and recommend the appropriate structure."
          },
          {
            "title": "Drafting the Trust Deed",
            "desc": "Name, objectives, Settlor & Trustee details, powers, duties and dissolution clause."
          },
          {
            "title": "Execution of the Deed",
            "desc": "Executed on appropriate stamp paper as per applicable state laws."
          },
          {
            "title": "Registration",
            "desc": "Submit the Trust Deed and supporting documents to the registering authority."
          },
          {
            "title": "Registration Certificate",
            "desc": "Obtain the registration certificate upon successful completion."
          },
          {
            "title": "Post Registration Support",
            "desc": "PAN, bank account opening and accounting setup."
          }
        ]
      },
      "timeline": {
        "heading": "Estimated Timeline",
        "body": "Trust Registration may generally be completed within 7–20 working days, subject to state-specific procedures and approvals."
      },
      "fees": {
        "heading": "Government Fees & Professional Fees",
        "note": "Contact Biz360 Compliance for a customised quotation based on your Trust's objectives."
      },
      "benefits": {
        "heading": "Why Register a Trust?",
        "items": [
          "Legally recognised organisational structure",
          "Clearly defined rights and responsibilities of trustees",
          "Improved credibility with donors and institutions",
          "Ability to hold movable and immovable property",
          "Facilitates opening of bank accounts",
          "Foundation for obtaining further statutory registrations"
        ]
      },
      "afterService": {
        "heading": "Beyond Registration — Building a Compliant Trust",
        "items": [
          "Maintenance of trust records and accounting & bookkeeping",
          "Income Tax Return filing and statutory audit, where applicable",
          "GST registration & compliance, where applicable",
          "12AB and 80G registration for tax exemption / donor benefits, subject to eligibility"
        ]
      },
      "whyUs": {
        "heading": "Why Choose Biz360 Compliance?",
        "items": [
          "Trust registration and drafting of the Trust Deed",
          "PAN & TAN assistance, accounting & bookkeeping",
          "12AB & 80G registration assistance",
          "NGO advisory & governance support"
        ]
      },
      "faqs": [
        {
          "q": "What is a Trust?",
          "a": "A legal arrangement where a settlor transfers property to trustees to manage it for beneficiaries or specified charitable/religious purposes."
        },
        {
          "q": "Is Trust Registration mandatory?",
          "a": "It depends on applicable state laws and the nature of the Trust; registration is generally recommended for legal recognition."
        },
        {
          "q": "Is 80G registration mandatory?",
          "a": "No, it's optional but beneficial for eligible organisations offering tax benefits to donors."
        },
        {
          "q": "Can a Trust own property?",
          "a": "Yes, a registered Trust may hold property in accordance with its Trust Deed and applicable laws."
        },
        {
          "q": "How long does Trust Registration take?",
          "a": "Generally 7–20 working days, subject to the procedures of the relevant registration authority."
        }
      ],
      "extra": null,
      "related": [
        "section-8-company",
        "producer-company",
        "private-limited-company"
      ]
    }
  },
  {
    "slug": "gst-registration",
    "category": "GST Services",
    "sub_category": null,
    "icon": "BadgeCheck",
    "title": "GST Registration Services in India",
    "subtitle": "Get Your GST Registration with Professional Guidance",
    "read_time": "9 min read",
    "image": "https://images.unsplash.com/photo-1554224155-1696413565d3?crop=entropy&cs=srgb&fm=jpg&q=80&w=1200",
    "intro": "Goods and Services Tax (GST) is a comprehensive indirect tax applicable to the supply of goods and services in India, and businesses that become liable for registration must obtain it in the appropriate State or Union Territory. Registration grants a 15-digit GSTIN and enables a business to undertake taxable supplies in line with GST law. Whether you are starting a new venture, crossing the applicable turnover threshold, expanding into another State or becoming liable under a specific provision, determining the correct GST position before commencing taxable supplies is essential. The requirement is not based on turnover alone — several categories of persons are subject to compulsory registration regardless of turnover, while others may not need registration at all. Biz360 Compliance assists businesses with GST registration assessment, documentation, online application filing, clarification handling with the department and post-registration guidance, so that the right registration category is obtained the first time.",
    "sections": {
      "whoNeedsIt": {
        "heading": "Who Needs GST Registration?",
        "items": [
          "Businesses crossing the applicable turnover threshold",
          "Persons falling under specified categories requiring compulsory registration",
          "Businesses making taxable supplies from multiple States, where registration is required",
          "Certain e-commerce-related businesses",
          "Casual taxable persons",
          "Non-resident taxable persons",
          "Persons liable to pay tax under specified reverse charge provisions",
          "Input Service Distributors and other notified persons"
        ]
      },
      "eligibility": {
        "heading": "Eligibility & Applicability Assessment",
        "items": [
          "Constitution of the business",
          "Nature of goods/services supplied",
          "Taxability of supplies",
          "Aggregate turnover",
          "State-wise operations and inter-State supplies",
          "E-commerce transactions",
          "Reverse charge applicability",
          "Composition Scheme eligibility and existing registrations"
        ]
      },
      "documents": {
        "heading": "Documents Required",
        "groups": [
          {
            "title": "Proprietorship",
            "items": [
              "PAN of Proprietor",
              "Aadhaar / Identity Proof",
              "Photograph",
              "Mobile Number and Email ID",
              "Business Address Proof",
              "Bank Account Proof, where required"
            ]
          },
          {
            "title": "Partnership / LLP",
            "items": [
              "PAN of Firm / LLP",
              "Partnership Deed / LLP Agreement",
              "PAN & KYC of Partners",
              "Photograph of authorised signatory",
              "Business Address Proof",
              "Bank Account Proof, where required"
            ]
          },
          {
            "title": "Company",
            "items": [
              "Certificate of Incorporation",
              "PAN of Company",
              "MOA & AOA, where applicable",
              "PAN & KYC of Directors / Authorised Signatory",
              "Board Resolution / Authorisation",
              "Business Address Proof and Bank Account Proof, where required"
            ]
          },
          {
            "title": "Registered / Rented Premises",
            "items": [
              "Ownership document / property tax receipt",
              "Electricity or utility bill",
              "Rent / Lease Agreement",
              "NOC from owner, where applicable"
            ]
          }
        ]
      },
      "process": {
        "heading": "GST Registration Process",
        "steps": [
          {
            "title": "Applicability Assessment",
            "desc": "We determine whether GST registration is mandatory, optional or not presently required."
          },
          {
            "title": "Document Verification",
            "desc": "Documents relating to the applicant, business constitution and place of business are reviewed."
          },
          {
            "title": "GST Application",
            "desc": "The application is filed electronically in FORM GST REG-01 on the GST portal."
          },
          {
            "title": "Aadhaar Authentication / Verification",
            "desc": "Aadhaar authentication or prescribed e-KYC verification is completed as part of the registration process, where applicable."
          },
          {
            "title": "Departmental Verification",
            "desc": "The application may be processed without physical intervention where conditions are met; any clarification sought is responded to."
          },
          {
            "title": "GSTIN & Registration Certificate",
            "desc": "Upon approval, the GSTIN and registration certificate in FORM GST REG-06 are made available electronically."
          }
        ]
      },
      "timeline": {
        "heading": "Estimated Timeline",
        "body": "Generally, GST registration can be completed within a few working days where the application and documents are in order. Applications requiring clarification, authentication or departmental verification may take longer."
      },
      "fees": {
        "heading": "Government Fees & Professional Fees",
        "note": "There is generally no government fee for a normal GST registration application filed on the GST portal, though other statutory costs may arise depending on circumstances. Professional fees vary by business constitution, number of registrations, complexity and query handling required — get a customised quotation from Biz360 Compliance based on your requirements."
      },
      "benefits": {
        "heading": "Benefits of GST Registration",
        "items": [
          "Legal recognition of the business under the GST framework via GSTIN",
          "Ability to claim input tax credit, subject to conditions and restrictions",
          "Facilitates compliant taxable supplies across States",
          "Improves business credibility with customers, vendors and marketplaces",
          "Enables e-commerce and institutional business dealings that require a GSTIN",
          "Allows issuance of GST tax invoices and collection of GST in accordance with law"
        ]
      },
      "afterService": {
        "heading": "After GST Registration",
        "items": [
          "GST return filing",
          "Tax payment",
          "Tax invoice requirements and Input Tax Credit conditions",
          "E-Invoicing and E-Way Bill requirements, where applicable",
          "GST reconciliation and annual return requirements, where applicable",
          "Record maintenance, notices and registration amendments"
        ]
      },
      "whyUs": {
        "heading": "Why Choose Biz360 Compliance?",
        "items": [
          "Applicability First — we assess whether registration is actually required and under which category",
          "Accurate Documentation — documents and business details are reviewed before filing",
          "Professional Filing — applications are prepared and submitted through the prescribed GST portal process",
          "Query Support — we assist with preparing responses to departmental clarifications",
          "Post-Registration Support — continued support with returns, reconciliation, amendments, refunds and annual compliance"
        ]
      },
      "faqs": [
        {
          "q": "Is GST registration mandatory for every business?",
          "a": "No. It depends upon turnover, nature of supplies, location and specific compulsory-registration provisions."
        },
        {
          "q": "What is the GST registration turnover limit?",
          "a": "Broadly ₹40 lakh for eligible persons exclusively supplying goods in specified circumstances, and ₹20 lakh for services or mixed supplies, with lower thresholds in certain specified States."
        },
        {
          "q": "Can I voluntarily register under GST?",
          "a": "Yes. A person not otherwise liable to register may opt for voluntary registration under Section 25(3), and must then comply with applicable GST requirements as a registered taxpayer."
        },
        {
          "q": "Can I use my residential address for GST registration?",
          "a": "A residential premises may be used as a place of business where the premises and supporting documentation satisfy applicable requirements."
        },
        {
          "q": "How long does GST registration take?",
          "a": "Where the application and documents are in order and no additional verification is required, registration may be processed within a few working days."
        },
        {
          "q": "Is GST registration required separately in every State?",
          "a": "Generally yes — registration is State/UT-specific, and a person liable to registration may need separate registration in each State or Union Territory from which taxable supplies are made."
        }
      ],
      "extra": {
        "heading": "GST Registration Threshold",
        "kind": "table",
        "columns": [
          "Nature of Supply",
          "General Threshold",
          "Certain States / Special Cases"
        ],
        "rows": [
          [
            "Exclusive supply of goods",
            "₹40 lakh*",
            "₹20 lakh in specified States"
          ],
          [
            "Supply of services / mixed supplies",
            "₹20 lakh",
            "₹10 lakh in specified States"
          ]
        ],
        "note": "*The higher ₹40 lakh threshold for exclusive suppliers of goods is subject to specified conditions and exclusions. Crossing the threshold is not the only basis for registration — Section 24 of the CGST Act lists categories where registration may be compulsory irrespective of the normal threshold."
      },
      "related": [
        "gst-return-filing",
        "gst-amendment",
        "gst-advisory"
      ]
    }
  },
  {
    "slug": "gst-return-filing",
    "category": "GST Services",
    "sub_category": null,
    "icon": "Send",
    "title": "GST Return Filing Services for Businesses Across India",
    "subtitle": "Accurate GST Returns, Timely Filing & Professional Compliance Support",
    "read_time": "9 min read",
    "image": "https://images.unsplash.com/photo-1518186285589-2f7649de83e0?crop=entropy&cs=srgb&fm=jpg&q=80&w=1200",
    "intro": "GST return filing is an ongoing compliance requirement for every registered taxpayer, and the applicable returns or statements depend on the taxpayer's registration type, turnover, business activity and filing frequency. A GST return is not simply a formality — the information reported affects tax liability, input tax credit, customer reporting, e-invoicing and e-way bill data, and the taxpayer's overall compliance position. Regular taxpayers use GSTR-1 to report outward supply details and GSTR-3B for summary reporting of taxable supplies, input tax credit and tax liability or payment, with filing frequency and due dates depending on the taxpayer's category and scheme. Biz360 Compliance combines return preparation with transaction review and reconciliation to identify discrepancies before filing, rather than simply uploading figures to the portal. Our services cover manufacturers, traders, service providers, e-commerce businesses, exporters, startups, MSMEs and companies alike.",
    "sections": {
      "whoNeedsIt": {
        "heading": "Who Needs GST Return Filing?",
        "items": [
          "Manufacturers, Traders, Wholesalers and Retailers",
          "Service Providers",
          "E-commerce Businesses",
          "Exporters & Importers",
          "Startups and MSMEs",
          "Companies, LLPs and Partnership Firms",
          "Proprietorships and other registered taxpayers"
        ]
      },
      "eligibility": {
        "heading": "Returns & Statements We Handle",
        "items": [
          "GSTR-1 — details of outward supplies, invoices, debit notes and credit notes",
          "GSTR-3B — summary return covering outward supplies, reverse charge liability, ITC and tax payable",
          "IFF — Invoice Furnishing Facility for eligible QRMP taxpayers to report B2B invoices in the first two months of a quarter",
          "QRMP compliance — quarterly GSTR-1/GSTR-3B filing with monthly tax payment for eligible taxpayers up to ₹5 crore turnover",
          "Annual Return — assistance with GSTR-9 and related annual GST compliance, where applicable"
        ]
      },
      "documents": {
        "heading": "Documents & Data Required",
        "groups": [
          {
            "title": "Sales Reconciliation",
            "items": [
              "Sales register",
              "GSTR-1",
              "E-invoice data, where applicable",
              "E-way bill data, where relevant",
              "Books of account"
            ]
          },
          {
            "title": "Input Tax Credit Reconciliation",
            "items": [
              "Purchase register",
              "GSTR-2B",
              "Vendor invoices",
              "Credit notes/debit notes",
              "Reverse charge transactions"
            ]
          }
        ]
      },
      "process": {
        "heading": "GST Return Filing Process",
        "steps": [
          {
            "title": "Data Collection",
            "desc": "Collect sales, purchase, ITC and other relevant accounting data."
          },
          {
            "title": "Data Review",
            "desc": "Review the information for completeness and obvious inconsistencies."
          },
          {
            "title": "Reconciliation",
            "desc": "Reconcile books with GST portal data, including applicable GSTR-1 and GSTR-2B information."
          },
          {
            "title": "Liability Computation",
            "desc": "Determine output tax, eligible ITC, reverse charge liability and net tax payable."
          },
          {
            "title": "Client Review",
            "desc": "Share relevant observations or reconciliation differences requiring clarification."
          },
          {
            "title": "Return Preparation",
            "desc": "Prepare the applicable GST return based on reconciled and verified information."
          },
          {
            "title": "Filing",
            "desc": "File the return electronically through the GST Portal after obtaining required confirmation."
          },
          {
            "title": "Record Maintenance",
            "desc": "Maintain filing acknowledgement and relevant working papers for future reference."
          }
        ]
      },
      "timeline": {
        "heading": "Estimated Timeline",
        "body": "GST returns must be filed within the statutory due dates applicable to the taxpayer. Our objective is to complete preparation and reconciliation before the statutory due date, allowing sufficient time to resolve discrepancies and obtain confirmations."
      },
      "fees": {
        "heading": "Government Fees & Professional Fees",
        "note": "There is generally no separate government filing fee for a normal GST return filed within the prescribed time, though interest and late fees may apply for delayed filing or payment. Professional fees depend on the number of registrations, filing frequency, transaction volume and reconciliation complexity."
      },
      "benefits": {
        "heading": "Why Reconciliation Matters",
        "items": [
          "Catches sales reported incorrectly or invoices omitted from GSTR-1",
          "Identifies incorrect customer GSTINs and differences between books and GSTR-1",
          "Flags ITC not appearing in GSTR-2B or duplicate ITC claims",
          "Surfaces credit note differences and reverse charge omissions",
          "Detects incorrect tax classification and GSTR-1 vs GSTR-3B mismatches",
          "Reduces late fees, interest, notices and cash-flow impact from incorrect ITC reporting"
        ]
      },
      "afterService": null,
      "whyUs": {
        "heading": "Why Choose Biz360 Compliance?",
        "items": [
          "Reconciliation-Focused Approach — we review available books and GST data before finalising the return",
          "Professional Review — transactions and tax positions are reviewed from a compliance perspective",
          "Timely Filing — we work towards completing filing before the applicable due date",
          "Compliance Tracking — important filing dates and outstanding requirements are monitored",
          "Query Support — assistance in understanding discrepancies and GST communications",
          "Complete GST Support — extends beyond returns to registration, amendment, refund, LUT and annual compliance"
        ]
      },
      "faqs": [
        {
          "q": "Is GST return filing mandatory after registration?",
          "a": "Yes, registered taxpayers are generally required to comply with applicable return/statement filing requirements even where there are no transactions, subject to their category."
        },
        {
          "q": "What is the difference between GSTR-1 and GSTR-3B?",
          "a": "GSTR-1 primarily reports outward supply details, while GSTR-3B is a summary return for supplies, ITC, tax liability and payment."
        },
        {
          "q": "Can GST returns be filed quarterly?",
          "a": "Eligible taxpayers may opt for the QRMP Scheme, under which GSTR-1 and GSTR-3B are filed quarterly, subject to applicable conditions."
        },
        {
          "q": "What is GSTR-2B?",
          "a": "GSTR-2B is an auto-drafted ITC statement made available to the recipient based on supplier filings, and is important for ITC reconciliation."
        },
        {
          "q": "Can a nil GST return be filed?",
          "a": "Yes, where the taxpayer has no reportable transactions or liability for the period, a nil return may be applicable, subject to circumstances."
        },
        {
          "q": "Can GST returns be revised?",
          "a": "Correction mechanisms depend on the specific form and nature of error — corrections are generally made through subsequent permitted returns or prescribed amendment mechanisms rather than replacing a filed return."
        }
      ],
      "extra": null,
      "related": [
        "gst-registration",
        "gstr-9-gstr-9c-filing",
        "gst-annual-compliance"
      ]
    }
  },
  {
    "slug": "gstr-9-gstr-9c-filing",
    "category": "GST Services",
    "sub_category": null,
    "icon": "RefreshCw",
    "title": "GSTR-9 & GSTR-9C Filing & Annual GST Reconciliation",
    "subtitle": "Annual GST Reconciliation, Review & Compliance",
    "read_time": "10 min read",
    "image": "https://images.unsplash.com/photo-1554224155-6726b3ff858f?crop=entropy&cs=srgb&fm=jpg&q=80&w=1200",
    "intro": "Annual GST compliance requires more than transferring figures from monthly returns. GSTR-9 is the annual return applicable to specified registered taxpayers under Section 44 of the CGST Act, summarising outward and inward supplies, input tax credit, ITC reversals, tax payable and paid, refunds and HSN/SAC information for the financial year. GSTR-9C is a reconciliation statement required where a taxpayer's aggregate turnover exceeds ₹5 crore, reconciling the annual return with the corresponding figures in the financial statements; it is now a self-certified statement rather than requiring CA/CMA certification as before. Monthly returns may have been filed correctly, yet annual reconciliation can still surface differences between books, GSTR-1, GSTR-3B, GSTR-2B and financial statements. Biz360 Compliance provides professional assistance with GSTR-9 preparation, GSTR-9C reconciliation, ITC review, turnover reconciliation and annual GST compliance.",
    "sections": {
      "whoNeedsIt": {
        "heading": "Who Needs GSTR-9 & GSTR-9C?",
        "items": [
          "Specified registered taxpayers who were regular taxpayers during the relevant financial year (GSTR-9), subject to notified exemptions",
          "Taxpayers whose aggregate turnover exceeds ₹5 crore for the relevant financial year (GSTR-9C)",
          "Businesses with multiple GSTINs requiring consolidated or GSTIN-wise annual compliance",
          "Businesses with exports, SEZ supplies or complex RCM transactions needing detailed reconciliation",
          "Applicability must be checked separately for each financial year, since exemptions vary by year"
        ]
      },
      "eligibility": {
        "heading": "Eligibility & Applicability Assessment",
        "items": [
          "Taxpayer category and whether regular-taxpayer status applied through the financial year",
          "Aggregate turnover for the relevant financial year",
          "Exemptions notified by the Government for that specific financial year",
          "Whether the ₹5 crore threshold triggering GSTR-9C is crossed",
          "Number of GSTINs and multi-State operations",
          "Export, SEZ and RCM transaction exposure"
        ]
      },
      "documents": {
        "heading": "Documents & Data Required",
        "groups": [
          {
            "title": "Financial Records",
            "items": [
              "Audited / finalised financial statements",
              "Trial Balance",
              "General Ledger",
              "Sales Register",
              "Purchase Register",
              "Debit/Credit Note Register"
            ]
          },
          {
            "title": "GST Data",
            "items": [
              "GSTR-1, GSTR-3B and GSTR-2B",
              "GSTR-9 data",
              "Electronic Credit Ledger",
              "Electronic Cash Ledger",
              "Electronic Liability Ledger"
            ]
          },
          {
            "title": "Additional Records (where applicable)",
            "items": [
              "E-invoice and e-way bill data",
              "Import/export documents and Shipping Bills",
              "LUT details and refund records",
              "RCM workings and ITC reversal workings",
              "Previous-year GST reconciliation"
            ]
          }
        ]
      },
      "process": {
        "heading": "GSTR-9 & GSTR-9C Process",
        "steps": [
          {
            "title": "Applicability Review",
            "desc": "Determine whether GSTR-9 and GSTR-9C are applicable for the relevant financial year."
          },
          {
            "title": "Data Collection",
            "desc": "Collect financial statements, GST returns and relevant transaction data."
          },
          {
            "title": "Turnover Reconciliation",
            "desc": "Reconcile books with GSTR-1, GSTR-3B and annual return data."
          },
          {
            "title": "ITC Reconciliation",
            "desc": "Reconcile purchase records, GSTR-2B, GSTR-3B and annual ITC information."
          },
          {
            "title": "Tax Reconciliation & Difference Analysis",
            "desc": "Identify differences in tax liability and payment, and analyse their reasons and implications."
          },
          {
            "title": "Annual Return & GSTR-9C Preparation",
            "desc": "Prepare GSTR-9 and, where applicable, the GSTR-9C reconciliation statement."
          },
          {
            "title": "Review, Confirmation & Filing",
            "desc": "Discuss significant differences with the client and complete the filings through the GST Portal."
          }
        ]
      },
      "timeline": {
        "heading": "Estimated Timeline",
        "body": "The annual return is generally due by 31 December following the end of the relevant financial year, unless the Government extends the due date. We recommend beginning reconciliation well before December, particularly for businesses with multiple GSTINs, high transaction volumes, exports or complex RCM transactions."
      },
      "fees": {
        "heading": "Government Fees & Professional Fees",
        "note": "There is generally no separate government fee for normal filing of GSTR-9/GSTR-9C, though late fees may apply for delayed filing. Professional fees depend on annual turnover, number of GSTINs, transaction volume, reconciliation complexity and whether GSTR-9C is applicable."
      },
      "benefits": {
        "heading": "Why Annual GST Reconciliation Matters",
        "items": [
          "Identifies differences between books, GSTR-1, GSTR-3B and GSTR-2B before the annual return is finalised",
          "Reviews ITC claimed versus eligible ITC and ITC reversals",
          "Catches export and SEZ turnover mismatches and RCM transactions not reported",
          "Flags credit/debit note differences and HSN/SAC reporting issues",
          "Identifies transactions reported in the wrong financial year",
          "Reduces the risk of unreconciled tax liability going unnoticed until scrutiny"
        ]
      },
      "afterService": {
        "heading": "GSTR-9C — Important Current Position",
        "items": [
          "GSTR-9C is now self-certified by the taxpayer rather than requiring mandatory CA/CMA certification",
          "Financial statements must still be reconciled with GST data before self-certification",
          "Differences identified need to be analysed for their tax implications",
          "The taxpayer remains responsible for the accuracy of the self-certified statement",
          "Professional review before self-certification provides substantial compliance value for higher-turnover businesses"
        ]
      },
      "whyUs": {
        "heading": "Why Choose Biz360 Compliance?",
        "items": [
          "Reconciliation Before Filing — GSTR-9 is not treated as a simple data-entry exercise",
          "Books + GST Data — our approach connects accounting records with GST return data",
          "ITC-Focused Review — we review ITC movements to identify potential discrepancies",
          "Multi-GSTIN Support — consolidated and GSTIN-wise compliance support",
          "Export & SEZ Expertise — additional reconciliation requirements for export and SEZ transactions",
          "Complete GST Support — annual compliance integrated with return filing, LUT, refund and GST advisory"
        ]
      },
      "faqs": [
        {
          "q": "Is GSTR-9 mandatory for every GST-registered taxpayer?",
          "a": "No. Applicability depends upon the taxpayer's category and exemptions notified for the relevant financial year."
        },
        {
          "q": "When is GSTR-9C applicable?",
          "a": "Broadly, GSTR-9C applies where aggregate turnover exceeds ₹5 crore for the relevant financial year, subject to applicable provisions."
        },
        {
          "q": "Does GSTR-9C require CA certification?",
          "a": "No, under the current framework GSTR-9C is self-certified by the taxpayer; the earlier mandatory CA/CMA certification has been replaced by self-certification."
        },
        {
          "q": "What is the due date for GSTR-9?",
          "a": "Generally, the annual return is due by 31 December following the end of the financial year, unless the Government provides an extension."
        },
        {
          "q": "Can ITC be claimed in GSTR-9 if it was not claimed earlier?",
          "a": "GSTR-9 is not intended as a mechanism for claiming fresh ITC without considering statutory time limits and conditions."
        },
        {
          "q": "Can GSTR-9 be revised?",
          "a": "The ability to revise an already filed annual return is restricted, so the return should be reviewed carefully before filing."
        }
      ],
      "extra": {
        "heading": "GSTR-9 vs GSTR-9C",
        "kind": "table",
        "columns": [
          "Particulars",
          "GSTR-9",
          "GSTR-9C"
        ],
        "rows": [
          [
            "Nature",
            "Annual Return",
            "Reconciliation Statement"
          ],
          [
            "Purpose",
            "Annual GST reporting",
            "Reconcile GST data with financial statements"
          ],
          [
            "Applicable to",
            "Specified taxpayers, subject to exemptions",
            "Taxpayers exceeding ₹5 crore threshold"
          ],
          [
            "Basis",
            "GST returns and records",
            "Financial statements + GST records"
          ],
          [
            "Current certification",
            "Filed by taxpayer",
            "Self-certified by taxpayer"
          ]
        ]
      },
      "related": [
        "gst-return-filing",
        "gst-annual-compliance",
        "gst-advisory"
      ]
    }
  },
  {
    "slug": "gst-refund",
    "category": "GST Services",
    "sub_category": null,
    "icon": "RefreshCw",
    "title": "GST Refund & Export Refund Services",
    "subtitle": "Claim Eligible GST Refunds with Proper Documentation and Professional Support",
    "read_time": "9 min read",
    "image": "https://images.unsplash.com/photo-1518186285589-2f7649de83e0?crop=entropy&cs=srgb&fm=jpg&q=80&w=1200",
    "intro": "GST law allows refund of eligible tax, interest or other amounts in specified circumstances, governed primarily by Section 54 of the CGST Act, 2017 and related rules. Common situations include exports and other zero-rated supplies, accumulated input tax credit, inverted duty structure, excess balance in the electronic cash ledger, and refunds arising from assessment, appeal or other orders. A successful claim requires far more than simply filing FORM GST RFD-01 — the underlying transactions, tax payments, ITC, invoices, returns and supporting documents must be properly examined and reconciled before submission. Biz360 Compliance helps businesses evaluate whether a claim is eligible, prepare the necessary workings and documentation, submit the refund application, and provide support during the processing stage, including responding to departmental queries.",
    "sections": {
      "whoNeedsIt": {
        "heading": "Who Can Claim a GST Refund?",
        "items": [
          "Exporters of goods",
          "Exporters of services",
          "Suppliers to SEZ units/developers",
          "Businesses with eligible accumulated ITC",
          "Businesses affected by inverted duty structure",
          "Taxpayers with excess electronic cash ledger balances",
          "Taxpayers entitled to refunds pursuant to assessment, appeal or other orders"
        ]
      },
      "eligibility": {
        "heading": "Eligibility & Applicability Assessment",
        "items": [
          "Refund of unutilised ITC on eligible zero-rated supplies (exports and SEZ supplies)",
          "Refund of IGST paid on eligible zero-rated supplies",
          "Refund on account of inverted duty structure, subject to conditions and exclusions",
          "Refund of excess balance in the Electronic Cash Ledger",
          "Refund arising from assessment, provisional assessment, appellate or court/tribunal orders",
          "Eligibility is category-specific and must be assessed before filing"
        ]
      },
      "documents": {
        "heading": "Documents Required",
        "groups": [
          {
            "title": "Common Documents",
            "items": [
              "GST Registration Certificate",
              "GST Returns",
              "Sales & Purchase Register",
              "Tax Invoices",
              "Debit/Credit Notes",
              "ITC reconciliation",
              "Electronic Credit/Cash Ledger",
              "Bank details",
              "Refund computation"
            ]
          },
          {
            "title": "For Export of Goods",
            "items": [
              "Export invoices",
              "Shipping Bills / Bills of Export",
              "Export manifest/report details",
              "Relevant customs/export data"
            ]
          },
          {
            "title": "For Export of Services",
            "items": [
              "Export invoices",
              "GSTR-1 / relevant return data",
              "Bank Realisation Certificate (BRC) / FIRC, where applicable",
              "Foreign remittance details",
              "Agreements/contracts, where relevant"
            ]
          },
          {
            "title": "For Inverted Duty Refund",
            "items": [
              "Purchase & sales invoices",
              "GSTR-1, GSTR-3B, GSTR-2B / ITC data",
              "ITC reconciliation",
              "Refund computation",
              "Supporting invoice-level data"
            ]
          }
        ]
      },
      "process": {
        "heading": "GST Refund Process",
        "steps": [
          {
            "title": "Refund Eligibility Review",
            "desc": "Identify the nature of refund and determine whether the claim is eligible under applicable provisions."
          },
          {
            "title": "Transaction Reconciliation",
            "desc": "Reconcile relevant sales, purchases, ITC, tax payments and GST returns, including export/customs data for export refunds."
          },
          {
            "title": "Refund Computation",
            "desc": "Calculate the eligible refund amount using the applicable statutory formula and prescribed methodology."
          },
          {
            "title": "Documentation",
            "desc": "Prepare the refund statement, supporting documents, declarations and other required evidence."
          },
          {
            "title": "Filing of RFD-01",
            "desc": "File the refund application electronically in FORM GST RFD-01 through the GST Portal, where applicable."
          },
          {
            "title": "Departmental Processing",
            "desc": "The jurisdictional tax authority examines the application and may request additional information."
          },
          {
            "title": "Reply to Queries",
            "desc": "Assist in preparing responses to refund-related queries and departmental communications."
          },
          {
            "title": "Refund Order",
            "desc": "Upon approval, the eligible refund is processed in accordance with the applicable procedure."
          }
        ]
      },
      "timeline": {
        "heading": "Estimated Timeline",
        "body": "Actual processing time depends on the type of refund, completeness of documentation, departmental verification, clarifications sought, reconciliation requirements and jurisdictional processing. A fixed refund approval date cannot be promised."
      },
      "fees": {
        "heading": "Government Fees & Professional Fees",
        "note": "There is generally no separate government fee for filing a normal GST refund application, though applicable interest or other statutory amounts may arise depending on circumstances. Professional fees depend on the type of refund, invoice volume, number of GSTINs, reconciliation complexity and refund amount."
      },
      "benefits": {
        "heading": "Common Reasons for GST Refund Issues",
        "items": [
          "Incorrect refund category or computation",
          "Difference between books and GST returns",
          "ITC reconciliation issues and ineligible ITC included in the claim",
          "Incorrect invoice details or Shipping Bill/invoice mismatches",
          "Export data mismatches and missing BRC/FIRC or other evidence",
          "Incorrect turnover computation and unjust-enrichment issues",
          "Filing after the applicable limitation period"
        ]
      },
      "afterService": {
        "heading": "Time Limit for GST Refund",
        "items": [
          "Application generally must be made before expiry of two years from the relevant date under Section 54 of the CGST Act",
          "The relevant date is not identical for every type of refund — export claims and other categories have specific rules",
          "The limitation period should be checked claim-by-claim before filing",
          "Where a refund of unutilised ITC is rejected, rules provide for re-credit of the rejected amount to the electronic credit ledger"
        ]
      },
      "whyUs": {
        "heading": "Why Choose Biz360 Compliance?",
        "items": [
          "Eligibility assessment of the transaction and applicable refund category before proceeding",
          "Detailed transaction-level reconciliation wherever required",
          "Accurate computation using the applicable statutory methodology",
          "Documentation support to compile the evidence required for the claim",
          "Professional filing through the prescribed GST Portal mechanism",
          "Query and follow-up support for refund-related departmental communications"
        ]
      },
      "faqs": [
        {
          "q": "What is GST refund?",
          "a": "GST refund is the repayment of eligible tax, interest or other amounts under specified circumstances prescribed under GST law."
        },
        {
          "q": "Can exporters claim GST refund?",
          "a": "Yes, eligible zero-rated supplies can qualify for refund through the applicable route, subject to prescribed conditions."
        },
        {
          "q": "What is the time limit for filing a GST refund?",
          "a": "Generally, the application must be filed within two years from the relevant date, subject to specific rules for the particular refund category."
        },
        {
          "q": "What is RFD-01?",
          "a": "FORM GST RFD-01 is the electronic application used for claiming refund under specified categories."
        },
        {
          "q": "Can excess cash balance in the Electronic Cash Ledger be refunded?",
          "a": "Yes, an eligible taxpayer can claim refund of the unutilised balance, subject to applicable provisions."
        },
        {
          "q": "What happens if the refund application is rejected?",
          "a": "Depending on the circumstances and order passed, the taxpayer may have statutory remedies available, including filing an appeal where legally permissible."
        }
      ],
      "extra": null,
      "related": [
        "lut-registration",
        "gst-return-filing",
        "gst-advisory"
      ]
    }
  },
  {
    "slug": "lut-registration",
    "category": "GST Services",
    "sub_category": null,
    "icon": "Plane",
    "title": "LUT Registration for Exporters",
    "subtitle": "Export Goods or Services Without Upfront Payment of IGST",
    "read_time": "7 min read",
    "image": "https://images.unsplash.com/photo-1554224155-6726b3ff858f?crop=entropy&cs=srgb&fm=jpg&q=80&w=1200",
    "intro": "A Letter of Undertaking, or LUT, enables eligible GST-registered businesses to make qualifying zero-rated supplies — including exports of goods and services, and supplies to eligible SEZ units or developers — without payment of IGST upfront, subject to applicable conditions. It is furnished electronically in FORM GST RFD-11 through the GST Portal. Choosing between exporting under LUT and exporting with payment of IGST affects working capital, since the LUT route generally avoids the cash outflow of upfront IGST while allowing refund of eligible unutilised ITC instead. Biz360 Compliance assists exporters with LUT eligibility review, preparation, online filing, and the connected export GST compliance obligations. LUT is valid only for the financial year in which it is furnished, making it an annual compliance requirement rather than a one-time registration.",
    "sections": {
      "whoNeedsIt": {
        "heading": "Who Needs LUT?",
        "items": [
          "Exporters of goods",
          "Exporters of services",
          "Manufacturers exporting products",
          "Merchant exporters",
          "Traders engaged in exports",
          "IT & software companies",
          "Consultants and professional service exporters",
          "Other eligible suppliers to SEZ units/developers"
        ]
      },
      "eligibility": {
        "heading": "Eligibility & Applicability Assessment",
        "items": [
          "Must be a GST-registered person making eligible zero-rated supplies",
          "Applies when the business intends to export without payment of IGST",
          "Relevant to exports of goods, exports of services and supplies to eligible SEZ units/developers",
          "Not mandatory — relevant only where the exporter chooses the no-upfront-IGST route",
          "Appropriate route (LUT vs IGST payment) should be assessed based on ITC position and working capital",
          "A fresh LUT is required for each financial year of continued zero-rated supply without IGST"
        ]
      },
      "documents": {
        "heading": "Documents Required",
        "groups": [
          {
            "title": "Documents",
            "items": [
              "GSTIN",
              "Legal name of business",
              "PAN",
              "Details of authorised signatory",
              "Relevant financial year",
              "Required LUT declaration/details",
              "Witness details, where applicable"
            ]
          }
        ]
      },
      "process": {
        "heading": "LUT Registration Process",
        "steps": [
          {
            "title": "Eligibility Check",
            "desc": "Review the export activity and applicable GST treatment."
          },
          {
            "title": "Information Collection",
            "desc": "Collect GSTIN, business and authorised signatory details."
          },
          {
            "title": "LUT Preparation",
            "desc": "Prepare the prescribed undertaking."
          },
          {
            "title": "Online Filing",
            "desc": "File the LUT electronically through the GST Portal in FORM GST RFD-11."
          },
          {
            "title": "Verification & Acknowledgement",
            "desc": "Complete the prescribed verification and retain the filing acknowledgement."
          },
          {
            "title": "Export Compliance",
            "desc": "Ensure export invoices and GST returns correctly reflect the applicable export treatment."
          }
        ]
      },
      "timeline": {
        "heading": "Estimated Timeline",
        "body": "LUT is filed online through the GST Portal and is generally a quick, single-session filing once the required information and declaration are ready; it must be renewed with a fresh filing at the start of each financial year."
      },
      "fees": {
        "heading": "Government Fees & Professional Fees",
        "note": "There is generally no separate government fee for furnishing LUT through the GST Portal. Our professional fee depends on the number of GSTINs, nature of export activity, documentation requirements and any additional export compliance support needed."
      },
      "benefits": {
        "heading": "LUT vs Export with Payment of IGST",
        "items": [
          "Export under LUT: no IGST paid upfront, LUT required, generally lower working capital impact, refund claimed on eligible unutilised ITC",
          "Export with IGST: IGST paid upfront, no LUT required, generally higher working capital impact, refund claimed on eligible IGST paid",
          "LUT route suits eligible exporters preferring to avoid upfront IGST outlay",
          "IGST route suits eligible exporters using the payment-and-refund mechanism",
          "Choice should be evaluated against the business's ITC position and working-capital requirements"
        ]
      },
      "afterService": {
        "heading": "Important Compliance After LUT",
        "items": [
          "Correct export invoice endorsement: \"SUPPLY MEANT FOR EXPORT UNDER BOND OR LETTER OF UNDERTAKING WITHOUT PAYMENT OF IGST\"",
          "Proper reporting in GSTR-1 and correct tax treatment in GSTR-3B",
          "Proper maintenance of export records and ITC reconciliation",
          "Compliance with export timelines and proper documentation for refund claims",
          "Rule 96A conditions on export of goods within the prescribed period and receipt of payment for export of services apply"
        ]
      },
      "whyUs": {
        "heading": "Why Choose Biz360 Compliance?",
        "items": [
          "Simple and professional LUT filing process without unnecessary complexity",
          "Export-focused support connected to your broader export GST compliance",
          "Compliance guidance beyond filing — understanding implications for invoices, returns and refunds",
          "Ongoing support integrating LUT with regular GST return, reconciliation and refund requirements"
        ]
      },
      "faqs": [
        {
          "q": "What is LUT under GST?",
          "a": "LUT is a Letter of Undertaking furnished by an eligible registered person to make qualifying zero-rated supplies without payment of IGST."
        },
        {
          "q": "Is LUT mandatory for every exporter?",
          "a": "No, LUT is only relevant when an eligible exporter chooses to make qualifying zero-rated supplies without payment of IGST."
        },
        {
          "q": "Is LUT required every year?",
          "a": "Generally yes — a fresh LUT must be furnished for each financial year if the exporter intends to continue making eligible supplies without payment of IGST."
        },
        {
          "q": "Which form is used for LUT?",
          "a": "LUT is furnished electronically in FORM GST RFD-11 through the GST Portal."
        },
        {
          "q": "Does LUT remove other GST compliance requirements?",
          "a": "No, export invoices, GST returns, records, ITC reconciliation and other applicable compliance requirements continue to apply."
        },
        {
          "q": "Can I claim GST refund after exporting under LUT?",
          "a": "Yes, eligible exporters can claim refund of unutilised ITC arising from qualifying zero-rated supplies made under LUT, subject to applicable provisions."
        }
      ],
      "extra": null,
      "related": [
        "gst-refund",
        "gst-registration",
        "gst-advisory"
      ]
    }
  },
  {
    "slug": "gst-notice-reply",
    "category": "GST Services",
    "sub_category": null,
    "icon": "FileWarning",
    "title": "GST Notice Reply & Representation Services",
    "subtitle": "Professional Assistance for GST Notices, Queries & Proceedings",
    "read_time": "8 min read",
    "image": "https://images.unsplash.com/photo-1554224155-1696413565d3?crop=entropy&cs=srgb&fm=jpg&q=80&w=1200",
    "intro": "GST notices can arise from discrepancies in returns, input tax credit claims, tax liability, registration, refunds, exports or other compliance matters, and a proper response depends on understanding what the department has alleged, the relevant tax period, the supporting records and the applicable provisions. Rather than filing a generic reply, Biz360 Compliance reviews the notice in detail, verifies the underlying facts and figures, and reconciles books and GST data before preparing a structured, evidence-backed response. Support is available across return scrutiny notices, ITC and reconciliation mismatches, demand and show cause notices, registration-related queries, and refund or export notices. Where the matter proceeds further, assistance can extend to additional submissions, personal hearing preparation and other statutory proceedings.",
    "sections": {
      "whoNeedsIt": {
        "heading": "Who Needs GST Notice Reply & Representation Services?",
        "items": [
          "Businesses that have received a GST return scrutiny notice such as ASMT-10",
          "Taxpayers facing ITC mismatch, GSTR-2B difference or ITC reversal notices",
          "Businesses served with a GST demand or show cause notice",
          "Taxpayers who received registration-related notices, including proposed cancellation",
          "Exporters or refund applicants who received refund or export-related queries",
          "Anyone unsure how to interpret a GST notice or its response deadline"
        ]
      },
      "eligibility": {
        "heading": "Types of Notices We Handle",
        "items": [
          "Return scrutiny notices covering turnover, tax liability and ITC discrepancies (e.g. ASMT-10)",
          "ITC and reconciliation notices, including excess/ineligible ITC and supplier-related discrepancies",
          "GST demand or show cause notices proposing tax, interest or penalty",
          "Registration-related notices, including clarification and proposed cancellation",
          "Refund and export notices covering LUT, shipping bill data and refund computation",
          "Notices requiring further submissions, clarifications or personal hearings"
        ]
      },
      "documents": {
        "heading": "Documents Required",
        "groups": [
          {
            "title": "Documents Generally Required",
            "items": [
              "GST Notice / Show Cause Notice",
              "GSTR-1 & GSTR-3B",
              "GSTR-2B",
              "Sales & Purchase Registers",
              "Tax Invoices",
              "Credit/Debit Notes",
              "E-invoice / E-way Bill data",
              "GST payment records",
              "Refund/LUT documents, where applicable",
              "Previous correspondence with the department"
            ]
          }
        ]
      },
      "process": {
        "heading": "Our GST Notice Reply Process",
        "steps": [
          {
            "title": "Notice Review",
            "desc": "Examine the notice, allegation, tax period, amount involved and response deadline."
          },
          {
            "title": "Fact & Data Verification",
            "desc": "Review relevant books, GST returns, invoices and supporting records."
          },
          {
            "title": "Reconciliation",
            "desc": "Reconcile Books, GSTR-1, GSTR-3B, GSTR-2B and other GST data where required."
          },
          {
            "title": "Response Preparation",
            "desc": "Prepare a structured response addressing the issues raised, supported by relevant documents."
          },
          {
            "title": "Online Submission",
            "desc": "Submit the response and supporting documents through the applicable GST Portal mechanism."
          },
          {
            "title": "Further Support",
            "desc": "Assist with additional submissions, personal hearing preparation and further statutory proceedings where required."
          }
        ]
      },
      "timeline": {
        "heading": "Estimated Timeline",
        "body": "Every notice carries its own statutory response period; for example, an ASMT-10 scrutiny notice generally allows a 30-day period for reply unless a further period is permitted by the proper officer. We recommend sharing the notice as soon as it is received rather than waiting until the deadline."
      },
      "fees": {
        "heading": "Government Fees & Professional Fees",
        "note": "Professional fees depend on the nature of the notice, tax amount involved, number of issues, extent of reconciliation required, volume of supporting documents, complexity of the matter and any hearing or representation requirements."
      },
      "benefits": {
        "heading": "Benefits of Professional GST Notice Reply Support",
        "items": [
          "Response prepared based on the actual issue rather than a generic reply format",
          "Underlying financial and GST data verified through reconciliation before responding",
          "Focus on factual position, applicable GST provisions and documentary evidence",
          "Structured support from initial review through response and further proceedings",
          "Reduced risk of an inadequate or hasty reply that worsens the outcome",
          "Assistance available for personal hearings where required"
        ]
      },
      "afterService": null,
      "whyUs": {
        "heading": "Why Choose Biz360 Compliance?",
        "items": [
          "Notice-Specific Approach: response prepared based on the actual issue rather than generic formats",
          "Reconciliation-Based Review: underlying records verified before preparing the response",
          "Practical & Professional: focus on factual position, applicable provisions and documentary evidence",
          "End-to-End Support: from initial notice review to further submissions or representation"
        ]
      },
      "faqs": [
        {
          "q": "I have received a GST notice. What should I do?",
          "a": "First check the notice, response deadline and issues raised, and avoid filing a generic response without understanding the underlying discrepancy."
        },
        {
          "q": "Can Biz360 prepare my GST notice reply?",
          "a": "Yes. We review the notice, analyse the issue, prepare the response and assist with online submission."
        },
        {
          "q": "What is ASMT-10?",
          "a": "ASMT-10 is used to communicate discrepancies identified during scrutiny of a GST return, with the taxpayer's response generally furnished in ASMT-11."
        },
        {
          "q": "Can you handle ITC mismatch notices?",
          "a": "Yes. We can reconcile purchase records, GSTR-2B, ITC claimed and other relevant records."
        },
        {
          "q": "Can you assist with personal hearings?",
          "a": "Yes, where required and included within the scope of engagement."
        },
        {
          "q": "How quickly should I contact you after receiving a notice?",
          "a": "Preferably immediately, since early review provides sufficient time for reconciliation, document collection and preparation of a proper response."
        }
      ],
      "extra": null,
      "related": [
        "gst-amendment",
        "gst-cancellation",
        "gst-advisory"
      ]
    }
  },
  {
    "slug": "gst-amendment",
    "category": "GST Services",
    "sub_category": null,
    "icon": "RefreshCw",
    "title": "GST Registration Amendment Services",
    "subtitle": "Update Your GST Registration Details Accurately and on Time",
    "read_time": "7 min read",
    "image": "https://images.unsplash.com/photo-1554224154-22dec7ec8818?crop=entropy&cs=srgb&fm=jpg&q=80&w=1200",
    "intro": "Business details often change after GST registration, whether it is the address, contact information, authorised signatory, bank account or business constitution, and these changes need to be reflected accurately on the GST Portal. Depending on the nature of the change, some updates can be processed electronically without officer approval, while others fall under core amendments that require supporting documents and approval by the tax officer. Biz360 Compliance helps businesses identify which amendment route applies, reviews the supporting documentation, prepares and files the amendment application through the GST Portal, and follows up where departmental clarification or approval is needed. GST amendments can also be handled alongside regular return filing, reconciliation, refund and annual compliance work.",
    "sections": {
      "whoNeedsIt": {
        "heading": "Who Needs GST Amendment Services?",
        "items": [
          "Businesses that have changed their principal or additional place of business",
          "Businesses updating mobile number, email or other communication details",
          "Businesses with a change in authorised signatory",
          "Businesses updating bank account details linked to GST registration",
          "Businesses undergoing a change in constitution",
          "Any registered person needing to update other permitted registration particulars"
        ]
      },
      "eligibility": {
        "heading": "Eligibility & Applicability Assessment",
        "items": [
          "Change in Principal Place of Business or Additional Place of Business",
          "Change in mobile number, email address or other communication details",
          "Change in authorised signatory or related details",
          "Change in bank account information linked to the registration",
          "Change in business constitution, subject to applicable GST procedure",
          "Determination of whether the change is a core or non-core amendment"
        ]
      },
      "documents": {
        "heading": "Documents Required",
        "groups": [
          {
            "title": "Common Documents",
            "items": [
              "GST Registration Certificate",
              "PAN",
              "Address proof",
              "Rent/Lease Agreement",
              "Electricity/Utility Bill",
              "NOC from property owner, where applicable",
              "Board Resolution / Authorisation",
              "Partnership Deed / LLP Agreement",
              "Updated constitutional documents",
              "Bank details",
              "KYC of relevant persons"
            ]
          }
        ]
      },
      "process": {
        "heading": "GST Amendment Process",
        "steps": [
          {
            "title": "Identify the Change",
            "desc": "Review the existing GST registration and identify the required amendment."
          },
          {
            "title": "Document Review",
            "desc": "Verify the supporting documents applicable to the proposed change."
          },
          {
            "title": "Application Preparation",
            "desc": "Prepare the amendment application through the GST Portal."
          },
          {
            "title": "Submission",
            "desc": "Submit the application with the required supporting documents."
          },
          {
            "title": "Departmental Processing",
            "desc": "Where officer approval is required, monitor the application for processing or clarification."
          },
          {
            "title": "Updated GST Registration",
            "desc": "Once approved, the amended details are reflected in the GST registration records."
          }
        ]
      },
      "timeline": {
        "heading": "Estimated Timeline",
        "body": "The timeline depends on the nature of the amendment. Non-core changes processed electronically are typically quicker, while core changes requiring officer approval may take longer."
      },
      "fees": {
        "heading": "Government Fees & Professional Fees",
        "note": "Professional fees depend on the type of amendment, documentation required, whether officer approval is involved, complexity of the change and any additional compliance support required."
      },
      "benefits": {
        "heading": "Benefits of Keeping GST Registration Updated",
        "items": [
          "Registration records stay accurate and consistent with actual business details",
          "Reduced risk of issues with customers, vendors or the GST department over mismatched details",
          "Correct identification of core versus non-core amendment route avoids delays",
          "Documentation reviewed before filing, reducing chances of rejection or query",
          "Follow-up support where officer approval or clarification is required",
          "Can be coordinated with regular return filing, reconciliation, refund and annual compliance"
        ]
      },
      "afterService": null,
      "whyUs": {
        "heading": "Why Choose Biz360 Compliance?",
        "items": [
          "Correct Amendment Route: identify whether the change requires a core or non-core amendment and the applicable procedure",
          "Documentation Review: supporting documents checked before filing",
          "Portal Filing: amendment application prepared and submitted through the GST Portal",
          "Follow-Up Support: assistance where officer approval or clarification is required",
          "Complete GST Support: amendments handled alongside regular return filing, reconciliation, refund and annual compliance"
        ]
      },
      "faqs": [
        {
          "q": "Can GST registration details be changed after registration?",
          "a": "Yes. Permitted registration particulars can be amended through the prescribed GST amendment process."
        },
        {
          "q": "Can the principal business address be changed?",
          "a": "Yes, subject to the applicable procedure and supporting documents."
        },
        {
          "q": "Can I add another business location?",
          "a": "Yes. An additional place of business can be added through the prescribed amendment process."
        },
        {
          "q": "Do all GST amendments require officer approval?",
          "a": "No. The treatment depends on whether the change falls under the core or non-core amendment process."
        },
        {
          "q": "What documents are required for an address amendment?",
          "a": "Documents may include ownership proof, rent/lease agreement, utility bill and NOC, depending on the nature of the premises."
        },
        {
          "q": "How long does a GST amendment take?",
          "a": "The timeline depends on the nature of the amendment; changes requiring officer approval may take longer than those processed electronically."
        }
      ],
      "extra": {
        "heading": "Core vs Non-Core Amendments",
        "kind": "cards",
        "cards": [
          {
            "title": "Non-Core Changes",
            "desc": "Certain changes may be processed electronically without approval from the tax officer, subject to the GST Portal process."
          },
          {
            "title": "Core Changes",
            "desc": "Certain important changes may require supporting documents and approval by the appropriate officer."
          }
        ]
      },
      "related": [
        "gst-registration",
        "gst-cancellation",
        "gst-notice-reply"
      ]
    }
  },
  {
    "slug": "gst-cancellation",
    "category": "GST Services",
    "sub_category": null,
    "icon": "XCircle",
    "title": "GST Registration Cancellation Services",
    "subtitle": "Close Your GST Registration Properly and Complete the Required Compliance",
    "read_time": "9 min read",
    "image": "https://images.unsplash.com/photo-1554224155-6726b3ff858f?crop=entropy&cs=srgb&fm=jpg&q=80&w=1200",
    "intro": "GST registration can be cancelled voluntarily by a registered taxpayer where the registration is no longer required, or it may be initiated by the tax authorities under the applicable provisions, such as in cases of non-compliance. Whatever the trigger, cancellation does not automatically eliminate obligations relating to periods before cancellation, including pending returns, tax dues, interest, penalties and ITC reversal on stock or capital goods. Biz360 Compliance helps businesses assess their complete GST position before applying, prepares and files the cancellation application through the GST Portal, handles departmental queries, and assists with the final return and other post-cancellation compliance. Where a registration has been cancelled by the department and restoration is legally available, assistance with revocation of cancellation can also be provided separately.",
    "sections": {
      "whoNeedsIt": {
        "heading": "Who Needs GST Cancellation Services?",
        "items": [
          "Businesses that have discontinued operations",
          "Businesses that have been transferred, merged or otherwise disposed of",
          "Businesses undergoing a change in constitution requiring a different registration",
          "Taxpayers whose taxable business activity has ceased",
          "Registered persons no longer liable to remain registered",
          "Businesses seeking revocation of a registration cancelled by the tax officer"
        ]
      },
      "eligibility": {
        "heading": "Types of GST Cancellation We Handle",
        "items": [
          "Voluntary cancellation where registration is no longer required",
          "Cancellation initiated by the tax officer, including cases of non-compliance",
          "Cancellation due to business closure, transfer or merger",
          "Cancellation arising from a change in business constitution",
          "Cases requiring a fresh registration alongside cancellation of the existing one",
          "Revocation of a cancellation order issued by the proper officer, where legally available"
        ]
      },
      "documents": {
        "heading": "Documents Required",
        "groups": [
          {
            "title": "Documents & Information Required",
            "items": [
              "GSTIN",
              "PAN",
              "Cancellation reason",
              "Date from which cancellation is required",
              "Last GST return details",
              "Sales and purchase information",
              "Details of stock, if relevant",
              "Tax liability and ITC information",
              "Business closure/transfer documents, where applicable"
            ]
          }
        ]
      },
      "process": {
        "heading": "GST Cancellation Process",
        "steps": [
          {
            "title": "Review GST Position",
            "desc": "Check registration status, pending returns, tax liability and other compliance requirements."
          },
          {
            "title": "Determine Cancellation Reason",
            "desc": "Identify the appropriate reason and effective date."
          },
          {
            "title": "Prepare Application",
            "desc": "Prepare the cancellation application with the required information."
          },
          {
            "title": "Online Filing",
            "desc": "Submit the application through the GST Portal."
          },
          {
            "title": "Departmental Processing",
            "desc": "Respond to queries raised by the proper officer, where required."
          },
          {
            "title": "Cancellation Order",
            "desc": "Upon approval, the GST registration is cancelled from the date specified in the order."
          },
          {
            "title": "Post-Cancellation Compliance",
            "desc": "Complete the applicable final return and settle outstanding GST obligations."
          }
        ]
      },
      "timeline": {
        "heading": "Estimated Timeline",
        "body": "The timeline depends on the reason for cancellation, completeness of the application, pending compliance, whether officer clarification is required and departmental processing."
      },
      "fees": {
        "heading": "Government Fees & Professional Fees",
        "note": "Professional fees depend on the nature of cancellation, pending GST returns, tax/ITC reconciliation, departmental queries, final compliance requirements and revocation assistance if required."
      },
      "benefits": {
        "heading": "Benefits of Proper GST Cancellation",
        "items": [
          "Complete review of pending GST obligations before the application is filed, not just the cancellation form itself",
          "Reduced risk of future compliance issues arising from an incomplete cancellation",
          "Correct documentation matched to the specific cancellation reason",
          "Support with departmental queries during processing",
          "Final return and other post-cancellation compliance handled as part of the same engagement",
          "Revocation option evaluated where restoration of a cancelled registration is legally available"
        ]
      },
      "afterService": {
        "heading": "Important: GST Cancellation Does Not End All Liability",
        "items": [
          "Pending GST returns",
          "Tax dues and interest",
          "Penalties",
          "ITC reversal, where applicable",
          "Liability relating to stock/capital goods",
          "Final return requirements, including GSTR-10",
          "Existing notices or proceedings"
        ]
      },
      "whyUs": {
        "heading": "Why Choose Biz360 Compliance?",
        "items": [
          "Complete Compliance Review: we look beyond the cancellation application and review pending GST obligations",
          "Proper Documentation: help identify the documents required for the particular cancellation reason",
          "Portal Filing Support: application prepared and submitted through the GST Portal",
          "Query Handling: assistance with clarification where sought by the department",
          "Post-Cancellation Support: final return and other applicable compliance handled as part of the engagement"
        ]
      },
      "faqs": [
        {
          "q": "Can I cancel my GST registration voluntarily?",
          "a": "Yes, where the applicable conditions for cancellation are satisfied."
        },
        {
          "q": "Do I need to clear pending returns before cancellation?",
          "a": "Pending compliance and tax liabilities should be reviewed and appropriately dealt with, as cancellation does not automatically remove earlier obligations."
        },
        {
          "q": "Is GST cancellation immediate?",
          "a": "Not necessarily; the effective date and processing depend on the application and applicable proceedings."
        },
        {
          "q": "What is GSTR-10?",
          "a": "GSTR-10 is the final return applicable to a taxpayer whose GST registration has been cancelled or surrendered, subject to applicable provisions."
        },
        {
          "q": "Can a cancelled GST registration be restored?",
          "a": "Where the registration was cancelled by the proper officer and statutory conditions are satisfied, revocation of cancellation may be available."
        },
        {
          "q": "Can I cancel GST if I have received a notice?",
          "a": "The correct course depends on the nature of the notice and cancellation proceedings, and the notice should be reviewed before taking action."
        }
      ],
      "extra": null,
      "related": [
        "gst-amendment",
        "gst-notice-reply",
        "gst-annual-compliance"
      ]
    }
  },
  {
    "slug": "gst-annual-compliance",
    "category": "GST Services",
    "sub_category": null,
    "icon": "RefreshCw",
    "title": "GST Annual Compliance Services",
    "subtitle": "Review, Reconcile & Close Your GST Year Properly",
    "read_time": "8 min read",
    "image": "https://images.unsplash.com/photo-1519389950473-47ba0277781c?crop=entropy&cs=srgb&fm=jpg&q=80&w=1200",
    "intro": "Annual GST compliance is more than filing an annual return. Before closing the financial year, businesses should review their turnover, input tax credit, tax payments and return data to confirm that books, GST returns and tax records are consistent with each other. Biz360 Compliance helps businesses undertake this year-end review, covering turnover reconciliation, GST return reconciliation, ITC review, tax liability review, RCM review, export and SEZ transactions, GST refunds, annual return readiness and pending compliance items. The objective is to identify discrepancies before they develop into notices, additional tax liabilities or difficulties during annual return filing. This service is closely connected with, but distinct from, GSTR-9 and GSTR-9C filing, which is offered as a separate service.",
    "sections": {
      "whoNeedsIt": {
        "heading": "Who Needs Annual GST Compliance Review?",
        "items": [
          "Companies, LLPs and Partnership Firms",
          "Manufacturers, Traders and Service Providers",
          "Exporters with LUT, refund or SEZ transactions",
          "E-commerce businesses",
          "Businesses with multiple GST registrations",
          "Businesses with significant ITC or high-volume transactions"
        ]
      },
      "eligibility": {
        "heading": "What Does Annual GST Compliance Include?",
        "items": [
          "Turnover reconciliation across books, GSTR-1 and GSTR-3B",
          "ITC review covering purchase records, GSTR-2B, ITC claimed, reversals and RCM ITC",
          "Tax liability review of output tax, RCM and tax payments",
          "GST return review to identify significant differences or errors in periodic returns",
          "Export and SEZ review covering export turnover, LUT transactions, shipping/export data, refund claims and SEZ supplies",
          "Annual return readiness review of records required for GSTR-9 and GSTR-9C, where applicable"
        ]
      },
      "documents": {
        "heading": "Documents Generally Required",
        "groups": [
          {
            "title": "Depending on the Scope of Review",
            "items": [
              "Financial statements and trial balance",
              "Sales register and purchase register",
              "GSTR-1, GSTR-3B and GSTR-2B",
              "ITC workings and RCM workings",
              "E-invoice data and e-way bill data",
              "Export documents and refund details",
              "Previous GST reconciliation records"
            ]
          }
        ]
      },
      "process": {
        "heading": "Annual GST Compliance Process",
        "steps": [
          {
            "title": "Data Collection",
            "desc": "Collect financial statements, GST returns, ledgers and relevant GST records."
          },
          {
            "title": "Reconciliation",
            "desc": "Reconcile turnover, ITC and tax liability with GST portal data."
          },
          {
            "title": "Difference Analysis",
            "desc": "Identify material differences and determine their reasons."
          },
          {
            "title": "Compliance Review",
            "desc": "Review pending liabilities, ITC issues, RCM, exports, refunds and other relevant matters."
          },
          {
            "title": "Corrective Action",
            "desc": "Where required, identify appropriate corrective measures under the applicable GST provisions."
          },
          {
            "title": "Annual Return Preparation",
            "desc": "Prepare the business for GSTR-9 and GSTR-9C, where applicable."
          },
          {
            "title": "Final Compliance Review",
            "desc": "Provide a year-end GST compliance summary and identify outstanding matters requiring attention."
          }
        ]
      },
      "timeline": {
        "heading": "Estimated Timeline",
        "body": "Annual GST compliance should ideally begin before the annual return filing deadline, particularly for businesses with large transaction volumes or multiple GST registrations. The statutory annual return framework generally provides a due date of 31 December following the end of the financial year, subject to exemptions and extensions."
      },
      "fees": {
        "heading": "Professional Fees",
        "note": "Fees depend on annual turnover, number of GSTINs, transaction volume, reconciliation complexity, export/SEZ transactions, ITC complexity, GSTR-9/GSTR-9C requirements and the overall scope of review."
      },
      "benefits": {
        "heading": "Why Annual GST Review Matters",
        "items": [
          "Helps identify turnover mismatch between books and GST returns",
          "Flags excess or ineligible ITC before it becomes a bigger issue",
          "Surfaces unreported RCM liability",
          "Highlights differences between GSTR-1 and GSTR-3B",
          "Identifies export data differences",
          "Catches incorrect tax classification",
          "Addresses previous-year/current-year timing differences before annual filing"
        ]
      },
      "afterService": null,
      "whyUs": {
        "heading": "Why Choose Biz360 Compliance?",
        "items": [
          "Year-end compliance review that looks at the overall GST position, not just another return",
          "Accounting and GST reconciliation that connects financial records with GST portal data",
          "ITC-focused review against available records and applicable GST requirements",
          "Export support that integrates annual GST review with LUT, refund and Export GST Compliance requirements",
          "Preparation support for GSTR-9/GSTR-9C where applicable"
        ]
      },
      "faqs": [
        {
          "q": "What is GST Annual Compliance?",
          "a": "It is a year-end review of GST returns, books, ITC, tax liability and other relevant GST records to identify and address discrepancies."
        },
        {
          "q": "Is GST Annual Compliance the same as GSTR-9?",
          "a": "No. GSTR-9 is an annual return. Annual GST compliance is broader and can include reconciliation and year-end review before filing the annual return."
        },
        {
          "q": "Who should undertake an annual GST review?",
          "a": "It is particularly useful for businesses with significant turnover, ITC, exports, multiple GST registrations or complex transactions."
        },
        {
          "q": "Do exporters need an annual GST review?",
          "a": "It can be particularly useful for exporters because LUT, export invoices, GST returns, ITC and refund claims need to remain consistent."
        },
        {
          "q": "Does the annual review include ITC reconciliation?",
          "a": "Yes, ITC reconciliation can form an important part of the annual GST review."
        },
        {
          "q": "Is GSTR-9C included in annual GST compliance?",
          "a": "It can be included where applicable. Detailed GSTR-9/GSTR-9C preparation can also be engaged as a separate service."
        }
      ],
      "extra": null,
      "related": [
        "gstr-9-gstr-9c-filing",
        "gst-return-filing",
        "gst-advisory"
      ]
    }
  },
  {
    "slug": "gst-advisory",
    "category": "GST Services",
    "sub_category": null,
    "icon": "MessageSquare",
    "title": "GST Advisory Services",
    "subtitle": "Practical GST Guidance for Business Decisions & Complex Transactions",
    "read_time": "8 min read",
    "image": "https://images.unsplash.com/photo-1519389950473-47ba0277781c?crop=entropy&cs=srgb&fm=jpg&q=80&w=1200",
    "intro": "GST implications can vary depending on the nature of a transaction, business structure, supply, place of supply and applicable provisions, and GST decisions can have a direct impact on pricing, working capital, input tax credit and compliance risk. Biz360 Compliance provides practical GST advisory support for businesses dealing with complex transactions, tax positions, ITC, exports, registrations and ongoing compliance matters, helping them understand the applicable GST treatment before implementing a transaction or business decision. Coverage spans GST applicability and taxability, HSN/SAC classification and rate, input tax credit, reverse charge mechanism, place of supply, export and zero-rated supplies, business restructuring and GST registration. Advisory can be provided for a single transaction or on an ongoing basis.",
    "sections": {
      "whoNeedsIt": {
        "heading": "Who Can Benefit from GST Advisory?",
        "items": [
          "Startups and MSMEs",
          "Companies, LLPs and Partnership Firms",
          "Manufacturers, Traders and Service Providers",
          "E-commerce businesses",
          "Exporters and Importers",
          "Businesses operating across multiple States",
          "Businesses facing a transaction that does not fit a straightforward routine GST treatment"
        ]
      },
      "eligibility": {
        "heading": "Areas We Cover",
        "items": [
          "GST applicability and taxability, including whether a transaction is taxable, exempt or zero-rated",
          "Classification and GST rate, including applicable HSN/SAC classification",
          "Input tax credit, including eligibility, restrictions, reversal requirements and GSTR-2B reconciliation",
          "Reverse charge mechanism applicability and related compliance requirements",
          "Place of supply issues for inter-State transactions, services, exports, imports and multiple-State operations",
          "Export and zero-rated supplies, including LUT, export documentation and export refunds",
          "Business restructuring, including business transfer, merger, sale of business and change in constitution",
          "GST registration, including applicability, additional registrations, amendments and cancellation"
        ]
      },
      "documents": {
        "heading": "Documents Generally Required",
        "groups": [
          {
            "title": "Depending on the Matter",
            "items": [
              "Transaction details",
              "Agreements and contracts",
              "Purchase orders and invoices",
              "GST registration details",
              "Relevant GST returns and accounting records",
              "Product/service description and HSN/SAC details",
              "Import/export documents",
              "Previous GST correspondence"
            ]
          }
        ]
      },
      "process": {
        "heading": "Our GST Advisory Process",
        "steps": [
          {
            "title": "Understand the Transaction",
            "desc": "We understand the proposed or existing transaction and relevant commercial background."
          },
          {
            "title": "Review Documents",
            "desc": "Where necessary, we examine agreements, invoices, purchase orders and other supporting documents."
          },
          {
            "title": "Identify GST Implications",
            "desc": "Review applicable GST provisions, notifications, circulars and relevant interpretations."
          },
          {
            "title": "Evaluate Alternatives",
            "desc": "Where more than one approach is possible, we explain the practical implications and compliance risks."
          },
          {
            "title": "Provide Practical Advice",
            "desc": "The conclusion is provided in a clear, business-oriented manner with recommended compliance action."
          },
          {
            "title": "Implementation Support",
            "desc": "Where required, the advisory can be connected with GST registration, invoicing, returns, refund or other compliance services."
          }
        ]
      },
      "timeline": {
        "heading": "Estimated Timeline",
        "body": "GST advice should ideally be sought before implementing a significant or unusual transaction, particularly where the GST treatment is uncertain. Turnaround depends on the complexity of the transaction and the documentation involved."
      },
      "fees": {
        "heading": "Professional Fees",
        "note": "GST advisory fees depend upon the complexity of the transaction, the number of issues involved, documentation to be reviewed, research required and whether a written opinion or ongoing advisory support is required."
      },
      "benefits": {
        "heading": "Benefits of GST Advisory",
        "items": [
          "Clarifies the applicable GST rate and taxability before a transaction is implemented",
          "Assesses ITC availability upfront",
          "Determines whether RCM applies and the related compliance requirement",
          "Clarifies which State should charge GST for inter-State or multi-State transactions",
          "Confirms whether LUT or zero-rating applies for export transactions",
          "Guides correct invoicing and GST return reporting",
          "Reduces compliance risk by addressing GST implications before implementation"
        ]
      },
      "afterService": null,
      "whyUs": {
        "heading": "Why Choose Biz360 Compliance?",
        "items": [
          "Practical advice focused on how GST provisions apply to the actual business transaction",
          "Business-oriented approach that considers both tax compliance and practical implementation",
          "Documentation-based analysis grounded in contracts, invoices and supporting records rather than assumptions",
          "Integrated GST support connecting advisory with registration, return, refund, LUT and notice-related requirements",
          "Ongoing support for both individual transactions and recurring advisory requirements"
        ]
      },
      "faqs": [
        {
          "q": "What is GST advisory?",
          "a": "GST advisory involves professional guidance on the GST implications of a business transaction, structure or compliance issue."
        },
        {
          "q": "When should I seek GST advice?",
          "a": "Ideally, before implementing a significant or unusual transaction, particularly where the GST treatment is uncertain."
        },
        {
          "q": "Can you advise on GST rates?",
          "a": "Yes. We can assist with HSN/SAC classification and applicable GST rate based on the facts and relevant provisions."
        },
        {
          "q": "Can you advise on ITC eligibility?",
          "a": "Yes. ITC eligibility, restrictions and reversal requirements can be reviewed based on the nature of the transaction."
        },
        {
          "q": "Can you advise on export transactions?",
          "a": "Yes. Export GST advisory can cover LUT, zero-rated supplies, export of services, refunds and related compliance."
        },
        {
          "q": "Can advisory be combined with GST compliance?",
          "a": "Yes. Advisory can be integrated with GST registration, return filing, reconciliation, refunds, LUT and notice support."
        }
      ],
      "extra": null,
      "related": [
        "gst-registration",
        "gst-annual-compliance",
        "gst-refund"
      ]
    }
  },
  {
    "slug": "income-tax-return-filing",
    "category": "Income Tax",
    "sub_category": "Returns & Compliance",
    "icon": "FileCheck",
    "title": "Income Tax Return Filing Services",
    "subtitle": "Professional ITR preparation and filing for individuals, professionals, businesses, HUFs and other taxpayers.",
    "read_time": "8 min read",
    "image": "https://images.unsplash.com/photo-1554224154-22dec7ec8818?crop=entropy&cs=srgb&fm=jpg&q=80&w=1200",
    "intro": "Filing an Income Tax Return is more than entering figures into an online form. The correct return depends on the nature and source of income, taxpayer status, business activity, investments and applicable tax provisions. Biz360 Compliance assists taxpayers in preparing and filing their returns after reviewing relevant financial and tax information, including AIS, TIS, Form 26AS, TDS certificates and other supporting records. Our objective is to ensure that income is properly reported, eligible claims are considered and avoidable discrepancies are identified before filing. Whether you are a salaried individual, a business owner, a professional, an investor or an NRI, we help you determine the applicable return, compute your tax liability accurately and file on time, while flagging issues such as income mismatches or incorrect TDS credit before they become notices.",
    "sections": {
      "whoNeedsIt": {
        "heading": "Who Should File an Income Tax Return?",
        "items": [
          "Salaried individuals",
          "Business owners",
          "Professionals and freelancers",
          "Proprietors, partners and directors",
          "Investors and individuals with capital gains",
          "Individuals having rental income",
          "NRIs and HUFs",
          "Partnership firms, LLPs, companies, trusts and other eligible entities"
        ]
      },
      "eligibility": {
        "heading": "Types of ITR We Handle",
        "items": [
          "ITR-1 — eligible resident individuals with specified income",
          "ITR-2 — individuals/HUFs without business or professional income",
          "ITR-3 — individuals/HUFs having business or professional income",
          "ITR-4 — eligible taxpayers opting for presumptive taxation",
          "ITR-5 — firms, LLPs and certain other entities",
          "ITR-6 — companies not claiming exemption under specified provisions",
          "ITR-7 — trusts, institutions and other persons required to file under specified provisions"
        ]
      },
      "documents": {
        "heading": "Documents & Information Required",
        "groups": [
          {
            "title": "Depending on the nature of your income",
            "items": [
              "PAN and Aadhaar details",
              "Form 16 / salary details and Form 16A, where applicable",
              "Form 26AS and AIS / TIS",
              "Bank statements",
              "Capital gain statements",
              "Investment / deduction proofs",
              "Home loan / rent details, where applicable",
              "Business financial statements, previous ITR and foreign asset/income details, where applicable"
            ]
          }
        ]
      },
      "process": {
        "heading": "Our ITR Filing Process",
        "steps": [
          {
            "title": "Share Your Information",
            "desc": "Submit your basic details and relevant financial documents."
          },
          {
            "title": "Tax Data Review",
            "desc": "We review available information including AIS, TIS, Form 26AS and TDS details."
          },
          {
            "title": "Income & Tax Computation",
            "desc": "Income, deductions, applicable tax provisions and tax liability are evaluated."
          },
          {
            "title": "Return Preparation",
            "desc": "The appropriate ITR is prepared based on your taxpayer profile."
          },
          {
            "title": "Review & Confirmation",
            "desc": "You receive the computation / return details for confirmation wherever required."
          },
          {
            "title": "E-Filing & Verification",
            "desc": "The return is submitted electronically and the required verification process is completed."
          }
        ]
      },
      "timeline": {
        "heading": "Filing Timeline",
        "body": "The due date depends on the taxpayer and whether tax audit or other specified requirements apply. For AY 2026-27, the current guidance distinguishes between non-audit and audit cases, with 31 July 2026 generally applying to relevant non-audit cases and 31 August 2026 applying to specified cases such as eligible ITR-4 cases; applicable deadlines should always be checked for the particular taxpayer."
      },
      "fees": {
        "heading": "Government Fees & Professional Fees",
        "note": "There is generally no separate government filing fee for a normal timely ITR filing, though applicable tax, interest or late-filing fee may arise depending on circumstances — for example, a fee under Section 234F of ₹1,000 where total income does not exceed ₹5 lakh and ₹5,000 in other cases. Our professional fee depends on the type of ITR, number and nature of income sources, capital gains, business/professional income and complexity of tax computation."
      },
      "benefits": {
        "heading": "What We Check Before Filing",
        "items": [
          "Salary / professional income and business income",
          "Interest and other income, capital gains and house property income",
          "TDS and TCS credits",
          "AIS, TIS and Form 26AS",
          "Bank and investment information",
          "Eligible deductions and tax regime selection",
          "Advance tax / self-assessment tax",
          "Previous-year losses and relevant carry-forward information"
        ]
      },
      "afterService": {
        "heading": "Tax Regime Selection",
        "items": [
          "The choice between the applicable tax regimes can affect the overall tax liability for eligible taxpayers",
          "We help compare the available options based on your income, deductions and applicable conditions rather than simply selecting a regime by default",
          "Taxpayers having business or professional income face specific requirements when opting out of the default regime, including the prescribed Form 10-IEA process where applicable"
        ]
      },
      "whyUs": {
        "heading": "Why Choose Biz360 Compliance?",
        "items": [
          "Accurate Data Review — relevant tax information is reviewed wherever available, not just what's manually provided",
          "Appropriate ITR Selection — the return form is selected based on the taxpayer's actual income profile",
          "Tax & Compliance Perspective — our approach considers both return filing and potential compliance issues",
          "Digital Process — documents, communication and filing are handled through a streamlined digital process",
          "Support Beyond Filing — if an issue arises after filing, the matter can be taken up separately"
        ]
      },
      "faqs": [
        {
          "q": "Do I need to file an ITR if TDS has already been deducted?",
          "a": "TDS deduction does not by itself eliminate the requirement to file an ITR. The filing requirement depends on the applicable conditions and your overall income and transactions."
        },
        {
          "q": "Which ITR should I file?",
          "a": "It depends on your income sources, taxpayer status and other applicable conditions."
        },
        {
          "q": "Can you file an ITR for business income?",
          "a": "Yes. Business and professional taxpayers can be assisted with the applicable return and related computation."
        },
        {
          "q": "Can you handle capital gains?",
          "a": "Yes. Capital gains from shares, securities, mutual funds, property and other investments can be considered while preparing the return."
        },
        {
          "q": "Can you check AIS and Form 26AS before filing?",
          "a": "Yes. Reviewing AIS, TIS and Form 26AS can help identify TDS and reported-income differences before filing."
        },
        {
          "q": "Can I file a return after the due date?",
          "a": "A belated return may be filed subject to the applicable provisions, interest and late-filing consequences."
        }
      ],
      "extra": null,
      "related": [
        "advance-tax-compliance",
        "tds-compliance-filing",
        "tax-audit-support"
      ]
    }
  },
  {
    "slug": "advance-tax-compliance",
    "category": "Income Tax",
    "sub_category": "Returns & Compliance",
    "icon": "Calculator",
    "title": "Advance Tax Calculation & Compliance",
    "subtitle": "Plan your tax payments throughout the year and avoid last-minute tax liabilities.",
    "read_time": "5 min read",
    "image": "https://images.unsplash.com/photo-1554224155-8d04cb21cd6c?crop=entropy&cs=srgb&fm=jpg&q=80&w=1200",
    "intro": "Advance tax is a system of paying income tax in instalments during the year instead of paying the entire liability at the time of filing the Income Tax Return. For taxpayers with significant income and insufficient TDS/TCS, proper advance-tax planning can help manage cash flow and avoid applicable interest consequences. Biz360 Compliance helps individuals, professionals and businesses estimate their advance tax liability, factor in available TDS/TCS credits and plan timely tax payments across the year. Rather than relying on the previous year's numbers, we work from your expected current-year income so that each instalment reflects a realistic estimate, and we revisit the calculation whenever your income position changes, helping you avoid a large, unplanned liability at year end.",
    "sections": {
      "whoNeedsIt": {
        "heading": "Who May Need Advance Tax Planning?",
        "items": [
          "Business owners",
          "Professionals",
          "Proprietors",
          "Partners",
          "Investors",
          "Individuals with substantial capital gains",
          "Taxpayers having income not adequately covered by TDS",
          "Companies and LLPs"
        ]
      },
      "eligibility": {
        "heading": "Applicability of Advance Tax",
        "items": [
          "Applies where estimated tax liability after eligible TDS/TCS credits exceeds the prescribed threshold",
          "Relevant for taxpayers meeting the prescribed conditions and having sufficient net tax liability",
          "Particularly relevant where income is not adequately covered by TDS",
          "The actual applicability depends on the taxpayer's income and applicable provisions"
        ]
      },
      "documents": {
        "heading": "Documents Generally Required",
        "groups": [
          {
            "title": "Documents Generally Required",
            "items": [
              "Previous ITR",
              "Current-year income details",
              "Business/professional income estimates",
              "Investment/capital gains details",
              "TDS/TCS information",
              "Tax payment details",
              "Other relevant income information"
            ]
          }
        ]
      },
      "process": {
        "heading": "Our Process",
        "steps": [
          {
            "title": "Estimate Income",
            "desc": "Review expected business, professional, investment and other income."
          },
          {
            "title": "Calculate Tax",
            "desc": "Estimate the applicable tax liability."
          },
          {
            "title": "Adjust TDS/TCS",
            "desc": "Consider available and expected TDS/TCS credits."
          },
          {
            "title": "Plan Instalments",
            "desc": "Determine the advance-tax amount payable for the relevant instalment."
          },
          {
            "title": "Monitor & Revise",
            "desc": "Update the calculation if income changes during the year."
          }
        ]
      },
      "timeline": {
        "heading": "Estimated Timeline",
        "body": "Advance tax is paid in prescribed instalments during the financial year, based on estimated tax liability. Estimates should be reviewed each quarter and revised whenever income or tax liability changes."
      },
      "fees": {
        "heading": "Government Fees & Professional Fees",
        "note": "Fees depend on the complexity of income, number of income sources and frequency of tax calculations. Get a customised Advance Tax proposal."
      },
      "benefits": {
        "heading": "Benefits of Advance Tax Planning",
        "items": [
          "Practical Tax Estimation — calculations are based on expected income rather than simply relying on the previous year's liability",
          "TDS/TCS Reconciliation — available tax credits are considered while estimating the balance tax payable",
          "Cash-Flow Planning — tax payments can be planned throughout the year instead of facing a large year-end liability",
          "Ongoing Review — advance-tax estimates can be revised when business or investment income changes"
        ]
      },
      "afterService": null,
      "whyUs": {
        "heading": "Why Choose Biz360 Compliance?",
        "items": [
          "Practical Tax Estimation based on expected, not historical, income",
          "TDS/TCS Reconciliation built into every estimate",
          "Cash-Flow Planning across the year rather than a year-end scramble",
          "Ongoing Review of estimates as your income changes"
        ]
      },
      "faqs": [
        {
          "q": "What is advance tax?",
          "a": "Advance tax is income tax paid during the year in prescribed instalments based on estimated tax liability."
        },
        {
          "q": "Who is required to pay advance tax?",
          "a": "Taxpayers meeting the prescribed conditions and having sufficient net tax liability may be required to pay advance tax."
        },
        {
          "q": "Is advance tax applicable to business owners?",
          "a": "It can be, particularly where the estimated tax liability after eligible TDS/TCS credits exceeds the prescribed threshold."
        },
        {
          "q": "Are TDS and TCS considered while calculating advance tax?",
          "a": "Yes. Expected and available TDS/TCS credits are generally considered while estimating the balance tax payable."
        },
        {
          "q": "Can advance tax be recalculated during the year?",
          "a": "Yes. The estimate can be revised when income or tax liability changes."
        },
        {
          "q": "What happens if advance tax is paid late or is insufficient?",
          "a": "Interest may arise under the applicable provisions depending on the nature and extent of the shortfall."
        }
      ],
      "extra": null,
      "related": [
        "income-tax-return-filing",
        "tds-compliance-filing",
        "income-tax-planning-advisory"
      ]
    }
  },
  {
    "slug": "tds-compliance-filing",
    "category": "Income Tax",
    "sub_category": "Returns & Compliance",
    "icon": "Receipt",
    "title": "TDS Compliance & Return Filing Services",
    "subtitle": "Accurate TDS deduction, payment, returns and certificates for businesses and employers.",
    "read_time": "7 min read",
    "image": "https://images.unsplash.com/photo-1518186285589-2f7649de83e0?crop=entropy&cs=srgb&fm=jpg&q=80&w=1200",
    "intro": "Tax Deducted at Source (TDS) is an important part of the tax compliance framework for businesses making specified payments. Incorrect deduction, delayed payment or inaccurate reporting can result in interest, fees, notices and reconciliation issues for both deductors and deductees. Biz360 Compliance provides end-to-end TDS support, helping businesses manage their obligations from deduction and challan payment through to quarterly statements, certificates, corrections and reconciliation. We review applicability, calculate and deduct TDS on applicable payments including salary and specified non-salary payments, support timely challan payment, prepare and file the relevant quarterly statements, and help reconcile books, challans, statements and certificates so that deductees do not face missing or incorrect TDS credit.",
    "sections": {
      "whoNeedsIt": {
        "heading": "Who Needs TDS Compliance?",
        "items": [
          "Companies",
          "LLPs",
          "Partnership firms",
          "Proprietorships",
          "Employers",
          "Professionals",
          "Trusts and institutions",
          "Government / specified entities and other persons making specified payments"
        ]
      },
      "eligibility": {
        "heading": "Common Payments Requiring TDS Review",
        "items": [
          "Salary",
          "Contractor payments",
          "Professional / technical fees",
          "Commission or brokerage",
          "Rent",
          "Interest",
          "Certain payments to non-residents and certain property-related transactions",
          "Applicability depends on the nature of payment, payer, recipient, threshold and other prescribed conditions"
        ]
      },
      "documents": {
        "heading": "Documents & Information Required",
        "groups": [
          {
            "title": "Depending on the scope",
            "items": [
              "TAN details",
              "PAN details",
              "Vendor / employee master",
              "Payment details and salary records",
              "Invoices and ledger extracts",
              "TDS workings and challan details",
              "Previous TDS returns",
              "Form 16 / 16A requirements and lower/nil deduction certificates, where applicable"
            ]
          }
        ]
      },
      "process": {
        "heading": "Our TDS Compliance Process",
        "steps": [
          {
            "title": "Review",
            "desc": "We understand your business, payment structure and existing TDS setup."
          },
          {
            "title": "Identify",
            "desc": "Applicable TDS provisions, thresholds and rates are reviewed."
          },
          {
            "title": "Calculate & Deduct",
            "desc": "TDS is computed based on the applicable provisions and transaction details."
          },
          {
            "title": "Pay",
            "desc": "Applicable TDS is deposited within the prescribed timeline."
          },
          {
            "title": "File",
            "desc": "The relevant quarterly statement is prepared and filed."
          },
          {
            "title": "Reconcile",
            "desc": "Reported TDS and challan information is reviewed to minimise downstream mismatches."
          }
        ]
      },
      "timeline": {
        "heading": "TDS Compliance Timeline",
        "body": "TDS compliance involves multiple recurring deadlines, including deduction at the time prescribed under law, deposit within the applicable timeline, quarterly statement filing, TDS certificate issuance and correction/reconciliation wherever required. Under the current rules, the general TDS deposit timeline continues to be the 7th of the following month, with specific exceptions including March deductions."
      },
      "fees": {
        "heading": "Government Fees & Professional Fees",
        "note": "TDS professional fees depend on the number of deductees, number of transactions, monthly transaction volume, number of TANs, salary and non-salary compliance, quarterly return complexity and reconciliation/correction requirements."
      },
      "benefits": {
        "heading": "Our TDS Services",
        "items": [
          "Advance TDS applicability review to identify relevant provisions, threshold and applicable rate",
          "TDS calculation and deduction on applicable payments, including salary and specified non-salary payments",
          "TDS payment and challan support, including the current ITNS 281N/281 challan framework",
          "Preparation and filing of applicable quarterly TDS statements",
          "Form 16 and Form 16A certificate assistance",
          "TDS correction statements where errors occur in PAN, amount, challan or deductee details",
          "Reconciliation across books, TDS challans, TDS statements, Form 16/16A and taxpayer records"
        ]
      },
      "afterService": {
        "heading": "Quarterly TDS Statements & Forms",
        "items": [
          "For Tax Year 2026-27 onwards, ITNS 281N is used for TDS/TCS payments under the Income-tax Act, 2025, while ITNS 281 continues for payments under the earlier Act",
          "Form 138 — salary TDS statements, corresponding broadly to the earlier Form 24Q",
          "Form 140 — non-salary resident payments, corresponding broadly to the earlier Form 26Q",
          "Other prescribed forms depending on the nature of payment and deductee",
          "Quarterly due dates are currently prescribed as 31 July, 31 October, 31 January and 31 May for Forms 138 and 140"
        ]
      },
      "whyUs": {
        "heading": "Why Choose Biz360 Compliance?",
        "items": [
          "End-to-End Support — from applicability and deduction to filing, certificates and corrections",
          "Reconciliation-Focused — TDS data should also reconcile with books and recipient records",
          "Practical Compliance — our approach considers how TDS requirements fit into your actual accounting and payment processes",
          "Ongoing Support — suitable for businesses requiring recurring monthly and quarterly TDS management"
        ]
      },
      "faqs": [
        {
          "q": "What is TDS?",
          "a": "TDS is a mechanism through which tax is deducted at source from specified payments and deposited with the Government on behalf of the recipient."
        },
        {
          "q": "Does every business need to deduct TDS?",
          "a": "No. TDS applicability depends on the nature of payment, payer, recipient, threshold and other conditions."
        },
        {
          "q": "Is TAN mandatory for TDS?",
          "a": "Persons required to deduct TDS generally need a Tax Deduction and Collection Account Number (TAN), subject to specific provisions."
        },
        {
          "q": "Do you file quarterly TDS returns?",
          "a": "Yes. Applicable quarterly TDS statements can be prepared and filed."
        },
        {
          "q": "What if TDS credit is not appearing for the recipient?",
          "a": "The underlying deduction, challan and statement data should be reconciled to identify the reason for the mismatch."
        },
        {
          "q": "Can you help with TDS notices or defaults?",
          "a": "Yes. TDS Notice & Default Resolution can be taken up as a separate compliance/advisory assignment."
        }
      ],
      "extra": null,
      "related": [
        "advance-tax-compliance",
        "tax-audit-support",
        "form-15ca-15cb-support"
      ]
    }
  },
  {
    "slug": "tax-audit-support",
    "category": "Income Tax",
    "sub_category": "Returns & Compliance",
    "icon": "FileSearch",
    "title": "Tax Audit Support Services",
    "subtitle": "Complete assistance for tax audit preparation, reconciliation and compliance for businesses and professionals.",
    "read_time": "7 min read",
    "image": "https://images.unsplash.com/photo-1554224155-6726b3ff858f?crop=entropy&cs=srgb&fm=jpg&q=80&w=1200",
    "intro": "A tax audit involves detailed review of financial and tax information where the applicable provisions require an audit of accounts. Tax audit requires accurate financial data, tax reconciliations and proper documentation before the prescribed audit report is finalised. Biz360 Compliance supports businesses and professionals throughout the pre-audit preparation and compliance process, helping organise the information required by the appointed Chartered Accountant. Our role covers applicability assessment, financial data preparation, turnover reconciliation across books, GST returns and income tax records, GST and TDS reconciliation, audit schedules and workings, supporting documentation, query coordination and filing coordination. The statutory tax audit itself and signing of the prescribed audit report are undertaken by the eligible Chartered Accountant appointed for the audit.",
    "sections": {
      "whoNeedsIt": {
        "heading": "Who Can Benefit?",
        "items": [
          "Proprietorship businesses",
          "Partnership firms",
          "LLPs",
          "Companies",
          "Professionals and consultants",
          "Doctors and architects",
          "Other eligible professionals",
          "Businesses approaching the prescribed turnover limits"
        ]
      },
      "eligibility": {
        "heading": "Tax Audit Applicability Assessment",
        "items": [
          "We review your business/professional activity, turnover and relevant conditions to help determine whether tax audit requirements may apply",
          "Whether tax audit is applicable depends on the nature of activity, turnover/gross receipts, cash transactions, presumptive taxation and other applicable conditions",
          "For FY 2025-26 / AY 2026-27, the existing tax-audit framework using Forms 3CA/3CB and Form 3CD continues to apply",
          "For Tax Year 2026-27 onwards, the new Income-tax Act, 2025 introduces Form No. 26 as the consolidated tax-audit report framework"
        ]
      },
      "documents": {
        "heading": "Documents Generally Required",
        "groups": [
          {
            "title": "Depending on the business",
            "items": [
              "Trial Balance, Profit & Loss Account and Balance Sheet",
              "General Ledger, Sales Register and Purchase Register",
              "Expense Ledgers and Fixed Asset Register",
              "Bank Statements",
              "GST Returns and TDS Returns, along with TDS reconciliation",
              "Details of loans and advances, and details of related parties",
              "Previous tax audit report",
              "Other information required by the appointed CA"
            ]
          }
        ]
      },
      "process": {
        "heading": "Tax Audit Support Process",
        "steps": [
          {
            "title": "Applicability Review",
            "desc": "Understand your business/profession and assess the applicable tax-audit requirements."
          },
          {
            "title": "Data Collection",
            "desc": "Collect accounting, GST, TDS and other relevant information."
          },
          {
            "title": "Reconciliation",
            "desc": "Identify differences between books and tax records."
          },
          {
            "title": "Compliance Review",
            "desc": "Review key areas relevant to tax-audit reporting."
          },
          {
            "title": "Audit Data Preparation",
            "desc": "Prepare the schedules, workings and supporting information required for the appointed CA."
          },
          {
            "title": "CA Review & Audit",
            "desc": "The appointed Chartered Accountant performs the statutory tax audit and finalises the prescribed report."
          },
          {
            "title": "Filing Coordination",
            "desc": "Assist with electronic filing and related Income Tax Return compliance."
          }
        ]
      },
      "timeline": {
        "heading": "Timeline",
        "body": "Tax audit preparation should ideally begin well before the statutory filing deadline. Early preparation provides sufficient time for data collection, reconciliation, identification of discrepancies, CA review, and finalisation and filing."
      },
      "fees": {
        "heading": "Government Fees & Professional Fees",
        "note": "Professional fees depend on turnover / gross receipts, nature of business, transaction volume, accounting system, number of GSTINs, GST/TDS complexity, reconciliation requirements and scope of support."
      },
      "benefits": {
        "heading": "Benefits of Tax Audit Support",
        "items": [
          "Pre-Audit Preparation — we help organise the financial and tax information before the CA begins the audit",
          "Integrated Reconciliation — GST, TDS and accounting data can be reviewed together",
          "Better Documentation — relevant schedules and supporting records are organised systematically",
          "CA Coordination — we coordinate with the appointed CA to facilitate a smoother audit process",
          "Year-End Compliance Support — tax audit preparation can be integrated with Income Tax Return, GST Annual Compliance and TDS compliance"
        ]
      },
      "afterService": {
        "heading": "Turnover, GST & TDS Reconciliation",
        "items": [
          "Turnover reconciliation across Books, GST Returns and Income Tax Records to identify differences before the tax audit process",
          "GST reconciliation across GSTR-1, GSTR-3B, GST annual records, books turnover and export/SEZ turnover",
          "TDS reconciliation covering TDS deducted, deposited, returns filed, TDS-related expenses and outstanding TDS liabilities",
          "A connected review flow of Accounting, TDS, GST, Tax Audit and ITR"
        ]
      },
      "whyUs": {
        "heading": "Why Choose Biz360 Compliance?",
        "items": [
          "Pre-Audit Preparation — we help organise the financial and tax information before the CA begins the audit",
          "Integrated Reconciliation — GST, TDS and accounting data can be reviewed together",
          "Better Documentation of relevant schedules and supporting records",
          "CA Coordination to facilitate a smoother audit process",
          "Year-End Compliance Support integrated with ITR, GST Annual Compliance and TDS compliance"
        ]
      },
      "faqs": [
        {
          "q": "What is Tax Audit Support?",
          "a": "It is assistance with preparing financial, accounting and tax information required for the tax audit process."
        },
        {
          "q": "Does Biz360 conduct the statutory tax audit?",
          "a": "Biz360 provides tax audit preparation and compliance support. The statutory tax audit and prescribed audit report are undertaken by the eligible Chartered Accountant appointed for the audit."
        },
        {
          "q": "Can you check whether tax audit is applicable?",
          "a": "Yes. We can review the relevant turnover, nature of activity and other applicable conditions."
        },
        {
          "q": "Do you prepare the information required for Form 3CD?",
          "a": "Yes. We can assist in compiling and reconciling the information required for the appointed CA's review and reporting."
        },
        {
          "q": "Can GST and TDS be reconciled as part of the service?",
          "a": "Yes. GST and TDS reconciliation can be included depending on the scope of engagement."
        },
        {
          "q": "Is tax audit the same as statutory audit?",
          "a": "No. Tax audit and statutory audit are separate compliance requirements under different laws."
        }
      ],
      "extra": null,
      "related": [
        "income-tax-return-filing",
        "tds-compliance-filing",
        "income-tax-planning-advisory"
      ]
    }
  },
  {
    "slug": "income-tax-planning-advisory",
    "category": "Income Tax",
    "sub_category": "Tax Planning & Advisory",
    "icon": "TrendingUp",
    "title": "Income Tax Planning & Advisory",
    "subtitle": "Plan your taxes and make better financial decisions with practical, forward-looking tax advisory.",
    "read_time": "8 min read",
    "image": "https://images.unsplash.com/photo-1518186285589-2f7649de83e0?crop=entropy&cs=srgb&fm=jpg&q=80&w=1200",
    "intro": "Effective tax planning is not simply about finding deductions — it involves understanding the applicable tax provisions and structuring legitimate financial and business decisions in a tax-efficient and compliant manner. Biz360 Compliance provides practical tax planning support based on your income profile, business structure, investments and future financial plans, whether you are a salaried individual, professional, business owner or growing enterprise. Our approach is focused strictly on legal tax planning rather than aggressive tax avoidance or unsupported claims, so every recommendation stays within the applicable legal framework. We help you understand the tax impact of your income, investments, business decisions and financial transactions before they happen, so you can plan ahead with greater clarity.",
    "sections": {
      "whoNeedsIt": {
        "heading": "Who Needs Tax Planning Advice?",
        "items": [
          "Business owners and entrepreneurs",
          "Professionals and directors",
          "Partners and investors",
          "Individuals with multiple income sources",
          "HUFs, companies and LLPs",
          "Startups and growing businesses",
          "Anyone facing a major financial, investment or business decision"
        ]
      },
      "eligibility": {
        "heading": "When Should You Consider Tax Planning?",
        "items": [
          "Starting a new business",
          "Changing your business structure",
          "Selling property or investments",
          "Making substantial investments",
          "Receiving significant income",
          "Planning business expansion or expecting a major capital gain",
          "Reviewing your applicable tax regime",
          "Planning remuneration, profit distribution or other significant financial transactions"
        ]
      },
      "documents": {
        "heading": "Documents & Information Generally Required",
        "groups": [
          {
            "title": "Depending on the Assignment",
            "items": [
              "Previous Income Tax Returns",
              "Income details and financial statements",
              "Investment statements and capital gains details",
              "Property transaction details",
              "Loan information",
              "Business structure details",
              "Proposed transaction details",
              "TDS/TCS information and other relevant financial documents"
            ]
          }
        ]
      },
      "process": {
        "heading": "Our Tax Planning Process",
        "steps": [
          {
            "title": "Understand Your Financial Position",
            "desc": "We review your income, investments, business structure and relevant financial information."
          },
          {
            "title": "Identify Tax Implications",
            "desc": "Potential tax liabilities, applicable provisions and compliance requirements are evaluated."
          },
          {
            "title": "Compare Available Options",
            "desc": "Where legitimate alternatives exist, we compare their tax and practical implications."
          },
          {
            "title": "Recommend an Approach",
            "desc": "We provide practical recommendations based on your specific circumstances."
          },
          {
            "title": "Implementation Support",
            "desc": "Where required, we assist with related return filing, tax computation, documentation and compliance."
          }
        ]
      },
      "timeline": {
        "heading": "Estimated Timeline",
        "body": "Timelines vary with the complexity of the assignment, since tax planning is most effective when it is completed before the transaction or financial year-end rather than after the tax liability has already arisen."
      },
      "fees": {
        "heading": "Government Fees & Professional Fees",
        "note": "Professional fees depend on the complexity of the assignment, number of income sources, nature of transactions, business structure, capital gains or investment issues, and whether detailed written advisory is required."
      },
      "benefits": {
        "heading": "Benefits of Income Tax Planning",
        "items": [
          "Practical advice based on actual financial and business circumstances rather than generic formulas",
          "Focus on legitimate, compliance-focused tax planning within the applicable legal framework",
          "Forward-looking guidance available before a transaction or decision is implemented",
          "Ability to compare available tax regimes based on real income and circumstances",
          "Support for advance-tax estimation to reduce unexpected tax outflows and interest exposure",
          "Integration with ITR filing, accounting, GST, TDS and other business compliance requirements"
        ]
      },
      "afterService": null,
      "whyUs": {
        "heading": "Why Choose Biz360 Compliance?",
        "items": [
          "Practical, Not Formula-Based — tax planning is based on your actual financial and business circumstances",
          "Compliance-Focused — we focus on legitimate tax planning within the applicable legal framework",
          "Forward-Looking — advice can be provided before a transaction or financial decision is implemented",
          "Integrated Support — tax planning can be connected with ITR filing, accounting, GST, TDS and business compliance requirements"
        ]
      },
      "faqs": [
        {
          "q": "What is income tax planning?",
          "a": "Income tax planning involves arranging legitimate financial and business decisions in a tax-efficient manner while complying with applicable law."
        },
        {
          "q": "Is tax planning the same as tax avoidance?",
          "a": "No. Tax planning uses legally available provisions. Aggressive or unlawful tax avoidance is not the objective."
        },
        {
          "q": "Can you compare the old and new tax regimes?",
          "a": "Yes. The applicable regimes can be compared based on your income, deductions and individual circumstances."
        },
        {
          "q": "Should tax planning be done before making an investment?",
          "a": "Ideally, yes. Understanding the tax consequences before investing or selling an asset can help avoid unexpected tax liabilities."
        },
        {
          "q": "Can you help with capital gains planning?",
          "a": "Yes. The tax implications of proposed sales or transfers of eligible capital assets can be evaluated."
        },
        {
          "q": "Can tax planning reduce my tax liability?",
          "a": "Legitimate tax planning may help optimise tax liability where applicable provisions and alternatives are available; the outcome depends on individual facts."
        }
      ],
      "extra": null,
      "related": [
        "capital-gains-tax-advisory",
        "nri-taxation-compliance",
        "advance-tax-compliance"
      ]
    }
  },
  {
    "slug": "capital-gains-tax-advisory",
    "category": "Income Tax",
    "sub_category": "Tax Planning & Advisory",
    "icon": "Calculator",
    "title": "Capital Gains Tax Advisory & Compliance",
    "subtitle": "Understand your tax liability before you sell, transfer or reinvest in property, shares or other capital assets.",
    "read_time": "9 min read",
    "image": "https://images.unsplash.com/photo-1554224155-8d04cb21cd6c?crop=entropy&cs=srgb&fm=jpg&q=80&w=1200",
    "intro": "Selling an investment or asset can carry tax consequences well beyond the sale price. The tax treatment depends on the nature of the asset, the period of holding, the date and manner of transfer, the cost and improvements incurred, related expenses, and any applicable exemptions or special provisions. Biz360 Compliance provides practical support for capital gains arising from the sale of residential, commercial and land assets, as well as shares, securities, mutual funds and eligible business assets. Our approach covers computation, tax planning, return reporting and related compliance, with particular attention to reviewing sale consideration, cost, eligible expenses, holding period, applicable tax treatment and available exemptions or reliefs. Because transactions can span the transition between the earlier Income-tax Act, 1961 and the Income-tax Act, 2025, we also help you consider the date of transfer and the tax year to which a transaction relates before you complete the sale.",
    "sections": {
      "whoNeedsIt": {
        "heading": "Who Needs Capital Gains Advisory?",
        "items": [
          "Individuals selling residential, commercial or land property",
          "Investors selling shares or securities",
          "Investors redeeming substantial mutual fund holdings",
          "Individuals selling an inherited asset",
          "Businesses transferring eligible business assets",
          "Anyone restructuring or planning reinvestment of investments",
          "Anyone expecting a significant capital gain"
        ]
      },
      "eligibility": {
        "heading": "When Should You Take Capital Gains Advice?",
        "items": [
          "Before selling a property",
          "Before selling shares or securities",
          "Before redeeming substantial investments",
          "When selling an inherited asset",
          "When transferring business assets",
          "When restructuring investments or planning reinvestment",
          "When expecting a significant capital gain"
        ]
      },
      "documents": {
        "heading": "Documents Generally Required",
        "groups": [
          {
            "title": "Depending on the Asset",
            "items": [
              "Purchase agreement / sale deed and purchase invoice",
              "Sale agreement / sale deed",
              "Cost of improvement records and stamp duty details",
              "Brokerage / transfer expenses",
              "Demat / investment statements and mutual fund statements",
              "Share transaction statements",
              "Previous ownership documents and details of inherited assets",
              "Reinvestment documents, where applicable"
            ]
          }
        ]
      },
      "process": {
        "heading": "Our Capital Gains Process",
        "steps": [
          {
            "title": "Understand the Transaction",
            "desc": "We review the asset, purchase details, proposed sale and nature of transfer."
          },
          {
            "title": "Review Cost & Holding Period",
            "desc": "Purchase cost, improvement cost, acquisition date and relevant expenses are examined."
          },
          {
            "title": "Compute Capital Gain",
            "desc": "The applicable computation is prepared based on the nature of the asset and relevant tax provisions."
          },
          {
            "title": "Review Exemptions",
            "desc": "Where applicable, available exemptions or reinvestment options are evaluated."
          },
          {
            "title": "Tax Planning",
            "desc": "For proposed transactions, alternative approaches can be considered from a tax and compliance perspective."
          },
          {
            "title": "Return Filing",
            "desc": "The final capital gain can be appropriately reported in the applicable Income Tax Return."
          }
        ]
      },
      "timeline": {
        "heading": "Estimated Timeline",
        "body": "Capital gains advice works best before a transaction is completed, allowing time to review cost, holding period and available exemptions ahead of the sale or transfer."
      },
      "fees": {
        "heading": "Government Fees & Professional Fees",
        "note": "Fees depend on the nature of the asset, transaction value, number of transactions, complexity of computation, multiple acquisition dates, reinvestment/exemption analysis and return filing requirements."
      },
      "benefits": {
        "heading": "Benefits of Capital Gains Advisory",
        "items": [
          "Transaction-specific review based on the actual asset rather than a standard calculation",
          "Planning before the sale to help identify tax implications ahead of completion",
          "Documentation-based computation using available supporting records",
          "Clarity on holding-period classification and its effect on rate, computation and exemptions",
          "Assessment of reinvestment exemptions subject to eligibility, limits and lock-in conditions",
          "Integration with ITR filing, tax planning, accounting and tax notice assistance"
        ]
      },
      "afterService": {
        "heading": "Capital Gains & Income Tax Return",
        "items": [
          "Capital gains generally need to be reported in the appropriate Income Tax Return based on the taxpayer's profile and nature of income",
          "For AY 2026-27, the ITR-2 guidance specifically covers individuals/HUFs having income from capital gains",
          "The appropriate ITR and schedules should be determined based on the taxpayer's complete income profile"
        ]
      },
      "whyUs": {
        "heading": "Why Choose Biz360 Compliance?",
        "items": [
          "Transaction-Specific Review — capital gains are assessed based on the actual asset and transaction rather than a standard calculation",
          "Planning Before the Sale — where possible, we help identify tax implications before the transaction is completed",
          "Documentation-Based Computation — cost, holding period and eligible expenses are reviewed using available supporting records",
          "Integrated Tax Support — capital gains support can be connected with ITR filing, tax planning, accounting and tax notice assistance"
        ]
      },
      "faqs": [
        {
          "q": "What is capital gains tax?",
          "a": "It is tax on profits or gains arising from the transfer of a capital asset, subject to the applicable provisions."
        },
        {
          "q": "Does selling property attract capital gains tax?",
          "a": "A gain arising from the transfer of a taxable capital asset may be subject to capital gains tax, depending on the applicable provisions and exemptions."
        },
        {
          "q": "Are shares and mutual funds covered?",
          "a": "Yes. Capital gains can arise from the transfer or redemption of applicable shares, securities and mutual fund investments."
        },
        {
          "q": "How is capital gain calculated?",
          "a": "The computation depends on the asset and applicable law and generally involves consideration, cost, eligible expenses and other prescribed adjustments."
        },
        {
          "q": "Can I reduce capital gains tax by reinvesting the money?",
          "a": "Certain exemptions may be available if the prescribed conditions are satisfied. Reinvestment should therefore be planned carefully."
        },
        {
          "q": "What if I inherited the property?",
          "a": "Inherited assets require specific consideration of the previous owner's cost and relevant dates. The computation should be reviewed based on the inheritance documents and applicable provisions."
        }
      ],
      "extra": {
        "heading": "Short-Term vs Long-Term Capital Gains",
        "body": "Capital assets may receive different tax treatment depending on the applicable holding-period rules and the nature of the asset. This classification can affect the applicable tax rate, computation methodology, availability of exemptions, set-off and carry-forward implications, and reporting requirements. For transactions governed by the earlier Income-tax Act, 1961, exemptions such as Sections 54, 54B and 54F may continue to have relevance under applicable transitional provisions, with certain conditions attached to old-Act exemptions continuing to operate after 1 April 2026."
      },
      "related": [
        "income-tax-planning-advisory",
        "nri-taxation-compliance",
        "income-tax-return-filing"
      ]
    }
  },
  {
    "slug": "nri-taxation-compliance",
    "category": "Income Tax",
    "sub_category": "Tax Planning & Advisory",
    "icon": "Globe",
    "title": "NRI Taxation & Compliance Services",
    "subtitle": "Professional Indian tax support for Indians living and earning abroad.",
    "read_time": "9 min read",
    "image": "https://images.unsplash.com/photo-1521791136064-7986c2920216?crop=entropy&cs=srgb&fm=jpg&q=80&w=1200",
    "intro": "Being an NRI does not automatically mean there is no Indian tax liability. Taxability depends on factors such as residential status, source and nature of income, location of the asset, applicable tax provisions and, where relevant, the applicable Double Taxation Avoidance Agreement. Managing Indian tax obligations from overseas can involve residential-status analysis, Indian-source income, property, investments, capital gains, TDS and Income Tax Return requirements, all of which can be difficult to track from another country. Biz360 Compliance helps NRIs and overseas Indians understand their Indian tax position and manage compliance, tax planning and reporting requirements through a practical, digitally enabled process, so the full picture of Indian tax exposure is considered together rather than piecemeal.",
    "sections": {
      "whoNeedsIt": {
        "heading": "Who Should Consider NRI Tax Support?",
        "items": [
          "Indians working overseas",
          "NRIs owning property in India",
          "NRIs receiving rental income from Indian property",
          "NRIs with Indian investments",
          "Overseas professionals",
          "NRIs selling Indian property",
          "NRIs earning interest or dividend income in India",
          "Returning Indians changing their residential status"
        ]
      },
      "eligibility": {
        "heading": "Common NRI Tax Issues We Help Assess",
        "items": [
          "Whether the individual is tax resident or non-resident",
          "Taxability of Indian income, including rental income from Indian property",
          "Sale of Indian property and resulting capital gains",
          "TDS on property transactions and interest from Indian bank accounts",
          "Foreign income and reporting requirements",
          "DTAA relief and tax credit for taxes paid overseas",
          "Repatriation-related tax considerations"
        ]
      },
      "documents": {
        "heading": "Documents Generally Required",
        "groups": [
          {
            "title": "Depending on the Assignment",
            "items": [
              "PAN and passport",
              "Travel/stay details and overseas residential information",
              "Indian bank statements and NRO/NRE account details",
              "Form 26AS and AIS/TIS",
              "TDS certificates",
              "Property documents and rental income details",
              "Capital gains and investment statements",
              "Foreign income details and details of taxes paid overseas, where relevant",
              "Previous Income Tax Returns"
            ]
          }
        ]
      },
      "process": {
        "heading": "Our NRI Tax Process",
        "steps": [
          {
            "title": "Understand Your Situation",
            "desc": "We review your country of residence, India visits, income sources and assets."
          },
          {
            "title": "Determine Residential Status",
            "desc": "Your residential status is evaluated for the relevant tax year."
          },
          {
            "title": "Review Indian Income",
            "desc": "We identify taxable income arising or received in India and other relevant reporting requirements."
          },
          {
            "title": "Review DTAA, Where Applicable",
            "desc": "Where you are resident of another country for tax purposes, the relevant treaty position can be considered."
          },
          {
            "title": "Calculate Tax & TDS",
            "desc": "Applicable tax liability, TDS and available reliefs are reviewed."
          },
          {
            "title": "File & Complete Compliance",
            "desc": "The appropriate Income Tax Return and related compliance are completed."
          }
        ]
      },
      "timeline": {
        "heading": "Estimated Timeline",
        "body": "Timelines depend on the complexity of residential-status analysis, number of income sources and whether DTAA review is required; advance planning is particularly useful before a property sale, given TDS obligations that fall on the purchaser."
      },
      "fees": {
        "heading": "Government Fees & Professional Fees",
        "note": "Fees depend on the nature and number of income sources, residential-status analysis, capital gains, property transactions, DTAA analysis, foreign income/reporting requirements and complexity of the ITR."
      },
      "benefits": {
        "heading": "Benefits of NRI Tax Support",
        "items": [
          "Clarity on residential status and its effect on Indian tax liability",
          "Assistance filing the correct ITR for salary, rental, interest, capital gains, dividend and other Indian-source income",
          "Review of property-related TDS and reinvestment/exemption considerations",
          "DTAA review to help identify potential relief from double taxation",
          "Tax planning for proposed property sales, investments, remittances and changes in residential status",
          "A fully digital process suitable for clients living outside India"
        ]
      },
      "afterService": {
        "heading": "NRI Tax & DTAA",
        "items": [
          "Where an NRI is also tax resident in another country, the relevant DTAA may need to be considered alongside Indian domestic tax provisions",
          "Treaty provisions may address taxability of specific income, applicable tax rates, relief from double taxation, foreign tax credit and residence-related issues",
          "The applicable treaty depends on the country of tax residence and the nature of income"
        ]
      },
      "whyUs": {
        "heading": "Why Choose Biz360 Compliance?",
        "items": [
          "India-Focused Tax Support — we help overseas Indians manage their Indian tax and compliance requirements remotely",
          "Complete View — residential status, income, TDS, capital gains and return filing can be considered together",
          "Transaction-Based Advice — we can review tax implications before significant transactions such as property sales or investments",
          "Digital Process — documents and communication can be managed remotely, suiting clients living outside India",
          "Connected Services — NRI taxation can be integrated with ITR filing, capital gains, TDS, tax planning and notice support"
        ]
      },
      "faqs": [
        {
          "q": "Does an NRI have to file an Indian Income Tax Return?",
          "a": "Not every NRI is required to file a return. The requirement depends on income, applicable conditions and other provisions for the relevant tax year."
        },
        {
          "q": "How is NRI residential status determined?",
          "a": "Residential status is determined primarily using the prescribed stay-in-India tests along with the specific conditions applicable to the taxpayer."
        },
        {
          "q": "Is rental income from Indian property taxable for an NRI?",
          "a": "Indian-source rental income can be taxable in India, subject to the applicable provisions."
        },
        {
          "q": "Does an NRI have to pay tax on the sale of Indian property?",
          "a": "Capital gains may arise on the transfer of Indian property, subject to applicable provisions and exemptions."
        },
        {
          "q": "Is TDS applicable when an NRI sells property?",
          "a": "Specific TDS provisions can apply to payments to non-resident sellers. The transaction should be reviewed before completion."
        },
        {
          "q": "Which ITR is applicable to an NRI?",
          "a": "It depends on the nature of income. Eligible NRIs without business/professional income may use ITR-2, while ITR-3 may apply where business or professional income is involved."
        }
      ],
      "extra": null,
      "related": [
        "income-tax-planning-advisory",
        "capital-gains-tax-advisory",
        "form-15ca-15cb-support"
      ]
    }
  },
  {
    "slug": "income-tax-notice-assessment-support",
    "category": "Income Tax",
    "sub_category": "Notices & Disputes",
    "icon": "BellRing",
    "title": "Income Tax Notice Reply & Assessment Support",
    "subtitle": "Professional review and response support for Income Tax notices, intimations and compliance communications.",
    "read_time": "8 min read",
    "image": "https://images.unsplash.com/photo-1554224155-1696413565d3?crop=entropy&cs=srgb&fm=jpg&q=80&w=1200",
    "intro": "Receiving an Income Tax notice does not necessarily mean that a tax violation has occurred or that additional tax is automatically payable. A notice may relate to a return discrepancy, an information mismatch, an outstanding tax demand, a verification requirement, a defective return, a proposed adjustment, an ongoing assessment proceeding or a request for clarification. What matters most is understanding why the notice was issued, what information the Department is asking for, and what an appropriate response looks like. Biz360 Compliance helps taxpayers review the communication, identify the underlying issue, examine the relevant records such as the filed return, computation, Form 26AS and AIS/TIS, and prepare a response through the prescribed channel, including the e-Proceedings facility on the Income Tax e-Filing portal where applicable.",
    "sections": {
      "whoNeedsIt": {
        "heading": "Who Needs This Service?",
        "items": [
          "Taxpayers who have received an Income Tax notice, intimation or other departmental communication",
          "Taxpayers with a mismatch between the filed ITR and AIS/TIS or Form 26AS",
          "Taxpayers facing a TDS or TCS mismatch notice",
          "Taxpayers whose return has been flagged as defective",
          "Taxpayers under scrutiny, assessment or reassessment/verification proceedings",
          "Taxpayers with an outstanding tax demand shown on their account",
          "Taxpayers asked to submit clarification or supporting documents"
        ]
      },
      "eligibility": {
        "heading": "Types of Notices & Communications We Handle",
        "items": [
          "Defective return notices",
          "Proposed adjustments and intimations",
          "Tax demand and adjustment matters, including refund adjusted against demand",
          "Scrutiny and assessment notices and information requests",
          "Information and clarification notices requesting supporting documents",
          "Rectification matters arising from an apparent mistake in an intimation, order or computation",
          "Reassessment or verification proceedings"
        ]
      },
      "documents": {
        "heading": "Documents Generally Required",
        "groups": [
          {
            "title": "Documents (as applicable to the notice)",
            "items": [
              "Income Tax notice or intimation",
              "Previous ITR and tax computation",
              "Form 26AS and AIS/TIS",
              "TDS certificates",
              "Bank statements and investment statements",
              "Capital gain statements",
              "Financial statements",
              "Invoices and agreements",
              "Supporting deduction documents",
              "Previous correspondence with the Department"
            ]
          }
        ]
      },
      "process": {
        "heading": "Our Notice Response Process",
        "steps": [
          {
            "title": "Notice Review",
            "desc": "We examine the notice, the communication reference, the tax year and the response requirements."
          },
          {
            "title": "Identify the Issue",
            "desc": "The underlying reason for the communication is analysed along with the information available with the taxpayer."
          },
          {
            "title": "Document Review",
            "desc": "Relevant ITRs, computation, AIS/TIS, Form 26AS, financial records and supporting documents are reviewed as required."
          },
          {
            "title": "Response Strategy",
            "desc": "We determine the appropriate response, clarification, correction or further compliance action."
          },
          {
            "title": "Prepare & Submit",
            "desc": "The response and supporting documents are prepared and submitted through the prescribed electronic or other applicable channel."
          },
          {
            "title": "Follow-Up",
            "desc": "Where required, subsequent communications or queries arising from the proceeding are reviewed and addressed."
          }
        ]
      },
      "timeline": {
        "heading": "Estimated Timeline",
        "body": "Timelines depend on the deadline specified in the notice itself and the nature of the proceeding. Because failure to respond within the prescribed time can affect a taxpayer's position, the notice should be shared for review as soon as it is received rather than closer to the response deadline."
      },
      "fees": {
        "heading": "Government Fees & Professional Fees",
        "note": "Professional fees depend on the type of notice, the tax year involved, the complexity of the issue, the amount and nature of the disputed information, the number of documents involved, and whether a detailed written submission or further proceedings/follow-up are involved."
      },
      "benefits": {
        "heading": "Benefits of Professional Notice Review",
        "items": [
          "Avoids missing the statutory response deadline stated in the notice",
          "Reduces the risk of an unfavourable outcome due to non-response",
          "Clarifies whether the notice actually indicates a tax liability or is procedural",
          "A structured, document-backed response instead of a generic reply",
          "Notice can be authenticated before any action is taken on it",
          "Guidance on whether further proceedings such as rectification, demand or appeal may follow"
        ]
      },
      "afterService": {
        "heading": "Common Reasons for Receiving a Tax Notice",
        "items": [
          "Difference between ITR and AIS/TIS information",
          "TDS or TCS mismatch",
          "Income not reported or incorrectly reported",
          "Difference between reported income and third-party information",
          "Incorrect deduction or exemption claim",
          "Capital gains mismatch",
          "High-value financial transactions",
          "Outstanding tax demand, defective return or verification of particular transactions"
        ]
      },
      "whyUs": {
        "heading": "Why Choose Biz360 Compliance?",
        "items": [
          "Notice-Specific Approach: we first understand the exact issue instead of using a standard reply for every notice",
          "Document-Based Review: the response is supported by relevant records and information wherever required",
          "Compliance & Tax Perspective: we consider the tax implications as well as the procedural requirements of the proceeding",
          "Digital Response Support: where the matter is eligible for e-Proceedings, responses are prepared for submission through the prescribed portal mechanism",
          "Further Assistance: where the matter develops into assessment, rectification, demand or appellate proceedings, appropriate professional support can be considered separately"
        ]
      },
      "faqs": [
        {
          "q": "I received an Income Tax notice. What should I do first?",
          "a": "Read the notice carefully and check the response deadline. It is advisable to have the notice professionally reviewed before submitting a response."
        },
        {
          "q": "Does receiving a notice mean that I have done something wrong?",
          "a": "No. Notices may be issued for verification, clarification, mismatch, proposed adjustment or other procedural reasons."
        },
        {
          "q": "Can I respond to the notice online?",
          "a": "Many notices and communications can be responded to through the e-Proceedings facility on the Income Tax e-Filing portal."
        },
        {
          "q": "What if the information in the notice is incorrect?",
          "a": "The underlying records and tax information should be reviewed first. Where the Department's information is incorrect or incomplete, an appropriate explanation and supporting evidence can be submitted."
        },
        {
          "q": "What happens if I miss the response deadline?",
          "a": "The consequences depend on the type of proceeding. You should seek professional advice immediately rather than assuming that nothing can be done."
        },
        {
          "q": "Can you assist with outstanding tax demand?",
          "a": "Yes. The demand can be reviewed to determine whether it is correct, already paid, incorrectly raised or requires rectification/other action."
        }
      ],
      "extra": {
        "heading": "Important 2026 Transition",
        "body": "The Income-tax Act, 2025 has come into force from 1 April 2026, but this does not mean all earlier proceedings have shifted to the new Act. Proceedings relating to tax years beginning before 1 April 2026 continue to be governed by the Income-tax Act, 1961, including proceedings initiated after 1 April 2026 in respect of those earlier tax years, as provided by the transition provisions of the new Act."
      },
      "related": [
        "tax-demand-rectification-support",
        "tax-representation-assessment-support",
        "income-tax-appeals-litigation"
      ]
    }
  },
  {
    "slug": "tax-demand-rectification-support",
    "category": "Income Tax",
    "sub_category": "Notices & Disputes",
    "icon": "RotateCcw",
    "title": "Income Tax Demand & Rectification Support",
    "subtitle": "Resolution support for outstanding tax demand, TDS mismatch, payment mismatch and rectification requirements.",
    "read_time": "6 min read",
    "image": "https://images.unsplash.com/photo-1554224155-6726b3ff858f?crop=entropy&cs=srgb&fm=jpg&q=80&w=1200",
    "intro": "Many taxpayers do not need a conventional notice reply at all — what they are actually facing is an outstanding demand, an incorrect demand, a TDS mismatch, a tax-payment mismatch or a return that has been processed incorrectly. Biz360 Compliance's Income Tax Demand & Rectification Support is built around this exact situation. We review the outstanding demand shown on your account, reconcile it against your tax payments, TDS credits and the return as filed, and identify whether the demand is correct, already paid, incorrectly raised, or the result of a processing error that needs rectification. Depending on the finding, we prepare and file the appropriate rectification application or a response to the demand, and follow up with the Income Tax Department until the matter is resolved.",
    "sections": {
      "whoNeedsIt": {
        "heading": "Who Needs This Service?",
        "items": [
          "Taxpayers with an outstanding demand reflected on the income tax portal",
          "Taxpayers who believe a demand raised against them is incorrect",
          "Taxpayers facing a TDS credit mismatch with their return",
          "Taxpayers with a mismatch between tax paid and tax recorded against their PAN",
          "Taxpayers charged incorrect interest or fee in an intimation or order",
          "Taxpayers whose refund has been adjusted against an existing demand",
          "Taxpayers who need to file a rectification application for an apparent mistake"
        ]
      },
      "eligibility": {
        "heading": "Types of Matters We Handle",
        "items": [
          "Outstanding demand review",
          "Demand reconciliation",
          "TDS credit mismatch",
          "Tax payment mismatch",
          "Incorrect interest or fee",
          "Refund adjusted against demand",
          "Rectification application",
          "Response to demand",
          "Follow-up with the Income Tax Department"
        ]
      },
      "documents": {
        "heading": "Documents Generally Required",
        "groups": [
          {
            "title": "Documents (as applicable to the matter)",
            "items": [
              "Outstanding demand notice or order",
              "Previous ITR and tax computation",
              "Form 26AS and AIS/TIS",
              "TDS certificates",
              "Challans and tax payment proofs",
              "Refund adjustment details, where applicable",
              "Any earlier rectification application already filed",
              "Previous correspondence with the Department"
            ]
          }
        ]
      },
      "process": {
        "heading": "Our Demand & Rectification Process",
        "steps": [
          {
            "title": "Demand Review",
            "desc": "The outstanding demand shown on the portal is reviewed along with the related intimation or order."
          },
          {
            "title": "Reconciliation",
            "desc": "The demand is reconciled against tax payments, TDS credits, Form 26AS/AIS and the return as filed."
          },
          {
            "title": "Identify Root Cause",
            "desc": "We identify whether the demand arises from a mismatch, incorrect processing, or a genuine outstanding liability."
          },
          {
            "title": "Decide Course of Action",
            "desc": "Based on the finding, we determine whether a rectification application or a direct response to the demand is appropriate."
          },
          {
            "title": "Prepare & File",
            "desc": "The rectification application or demand response is prepared and filed through the applicable facility."
          },
          {
            "title": "Follow-Up",
            "desc": "We follow up with the Income Tax Department on the status of the rectification or demand resolution as required."
          }
        ]
      },
      "timeline": {
        "heading": "Estimated Timeline",
        "body": "Timelines depend on the complexity of the reconciliation, the number of tax years or demand entries involved, and the processing time taken by the Income Tax Department once the rectification application or demand response has been filed."
      },
      "fees": {
        "heading": "Government Fees & Professional Fees",
        "note": "Professional fees depend on the amount and nature of the demand, the complexity of the reconciliation, the number of tax years involved, and the number of rectification applications or demand responses required."
      },
      "benefits": {
        "heading": "Benefits of Demand & Rectification Support",
        "items": [
          "Clarifies whether a demand is genuine, already paid, or incorrectly raised",
          "Identifies TDS credit and tax payment mismatches before they compound",
          "Correction of incorrect interest or fee components in the demand",
          "Review of refund adjustments made against an existing demand",
          "A properly filed rectification application for apparent mistakes in the order or computation",
          "Continued follow-up with the Department until the demand is resolved"
        ]
      },
      "afterService": null,
      "whyUs": {
        "heading": "Why Choose Biz360 Compliance?",
        "items": [
          "Demand is reconciled against actual payment and credit records rather than accepted at face value",
          "Rectification and demand-response matters are handled by professionals familiar with the underlying filing",
          "The service is positioned as a natural continuation of ITR filing and notice-reply support",
          "We stay engaged with the Department until the demand or rectification is actually resolved"
        ]
      },
      "faqs": [
        {
          "q": "I have an outstanding demand on the portal that I believe is incorrect — can you help?",
          "a": "Yes, we review the demand to check whether it is correct, already paid, wrongly raised, or requires rectification."
        },
        {
          "q": "What is the difference between a demand response and a rectification application?",
          "a": "A response to demand addresses the outstanding demand entry directly, while a rectification application is used to correct an apparent mistake in an intimation, order or tax computation."
        },
        {
          "q": "My refund was adjusted against an old demand I wasn't aware of — what can be done?",
          "a": "We review the adjustment and the underlying demand to determine whether it was valid and whether any correction is warranted."
        },
        {
          "q": "Can a TDS credit mismatch be resolved without visiting the tax office?",
          "a": "Where covered by the applicable online facility, mismatches can generally be addressed through electronic reconciliation and submission."
        },
        {
          "q": "Do you also review the interest or fee shown in the demand?",
          "a": "Yes, incorrect interest or fee components are reviewed as part of the demand reconciliation."
        },
        {
          "q": "What happens after the rectification or response is submitted?",
          "a": "We follow up with the Income Tax Department on the status of the rectification or demand resolution as required."
        }
      ],
      "extra": {
        "heading": "Part of Your Compliance Journey",
        "body": "This service follows on naturally from ITR Filing and Notice Reply support, and links directly into demand and rectification resolution as part of the broader compliance journey: ITR Filing → Notice Reply → Demand & Rectification."
      },
      "related": [
        "income-tax-notice-assessment-support",
        "tax-representation-assessment-support",
        "income-tax-appeals-litigation"
      ]
    }
  },
  {
    "slug": "tax-representation-assessment-support",
    "category": "Income Tax",
    "sub_category": "Notices & Disputes",
    "icon": "Landmark",
    "title": "Income Tax Assessment & Representation Support",
    "subtitle": "Representation and submission support for scrutiny assessment and e-Proceedings before the Income Tax Department.",
    "read_time": "7 min read",
    "image": "https://images.unsplash.com/photo-1450101499163-c8848c66ca85?crop=entropy&cs=srgb&fm=jpg&q=80&w=1200",
    "intro": "Income Tax Assessment & Representation Support is a premium engagement for taxpayers whose case has moved beyond a simple notice into a scrutiny assessment or a similar proceeding conducted through the Department's e-Proceedings mechanism. These matters typically involve repeated information requests, detailed written submissions, compiled documentary evidence and one or more hearings, and the outcome can depend heavily on how well the case is presented at each stage. Biz360 Compliance reviews the assessment notice and the questions raised, compiles the supporting financial records and evidence needed to address them, and prepares detailed written submissions responding to each point raised by the assessing authority, then prepares you for the hearing itself and follows up with the Department as the proceeding progresses.",
    "sections": {
      "whoNeedsIt": {
        "heading": "Who Needs This Service?",
        "items": [
          "Taxpayers whose case has been selected for scrutiny assessment",
          "Taxpayers required to respond to the Department through the e-Proceedings facility",
          "Taxpayers who need detailed written submissions prepared for an assessment proceeding",
          "Taxpayers who need their documents compiled and organised before submission",
          "Taxpayers preparing for a hearing in an assessment matter",
          "Taxpayers who need ongoing follow-up with the Department during an assessment"
        ]
      },
      "eligibility": {
        "heading": "Scope of Assessment & Representation Services",
        "items": [
          "Scrutiny assessment",
          "e-Proceedings",
          "Assessment submissions",
          "Information requests",
          "Detailed written submissions",
          "Document compilation",
          "Hearing preparation",
          "Follow-up with the Department"
        ]
      },
      "documents": {
        "heading": "Documents Generally Required",
        "groups": [
          {
            "title": "Documents (as applicable to the assessment)",
            "items": [
              "Scrutiny or assessment notice",
              "Previous ITR and tax computation",
              "Form 26AS and AIS/TIS",
              "Financial statements and supporting evidence for claims made",
              "Bank statements and investment records, where relevant",
              "Draft written submissions prepared for each information request",
              "Previous correspondence with the Department"
            ]
          }
        ]
      },
      "process": {
        "heading": "Our Assessment & Representation Process",
        "steps": [
          {
            "title": "Case Review & Notice Analysis",
            "desc": "The scrutiny or assessment notice and the specific questions raised are reviewed in detail."
          },
          {
            "title": "Document Compilation",
            "desc": "Financial records, computations and supporting evidence relevant to the assessment are compiled."
          },
          {
            "title": "Preparation of Written Submissions",
            "desc": "Detailed written submissions are prepared to address each information request raised by the assessing authority."
          },
          {
            "title": "e-Proceedings Filing",
            "desc": "Submissions and supporting documents are filed through the e-Proceedings facility where applicable."
          },
          {
            "title": "Hearing Preparation",
            "desc": "Facts, computations and documents are organised so the case is ready to be presented at any hearing."
          },
          {
            "title": "Follow-Up with the Department",
            "desc": "We continue to follow up with the Department as the assessment proceeding progresses."
          }
        ]
      },
      "timeline": {
        "heading": "Estimated Timeline",
        "body": "As a premium, multi-stage service, timelines depend on the number of information requests raised, the volume of documentation required, and how many rounds of submissions or hearings the assessment proceeding involves."
      },
      "fees": {
        "heading": "Government Fees & Professional Fees",
        "note": "As a premium engagement, professional fees depend on the complexity of the assessment, the number of information requests and submissions involved, the volume of documentation to be compiled, and the number of hearings the proceeding requires."
      },
      "benefits": {
        "heading": "Benefits of Assessment & Representation Support",
        "items": [
          "A single point of coordination across a multi-stage assessment proceeding",
          "Detailed written submissions addressing each information request rather than a generic reply",
          "Documents compiled and organised in advance of submission deadlines",
          "Structured preparation ahead of any hearing in the proceeding",
          "Continued follow-up with the Department as the assessment progresses",
          "Submissions filed through the e-Proceedings facility where the matter is eligible"
        ]
      },
      "afterService": null,
      "whyUs": {
        "heading": "Why Choose Biz360 Compliance?",
        "items": [
          "The service is structured as a premium, end-to-end engagement rather than a single response",
          "Each information request is analysed and answered with a dedicated written submission",
          "Document compilation and hearing preparation are treated as distinct, essential stages",
          "We remain engaged with the Department through to the conclusion of the proceeding"
        ]
      },
      "faqs": [
        {
          "q": "What does assessment representation actually include?",
          "a": "It covers reviewing the assessment notice, compiling documents, preparing detailed written submissions, responding to information requests, preparing for hearings, and following up with the Department."
        },
        {
          "q": "Is this handled entirely online?",
          "a": "Where the matter is eligible, submissions and responses are filed through the e-Proceedings facility on the Income Tax e-Filing portal."
        },
        {
          "q": "How many rounds of submissions can a scrutiny assessment involve?",
          "a": "This depends on the specific case; assessment proceedings can involve multiple information requests, each of which is addressed with its own written submission."
        },
        {
          "q": "Will I need to prepare for a hearing?",
          "a": "Depending on the proceeding, we help organise the facts, computations and documents so you are ready to present them at any hearing."
        },
        {
          "q": "Can you compile my documents for me?",
          "a": "Yes, relevant financial records and supporting evidence are compiled and organised as part of the service."
        },
        {
          "q": "Do you follow up with the Department after submissions are filed?",
          "a": "Yes, follow-up with the Department is part of the service as the assessment proceeding progresses."
        }
      ],
      "extra": null,
      "related": [
        "income-tax-notice-assessment-support",
        "tax-demand-rectification-support",
        "income-tax-appeals-litigation"
      ]
    }
  },
  {
    "slug": "income-tax-appeals-litigation",
    "category": "Income Tax",
    "sub_category": "Notices & Disputes",
    "icon": "Gavel",
    "title": "Income Tax Appeals & Litigation Support",
    "subtitle": "Support across the appeal journey, from assessment orders to appellate proceedings.",
    "read_time": "7 min read",
    "image": "https://images.unsplash.com/photo-1554224154-26032ffc0d07?crop=entropy&cs=srgb&fm=jpg&q=80&w=1200",
    "intro": "An Income Tax dispute typically moves through a sequence: a notice is issued, an assessment is conducted, an order is passed, a demand may follow, and where the order is contested, rectification or an appeal becomes the next step. Biz360 Compliance's Income Tax Appeals & Litigation Support is built around this later stage of the journey, for taxpayers who wish to challenge an assessment order rather than accept it. We review the order to assess the grounds available, prepare the appeal documentation including the statement of facts and the grounds of appeal, and draft the written submissions required to support the appeal, while maintaining the appeal-related compliance obligations that arise once an appeal is filed and coordinating with the tax professionals and counsel involved in representation.",
    "sections": {
      "whoNeedsIt": {
        "heading": "Who Needs This Service?",
        "items": [
          "Taxpayers who have received an assessment order they wish to contest",
          "Taxpayers who need appeal documentation prepared",
          "Taxpayers who need a statement of facts and grounds of appeal drafted",
          "Taxpayers who need written submissions prepared for appellate proceedings",
          "Taxpayers who need to maintain appeal-related compliance once an appeal is filed",
          "Taxpayers who need coordination with tax professionals or counsel for representation"
        ]
      },
      "eligibility": {
        "heading": "Services Covered",
        "items": [
          "Appeal against assessment orders",
          "Appeal documentation",
          "Statement of facts",
          "Grounds of appeal",
          "Written submissions",
          "Appeal-related compliance",
          "Coordination with tax professionals",
          "Follow-up proceedings"
        ]
      },
      "documents": {
        "heading": "Documents Generally Required",
        "groups": [
          {
            "title": "Documents (as applicable to the appeal)",
            "items": [
              "Assessment order or appellate order",
              "Previous ITR and tax computation",
              "Notice and response history for the case",
              "Draft statement of facts",
              "Draft grounds of appeal",
              "Supporting evidence relevant to the disputed additions or adjustments",
              "Previous correspondence with the Department"
            ]
          }
        ]
      },
      "process": {
        "heading": "Our Appeals & Litigation Process",
        "steps": [
          {
            "title": "Order Review",
            "desc": "The assessment order is reviewed to understand the additions, adjustments or findings being contested."
          },
          {
            "title": "Appeal Feasibility Assessment",
            "desc": "We assess the grounds available to challenge the order before proceeding further."
          },
          {
            "title": "Statement of Facts",
            "desc": "A statement of facts summarising the case is prepared for the appeal."
          },
          {
            "title": "Grounds of Appeal",
            "desc": "The specific grounds of appeal are drafted based on the issues in dispute."
          },
          {
            "title": "Written Submissions",
            "desc": "Detailed written submissions are prepared to support the appeal."
          },
          {
            "title": "Filing & Appeal-Related Compliance",
            "desc": "The appeal is filed along with the required documentation, and related compliance obligations are maintained."
          },
          {
            "title": "Coordination with Tax Professionals",
            "desc": "We coordinate with the tax professionals and counsel involved in representing the appeal."
          },
          {
            "title": "Follow-Up on Proceedings",
            "desc": "We follow up on the appellate proceedings as the matter progresses."
          }
        ]
      },
      "timeline": {
        "heading": "Estimated Timeline",
        "body": "Timelines depend on the appellate forum involved, the complexity of the grounds raised, and the number of hearings or submissions the appeal requires as the proceeding progresses."
      },
      "fees": {
        "heading": "Government Fees & Professional Fees",
        "note": "Professional fees depend on the complexity of the case, the appellate stage involved, the volume of documentation and submissions required, and the extent of coordination needed with tax professionals or counsel."
      },
      "benefits": {
        "heading": "Benefits of Appeals & Litigation Support",
        "items": [
          "A clear assessment of the grounds available before an appeal is filed",
          "Properly drafted statement of facts and grounds of appeal",
          "Written submissions that address the specific issues in dispute",
          "Appeal-related compliance obligations are tracked and maintained",
          "Coordination with the tax professionals and counsel involved in representation",
          "Continued follow-up on the appellate proceedings as the matter progresses"
        ]
      },
      "afterService": null,
      "whyUs": {
        "heading": "Why Choose Biz360 Compliance?",
        "items": [
          "Appeals and litigation are handled as a dedicated service, not bundled into routine notice-reply work",
          "The case is understood in the context of the full journey — notice, assessment, order, demand and rectification",
          "Appeal documentation is prepared with attention to the statement of facts and grounds of appeal",
          "We coordinate directly with the tax professionals and counsel involved in your representation",
          "Ongoing follow-up on the appellate proceeding rather than a one-time filing"
        ]
      },
      "faqs": [
        {
          "q": "What is the difference between rectification and an appeal?",
          "a": "Rectification addresses an apparent mistake in an order or computation, while an appeal is used to formally contest an assessment order on its merits."
        },
        {
          "q": "Which orders can be appealed?",
          "a": "Assessment orders that a taxpayer wishes to contest can be considered for appeal; the specific grounds available depend on the facts of the order."
        },
        {
          "q": "What is a statement of facts and grounds of appeal?",
          "a": "The statement of facts summarises the case background, while the grounds of appeal set out the specific points on which the order is being challenged."
        },
        {
          "q": "Do you coordinate with counsel or advocates for representation?",
          "a": "Yes, we coordinate with the tax professionals and counsel involved in representing the appeal."
        },
        {
          "q": "What happens after an appeal is filed?",
          "a": "Appeal-related compliance obligations are maintained, and we follow up on the appellate proceedings as they progress."
        },
        {
          "q": "Is there a sequence I should be aware of before reaching the appeal stage?",
          "a": "Yes — matters typically progress through notice, assessment, order, demand and rectification before reaching the appeal stage."
        }
      ],
      "extra": {
        "heading": "The Compliance Journey",
        "body": "Appeals and litigation support is best understood as part of a broader sequence: Notice → Assessment → Order → Demand → Rectification → Appeal. This is why it is offered as a separate, dedicated service rather than combined with routine notice-reply support."
      },
      "related": [
        "tax-representation-assessment-support",
        "tax-demand-rectification-support",
        "income-tax-notice-assessment-support"
      ]
    }
  },
  {
    "slug": "form-15ca-15cb-support",
    "category": "Income Tax",
    "sub_category": "Specialised Services",
    "icon": "Send",
    "title": "Form 15CA / 15CB Support",
    "subtitle": "Get professional assistance for tax compliance on payments made outside India.",
    "read_time": "6 min read",
    "image": "https://images.unsplash.com/photo-1518186285589-2f7649de83e0?crop=entropy&cs=srgb&fm=jpg&q=80&w=1200",
    "intro": "When a person makes certain payments to a non-resident, the payment may carry Income Tax and TDS implications that need to be examined before the money leaves India. Depending on the nature of the payment and the applicable provisions, Form 15CA may need to be furnished, and in specified cases a Form 15CB certificate from a Chartered Accountant is also required. Biz360 Compliance helps individuals and businesses review the proposed remittance, assess its taxability and TDS treatment, and determine the applicable Form 15CA / Form 15CB compliance before the remittance is made. Our approach looks at the actual transaction rather than applying a standard TDS treatment, considers relevant DTAA provisions where applicable, and coordinates with an appointed Chartered Accountant wherever a Form 15CB certificate is needed.",
    "sections": {
      "whoNeedsIt": {
        "heading": "Who Needs Form 15CA / 15CB Support?",
        "items": [
          "Businesses paying professional or consultancy fees to non-residents",
          "Companies making technical service payments abroad",
          "Persons paying royalty to a foreign recipient",
          "Businesses paying interest or commission to non-residents",
          "Entities making software or subscription payments overseas",
          "Businesses remitting payments for imports or other specified transactions",
          "Any person making other payments to non-residents"
        ]
      },
      "eligibility": {
        "heading": "Eligibility & Applicability Assessment",
        "items": [
          "Review of the nature and purpose of the proposed payment",
          "Assessment of whether the payment is taxable in India",
          "Review of applicable TDS provisions on the remittance",
          "Consideration of DTAA provisions where relevant",
          "Determination of whether Form 15CA is required",
          "Determination of whether Form 15CB certification is additionally required"
        ]
      },
      "documents": {
        "heading": "Documents Required",
        "groups": [
          {
            "title": "Documents Generally Required",
            "items": [
              "PAN of remitter",
              "Details of the foreign recipient",
              "Invoice",
              "Agreement / contract",
              "Nature and purpose of payment",
              "Amount and currency",
              "Tax residency details of the recipient",
              "TRC, where relevant",
              "Form 10F, where applicable",
              "Bank / remittance details"
            ]
          }
        ]
      },
      "process": {
        "heading": "Our Process",
        "steps": [
          {
            "title": "Understand the Payment",
            "desc": "Review the nature, purpose and recipient of the remittance."
          },
          {
            "title": "Taxability Review",
            "desc": "Determine the potential Indian tax and TDS implications."
          },
          {
            "title": "DTAA Review",
            "desc": "Where applicable, consider the relevant Double Taxation Avoidance Agreement."
          },
          {
            "title": "Form Selection",
            "desc": "Determine the appropriate Form 15CA requirement and whether Form 15CB is applicable."
          },
          {
            "title": "Documentation",
            "desc": "Prepare and compile the required information and supporting documents."
          },
          {
            "title": "Filing & Coordination",
            "desc": "Complete the applicable filing and coordinate with the bank/remittance process."
          }
        ]
      },
      "timeline": {
        "heading": "Estimated Timeline",
        "body": "Timelines depend on the nature of the remittance, the taxability and DTAA analysis involved, and whether a Form 15CB certificate from a Chartered Accountant is required before the Form 15CA can be filed."
      },
      "fees": {
        "heading": "Government Fees & Professional Fees",
        "note": "Fees depend on the nature of the remittance, the amount involved, the taxability analysis, DTAA applicability, whether Form 15CA alone or Form 15CA with Form 15CB is required, and the complexity of documentation."
      },
      "benefits": {
        "heading": "Benefits of Form 15CA / 15CB Support",
        "items": [
          "Clarity on the tax and TDS treatment before the remittance is made",
          "Reduced risk of incorrect TDS deduction or delayed remittance",
          "Transaction-specific review instead of a standard TDS treatment",
          "Consideration of applicable DTAA provisions",
          "Organised documentation supporting the remittance",
          "Coordinated Form 15CB certification with the appointed Chartered Accountant, where required"
        ]
      },
      "afterService": null,
      "whyUs": {
        "heading": "Why Choose Biz360 Compliance?",
        "items": [
          "Transaction-Specific Review — we assess the actual payment instead of applying a standard TDS treatment",
          "Tax + Documentation Support — taxability, TDS and documentation are considered together",
          "DTAA Consideration — treaty provisions can be considered where applicable in determining the tax treatment",
          "CA Coordination — where Form 15CB or a CA certification is required, the process is coordinated with the appointed Chartered Accountant"
        ]
      },
      "faqs": [
        {
          "q": "What is Form 15CA?",
          "a": "Form 15CA is a declaration furnished in relation to specified payments made to non-residents, as prescribed under the Income-tax framework."
        },
        {
          "q": "Is Form 15CA required for every foreign remittance?",
          "a": "No. Applicability depends on the nature of payment and the applicable provisions."
        },
        {
          "q": "What is Form 15CB?",
          "a": "Form 15CB is a certificate issued by a Chartered Accountant in specified circumstances involving remittances to non-residents."
        },
        {
          "q": "Is Form 15CB mandatory for every remittance?",
          "a": "No. Whether Form 15CB is required depends on the applicable provisions and circumstances of the remittance."
        },
        {
          "q": "Can Biz360 help with Form 15CA?",
          "a": "Yes. We can assist with determining the applicable requirement and preparation/furnishing of the relevant form."
        },
        {
          "q": "Is TDS applicable to payments made outside India?",
          "a": "Not necessarily in every case. Taxability, nature of payment, the recipient's status and applicable provisions need to be examined."
        }
      ],
      "extra": null,
      "related": [
        "lower-nil-tds-certificate",
        "pan-tan-services",
        "nri-taxation-compliance"
      ]
    }
  },
  {
    "slug": "lower-nil-tds-certificate",
    "category": "Income Tax",
    "sub_category": "Specialised Services",
    "icon": "Percent",
    "title": "Lower / Nil TDS Certificate Support",
    "subtitle": "Reduce excess TDS deduction through the prescribed certificate process.",
    "read_time": "7 min read",
    "image": "https://images.unsplash.com/photo-1554224155-6726b3ff858f?crop=entropy&cs=srgb&fm=jpg&q=80&w=1200",
    "intro": "If the TDS being deducted on your expected income is significantly higher than your actual tax liability, you may be eligible to apply for a lower or nil withholding certificate. Such a certificate allows tax to be deducted at a lower rate, or at nil, where the taxpayer's estimated total income and tax liability justify that treatment, and it is issued by the Assessing Officer after considering the taxpayer's projected income and tax position. Biz360 Compliance assists taxpayers with eligibility review, tax computation, application preparation, documentation and coordination through the certificate process, whether the application relates to interest, contractual or professional receipts, rent, commission or other specified payments.",
    "sections": {
      "whoNeedsIt": {
        "heading": "Who May Need This Service?",
        "items": [
          "Taxpayers expecting significant TDS on interest income",
          "Persons receiving contractual or professional receipts",
          "Recipients of commission",
          "Landlords receiving rent subject to TDS",
          "Businesses with other specified receipts subject to TDS",
          "Businesses expecting significant TDS on business receipts",
          "Non-residents with certain income, where applicable",
          "Anyone whose expected TDS is substantially higher than their estimated final tax liability"
        ]
      },
      "eligibility": {
        "heading": "Eligibility & Applicability Assessment",
        "items": [
          "Review of expected income, TDS and estimated tax liability",
          "Preparation of the estimated income and tax computation supporting the application",
          "Assessment of whether the expected TDS is disproportionate to the actual tax liability",
          "Evaluation by the Assessing Officer of the taxpayer's estimated income and tax position",
          "Consideration of the applicable rate and validity period the certificate would carry"
        ]
      },
      "documents": {
        "heading": "Documents Required",
        "groups": [
          {
            "title": "Documents Generally Required",
            "items": [
              "PAN",
              "Previous Income Tax Returns",
              "Expected income details",
              "Contracts / agreements",
              "Invoices / expected receipts",
              "TDS details",
              "Financial statements, where applicable",
              "Estimated tax computation",
              "Advance tax details"
            ]
          }
        ]
      },
      "process": {
        "heading": "Our Process",
        "steps": [
          {
            "title": "Income Review",
            "desc": "Review expected receipts and other income for the relevant period."
          },
          {
            "title": "TDS Analysis",
            "desc": "Estimate the TDS likely to be deducted."
          },
          {
            "title": "Tax Computation",
            "desc": "Calculate the expected overall tax liability."
          },
          {
            "title": "Eligibility Assessment",
            "desc": "Evaluate whether a lower/nil deduction application is appropriate."
          },
          {
            "title": "Application Preparation",
            "desc": "Prepare the prescribed application and supporting information."
          },
          {
            "title": "Submission & Follow-Up",
            "desc": "Assist with submission and subsequent communication with the department and payers."
          }
        ]
      },
      "timeline": {
        "heading": "Estimated Timeline",
        "body": "Processing depends on the Assessing Officer's review of the estimated income and tax position, the completeness of the supporting computation, and the applicable submission process for the relevant tax year."
      },
      "fees": {
        "heading": "Government Fees & Professional Fees",
        "note": "Fees depend on the nature of income, the number of income sources, the estimated tax computation, the complexity of the application, the documentation involved and follow-up requirements."
      },
      "benefits": {
        "heading": "Benefits of Lower / Nil TDS Certificate Support",
        "items": [
          "Reduced cash-flow impact from excess TDS deduction",
          "Tax computation prepared before the application is filed",
          "Organised financial and tax documentation for the application",
          "Application prepared based on the prescribed requirements",
          "Follow-up support through submission and issuance",
          "Assistance communicating the certificate details to relevant payers",
          "Can be integrated with ongoing ITR filing, advance tax and tax planning support"
        ]
      },
      "afterService": null,
      "whyUs": {
        "heading": "Why Choose Biz360 Compliance?",
        "items": [
          "Tax Computation Before Application — we first assess the expected tax position rather than filing the application without supporting analysis",
          "Documentation Support — relevant financial and tax information is organised for the application",
          "Professional Process — the application is prepared based on the prescribed requirements",
          "Ongoing Tax Support — the service can be integrated with ITR filing, advance tax, TDS and tax planning"
        ]
      },
      "faqs": [
        {
          "q": "What is a lower TDS certificate?",
          "a": "It is a certificate allowing tax to be deducted at a rate lower than the otherwise applicable rate, where the taxpayer's estimated tax liability justifies it."
        },
        {
          "q": "What is a nil TDS certificate?",
          "a": "It permits the payer to deduct no TDS on the specified payments covered by the certificate, subject to its terms."
        },
        {
          "q": "Who issues the certificate?",
          "a": "The certificate is issued by the Assessing Officer after considering the taxpayer's estimated income and tax liability."
        },
        {
          "q": "Is approval guaranteed?",
          "a": "No. The Assessing Officer considers the taxpayer's estimated income and tax position before issuing the certificate."
        },
        {
          "q": "Can a business apply for a lower TDS certificate?",
          "a": "Yes, eligible taxpayers can apply where the applicable conditions are satisfied."
        },
        {
          "q": "Can an existing certificate continue to be valid after a change in the applicable law?",
          "a": "Certificates issued under the earlier provision can continue to be valid for the relevant period, subject to the conditions specified by the Income Tax Department for the applicable transition."
        }
      ],
      "extra": null,
      "related": [
        "form-15ca-15cb-support",
        "pan-tan-services",
        "tds-compliance-filing"
      ]
    }
  },
  {
    "slug": "pan-tan-services",
    "category": "Income Tax",
    "sub_category": "Specialised Services",
    "icon": "BadgeCheck",
    "title": "PAN & TAN Services",
    "subtitle": "Get PAN and TAN applications, corrections and related tax-registration support with a simple professional process.",
    "read_time": "5 min read",
    "image": "https://images.unsplash.com/photo-1554224155-1696413565d3?crop=entropy&cs=srgb&fm=jpg&q=80&w=1200",
    "intro": "PAN and TAN are important identifiers for various Income Tax and TDS-related compliances, whether you are an individual filing returns, a business deducting tax at source, or an organisation managing its statutory registrations. Biz360 Compliance assists individuals, businesses and organisations with new PAN applications, corrections and reprints, along with new TAN applications, corrections and related updates. We help clients select the correct application type, verify documentation before submission, complete the online filing, and follow up until the PAN or TAN is issued or the correction is reflected, integrated with the business incorporation and post-incorporation compliance process where relevant.",
    "sections": {
      "whoNeedsIt": {
        "heading": "Who Needs These Services?",
        "items": [
          "Individuals",
          "Proprietorships",
          "Partnership Firms",
          "LLPs",
          "Companies",
          "Trusts & institutions",
          "Employers",
          "Businesses required to deduct TDS"
        ]
      },
      "eligibility": {
        "heading": "Eligibility & Applicability Assessment",
        "items": [
          "Individuals and entities without an existing PAN needing a new application",
          "PAN holders needing correction of name, address or date-of-birth details",
          "PAN holders needing a reprint of their existing card",
          "Entities required to deduct or collect tax needing a new TAN",
          "TAN holders needing correction or update of existing details",
          "Newly incorporated businesses needing PAN/TAN as part of initial compliance"
        ]
      },
      "documents": {
        "heading": "Documents Required",
        "groups": [
          {
            "title": "Documents Generally Required",
            "items": [
              "Identity proof",
              "Address proof",
              "Date-of-birth proof, where applicable",
              "Incorporation/constitution documents",
              "Authorisation documents",
              "Existing PAN/TAN details, for corrections or updates",
              "Other documents prescribed for the particular application"
            ]
          }
        ]
      },
      "process": {
        "heading": "Process",
        "steps": [
          {
            "title": "Requirement Check",
            "desc": "Identify the correct PAN or TAN application type for your situation."
          },
          {
            "title": "Document Verification",
            "desc": "Verify identity, address and other supporting documents before filing."
          },
          {
            "title": "Application Preparation",
            "desc": "Prepare the application with the verified details."
          },
          {
            "title": "Online Submission",
            "desc": "File the application through the applicable online process."
          },
          {
            "title": "Processing & Follow-up",
            "desc": "Track the application and follow up with the issuing authority as needed."
          },
          {
            "title": "PAN/TAN Delivery or Update",
            "desc": "Confirm issuance of the new PAN/TAN or reflection of the correction."
          }
        ]
      },
      "timeline": {
        "heading": "Estimated Timeline",
        "body": "Processing time depends on the type of application, the completeness of documentation and the issuing authority's turnaround for that category of request."
      },
      "fees": {
        "heading": "Government Fees & Professional Fees",
        "note": "Government charges and professional fees vary depending on the application and service scope. Get a customised quote before filing."
      },
      "benefits": {
        "heading": "Benefits of PAN & TAN Services",
        "items": [
          "Correct application type selected upfront, reducing rejection risk",
          "Documents verified before submission",
          "Online filing handled on your behalf",
          "Correction and reprint requests managed through the prescribed process",
          "Support can be integrated with new business incorporation",
          "Single point of contact for PAN and TAN across the organisation"
        ]
      },
      "afterService": null,
      "whyUs": {
        "heading": "Why Choose Biz360 Compliance?",
        "items": [
          "Correct application selection for the specific PAN/TAN requirement",
          "Document verification before submission",
          "Online filing support throughout the process",
          "Correction/reprint assistance for existing PAN/TAN holders",
          "Professional compliance support that can extend to related tax registrations"
        ]
      },
      "faqs": [
        {
          "q": "Can I apply for a new PAN through Biz360?",
          "a": "Yes. We can assist with the application and required documentation."
        },
        {
          "q": "Can an existing PAN be corrected?",
          "a": "Yes. Permitted details can be updated through the prescribed correction process."
        },
        {
          "q": "Can a company obtain PAN?",
          "a": "Yes. Companies and other eligible entities require PAN for applicable tax and financial compliances."
        },
        {
          "q": "What is TAN?",
          "a": "TAN is the Tax Deduction and Collection Account Number required for persons responsible for deducting or collecting tax in specified circumstances."
        },
        {
          "q": "Is TAN required for every business?",
          "a": "No. TAN applicability depends on whether the entity is required to deduct or collect tax under the applicable provisions."
        },
        {
          "q": "Can you help with PAN/TAN if the business is newly incorporated?",
          "a": "Yes. PAN/TAN-related support can be integrated with the business incorporation and post-incorporation compliance process."
        }
      ],
      "extra": null,
      "related": [
        "form-15ca-15cb-support",
        "lower-nil-tds-certificate",
        "income-tax-return-filing"
      ]
    }
  },
  {
    "slug": "roc-mca-annual-compliance",
    "category": "Compliance",
    "sub_category": "Corporate Compliance",
    "icon": "Landmark",
    "title": "ROC & MCA Annual Compliance for Companies",
    "subtitle": "Stay on top of annual filings, financial statements and statutory company compliance.",
    "read_time": "7 min read",
    "image": "https://images.unsplash.com/photo-1450101499163-c8848c66ca85?crop=entropy&cs=srgb&fm=jpg&q=80&w=1200",
    "intro": "Companies registered under the Companies Act, 2013 are required to comply with a range of annual filing and disclosure obligations with the Ministry of Corporate Affairs (MCA). This typically involves maintaining statutory records and submitting prescribed information within applicable timelines, though the exact requirements vary by company type, financial year and applicable exemptions. Biz360 Compliance helps companies manage these recurring obligations end to end, from reviewing existing MCA records and finalised financial statements to identifying the applicable annual forms, resolutions and supporting documents. Core services include financial statement filing (AOC-4), annual return filing (MGT-7/MGT-7A), director KYC (DIR-3 KYC), registered office and company detail updates, and a broader statutory records review before the annual filing cycle begins. Rather than treating annual filing as a once-a-year scramble, Biz360 can track due dates and manage compliance on an ongoing basis, keeping company records accurate and reducing the risk of penalties or accumulated non-compliance.",
    "sections": {
      "whoNeedsIt": {
        "heading": "Who Needs Annual ROC Compliance?",
        "items": [
          "Private Limited Companies",
          "Public Limited Companies",
          "One Person Companies",
          "Section 8 Companies",
          "Other companies registered under the Companies Act, as applicable",
          "Companies with pending or previously missed MCA filings"
        ]
      },
      "eligibility": {
        "heading": "Key Annual Compliance Services",
        "items": [
          "Financial Statement Filing (AOC-4) with applicable attachments",
          "Annual Return filing (MGT-7 / MGT-7A) based on company category",
          "Director KYC (DIR-3 KYC) for applicable directors",
          "Registered office and company detail updates",
          "Statutory records and compliance review before the filing cycle",
          "Identification of event-based changes affecting annual filings"
        ]
      },
      "documents": {
        "heading": "Typical Documents Required",
        "groups": [
          {
            "title": "Depending on the company and filing",
            "items": [
              "Financial statements",
              "Trial balance / accounting data",
              "Directors' details",
              "Shareholding information",
              "Registered office details",
              "Previous MCA filings",
              "Board/shareholder resolutions",
              "Auditor-related information",
              "Digital Signature Certificates (DSCs)",
              "Other statutory records"
            ]
          }
        ]
      },
      "process": {
        "heading": "Our Annual Compliance Process",
        "steps": [
          {
            "title": "Compliance Review",
            "desc": "We review the company's existing MCA records and previous compliance status."
          },
          {
            "title": "Financial Information",
            "desc": "Finalised financial statements and relevant supporting information are collected."
          },
          {
            "title": "Compliance Checklist",
            "desc": "Applicable annual forms, resolutions and supporting documents are identified."
          },
          {
            "title": "Preparation",
            "desc": "Required forms, statements and supporting information are prepared."
          },
          {
            "title": "Filing",
            "desc": "Applicable forms are filed with the MCA within the prescribed timelines."
          },
          {
            "title": "Compliance Record",
            "desc": "Filed forms, challans and relevant records are maintained for future reference."
          }
        ]
      },
      "timeline": {
        "heading": "Estimated Timeline",
        "body": "Timeline depends on the availability of documents, DSCs, finalised financial statements and MCA processing speed."
      },
      "fees": {
        "heading": "Government Fees & Professional Fees",
        "note": "Professional fees depend on the type of company, number of filings, financial statement status, pending compliance, additional event-based filings and the complexity of the company's records. Government filing fees and any additional fees, where applicable, are separate from professional fees."
      },
      "benefits": {
        "heading": "Benefits of Timely ROC Compliance",
        "items": [
          "Avoid unnecessary additional fees and penalties",
          "Maintain an updated MCA record",
          "Keep company information current",
          "Support banking and funding requirements",
          "Maintain good corporate governance",
          "Reduce the risk of compliance issues accumulating over time"
        ]
      },
      "afterService": null,
      "whyUs": {
        "heading": "Why Choose Biz360 Compliance?",
        "items": [
          "Compliance calendar tracking recurring filing requirements and important due dates",
          "Document-based process where required information is collected and reviewed before filing",
          "MCA filing support with forms and attachments prepared and filed through the prescribed process",
          "Integrated accounting support connecting ROC compliance with financial statement preparation",
          "Ongoing support that manages recurring compliance throughout the year, not just at deadline time"
        ]
      },
      "faqs": [
        {
          "q": "Is annual ROC compliance mandatory for every company?",
          "a": "Companies are generally subject to annual filing requirements under the Companies Act, subject to applicable provisions and exemptions."
        },
        {
          "q": "What are the main annual ROC filings?",
          "a": "For many companies, the key filings include financial statement filing and annual return filing, along with other applicable compliance such as director KYC."
        },
        {
          "q": "What is AOC-4?",
          "a": "AOC-4 is the prescribed form used for filing financial statements and related documents with the MCA, where applicable."
        },
        {
          "q": "What is MGT-7?",
          "a": "MGT-7 is the annual return form applicable to companies covered by the relevant provisions."
        },
        {
          "q": "Is DIR-3 KYC an annual requirement?",
          "a": "Applicable directors are required to comply with the prescribed DIN KYC requirements within the applicable framework."
        },
        {
          "q": "What if previous ROC filings are pending?",
          "a": "Pending compliance should be reviewed before proceeding with the current annual filing, as additional fees or other consequences may apply depending on the default."
        }
      ],
      "extra": null,
      "related": [
        "llp-annual-compliance",
        "event-based-roc-mca-compliance",
        "director-din-compliance"
      ]
    }
  },
  {
    "slug": "llp-annual-compliance",
    "category": "Compliance",
    "sub_category": "Corporate Compliance",
    "icon": "Layers",
    "title": "LLP Annual Compliance Services",
    "subtitle": "Keep your LLP's annual filings, financial information and statutory records up to date.",
    "read_time": "7 min read",
    "image": "https://images.unsplash.com/photo-1554224155-1696413565d3?crop=entropy&cs=srgb&fm=jpg&q=80&w=1200",
    "intro": "Limited Liability Partnerships must comply with prescribed annual filing and disclosure requirements under the Limited Liability Partnership Act, 2008 and applicable rules. For most LLPs, this centres on two filings: Form 11, the Annual Return covering partner and contribution details, and Form 8, the Statement of Account & Solvency. Additional event-based compliance may also apply depending on changes during the year, such as a change in partners, contribution, registered office or the LLP agreement. Biz360 Compliance helps LLPs manage this recurring workload by reviewing basic details and previous filings, verifying partner and contribution information, preparing the applicable annual forms, and filing them through the prescribed MCA/LLP system. Even LLPs with limited or no business activity should have their filing obligations reviewed, since inactivity does not automatically remove statutory requirements. Compliance can also be linked with broader accounting, GST, income tax and payroll support for a single coordinated engagement.",
    "sections": {
      "whoNeedsIt": {
        "heading": "Who Needs LLP Compliance?",
        "items": [
          "Newly incorporated LLPs",
          "Operating LLPs",
          "Professional LLPs",
          "Family-owned LLPs",
          "Trading LLPs",
          "Service businesses",
          "Investment/holding LLPs",
          "LLPs with limited or no business activity"
        ]
      },
      "eligibility": {
        "heading": "Key LLP Compliance Services",
        "items": [
          "Form 11 – Annual Return covering partners and contribution details",
          "Form 8 – Statement of Account & Solvency and applicable disclosures",
          "Partner and contribution detail review, including changes during the year",
          "LLP compliance review to identify pending or event-based requirements",
          "Event-based LLP filings for change in partners, contribution, registered office or LLP agreement",
          "Other prescribed event-based compliance as applicable"
        ]
      },
      "documents": {
        "heading": "Documents Generally Required",
        "groups": [
          {
            "title": "Depending on the LLP",
            "items": [
              "LLP Agreement",
              "Previous Form 8 & Form 11",
              "Financial statements / accounting records",
              "Partner details",
              "Contribution details",
              "Registered office details",
              "DSCs of designated partners",
              "Details of changes during the year",
              "Other information required for the applicable filing"
            ]
          }
        ]
      },
      "process": {
        "heading": "Our LLP Compliance Process",
        "steps": [
          {
            "title": "Compliance Review",
            "desc": "We review the LLP's basic details, previous filings and current-year changes."
          },
          {
            "title": "Financial Information",
            "desc": "Relevant accounting and financial information is collected."
          },
          {
            "title": "Partner & Contribution Review",
            "desc": "Partner details, contribution and changes are verified."
          },
          {
            "title": "Form Preparation",
            "desc": "Applicable annual forms and supporting information are prepared."
          },
          {
            "title": "Filing",
            "desc": "Forms are filed through the prescribed MCA/LLP filing system."
          },
          {
            "title": "Compliance Record",
            "desc": "Filed forms, challans and relevant documents are maintained for future reference."
          }
        ]
      },
      "timeline": {
        "heading": "Estimated Timeline",
        "body": "As a general framework, Form 11 (Annual Return) is generally required within 60 days from the close of the financial year, while Form 8 (Statement of Account & Solvency) is generally due within 30 days from the end of six months of the financial year. Exact deadlines should be checked for the relevant financial year and LLP circumstances."
      },
      "fees": {
        "heading": "Government Fees & Professional Fees",
        "note": "Fees depend on the LLP's structure, transaction volume, financial statement status, number of partners, pending filings, additional event-based compliance and complexity of records. Government filing fees and additional fees, where applicable, are separate from professional fees."
      },
      "benefits": {
        "heading": "Benefits of Staying LLP-Compliant",
        "items": [
          "Avoid additional fees and consequences from delayed filings",
          "Keep partner and contribution records accurate and current",
          "Maintain a clean statutory filing history with the MCA",
          "Identify event-based changes before they become compliance gaps",
          "Support banking, funding and due-diligence requirements",
          "Reduce risk of accumulated non-compliance over time"
        ]
      },
      "afterService": null,
      "whyUs": {
        "heading": "Why Choose Biz360 Compliance?",
        "items": [
          "Annual compliance tracking so important LLP filing requirements are monitored throughout the year",
          "Accounting-linked compliance coordinating financial information with your accounting services",
          "Partner detail review to flag changes in partners, contribution or structure before filing",
          "End-to-end filing support from document collection to filing and record maintenance",
          "Integrated business support connecting LLP compliance with GST, Income Tax, accounting and payroll"
        ]
      },
      "faqs": [
        {
          "q": "Is annual compliance mandatory for an LLP?",
          "a": "LLPs are generally required to comply with prescribed annual filing requirements, subject to applicable provisions."
        },
        {
          "q": "What are the main annual LLP filings?",
          "a": "The principal annual filings are generally Form 11 and Form 8."
        },
        {
          "q": "What is Form 11?",
          "a": "Form 11 is the LLP's Annual Return, containing prescribed information about the LLP and its partners."
        },
        {
          "q": "What is Form 8?",
          "a": "Form 8 contains the LLP's Statement of Account & Solvency and applicable disclosures."
        },
        {
          "q": "Does an LLP with no business activity need annual compliance?",
          "a": "The absence of business activity does not automatically eliminate statutory filing obligations; the LLP's specific circumstances should be reviewed."
        },
        {
          "q": "What happens if LLP filings are delayed?",
          "a": "Additional fees and other consequences may apply depending on the nature and duration of the delay."
        }
      ],
      "extra": null,
      "related": [
        "roc-mca-annual-compliance",
        "event-based-roc-mca-compliance",
        "annual-compliance-management"
      ]
    }
  },
  {
    "slug": "event-based-roc-mca-compliance",
    "category": "Compliance",
    "sub_category": "Corporate Compliance",
    "icon": "Zap",
    "title": "Event-Based ROC & MCA Compliance",
    "subtitle": "Handle important company changes with the right approvals, documentation and MCA filings.",
    "read_time": "8 min read",
    "image": "https://images.unsplash.com/photo-1554224154-26032ffc0d07?crop=entropy&cs=srgb&fm=jpg&q=80&w=1200",
    "intro": "Not every company filing is annual. Certain changes during the year, commonly called event-based or event-driven compliances, trigger specific corporate approvals, statutory documentation and filings with the Ministry of Corporate Affairs. These can arise from director-related changes such as appointment, resignation or removal; registered office changes within a city or across ROC jurisdictions; share capital changes including increases, alterations, or issue and allotment of shares; shifts in shareholding or ownership; and other corporate changes such as a change in company name, objects, or amendments to the MOA/AOA. The applicable form, timeline and documentation depend entirely on the nature of the change and the type of company involved. Biz360 Compliance assists companies by first understanding the proposed change, determining the applicable Companies Act provisions and MCA filing requirements, preparing the necessary resolutions and documentation, securing corporate approvals, and filing the prescribed form within the applicable timeline. Because event-based compliance often carries a strict statutory filing window, it should ideally be assessed before the corporate change is implemented, not after.",
    "sections": {
      "whoNeedsIt": {
        "heading": "Who Needs Event-Based MCA Compliance?",
        "items": [
          "Companies appointing, removing or accepting resignation of a director",
          "Companies changing their registered office, within a city or across ROC jurisdictions",
          "Companies increasing or altering authorised share capital, or issuing/allotting shares",
          "Companies undergoing changes in shareholding or ownership",
          "Companies changing their name, objects, or amending MOA/AOA",
          "Companies making other prescribed event-based changes"
        ]
      },
      "eligibility": {
        "heading": "Common Event-Based Compliance Services",
        "items": [
          "Director-related changes: appointment, resignation, removal, change in particulars, additional/alternate/nominee director matters",
          "Registered office changes: within the same city, or involving another ROC jurisdiction",
          "Share capital changes: increase in authorised capital, alteration of capital, issue/allotment of shares, transfer-related documentation",
          "Shareholding and ownership change documentation and filings",
          "Other corporate changes: change in name, change in objects, amendments to MOA/AOA, director-related disclosures"
        ]
      },
      "documents": {
        "heading": "Documents Generally Required",
        "groups": [
          {
            "title": "Depending on the event",
            "items": [
              "Company incorporation documents",
              "MOA & AOA",
              "Board/shareholder resolutions",
              "Director details",
              "Shareholder details",
              "Registered office documents",
              "Share certificates",
              "Financial information",
              "Agreements or supporting documents",
              "DSCs",
              "Other event-specific documents"
            ]
          }
        ]
      },
      "process": {
        "heading": "Our Process",
        "steps": [
          {
            "title": "Understand the Proposed Change",
            "desc": "We first identify what the company intends to change."
          },
          {
            "title": "Determine Applicability",
            "desc": "The applicable Companies Act provisions, approvals and MCA filing requirements are identified."
          },
          {
            "title": "Documentation",
            "desc": "Required resolutions, declarations, forms and supporting documents are prepared or coordinated."
          },
          {
            "title": "Corporate Approval",
            "desc": "Applicable Board/Shareholder approvals are completed."
          },
          {
            "title": "MCA Filing",
            "desc": "The prescribed MCA form is prepared and filed within the applicable timeline."
          },
          {
            "title": "Record Update",
            "desc": "Filed documents and updated MCA records are reviewed and maintained."
          }
        ]
      },
      "timeline": {
        "heading": "Estimated Timeline",
        "body": "Event-based compliance often has a specific statutory filing period tied to the nature of the change, so timing should be assessed before the corporate change is implemented rather than after."
      },
      "fees": {
        "heading": "Government Fees & Professional Fees",
        "note": "Fees depend on the nature of the corporate event, the number of forms involved, documentation required, board/shareholder approval requirements and the complexity of the transaction. Government filing fees and applicable additional fees are separate from professional fees."
      },
      "benefits": {
        "heading": "Benefits of Timely Event-Based Compliance",
        "items": [
          "Avoid additional government fees triggered by delayed filings",
          "Reduce the risk of penalties or other statutory consequences",
          "Prevent difficulty completing subsequent, dependent compliance",
          "Keep MCA records consistent with the company's actual position",
          "Ensure corporate changes are backed by the right approvals and documentation",
          "Support smoother due diligence and future transactions"
        ]
      },
      "afterService": {
        "heading": "Why Timing Matters",
        "items": [
          "A delay may result in additional government fees",
          "A delay may result in penalties or other consequences",
          "A delay can create difficulty completing subsequent compliance",
          "A delay can cause inconsistencies in MCA records"
        ]
      },
      "whyUs": {
        "heading": "Why Choose Biz360 Compliance?",
        "items": [
          "Event-specific assessment that looks at the transaction before identifying applicable compliance",
          "Documentation support coordinating corporate approvals alongside the filing",
          "Timeline awareness that factors in applicable filing periods to reduce delay risk",
          "Integrated support connecting event-based MCA compliance with accounting, taxation and annual ROC compliance"
        ]
      },
      "faqs": [
        {
          "q": "What is event-based MCA compliance?",
          "a": "It refers to statutory compliance triggered by a specific corporate event or change rather than a routine annual filing."
        },
        {
          "q": "Is event-based compliance applicable to every company?",
          "a": "No. It depends on the corporate event and the applicable provisions."
        },
        {
          "q": "Can you handle director appointment or resignation?",
          "a": "Yes. Applicable documentation and MCA filing support can be provided."
        },
        {
          "q": "Can you handle registered office changes?",
          "a": "Yes, subject to the applicable procedure and documentation."
        },
        {
          "q": "Can you assist with increase in authorised capital?",
          "a": "Yes. Applicable corporate approvals and MCA filing support can be provided."
        },
        {
          "q": "What happens if an event-based filing is delayed?",
          "a": "Additional fees and other statutory consequences may apply depending on the particular filing and delay."
        }
      ],
      "extra": null,
      "related": [
        "roc-mca-annual-compliance",
        "director-din-compliance",
        "llp-annual-compliance"
      ]
    }
  },
  {
    "slug": "director-din-compliance",
    "category": "Compliance",
    "sub_category": "Corporate Compliance",
    "icon": "UserCheck",
    "title": "Director & DIN Compliance Services",
    "subtitle": "Keep director records, DIN status and related MCA compliances up to date.",
    "read_time": "8 min read",
    "image": "https://images.unsplash.com/photo-1554224155-6726b3ff858f?crop=entropy&cs=srgb&fm=jpg&q=80&w=1200",
    "intro": "Directors of companies carry specific compliance obligations under the Companies Act, 2013 and applicable rules, whether they are being appointed, resigning, changing designation or particulars, or simply holding a DIN that requires annual KYC. Biz360 Compliance assists both companies and individual directors with DIN-related compliance, DIR-3 KYC, appointment and resignation filings, and other director-related MCA requirements. A central piece of this is DIR-3 KYC: under Rule 12A of the Companies (Appointment and Qualification of Directors) Rules, 2014, a person allotted a DIN up to 31 March of a financial year is generally required to complete the prescribed KYC filing by 30 September of the following financial year, failing which the DIN may be marked deactivated due to non-filing. Director appointment, resignation and other particulars changes are separately reported to the Registrar, commonly through Form DIR-12, which the MCA's instruction kit ties to a general 30-day filing window. Biz360 reviews DIN and MCA status, identifies the applicable requirement, and manages document collection, form preparation, DSC verification and filing through to record update.",
    "sections": {
      "whoNeedsIt": {
        "heading": "Who Needs This Service?",
        "items": [
          "Private Limited Companies",
          "Public Limited Companies",
          "One Person Companies",
          "Section 8 Companies",
          "Existing directors",
          "Newly appointed directors",
          "Persons holding a DIN",
          "Individuals requiring DIR-3 KYC support"
        ]
      },
      "eligibility": {
        "heading": "Our Director & DIN Services",
        "items": [
          "DIR-3 KYC – annual KYC compliance for applicable DIN holders",
          "Director appointment – documentation and applicable MCA filing",
          "Director resignation – documentation and filing of applicable particulars",
          "Change in director particulars – updates to MCA-held director information",
          "DIN-related support: status review, deactivated DIN handling, MCA master-data verification"
        ]
      },
      "documents": {
        "heading": "Documents Generally Required",
        "groups": [
          {
            "title": "Depending on the service",
            "items": [
              "DIN",
              "PAN",
              "Aadhaar / passport or other prescribed identity document",
              "Address details",
              "Mobile number",
              "Email ID",
              "Proof of address, where required",
              "DSC",
              "Director consent/resignation documents",
              "Board resolutions",
              "Other event-specific documents"
            ]
          }
        ]
      },
      "process": {
        "heading": "Our Process",
        "steps": [
          {
            "title": "DIN / Director Status Check",
            "desc": "We review the individual's DIN and relevant MCA records."
          },
          {
            "title": "Identify the Requirement",
            "desc": "We determine whether the requirement relates to KYC, appointment, resignation, change in particulars or another event."
          },
          {
            "title": "Document Collection",
            "desc": "Required identity, address and corporate documents are collected."
          },
          {
            "title": "Form Preparation",
            "desc": "The applicable MCA form/webform is prepared."
          },
          {
            "title": "DSC & Verification",
            "desc": "Required digital signatures and verification are completed."
          },
          {
            "title": "MCA Filing & Record Update",
            "desc": "The filing is submitted and the resulting MCA status/records are reviewed."
          }
        ]
      },
      "timeline": {
        "heading": "Estimated Timeline",
        "body": "DIR-3 KYC is generally due by 30 September of the financial year following DIN allotment (for a DIN allotted up to 31 March). Director appointment, cessation or designation changes are generally reported via Form DIR-12 within a 30-day filing window from the relevant event, per the MCA's instruction kit."
      },
      "fees": {
        "heading": "Government Fees & Professional Fees",
        "note": "Professional fees depend on the nature of the compliance, number of directors, number of filings, documentation requirements, whether the DIN is active or deactivated, and additional MCA compliance required. Government fees and additional fees, where applicable, are separate from professional fees."
      },
      "benefits": {
        "heading": "Benefits of Timely Director Compliance",
        "items": [
          "Keep MCA records updated",
          "Avoid DIN deactivation due to non-filing",
          "Complete corporate changes within prescribed timelines",
          "Maintain accurate director information",
          "Reduce additional fees and compliance complications",
          "Keep the company's broader MCA compliance in order"
        ]
      },
      "afterService": {
        "heading": "DIR-3 KYC – Important Compliance",
        "items": [
          "A person allotted a DIN up to 31 March of a financial year is generally required to file the prescribed KYC webform by 30 September of the following financial year",
          "The KYC process also allows updating the registered mobile number and email",
          "Where KYC compliance is not completed, the DIN may be marked deactivated due to non-filing of DIR-3 KYC",
          "Restoration of a deactivated DIN is subject to the applicable MCA process"
        ]
      },
      "whyUs": {
        "heading": "Why Choose Biz360 Compliance?",
        "items": [
          "Individual + company compliance viewed together, covering both the director's DIN and the company's related MCA requirements",
          "Deadline tracking for recurring requirements such as DIR-3 KYC",
          "Event-based support for appointment, resignation and other changes as they arise",
          "Integrated MCA compliance combining director compliance with ROC annual and event-based filings"
        ]
      },
      "faqs": [
        {
          "q": "What is DIR-3 KYC?",
          "a": "It is the prescribed MCA KYC process for applicable DIN holders."
        },
        {
          "q": "Who needs to file DIR-3 KYC?",
          "a": "A person allotted a DIN up to 31 March of the relevant financial year is generally required to complete the prescribed KYC process by 30 September of the immediately following financial year."
        },
        {
          "q": "What happens if DIR-3 KYC is not filed?",
          "a": "The DIN can be marked deactivated due to non-filing of DIR-3 KYC, subject to the applicable MCA provisions."
        },
        {
          "q": "Can a deactivated DIN be restored?",
          "a": "Yes, the applicable MCA process can be followed for restoration, subject to the circumstances and prescribed fees/requirements."
        },
        {
          "q": "What is DIR-12?",
          "a": "DIR-12 is used for filing particulars relating to appointment, cessation and changes in designation of directors and KMP, where applicable."
        },
        {
          "q": "How quickly should director appointment or resignation be reported?",
          "a": "For the general applicable cases, DIR-12 is required within 30 days of the appointment, cessation or relevant change."
        }
      ],
      "extra": null,
      "related": [
        "roc-mca-annual-compliance",
        "event-based-roc-mca-compliance",
        "llp-annual-compliance"
      ]
    }
  },
  {
    "slug": "payroll-processing-compliance",
    "category": "Compliance",
    "sub_category": "Payroll & Labour Compliance",
    "icon": "Users",
    "title": "Payroll Processing & Compliance Services",
    "subtitle": "Accurate payroll, timely salary processing and coordinated statutory compliance.",
    "read_time": "7 min read",
    "image": "https://images.unsplash.com/photo-1519389950473-47ba0277781c?crop=entropy&cs=srgb&fm=jpg&q=80&w=1200",
    "intro": "Payroll is not limited to calculating employee salaries. A proper payroll process must also account for applicable statutory deductions, employee records and monthly compliance obligations. Biz360 Compliance helps businesses manage their monthly payroll process along with applicable PF, ESI, Professional Tax and TDS-related requirements, taking the process from salary inputs all the way through to payroll reports and statutory compliance coordination. Rather than treating payroll as a standalone administrative task, our approach integrates it with your accounting and statutory filings so payroll data, accounts and statutory returns stay consistent. This is particularly useful for businesses that do not want to maintain a separate in-house payroll team, and works equally well for a small startup or a growing MSME with increasing employee strength. The result is a structured monthly cycle covering salary calculation, statutory review, reporting and reconciliation.",
    "sections": {
      "whoNeedsIt": {
        "heading": "Who Needs Payroll Processing & Compliance?",
        "items": [
          "Startups building their first payroll process",
          "MSMEs without a dedicated payroll team",
          "Private Limited Companies and LLPs",
          "Partnership Firms and Proprietorships",
          "Professional organisations",
          "Businesses with growing employee strength",
          "Businesses wanting payroll integrated with accounting"
        ]
      },
      "eligibility": {
        "heading": "What We Cover",
        "items": [
          "Monthly salary calculation and net pay processing",
          "Attendance-based adjustments, leave and deductions",
          "Incentives, reimbursements and overtime, where applicable",
          "Statutory payroll compliance across PF, ESI, Professional Tax and TDS",
          "Payroll reports and reconciliation",
          "Employee onboarding, exit and master data updates"
        ]
      },
      "documents": {
        "heading": "Documents & Information Generally Required",
        "groups": [
          {
            "title": "Payroll Inputs",
            "items": [
              "Employee master and salary structure",
              "Attendance and leave details",
              "New joining and exit information",
              "Incentives, reimbursements and loan/advance deductions"
            ]
          },
          {
            "title": "Statutory Details",
            "items": [
              "PF/ESI details",
              "Professional Tax details",
              "TDS declarations and investment information, where applicable"
            ]
          }
        ]
      },
      "process": {
        "heading": "Our Monthly Payroll Process",
        "steps": [
          {
            "title": "Collect Payroll Inputs",
            "desc": "Attendance, salary structure, leave, incentives, reimbursements and other relevant information are collected."
          },
          {
            "title": "Calculate Payroll",
            "desc": "Gross salary, deductions and net salary are calculated based on the applicable salary structure."
          },
          {
            "title": "Statutory Review",
            "desc": "Applicable PF, ESI, Professional Tax and TDS requirements are reviewed."
          },
          {
            "title": "Payroll Reports",
            "desc": "Salary sheets and statutory summaries are prepared."
          },
          {
            "title": "Compliance Coordination",
            "desc": "Applicable statutory payments and filings are coordinated within the prescribed timelines."
          },
          {
            "title": "Reconciliation",
            "desc": "Payroll records are reconciled with statutory and accounting records."
          }
        ]
      },
      "timeline": {
        "heading": "Estimated Timeline",
        "body": "Payroll runs on a defined monthly cycle, from collection of payroll inputs at the start of the cycle through to reports, statutory coordination and reconciliation before the next cycle begins."
      },
      "fees": {
        "heading": "Government Fees & Professional Fees",
        "note": "Professional fees depend on the number of employees, payroll complexity, salary structure, number of locations, statutory registrations, frequency of payroll processing and any additional HR/payroll requirements. Get a customised monthly payroll proposal."
      },
      "benefits": {
        "heading": "Benefits of Payroll Processing & Compliance",
        "items": [
          "Reduces administrative work so management can focus on operations",
          "Improves accuracy by reducing manual calculation and reconciliation issues",
          "Integrates PF, ESI, Professional Tax and TDS compliance with payroll",
          "Handles employee salary information through a controlled, confidential process",
          "Scales as employee strength increases",
          "Allows payroll data to flow directly into accounting and monthly financial reporting"
        ]
      },
      "afterService": null,
      "whyUs": {
        "heading": "Why Choose Biz360 Compliance?",
        "items": [
          "Accounting, payroll and compliance are managed together rather than in isolation",
          "A defined monthly payroll cycle maintains consistency",
          "PF, ESI, Professional Tax and TDS can be managed alongside payroll, where applicable",
          "Flexible engagement suited to basic payroll processing as well as broader compliance support"
        ]
      },
      "faqs": [
        {
          "q": "Do you provide monthly payroll processing?",
          "a": "Yes. Payroll can be processed every month based on the agreed payroll cycle."
        },
        {
          "q": "Can you manage PF and ESI along with payroll?",
          "a": "Yes. PF and ESI compliance can be integrated with the payroll engagement."
        },
        {
          "q": "Can Professional Tax be included?",
          "a": "Yes, where applicable under the relevant State law."
        },
        {
          "q": "Do you handle TDS on salary?",
          "a": "Yes. Salary TDS calculation and related compliance can be included based on the scope."
        },
        {
          "q": "Can payroll be integrated with accounting?",
          "a": "Yes. Payroll information can be incorporated into the accounting records."
        },
        {
          "q": "Can you handle payroll for a small company?",
          "a": "Yes. Payroll outsourcing can be useful even for businesses with a relatively small employee base."
        }
      ],
      "extra": {
        "kind": "table",
        "columns": [
          "Area",
          "Support"
        ],
        "rows": [
          [
            "Salary",
            "Monthly salary calculation"
          ],
          [
            "PF",
            "Contribution & ECR compliance"
          ],
          [
            "ESI",
            "Contribution & ESIC compliance"
          ],
          [
            "Professional Tax",
            "Applicable deductions & filings"
          ],
          [
            "TDS",
            "Salary TDS & related compliance"
          ],
          [
            "Accounting",
            "Payroll accounting entries"
          ],
          [
            "Employee Records",
            "Joining, exit & master updates"
          ]
        ]
      },
      "related": [
        "pf-epf-compliance",
        "esi-compliance",
        "professional-tax-compliance"
      ]
    }
  },
  {
    "slug": "pf-epf-compliance",
    "category": "Compliance",
    "sub_category": "Payroll & Labour Compliance",
    "icon": "Landmark",
    "title": "PF / EPF Compliance Services for Employers",
    "subtitle": "Manage your provident fund obligations, monthly ECR filings and employee-related EPF compliance with greater accuracy.",
    "read_time": "8 min read",
    "image": "https://images.unsplash.com/photo-1554224155-1696413565d3?crop=entropy&cs=srgb&fm=jpg&q=80&w=1200",
    "intro": "The Employees' Provident Funds and Miscellaneous Provisions Act, 1952, along with its related schemes, prescribes provident fund, pension and insurance-related obligations for covered establishments. For a covered employer, compliance goes well beyond simply depositing PF contributions each month; it requires maintaining employee records, handling UAN-related processes, preparing monthly contribution data and completing prescribed filings through EPFO's Electronic Challan-cum-Return (ECR) system, with payment generally due by the 15th of the following month. Biz360 Compliance provides ongoing EPF compliance support, including contribution calculation, ECR filing, employee onboarding and exit-related assistance. Since applicability depends on the nature of the establishment, its coverage under the Act and employee-level conditions rather than salary alone, we help businesses assess PF applicability properly, calculate contributions correctly, and stay current with EPFO's latest ECR format and portal requirements.",
    "sections": {
      "whoNeedsIt": {
        "heading": "Who Needs PF Compliance?",
        "items": [
          "Establishments covered under the EPF Act, including those meeting the prescribed employee-strength threshold",
          "Establishments otherwise brought under EPF coverage",
          "Employers with employees drawing basic wages plus DA up to ₹15,000 per month who must statutorily become members",
          "Employers with employees above that wage level who may become members in specified circumstances",
          "Businesses needing PF calculations integrated with payroll and accounting",
          "Employers managing UAN, onboarding and exit-related processes for staff"
        ]
      },
      "eligibility": {
        "heading": "Eligibility & Applicability Assessment",
        "items": [
          "PF applicability assessed establishment-wise based on coverage under the EPF Act",
          "Employee-level membership assessed based on applicable wage conditions",
          "Standard employee contribution of 12% of applicable basic wages, DA and retaining allowance, where applicable",
          "Employer contribution generally 12%, allocated between EPF and EPS as prescribed, plus EDLI contribution",
          "Statutory wage ceiling of ₹15,000 relevant for the standard contribution framework",
          "Separate rules applicable to international workers",
          "Applicability should not be determined by salary alone — a proper establishment and employee-wise review is advisable"
        ]
      },
      "documents": {
        "heading": "Documents & Information Generally Required",
        "groups": [
          {
            "title": "For Ongoing Compliance",
            "items": [
              "Employer PF registration details",
              "Employee master and UAN details",
              "Aadhaar/KYC information, where applicable",
              "Salary/payroll data",
              "Joining and exit details",
              "Attendance information",
              "Previous ECR/challan records",
              "Bank/payment details"
            ]
          }
        ]
      },
      "process": {
        "heading": "Monthly PF Compliance Process",
        "steps": [
          {
            "title": "Payroll Data",
            "desc": "Employee attendance, salary and applicable wage components are collected."
          },
          {
            "title": "PF Calculation",
            "desc": "Employee and employer contributions are calculated/reviewed."
          },
          {
            "title": "Employee Data Verification",
            "desc": "UAN and employee information are checked."
          },
          {
            "title": "ECR Preparation",
            "desc": "Monthly contribution data is prepared in the applicable EPFO format."
          },
          {
            "title": "ECR Filing & Payment",
            "desc": "ECR is filed and contribution payment is coordinated."
          },
          {
            "title": "Reconciliation",
            "desc": "Payroll records, ECR and payment information are reconciled."
          }
        ]
      },
      "timeline": {
        "heading": "Estimated Timeline",
        "body": "Monthly PF contribution and payment is generally due by the 15th of the following month, with ECR preparation and filing coordinated within that same monthly cycle."
      },
      "fees": {
        "heading": "Government Fees & Professional Fees",
        "note": "Professional fees depend on the number of employees, monthly payroll frequency, employee onboarding/exit volume, complexity of payroll, reconciliation requirements and additional EPFO services. Get a customised monthly compliance proposal."
      },
      "benefits": {
        "heading": "Benefits of Timely PF Compliance",
        "items": [
          "Avoids consequences of delayed contributions",
          "Maintains accurate employee records",
          "Reduces payroll-PF mismatches",
          "Keeps ECR and payment records organised",
          "Enables more effective responses to EPFO queries",
          "Maintains proper statutory documentation"
        ]
      },
      "afterService": {
        "heading": "Important Employee Compliance Areas",
        "items": [
          "New employee enrolment and UAN-related matters",
          "Aadhaar/KYC-related updates",
          "Transfer-related support",
          "Date of exit and employee profile corrections",
          "PF reconciliation and employer/member data discrepancies",
          "Use of the latest applicable ECR format and portal requirements"
        ]
      },
      "whyUs": {
        "heading": "Why Choose Biz360 Compliance?",
        "items": [
          "PF calculations integrated with your payroll and accounting process",
          "Monthly compliance tracking to avoid accumulation of pending filings",
          "Reconciliation-focused review of payroll, ECR and payment records",
          "Employee-level support for UAN, onboarding, exit and profile requirements",
          "PF compliance coordinated with ESI, Professional Tax, Payroll, TDS and accounting"
        ]
      },
      "faqs": [
        {
          "q": "When does PF become applicable to an establishment?",
          "a": "Applicability depends on the coverage provisions of the EPF law and the nature/strength of the establishment. A specific applicability review is advisable."
        },
        {
          "q": "Is PF applicable only when an employee earns less than ₹15,000?",
          "a": "No. The ₹15,000 wage ceiling is important for mandatory membership and contribution calculations, but PF applicability cannot be determined by salary alone."
        },
        {
          "q": "What is the normal employee PF contribution?",
          "a": "The employee contribution is generally 12% of applicable basic wages plus DA and retaining allowance, where applicable."
        },
        {
          "q": "What is the normal employer contribution?",
          "a": "The employer generally contributes 12%, allocated between EPF and EPS as prescribed, with other applicable employer contributions such as EDLI."
        },
        {
          "q": "When is monthly PF payment generally due?",
          "a": "Monthly contribution/payment is generally due by the 15th of the following month."
        },
        {
          "q": "Can PF compliance be combined with payroll?",
          "a": "Yes. Payroll processing and PF compliance can be integrated into one engagement."
        }
      ],
      "extra": {
        "kind": "table",
        "columns": [
          "Component",
          "Rate"
        ],
        "rows": [
          [
            "Employee EPF",
            "12% of applicable wages"
          ],
          [
            "Employer Contribution",
            "12% of applicable wages"
          ],
          [
            "EPS",
            "Employer contribution is allocated as prescribed"
          ],
          [
            "EDLI",
            "Employer contribution as prescribed"
          ]
        ]
      },
      "related": [
        "esi-compliance",
        "payroll-processing-compliance",
        "labour-law-compliance"
      ]
    }
  },
  {
    "slug": "esi-compliance",
    "category": "Compliance",
    "sub_category": "Payroll & Labour Compliance",
    "icon": "HeartHandshake",
    "title": "ESI Compliance Services for Employers",
    "subtitle": "Manage employee ESI contributions, monthly filings and statutory records with a structured compliance process.",
    "read_time": "7 min read",
    "image": "https://images.unsplash.com/photo-1521791136064-7986c2920216?crop=entropy&cs=srgb&fm=jpg&q=80&w=1200",
    "intro": "The Employees' State Insurance Act, 1948 provides social-security benefits to eligible employees covered under the ESI scheme. For an applicable employer, compliance involves far more than simply depositing contributions each month — it requires maintaining employee records, calculating contributions correctly, updating employee details and completing the prescribed monthly compliance processes. Applicability should be assessed based on the nature of the establishment, coverage provisions, employee count, wage criteria and applicable notifications, rather than on employee count or salary alone. Biz360 Compliance assists employers with ESI registration, monthly contribution compliance, employee records and ongoing ESIC-related requirements, including employee registration, exit and update support, reconciliation of payroll and ESIC records, and portal-related assistance, so that contributions, filings and employee data stay consistent and current.",
    "sections": {
      "whoNeedsIt": {
        "heading": "Who Needs ESI Compliance?",
        "items": [
          "Factories",
          "Shops",
          "Hotels and restaurants",
          "Commercial establishments",
          "Other notified establishments",
          "Employers whose employees fall within the applicable wage ceiling and coverage conditions"
        ]
      },
      "eligibility": {
        "heading": "Eligibility & Applicability Assessment",
        "items": [
          "Applicability assessed based on nature of the establishment and coverage provisions",
          "Employee count and wage criteria reviewed against applicable notifications",
          "Employee coverage subject to the applicable wage ceiling and other statutory conditions",
          "Standard employee contribution rate of 0.75% of wages",
          "Standard employer contribution rate of 3.25% of wages",
          "Total standard contribution of 4.00% of wages",
          "Applicability should not be determined solely on employee count or salary — a proper assessment is preferable"
        ]
      },
      "documents": {
        "heading": "Documents & Information Generally Required",
        "groups": [
          {
            "title": "Employer & Employee Records",
            "items": [
              "ESIC employer details",
              "Employee master and insurance numbers",
              "Aadhaar/KYC information, where applicable",
              "Salary and payroll data",
              "Joining and exit details",
              "Attendance information",
              "Previous contribution records"
            ]
          }
        ]
      },
      "process": {
        "heading": "Monthly ESI Compliance Process",
        "steps": [
          {
            "title": "Payroll Data",
            "desc": "Employee salary, attendance and other relevant payroll information is collected."
          },
          {
            "title": "Eligibility Review",
            "desc": "Employees covered under the applicable ESI provisions are identified."
          },
          {
            "title": "Contribution Calculation",
            "desc": "Employee and employer contributions are calculated."
          },
          {
            "title": "ESIC Compliance",
            "desc": "The applicable monthly contribution and portal processes are completed."
          },
          {
            "title": "Payment",
            "desc": "Payment is coordinated within the prescribed statutory timeline."
          },
          {
            "title": "Reconciliation",
            "desc": "Payroll, contribution and payment records are reconciled."
          }
        ]
      },
      "timeline": {
        "heading": "Estimated Timeline",
        "body": "ESI compliance follows a monthly cycle — eligibility review, contribution calculation, the ESIC compliance process and payment are completed within the prescribed statutory timeline each month, followed by reconciliation."
      },
      "fees": {
        "heading": "Government Fees & Professional Fees",
        "note": "Professional fees depend on the number of employees, payroll frequency, employee onboarding/exit volume, complexity of payroll, reconciliation requirements and additional ESIC services. Get a customised monthly compliance proposal."
      },
      "benefits": {
        "heading": "Benefits of Timely ESI Compliance",
        "items": [
          "Avoids accumulation of pending contributions",
          "Maintains accurate employee records",
          "Reduces payroll-to-ESI mismatches",
          "Maintains proper statutory documentation",
          "Enables more effective responses to ESIC queries",
          "Keeps employee-related statutory records organised"
        ]
      },
      "afterService": {
        "heading": "Employee-Level Support",
        "items": [
          "New employee registration and insurance number-related processes",
          "Employee profile updates",
          "Exit/date-related updates",
          "Family/dependent information",
          "Correction of employee details",
          "ESIC-related documentation"
        ]
      },
      "whyUs": {
        "heading": "Why Choose Biz360 Compliance?",
        "items": [
          "ESI compliance coordinated with your payroll and accounting process",
          "Monthly tracking to maintain a regular compliance cycle instead of dealing with accumulated filings",
          "Employee eligibility and records reviewed as part of the process",
          "Payroll and ESIC records compared to identify discrepancies",
          "ESI combined with PF, Professional Tax, Payroll and other applicable labour-law services"
        ]
      },
      "faqs": [
        {
          "q": "When does ESI become applicable?",
          "a": "Applicability depends on the establishment, employee count, wage conditions and the applicable provisions of the ESI framework."
        },
        {
          "q": "What is the employee ESI contribution?",
          "a": "The standard employee contribution is 0.75% of wages."
        },
        {
          "q": "What is the employer ESI contribution?",
          "a": "The standard employer contribution is 3.25% of wages."
        },
        {
          "q": "Can ESI compliance be handled along with payroll?",
          "a": "Yes. Payroll and ESI compliance are commonly integrated into a single monthly process."
        },
        {
          "q": "Do you provide monthly ESI compliance?",
          "a": "Yes. Monthly contribution and related compliance support can be provided."
        },
        {
          "q": "Can you handle PF and ESI together?",
          "a": "Yes. Biz360 can provide an integrated PF + ESI + Payroll Compliance engagement."
        }
      ],
      "extra": {
        "kind": "table",
        "columns": [
          "Contribution",
          "Rate"
        ],
        "rows": [
          [
            "Employee Contribution",
            "0.75%"
          ],
          [
            "Employer Contribution",
            "3.25%"
          ],
          [
            "Total",
            "4.00%"
          ]
        ]
      },
      "related": [
        "pf-epf-compliance",
        "payroll-processing-compliance",
        "labour-law-compliance"
      ]
    }
  },
  {
    "slug": "professional-tax-compliance",
    "category": "Compliance",
    "sub_category": "Payroll & Labour Compliance",
    "icon": "Percent",
    "title": "Professional Tax Registration & Compliance",
    "subtitle": "Stay on top of Professional Tax registration, enrolment, deductions and periodic compliance.",
    "read_time": "7 min read",
    "image": "https://images.unsplash.com/photo-1554224155-8d04cb21cd6c?crop=entropy&cs=srgb&fm=jpg&q=80&w=1200",
    "intro": "Professional Tax is a State-level tax imposed on income from professions, trades, callings and employment, within the limits prescribed under the Constitution and the respective State law. Unlike Income Tax, which is a Central levy, Professional Tax compliance requirements are State-specific — registration, enrolment, deduction, payment frequency, return filing and exemptions can all differ between States. Biz360 Compliance helps businesses manage applicable Professional Tax registration, employee deductions, payments, returns and related compliance according to the requirements of the relevant State. For businesses operating in Maharashtra, compliance is primarily governed by the Maharashtra State Tax on Professions, Trades, Callings and Employments Act, 1975, and typically involves both PTEC, relevant to persons/entities liable to pay the tax, and PTRC, relevant to employers responsible for deducting and depositing tax from employees. A business operating in more than one State should review applicability separately for each State.",
    "sections": {
      "whoNeedsIt": {
        "heading": "Who May Need Professional Tax Compliance?",
        "items": [
          "Employers with employees subject to State Professional Tax deduction",
          "Companies",
          "LLPs",
          "Partnership Firms",
          "Proprietorships",
          "Professionals",
          "Other persons covered by the applicable State law",
          "Businesses operating across multiple States"
        ]
      },
      "eligibility": {
        "heading": "Eligibility & Applicability Assessment",
        "items": [
          "Professional Tax applicable only in States/Union Territories where the relevant legislation is in force",
          "PTEC relevant to persons/entities liable to pay tax under Maharashtra provisions",
          "PTRC relevant to employers responsible for deducting and depositing tax from employees",
          "Employee-level applicability dependent on relevant State legislation, salary and exemptions/thresholds",
          "Exact applicability depends on the nature of the person/entity",
          "Businesses in more than one State should review State-wise applicability separately"
        ]
      },
      "documents": {
        "heading": "Documents Generally Required",
        "groups": [
          {
            "title": "Depending on State and Registration Type",
            "items": [
              "PAN",
              "Business registration documents",
              "Address proof",
              "Employer details",
              "Employee/payroll details",
              "Bank details",
              "Business commencement information",
              "Existing registration details, where applicable"
            ]
          }
        ]
      },
      "process": {
        "heading": "Our Compliance Process",
        "steps": [
          {
            "title": "Applicability Review",
            "desc": "The relevant State and applicable Professional Tax requirements are identified."
          },
          {
            "title": "Registration / Enrolment",
            "desc": "Where required, we assist with the applicable registration or enrolment."
          },
          {
            "title": "Payroll Integration",
            "desc": "Employee salary information is reviewed to determine applicable deductions."
          },
          {
            "title": "Periodic Compliance",
            "desc": "Applicable payments and returns are prepared and filed."
          },
          {
            "title": "Reconciliation",
            "desc": "Payroll records and Professional Tax payments are reviewed for consistency."
          },
          {
            "title": "Ongoing Tracking",
            "desc": "Due dates and changes in employee/business details are monitored."
          }
        ]
      },
      "timeline": {
        "heading": "Estimated Timeline",
        "body": "Registration/enrolment timelines depend on the applicable State process, after which Professional Tax follows a periodic payment and return cycle integrated with payroll."
      },
      "fees": {
        "heading": "Government Fees & Professional Fees",
        "note": "Fees depend on the State of operation, number of employees, registration requirements, filing frequency, number of establishments and any additional amendments or compliance work. Government taxes/fees and professional fees are separate."
      },
      "benefits": {
        "heading": "Benefits of Professional Tax Compliance",
        "items": [
          "State-specific assessment rather than a one-size-fits-all national procedure",
          "Professional Tax integrated with your salary and payroll process",
          "Regular compliance tracking for applicable payment and return requirements",
          "Reduced risk of missed State-level obligations",
          "Coordinated management alongside PF, ESI and Payroll Compliance"
        ]
      },
      "afterService": null,
      "whyUs": {
        "heading": "Why Choose Biz360 Compliance?",
        "items": [
          "State-specific compliance assessment for each business",
          "Payroll-linked process for Professional Tax deductions",
          "Regular compliance tracking to stay organised with payments and returns",
          "Integrated labour compliance alongside PF, ESI and Payroll"
        ]
      },
      "faqs": [
        {
          "q": "Is Professional Tax applicable throughout India?",
          "a": "No. Professional Tax is a State-level levy and is applicable only in States/Union Territories where the relevant legislation is in force."
        },
        {
          "q": "Is Professional Tax the same as Income Tax?",
          "a": "No. Income Tax is a Central tax, whereas Professional Tax is a State-level tax."
        },
        {
          "q": "What is PTRC in Maharashtra?",
          "a": "PTRC generally refers to the registration applicable to an employer responsible for deducting and depositing Professional Tax from employees."
        },
        {
          "q": "What is PTEC?",
          "a": "PTEC generally relates to enrolment for persons/entities liable to pay Professional Tax under the applicable Maharashtra provisions."
        },
        {
          "q": "Can Professional Tax be managed along with payroll?",
          "a": "Yes. This is generally the most practical approach because deductions are linked to employee payroll."
        },
        {
          "q": "Can Biz360 manage Professional Tax along with PF and ESI?",
          "a": "Yes. We can provide an integrated Payroll + PF + ESI + Professional Tax Compliance service."
        }
      ],
      "extra": {
        "kind": "cards",
        "cards": [
          {
            "title": "PTEC",
            "desc": "Professional Tax Enrolment Certificate — generally relevant to persons/entities liable to pay tax under the applicable provisions."
          },
          {
            "title": "PTRC",
            "desc": "Professional Tax Registration Certificate — generally relevant to employers responsible for deducting and depositing Professional Tax from employees."
          }
        ]
      },
      "related": [
        "payroll-processing-compliance",
        "pf-epf-compliance",
        "labour-law-compliance"
      ]
    }
  },
  {
    "slug": "labour-law-compliance",
    "category": "Compliance",
    "sub_category": "Payroll & Labour Compliance",
    "icon": "Scale",
    "title": "Labour Law Compliance for Businesses",
    "subtitle": "Manage employment-related statutory requirements with a structured compliance process.",
    "read_time": "8 min read",
    "image": "https://images.unsplash.com/photo-1554224154-26032ffc0d07?crop=entropy&cs=srgb&fm=jpg&q=80&w=1200",
    "intro": "Labour law compliance covers the statutory requirements applicable to an employer in relation to employees, wages, working conditions, records, leave, employment documentation and workplace requirements. What actually applies to a given business depends on factors such as the State of operation, nature of business, number of employees, type of establishment and employment structure, alongside the relevant Central and State laws in force. Biz360 Compliance helps businesses identify and manage applicable labour, employment, payroll and workplace compliance requirements based on their specific circumstances, rather than applying a single generic checklist to every client. This can span minimum wage and payment-of-wages requirements, working hours and leave, employee records and registers, PF, ESI, Professional Tax, Shops & Establishment requirements, contract labour, maternity and gratuity-related obligations. As a broader hub service, it connects naturally with our Payroll, PF, ESI and Professional Tax compliance offerings.",
    "sections": {
      "whoNeedsIt": {
        "heading": "Who Needs Labour Law Compliance?",
        "items": [
          "Private Limited Companies and LLPs",
          "Partnership Firms and Proprietorships",
          "Startups and MSMEs",
          "Factories",
          "Shops and commercial establishments",
          "Service businesses",
          "Employers with growing employee strength"
        ]
      },
      "eligibility": {
        "heading": "Applicability Assessment",
        "items": [
          "Applicability determined by State of operation, nature of business and employee strength",
          "Type of establishment and employment structure reviewed",
          "Relevant Central and State laws mapped to the business",
          "Not every law applies to every business — assessed on the establishment's specific circumstances",
          "May cover minimum wages, working hours, leave, wage registers and employee records",
          "May include PF, ESI, Professional Tax, Shops & Establishment, contract labour, maternity and gratuity requirements, where applicable"
        ]
      },
      "documents": {
        "heading": "Documents Generally Required",
        "groups": [
          {
            "title": "Depending on Scope",
            "items": [
              "Business registration documents",
              "Employee master and salary structure",
              "Attendance and leave records",
              "Existing labour registrations",
              "PF / ESI details",
              "Shops & Establishment details",
              "Payroll records and existing statutory registers",
              "Employment-related policies/documents"
            ]
          }
        ]
      },
      "process": {
        "heading": "Our Compliance Process",
        "steps": [
          {
            "title": "Understand the Business",
            "desc": "We review your business activity, location, employee strength and employment structure."
          },
          {
            "title": "Identify Applicable Requirements",
            "desc": "Relevant Central and State-level requirements are mapped based on the available information."
          },
          {
            "title": "Compliance Gap Review",
            "desc": "Existing registrations, records and processes are reviewed."
          },
          {
            "title": "Compliance Setup",
            "desc": "We help establish the required compliance calendar, records and processes."
          },
          {
            "title": "Periodic Monitoring",
            "desc": "Applicable recurring requirements are tracked and reviewed."
          },
          {
            "title": "Corrective Support",
            "desc": "Where gaps are identified, appropriate corrective steps can be recommended."
          }
        ]
      },
      "timeline": {
        "heading": "Estimated Timeline",
        "body": "Initial applicability review and compliance gap assessment are followed by compliance setup, with periodic monitoring maintained throughout the year rather than addressed only when a notice or inspection arises."
      },
      "fees": {
        "heading": "Government Fees & Professional Fees",
        "note": "Fees depend on the number of employees, business activity, State/location, number of registrations, compliance complexity, monthly/annual scope and number of establishments. Get a customised labour compliance proposal."
      },
      "benefits": {
        "heading": "Benefits of Labour Law Compliance",
        "items": [
          "Maintains proper employee records",
          "Reduces compliance gaps",
          "Avoids accumulation of statutory defaults",
          "Improves payroll and HR processes",
          "Enables more effective responses to inspections/notices",
          "Maintains better employment documentation"
        ]
      },
      "afterService": null,
      "whyUs": {
        "heading": "Why Choose Biz360 Compliance?",
        "items": [
          "Business-specific assessment rather than a single checklist for every business",
          "Labour compliance coordinated with Payroll, PF, ESI and Professional Tax",
          "State-aware approach reflecting where the establishment operates",
          "Ongoing compliance support throughout the year, not just at inspection time",
          "One compliance partner for accounting, taxation and employment compliance"
        ]
      },
      "faqs": [
        {
          "q": "What is labour law compliance?",
          "a": "It refers to complying with applicable employment, wage, workplace and employee-related statutory requirements."
        },
        {
          "q": "Does every business have the same labour-law requirements?",
          "a": "No. Applicability depends on factors such as business activity, location, employee strength and type of establishment."
        },
        {
          "q": "Does labour compliance include PF and ESI?",
          "a": "PF and ESI are important employment-related compliances, but they are separate statutory frameworks. They can be managed as part of a broader compliance engagement."
        },
        {
          "q": "Is Shops & Establishment compliance a labour-law requirement?",
          "a": "It is a separate State-specific regulatory framework governing establishments and employment conditions, and may form part of the broader compliance review."
        },
        {
          "q": "Can labour compliance be combined with payroll?",
          "a": "Yes. In fact, integrating payroll with applicable labour compliance can reduce duplication and discrepancies."
        },
        {
          "q": "Can you manage labour compliance on a monthly basis?",
          "a": "Yes. A recurring compliance arrangement can be structured according to the business requirements."
        }
      ],
      "extra": null,
      "related": [
        "pf-epf-compliance",
        "esi-compliance",
        "professional-tax-compliance"
      ]
    }
  },
  {
    "slug": "annual-compliance-management",
    "category": "Compliance",
    "sub_category": "Compliance Management & Advisory",
    "icon": "Calendar",
    "title": "Annual Compliance Management for Businesses",
    "subtitle": "One compliance calendar. Multiple statutory requirements. Better control throughout the year.",
    "read_time": "7 min read",
    "image": "https://images.unsplash.com/photo-1518186285589-2f7649de83e0?crop=entropy&cs=srgb&fm=jpg&q=80&w=1200",
    "intro": "Business compliance is not limited to filing returns at year-end — different obligations arise throughout the year depending on the business structure, employees, registrations and transactions involved. Biz360 Compliance helps businesses track and manage their recurring corporate, tax, payroll and statutory compliance requirements through a structured, centralised process. Instead of maintaining separate reminders for every registration, Biz360 helps build a centralised compliance calendar, coordinate required filings and identify upcoming obligations well in advance. The scope of the engagement is customised according to the entity type and the laws applicable to it, so businesses get a clearer view of what is due, when it is due and what information is required to complete it — rather than reacting to deadlines as they arrive.",
    "sections": {
      "whoNeedsIt": {
        "heading": "Who Needs Annual Compliance Management?",
        "items": [
          "Private Limited Companies",
          "LLPs",
          "Startups",
          "MSMEs",
          "Partnership Firms",
          "Proprietorships with multiple registrations",
          "Businesses with employees",
          "Multi-location businesses without an in-house compliance team"
        ]
      },
      "eligibility": {
        "heading": "What We Can Manage",
        "items": [
          "Corporate compliance — ROC & MCA annual filings, Director/DIN compliance, event-based MCA filings, LLP annual compliance",
          "Tax compliance — GST returns, TDS compliance, Income Tax compliance, Professional Tax",
          "Payroll & labour compliance — PF/EPF, ESI, payroll compliance, Shops & Establishment requirements",
          "Other applicable labour compliances",
          "Monitoring of business registrations, renewals and amendments",
          "Coordination of accounting, payroll and statutory filing information"
        ]
      },
      "documents": {
        "heading": "Documents Required",
        "groups": [
          {
            "title": "Entity & Registration Records",
            "items": [
              "Entity registration documents",
              "PAN and TAN",
              "GST registration details",
              "MCA records",
              "Details of business registrations"
            ]
          },
          {
            "title": "Operational & Filing Data",
            "items": [
              "Accounting information",
              "Payroll data",
              "PF/ESI details",
              "Professional Tax registration",
              "Previous return filings",
              "Existing compliance calendar, if any"
            ]
          }
        ]
      },
      "process": {
        "heading": "How Compliance Management Works",
        "steps": [
          {
            "title": "Compliance Assessment",
            "desc": "We understand your business structure, registrations, employee strength and applicable compliance areas."
          },
          {
            "title": "Compliance Calendar",
            "desc": "A practical compliance calendar is prepared based on the applicable requirements."
          },
          {
            "title": "Document & Data Collection",
            "desc": "Required accounting, payroll and statutory information is collected according to the filing cycle."
          },
          {
            "title": "Compliance Execution",
            "desc": "Applicable returns, forms and filings are prepared and coordinated."
          },
          {
            "title": "Due-Date Tracking",
            "desc": "Upcoming deadlines and pending requirements are monitored."
          },
          {
            "title": "Periodic Review",
            "desc": "Compliance status is reviewed to identify missed, pending or upcoming requirements."
          }
        ]
      },
      "timeline": {
        "heading": "Estimated Timeline",
        "body": "Compliance management is an ongoing engagement structured around monthly, quarterly, annual and event-based filing cycles rather than a one-time deliverable. The actual frequency of each activity depends on the entity type and the laws applicable to it."
      },
      "fees": {
        "heading": "Government Fees & Professional Fees",
        "note": "Professional fees depend on the entity type, number of registrations, employee strength, number of monthly/annual filings, transaction volume, number of locations and overall complexity of compliance requirements. A customised annual or monthly compliance proposal is provided after assessment."
      },
      "benefits": {
        "heading": "Benefits of Annual Compliance Management",
        "items": [
          "Avoid missed deadlines through a central compliance calendar",
          "Better coordination between accounting, payroll and statutory filing information",
          "Early identification of compliance gaps before they become larger issues",
          "One point of coordination instead of dealing with multiple activities separately",
          "A scalable framework that expands as the business grows",
          "Clearer visibility into what is due, when it is due and what information is required"
        ]
      },
      "afterService": null,
      "whyUs": {
        "heading": "Why Choose Biz360 Compliance?",
        "items": [
          "Integrated approach connecting accounting, taxation, payroll and corporate compliance instead of treating each requirement independently",
          "Entity-specific checklist based on your actual business structure and applicable registrations",
          "Regular monitoring throughout the year rather than only at year-end",
          "Professional review of important filings and information before submission",
          "One long-term compliance partner that incorporates new registrations, employees and regulatory requirements as your business grows"
        ]
      },
      "faqs": [
        {
          "q": "What is annual compliance management?",
          "a": "It is an organised approach to tracking and managing a business's recurring statutory and regulatory requirements throughout the year."
        },
        {
          "q": "Is this the same as annual ROC compliance?",
          "a": "No. ROC annual compliance is one component. Compliance management can cover multiple areas such as ROC, GST, TDS, PF, ESI, Professional Tax and other applicable requirements."
        },
        {
          "q": "Can you manage all compliance requirements of my business?",
          "a": "Subject to the agreed scope, multiple compliance areas can be coordinated under one engagement."
        },
        {
          "q": "Can accounting and payroll compliance be included?",
          "a": "Yes. Accounting, payroll, PF, ESI and Professional Tax can all be integrated into the compliance process where applicable."
        },
        {
          "q": "Do you provide a compliance calendar?",
          "a": "Yes. An entity-specific compliance calendar can be maintained as part of the engagement."
        },
        {
          "q": "Can you take over compliance from another consultant, and what about pending compliances?",
          "a": "Yes, existing registrations, previous filings and pending requirements can be reviewed before taking over. Pending matters identified during the initial review can be handled separately or incorporated into the engagement."
        }
      ],
      "extra": null,
      "related": [
        "compliance-health-check",
        "roc-mca-annual-compliance",
        "llp-annual-compliance"
      ]
    }
  },
  {
    "slug": "compliance-health-check",
    "category": "Compliance",
    "sub_category": "Compliance Management & Advisory",
    "icon": "FileSearch",
    "title": "Business Compliance Health Check",
    "subtitle": "Find compliance gaps before they become costly problems.",
    "read_time": "6 min read",
    "image": "https://images.unsplash.com/photo-1554224155-6726b3ff858f?crop=entropy&cs=srgb&fm=jpg&q=80&w=1200",
    "intro": "A Compliance Health Check is a structured review of the key statutory requirements applicable to a business, designed to identify pending, missed or potentially overlooked compliance areas before they turn into costly problems. Biz360 Compliance reviews existing registrations, filings and statutory records to help management understand exactly what needs attention. It is particularly useful when taking over an existing business, when a previous consultant has changed, when there is uncertainty over whether all returns have been filed, when the business has grown or added employees, after receiving a notice, or when preparing for an audit, funding round or due diligence. The scope of the review is customised according to entity type, registrations, employees and business activities, giving management an independent, practical view of the current compliance position.",
    "sections": {
      "whoNeedsIt": {
        "heading": "Who Needs a Compliance Health Check?",
        "items": [
          "Private Limited Companies",
          "LLPs",
          "Partnership Firms",
          "Proprietorships",
          "Startups and MSMEs",
          "Businesses changing consultants",
          "Businesses preparing for funding or due diligence",
          "Businesses that have accumulated pending compliance"
        ]
      },
      "eligibility": {
        "heading": "What We Review",
        "items": [
          "Corporate compliance — MCA/ROC filings, annual compliance, director-related compliance, event-based filings, LLP compliance where applicable",
          "Tax compliance — GST registration and returns, TDS compliance, Income Tax compliance, Professional Tax",
          "Payroll & labour compliance — PF/EPF, ESI, payroll-related compliance, Shops & Establishment requirements",
          "Other applicable employment compliances",
          "Business registrations — amendments, renewals and validity, where applicable",
          "Licence validity and applicable renewals"
        ]
      },
      "documents": {
        "heading": "Documents Required",
        "groups": [
          {
            "title": "Records Reviewed During the Health Check",
            "items": [
              "Relevant registrations and licences",
              "Previous return filings",
              "Available statutory records",
              "MCA/ROC filing history",
              "GST, TDS and Income Tax filing details",
              "PF, ESI and payroll records, where applicable"
            ]
          }
        ]
      },
      "process": {
        "heading": "Our Review Process",
        "steps": [
          {
            "title": "Understand the Business",
            "desc": "We understand the entity structure, business activity, locations and employee strength."
          },
          {
            "title": "Collect Compliance Information",
            "desc": "Relevant registrations, previous filings and available statutory records are reviewed."
          },
          {
            "title": "Compliance Mapping",
            "desc": "Applicable requirements are mapped against the business profile."
          },
          {
            "title": "Identify Gaps",
            "desc": "Potentially pending, missed or inconsistent compliance areas are identified."
          },
          {
            "title": "Review Findings",
            "desc": "Key observations are discussed with the business owner or management."
          },
          {
            "title": "Action Plan",
            "desc": "Where required, practical steps for regularisation and future compliance are recommended."
          }
        ]
      },
      "timeline": {
        "heading": "Estimated Timeline",
        "body": "The review is a defined, one-time engagement rather than an ongoing service, with the actual duration depending on the historical period to be reviewed, the number of compliance areas involved and the complexity of the business."
      },
      "fees": {
        "heading": "Government Fees & Professional Fees",
        "note": "Professional fees depend on entity type, number of registrations, number of compliance areas, the historical period to be reviewed, employee strength and overall complexity of the business. A customised Compliance Health Check proposal is provided on request."
      },
      "benefits": {
        "heading": "Benefits of a Compliance Health Check",
        "items": [
          "Independent, multi-disciplinary review covering corporate, tax, accounting and payroll-related compliance together",
          "Practical findings focused on issues that actually require attention, not a lengthy theoretical report",
          "Priority-based approach that separates critical, time-sensitive matters from routine observations",
          "Clearer picture of the current compliance position for management",
          "Useful basis for due diligence before a funding round or business transaction",
          "Action-oriented outcome that can lead directly into regular compliance management or corrective services"
        ]
      },
      "afterService": {
        "heading": "What You Receive",
        "items": [
          "Compliance status summary",
          "List of identified gaps",
          "Pending compliance checklist",
          "Key risk areas",
          "Priority actions",
          "Recommended compliance calendar"
        ]
      },
      "whyUs": {
        "heading": "Why Choose Biz360 Compliance?",
        "items": [
          "Multi-disciplinary review across corporate, tax, accounting and payroll-related compliance",
          "Practical findings rather than a lengthy theoretical report",
          "Priority-based approach that separates critical and time-sensitive matters from routine observations",
          "Action-oriented process that can be followed by regular compliance management or specific corrective services"
        ]
      },
      "faqs": [
        {
          "q": "Who should get a compliance health check?",
          "a": "Any business that is uncertain about its current compliance status or wants an independent review can consider one."
        },
        {
          "q": "Can you review compliance handled by another consultant?",
          "a": "Yes. An independent review can be conducted based on available records and filings."
        },
        {
          "q": "Can you identify old pending compliances?",
          "a": "Yes. Historical filings and available records can be reviewed to identify potential pending matters."
        },
        {
          "q": "Does a health check automatically regularise the defaults?",
          "a": "No. The health check identifies issues. Regularisation, filing or other corrective action would be handled separately."
        },
        {
          "q": "Can GST, Income Tax, PF, ESI and payroll be included?",
          "a": "Yes, subject to the agreed scope, these areas can be reviewed where applicable."
        },
        {
          "q": "Is the review useful before selling or investing in a business, and can it lead into ongoing compliance management?",
          "a": "Yes. A compliance review can help identify potential statutory issues before a transaction or due-diligence exercise, and afterward, ongoing compliance management can be structured based on the requirements identified."
        }
      ],
      "extra": null,
      "related": [
        "annual-compliance-management",
        "roc-mca-annual-compliance",
        "labour-law-compliance"
      ]
    }
  },
  {
    "slug": "udyam-registration",
    "category": "Business Licences",
    "sub_category": "Business Licences",
    "icon": "FileCheck",
    "title": "Udyam Registration",
    "subtitle": "Get your business recognised as a Micro, Small or Medium Enterprise under the MSME framework.",
    "read_time": "5 min read",
    "image": "https://images.unsplash.com/photo-1554224155-8d04cb21cd6c?crop=entropy&cs=srgb&fm=jpg&q=80&w=1200",
    "intro": "Udyam Registration is the official registration mechanism for Micro, Small and Medium Enterprises under the Ministry of MSME. The registration is online, paperless and based on self-declaration, and a permanent Udyam Registration Number along with an online certificate is issued after successful registration. Biz360 Compliance assists eligible businesses with Udyam Registration, classification, certificate generation and subsequent updates.",
    "sections": {
      "whoNeedsIt": {
        "heading": "Who Can Apply?",
        "items": [
          "Proprietorships",
          "Partnership Firms",
          "LLPs",
          "Companies",
          "Trusts and societies",
          "Manufacturing enterprises",
          "Service businesses",
          "Trading businesses, where eligible"
        ]
      },
      "eligibility": {
        "heading": "Current MSME Classification",
        "items": [
          "Micro: investment up to ₹2.5 Crore and turnover up to ₹10 Crore",
          "Small: investment up to ₹25 Crore and turnover up to ₹100 Crore",
          "Medium: investment up to ₹125 Crore and turnover up to ₹500 Crore",
          "Classification, effective from 1 April 2025, considers both investment and turnover criteria together"
        ]
      },
      "documents": {
        "heading": "Documents & Information",
        "groups": [
          {
            "title": "Generally Required",
            "items": [
              "Aadhaar details",
              "PAN",
              "GSTIN, where applicable",
              "Business address",
              "Bank details",
              "Business activity details",
              "Investment and turnover information"
            ]
          }
        ]
      },
      "process": {
        "heading": "Process",
        "steps": [
          {
            "title": "Eligibility Check",
            "desc": "We review your business details against the applicable MSME classification criteria."
          },
          {
            "title": "Aadhaar & PAN Verification",
            "desc": "Applicant Aadhaar authentication is completed and PAN details are verified through government databases."
          },
          {
            "title": "Business Details",
            "desc": "Business address, bank details and other required information are compiled."
          },
          {
            "title": "Classification & Activity Details",
            "desc": "The correct business activity and MSME category are identified based on investment and turnover."
          },
          {
            "title": "Online Submission",
            "desc": "The application is submitted on the official Udyam Registration portal."
          },
          {
            "title": "Udyam Certificate",
            "desc": "The permanent Udyam Registration Number and online certificate are issued and shared with you."
          }
        ]
      },
      "timeline": {
        "heading": "Timeline",
        "body": "The process is online and paperless, with the certificate generally issued once the application and verification steps are completed."
      },
      "fees": {
        "heading": "Government Fee",
        "note": "Udyam Registration on the official Government portal is free of charge. Professional assistance, if availed, is separately chargeable. There is no periodic renewal requirement for Udyam Registration."
      },
      "benefits": {
        "heading": "Why Register Under Udyam?",
        "items": [
          "Formal recognition as a Micro, Small or Medium Enterprise",
          "Permanent registration number with no renewal requirement",
          "Paperless, self-declaration based process",
          "Access to MSME-linked benefits and schemes, where applicable"
        ]
      },
      "afterService": null,
      "whyUs": {
        "heading": "Why Choose Biz360 Compliance?",
        "items": [
          "Eligibility and classification review",
          "Correct business activity selection",
          "Online application assistance",
          "Certificate verification",
          "Amendment/update support",
          "MSME compliance guidance"
        ]
      },
      "faqs": [
        {
          "q": "Is Udyam Registration mandatory for every business?",
          "a": "No. It is an MSME registration mechanism for eligible enterprises."
        },
        {
          "q": "Is Udyam Registration free?",
          "a": "Yes, the Government registration itself is free."
        },
        {
          "q": "Does Udyam Registration expire?",
          "a": "No, the registration is permanent and does not require renewal."
        },
        {
          "q": "Can a company obtain Udyam Registration?",
          "a": "Yes, subject to MSME eligibility."
        },
        {
          "q": "Can existing Udyog Aadhaar holders migrate to Udyam?",
          "a": "Yes, eligible existing registrations can be migrated."
        }
      ],
      "extra": null,
      "related": [
        "import-export-code-iec",
        "maharashtra-shop-establishment",
        "fssai-registration-licence"
      ]
    }
  },
  {
    "slug": "fssai-registration-licence",
    "category": "Business Licences",
    "sub_category": "Business Licences",
    "icon": "UtensilsCrossed",
    "title": "FSSAI Registration & Food Licence",
    "subtitle": "Get the right FSSAI registration or licence for your food business.",
    "read_time": "6 min read",
    "image": "https://images.unsplash.com/photo-1521791136064-7986c2920216?crop=entropy&cs=srgb&fm=jpg&q=80&w=1200",
    "intro": "Food Business Operators need the appropriate FSSAI registration or licence depending on the nature of business, activity, capacity and applicable turnover criteria. Biz360 Compliance helps food businesses with FSSAI registration, licence applications, amendments and compliance support through the FoSCoS framework.",
    "sections": {
      "whoNeedsIt": {
        "heading": "Who Needs FSSAI Registration or Licence?",
        "items": [
          "Food manufacturing units",
          "Restaurants",
          "Cafes",
          "Bakeries",
          "Cloud kitchens",
          "Catering businesses",
          "Food retail and wholesale businesses",
          "Food storage and distribution businesses",
          "Food import businesses",
          "Online food businesses"
        ]
      },
      "eligibility": {
        "heading": "Current FSSAI Turnover Thresholds",
        "items": [
          "Registration: general turnover up to ₹1.5 Crore, from 1 April 2026",
          "State Licence: general turnover above ₹1.5 Crore up to ₹50 Crore",
          "Central Licence: general turnover above ₹50 Crore",
          "Activity-specific eligibility criteria can differ, so the correct licence should be determined based on the actual food business activity"
        ]
      },
      "documents": {
        "heading": "Documents Generally Required",
        "groups": [
          {
            "title": "Depending on Category",
            "items": [
              "PAN / identity proof",
              "Business constitution documents",
              "Address proof",
              "Photograph",
              "Business activity details",
              "Food/product details",
              "Premises information",
              "Other documents applicable to the activity"
            ]
          }
        ]
      },
      "process": {
        "heading": "Process",
        "steps": [
          {
            "title": "Business Assessment",
            "desc": "We assess the nature, scale and activity of your food business."
          },
          {
            "title": "FSSAI Category Selection",
            "desc": "The correct category — Registration, State Licence or Central Licence — is identified based on turnover and activity."
          },
          {
            "title": "Document Preparation",
            "desc": "Required documents are compiled based on the selected category."
          },
          {
            "title": "FoSCoS Application",
            "desc": "The application is filed through the FoSCoS portal."
          },
          {
            "title": "Authority Review",
            "desc": "The application is reviewed by the concerned food safety authority."
          },
          {
            "title": "Registration / Licence",
            "desc": "The FSSAI registration or licence is issued upon approval."
          }
        ]
      },
      "timeline": {
        "heading": "Timeline",
        "body": "Processing timelines depend on the category applied for and the completeness of documentation, and are subject to authority review under FoSCoS."
      },
      "fees": {
        "heading": "Fees",
        "note": "Government fees vary based on the category (Registration, State Licence or Central Licence) and validity period applied for. Professional fees are separate."
      },
      "benefits": {
        "heading": "Our FSSAI Services",
        "items": [
          "New FSSAI Registration",
          "State Licence",
          "Central Licence",
          "FSSAI amendment",
          "Business activity modification",
          "Address/details update",
          "Licence-related compliance support"
        ]
      },
      "afterService": null,
      "whyUs": {
        "heading": "Why Choose Biz360 Compliance?",
        "items": [
          "Correct category assessment",
          "FoSCoS application support",
          "Documentation review",
          "Amendment assistance",
          "Ongoing compliance guidance"
        ]
      },
      "faqs": [
        {
          "q": "Is FSSAI required for every food business?",
          "a": "Food businesses generally require the appropriate FSSAI registration/licence, subject to the applicable framework."
        },
        {
          "q": "What is the difference between Registration and Licence?",
          "a": "The appropriate category depends on the nature and scale of the food business."
        },
        {
          "q": "What is the current basic registration turnover limit?",
          "a": "The general threshold is up to ₹1.5 Crore from 1 April 2026, subject to activity-specific criteria."
        },
        {
          "q": "Does FSSAI registration need renewal now?",
          "a": "The 2026 reforms introduced perpetual validity, subject to compliance and other applicable conditions."
        },
        {
          "q": "Can an existing FSSAI licence be amended?",
          "a": "Yes, where changes are permitted under the applicable process."
        }
      ],
      "extra": null,
      "related": [
        "maharashtra-shop-establishment",
        "udyam-registration",
        "import-export-code-iec"
      ]
    }
  },
  {
    "slug": "import-export-code-iec",
    "category": "Business Licences",
    "sub_category": "Business Licences",
    "icon": "Globe",
    "title": "Import Export Code (IEC) Registration",
    "subtitle": "Get your business ready for international trade with DGFT-issued IEC.",
    "read_time": "5 min read",
    "image": "https://images.unsplash.com/photo-1518186285589-2f7649de83e0?crop=entropy&cs=srgb&fm=jpg&q=80&w=1200",
    "intro": "The Importer Exporter Code (IEC) is the identification number issued by the Directorate General of Foreign Trade (DGFT) for eligible import/export activities. IEC is generally mandatory for undertaking import or export activities, subject to applicable exemptions. Biz360 Compliance assists businesses with IEC application, modification, documentation and ongoing IEC compliance.",
    "sections": {
      "whoNeedsIt": {
        "heading": "Who May Need IEC?",
        "items": [
          "Manufacturers",
          "Traders",
          "Exporters",
          "Importers",
          "E-commerce exporters",
          "Service providers, where IEC is required under the applicable Foreign Trade Policy",
          "Proprietorships, Partnership Firms, LLPs and Companies",
          "Other eligible entities"
        ]
      },
      "eligibility": {
        "heading": "Our IEC Services",
        "items": [
          "New IEC application",
          "IEC modification",
          "Address/details update",
          "Bank account update",
          "IEC status verification",
          "Annual IEC updation support",
          "Deactivated IEC reactivation assistance"
        ]
      },
      "documents": {
        "heading": "Documents & Information",
        "groups": [
          {
            "title": "Generally Required",
            "items": [
              "PAN",
              "Aadhaar / identity authentication",
              "Mobile number",
              "Email ID",
              "Business address",
              "Bank account details",
              "Entity/constitution details",
              "Other information required by DGFT"
            ]
          }
        ]
      },
      "process": {
        "heading": "Process",
        "steps": [
          {
            "title": "Business Verification",
            "desc": "Entity and constitution details are verified for IEC eligibility."
          },
          {
            "title": "DGFT Profile",
            "desc": "A profile is set up on the DGFT portal for the applicant."
          },
          {
            "title": "IEC Application",
            "desc": "The IEC application is prepared and filed online with the required business details."
          },
          {
            "title": "Authentication",
            "desc": "Applicant authentication is completed as required by DGFT."
          },
          {
            "title": "Government Fee",
            "desc": "The applicable Government fee is paid as part of the application."
          },
          {
            "title": "IEC Generation",
            "desc": "The IEC is generated and issued by DGFT."
          }
        ]
      },
      "timeline": {
        "heading": "Timeline",
        "body": "The DGFT IEC process is online and generally completed once applicant authentication and required business details are submitted."
      },
      "fees": {
        "heading": "Government Fee",
        "note": "A Government fee applies as prescribed by DGFT for the IEC application; professional fees are separate."
      },
      "benefits": {
        "heading": "What is IEC?",
        "items": [
          "Identification number required for undertaking import or export activities",
          "Issued by the Directorate General of Foreign Trade (DGFT)",
          "Generally mandatory for import/export, subject to applicable exemptions",
          "Linked to PAN-based entity identification"
        ]
      },
      "afterService": {
        "heading": "Annual IEC Compliance",
        "items": [
          "IEC holders are required to keep their IEC details updated as prescribed by DGFT",
          "Annual updation is generally carried out during the prescribed April–June period",
          "Confirmation is required even where there are no changes to IEC details",
          "Deactivated IEC can be reactivated where updation is completed"
        ]
      },
      "whyUs": {
        "heading": "Why Choose Biz360 Compliance?",
        "items": [
          "DGFT application support",
          "Documentation review",
          "Correct entity details",
          "Modification assistance",
          "Annual IEC compliance support"
        ]
      },
      "faqs": [
        {
          "q": "Is IEC mandatory for import and export?",
          "a": "Generally yes, subject to prescribed exemptions."
        },
        {
          "q": "Who issues IEC?",
          "a": "DGFT (Directorate General of Foreign Trade)."
        },
        {
          "q": "Can a proprietorship obtain IEC?",
          "a": "Yes."
        },
        {
          "q": "Is IEC separate from PAN?",
          "a": "DGFT issues IEC based on PAN-linked entity identification; IEC is a separate DGFT registration/identifier."
        },
        {
          "q": "Does IEC require annual updation?",
          "a": "Yes, IEC details are required to be updated/confirmed as prescribed by DGFT."
        }
      ],
      "extra": null,
      "related": [
        "udyam-registration",
        "fssai-registration-licence",
        "maharashtra-shop-establishment"
      ]
    }
  },
  {
    "slug": "maharashtra-shop-establishment",
    "category": "Business Licences",
    "sub_category": "Business Licences",
    "icon": "Store",
    "title": "Maharashtra Shops & Establishments Registration",
    "subtitle": "Complete your establishment registration or statutory intimation under Maharashtra's Shops & Establishments framework.",
    "read_time": "5 min read",
    "image": "https://images.unsplash.com/photo-1444653614773-995cb1ef9efa?crop=entropy&cs=srgb&fm=jpg&q=80&w=1200",
    "intro": "The Maharashtra Shops and Establishments (Regulation of Employment and Conditions of Service) Act, 2017 applies differently depending on the number of workers in an establishment. Biz360 Compliance assists businesses in Maharashtra with registration, intimation, documentation and related compliance support under this Act.",
    "sections": {
      "whoNeedsIt": {
        "heading": "Who Needs It?",
        "items": [
          "Establishments with 10 or more workers, which require registration under Section 6",
          "Establishments with fewer than 10 workers, which require an online intimation of commencement of business under Section 7",
          "Establishments where worker count subsequently reaches 10 or more, for which registration becomes applicable"
        ]
      },
      "eligibility": {
        "heading": "Our Services",
        "items": [
          "Applicability assessment",
          "Shops & Establishments registration",
          "Intimation for establishments with fewer than 10 workers",
          "Application preparation",
          "Document verification",
          "Online filing",
          "Registration certificate / intimation receipt support",
          "Amendment assistance",
          "Renewal / related compliance support, where applicable"
        ]
      },
      "documents": {
        "heading": "Documents Generally Required",
        "groups": [
          {
            "title": "Depending on the Establishment",
            "items": [
              "PAN / identity details",
              "Address proof",
              "Ownership / occupancy documents",
              "Establishment details",
              "Nature of business",
              "Employee details",
              "Employer/manager details",
              "Other prescribed declarations/documents"
            ]
          }
        ]
      },
      "process": {
        "heading": "Process",
        "steps": [
          {
            "title": "Business & Employee Details",
            "desc": "We collect establishment, business and employee count details."
          },
          {
            "title": "Applicability Review",
            "desc": "We determine whether Section 6 registration or Section 7 intimation applies."
          },
          {
            "title": "Document Preparation",
            "desc": "Required documents and declarations are compiled."
          },
          {
            "title": "Online Application",
            "desc": "The registration application or intimation is filed online."
          },
          {
            "title": "Department Processing",
            "desc": "The application is processed by the concerned department."
          },
          {
            "title": "Certificate / Intimation",
            "desc": "The registration certificate or intimation receipt is issued."
          }
        ]
      },
      "timeline": {
        "heading": "Timeline & Fees",
        "body": "Timeline depends on the completeness of documents and departmental processing. The Act prescribes a 60-day period from commencement of business for the applicable registration/intimation."
      },
      "fees": {
        "heading": "Fees",
        "note": "Government fees vary based on the applicable category and period. Professional fees are separate."
      },
      "benefits": {
        "heading": "Applicability Overview",
        "items": [
          "Registration required under Section 6 for establishments with 10 or more workers, within 60 days from commencement of business",
          "Online intimation required under Section 7 for establishments with fewer than 10 workers",
          "Registration becomes applicable if worker count subsequently reaches 10 or more"
        ]
      },
      "afterService": null,
      "whyUs": {
        "heading": "Why Choose Biz360 Compliance?",
        "items": [
          "Maharashtra-specific compliance support",
          "Applicability review",
          "Documentation assistance",
          "Online filing",
          "Post-registration support"
        ]
      },
      "faqs": [
        {
          "q": "Is Shops & Establishment registration compulsory for every business?",
          "a": "The compliance requirement depends on the number of workers and applicability of the Act."
        },
        {
          "q": "What if my establishment has fewer than 10 workers?",
          "a": "An intimation of commencement is generally required under Section 7."
        },
        {
          "q": "What happens if employees increase to 10 or more?",
          "a": "Registration under Section 6 becomes applicable."
        },
        {
          "q": "How long do I have to apply?",
          "a": "The Act prescribes a 60-day period from commencement of business for the applicable registration/intimation."
        }
      ],
      "extra": null,
      "related": [
        "fssai-registration-licence",
        "import-export-code-iec",
        "udyam-registration"
      ]
    }
  },
  {
    "slug": "bookkeeping-accounting",
    "category": "Account & Finance",
    "sub_category": null,
    "icon": "BookOpen",
    "title": "Bookkeeping & Accounting Services",
    "subtitle": "Keep your books accurate, up to date and ready for tax, compliance and business decisions.",
    "read_time": "6 min read",
    "image": "https://images.unsplash.com/photo-1554224155-8d04cb21cd6c?crop=entropy&cs=srgb&fm=jpg&q=80&w=1200",
    "intro": "Biz360 Compliance provides ongoing bookkeeping and accounting support for startups, MSMEs, professionals and growing businesses, helping you maintain organised accounts without the cost of building a full in-house finance team. Good accounting is more than recording transactions — your books should give you a clear picture of sales, expenses, receivables, payables, profitability and cash position. Our accounting team helps businesses maintain their books regularly and prepare reliable financial information for GST, TDS, income tax, statutory requirements and management review.",
    "sections": {
      "whoNeedsIt": {
        "heading": "Who Can Use Our Accounting Services?",
        "items": [
          "Proprietorships",
          "Partnership Firms",
          "LLPs",
          "Private Limited Companies",
          "Startups",
          "MSMEs",
          "Professionals, traders and manufacturers",
          "Service businesses and e-commerce businesses"
        ]
      },
      "eligibility": {
        "heading": "What We Handle",
        "items": [
          "Day-to-day bookkeeping: sales and purchase entries, expenses and payments, receivables and payables, bank and cash transactions, journal entries, ledger maintenance",
          "Reconciliations: bank, customer and vendor reconciliation, GST-related reconciliation, TDS reconciliation, ledger scrutiny",
          "Monthly accounting: monthly closing, trial balance review, outstanding analysis, expense review, preliminary profitability analysis",
          "Financial records: Profit & Loss Account, Balance Sheet, Trial Balance, ledger reports, supporting schedules",
          "Accounting software support across Tally, cloud accounting platforms, Excel-based systems and ERP/accounting software, including data migration and accounting clean-up"
        ]
      },
      "documents": {
        "heading": "What You Should Provide",
        "groups": [
          {
            "title": "Depending on the scope, we may require",
            "items": [
              "Sales invoices",
              "Purchase invoices",
              "Expense bills",
              "Bank statements",
              "Payment/receipt details",
              "GST information",
              "TDS details",
              "Payroll information",
              "Loan and investment details",
              "Other relevant financial documents"
            ]
          }
        ]
      },
      "process": {
        "heading": "How Our Accounting Engagement Works",
        "steps": [
          {
            "title": "Understand Your Business",
            "desc": "We understand your business model, transaction volume, existing accounting system and reporting requirements."
          },
          {
            "title": "Set Up the Accounting Process",
            "desc": "We establish the appropriate ledgers, accounting structure, documentation and workflow."
          },
          {
            "title": "Record & Reconcile",
            "desc": "Transactions are recorded periodically and relevant ledgers and balances are reconciled."
          },
          {
            "title": "Monthly Review",
            "desc": "Books are reviewed for unusual entries, outstanding balances and reconciliation issues."
          },
          {
            "title": "Reports & Compliance Support",
            "desc": "Financial information is made available for tax filings, statutory compliance and management review."
          }
        ]
      },
      "timeline": {
        "heading": "Ongoing Engagement",
        "body": "This is a continuing engagement rather than a one-time filing — books are maintained and reviewed periodically, with the scope structured according to your business requirements, whether that means complete outsourced accounting or assistance with specific accounting activities."
      },
      "fees": {
        "heading": "Accounting Packages Based on Your Business",
        "note": "Professional fees depend on factors such as monthly transaction volume, business structure, number of bank accounts, GST/TDS requirements, payroll requirements, accounting software and reporting requirements. Get a customised monthly accounting proposal."
      },
      "benefits": {
        "heading": "Why Outsource Your Accounting?",
        "items": [
          "Better Record Discipline: regular bookkeeping reduces the accumulation of unrecorded transactions",
          "Cleaner Compliance: well-maintained books make GST, TDS and income-tax compliance easier to manage",
          "Timely Financial Information: business owners can review financial performance without waiting until year-end",
          "Lower Overhead: get professional accounting support without maintaining a complete in-house accounts team",
          "Scalable Support: accounting support can be expanded as transaction volume and business requirements grow"
        ]
      },
      "afterService": null,
      "whyUs": {
        "heading": "Why Choose Biz360 Compliance?",
        "items": [
          "Professional accounting support",
          "Regular bookkeeping and reconciliation",
          "Tax and compliance coordination",
          "Monthly reporting options",
          "Flexible outsourced accounting models",
          "One platform for accounting, taxation and compliance"
        ]
      },
      "faqs": [
        {
          "q": "Can I outsource my complete accounting?",
          "a": "Yes. The scope can range from basic bookkeeping to complete outsourced accounting and monthly closing."
        },
        {
          "q": "Do you provide monthly accounting services?",
          "a": "Yes. Monthly accounting can be structured according to transaction volume and reporting requirements."
        },
        {
          "q": "Can you maintain accounts in Tally?",
          "a": "Yes, where Tally is the accounting platform used by the business."
        },
        {
          "q": "Can you work with our existing accountant?",
          "a": "Yes. We can provide specific accounting, reconciliation or review support where required."
        },
        {
          "q": "Do you provide GST and TDS compliance along with accounting?",
          "a": "Yes. Accounting can be integrated with applicable GST and TDS compliance services."
        },
        {
          "q": "Can you clean up old or incomplete books?",
          "a": "Yes. Historical accounting clean-up and reconciliation can be undertaken as a separate engagement."
        }
      ],
      "extra": null,
      "related": [
        "accounts-finalisation",
        "mis-reporting",
        "virtual-cfo-services"
      ]
    }
  },
  {
    "slug": "monthly-accounting-closing",
    "category": "Account & Finance",
    "sub_category": null,
    "icon": "CalendarCheck",
    "title": "Monthly Accounting & Closing Services",
    "subtitle": "Keep your books updated, reconciled and ready for timely reporting and compliance.",
    "read_time": "6 min read",
    "image": "https://images.unsplash.com/photo-1521791136064-7986c2920216?crop=entropy&cs=srgb&fm=jpg&q=80&w=1200",
    "intro": "Biz360 Compliance provides structured monthly accounting support for businesses that want their financial records reviewed and closed regularly instead of waiting until year-end. Regular accounting helps business owners understand their financial position throughout the year and identify errors or outstanding items before they become larger problems. The exact scope of the monthly engagement is customised according to the business.",
    "sections": {
      "whoNeedsIt": {
        "heading": "Who Can Benefit?",
        "items": [
          "Startups",
          "MSMEs",
          "Proprietorships",
          "Partnership Firms",
          "LLPs",
          "Private Limited Companies",
          "Professionals",
          "Growing businesses without a full-time finance team"
        ]
      },
      "eligibility": {
        "heading": "What is Included?",
        "items": [
          "Monthly Book Closure: transactions for the month are recorded and reviewed before closing the accounting period",
          "Bank Reconciliation: bank statements are reconciled with accounting records to identify unmatched or missing transactions",
          "Receivable & Payable Review: customer and vendor balances are reviewed to identify outstanding amounts and unusual balances",
          "GST & TDS Reconciliation: accounting records are compared with GST and TDS data to identify differences, where applicable",
          "Expense Review: major expenses and unusual accounting entries reviewed as part of monthly closing",
          "Monthly Financial Reports: Profit & Loss, Balance Sheet, Trial Balance, debtors/creditors ageing, expense summary, bank reconciliation, depending on the engagement"
        ]
      },
      "documents": {
        "heading": "Documents Generally Required",
        "groups": [
          {
            "title": "Depending on the engagement",
            "items": [
              "Sales invoices",
              "Purchase invoices",
              "Expense bills",
              "Bank statements",
              "Payment and receipt details",
              "GST records",
              "TDS records",
              "Payroll information",
              "Loan statements",
              "Other financial documents"
            ]
          }
        ]
      },
      "process": {
        "heading": "Our Monthly Closing Process",
        "steps": [
          {
            "title": "Data Collection",
            "desc": "Collect sales, purchase, expense, bank and other relevant records."
          },
          {
            "title": "Accounting Update",
            "desc": "Record pending transactions and update the books."
          },
          {
            "title": "Reconciliation",
            "desc": "Reconcile bank, customer, vendor, GST and TDS information as applicable."
          },
          {
            "title": "Review",
            "desc": "Identify unusual entries, outstanding items and accounting discrepancies."
          },
          {
            "title": "Monthly Closure",
            "desc": "Finalise the accounting records for the month."
          },
          {
            "title": "Reporting",
            "desc": "Provide agreed financial reports and information for management and compliance purposes."
          }
        ]
      },
      "timeline": {
        "heading": "Why Monthly Closing Matters",
        "body": "Waiting until the end of the financial year can make it difficult to identify unrecorded transactions, incorrect ledger balances, unreconciled bank entries, old receivables, vendor discrepancies, GST differences, TDS mismatches and unusual expenses. Regular monthly closing helps identify these issues while the information is still current and easier to correct."
      },
      "fees": {
        "heading": "Professional Fees",
        "note": "Monthly fees depend on the number of transactions, number of bank accounts, GST registrations, TDS requirements, payroll volume, accounting software, reporting requirements and complexity of reconciliation. Get a customised monthly accounting proposal."
      },
      "benefits": {
        "heading": "Why Monthly Accounting Helps",
        "items": [
          "Regular Accounting Discipline: your books are maintained and reviewed throughout the year",
          "Integrated Compliance: accounting can be connected with GST, TDS and Income Tax requirements",
          "Clear Monthly Reporting: get useful financial information instead of waiting for year-end",
          "Flexible Outsourcing: choose the level of accounting support your business actually needs",
          "Scalable Support: the accounting scope can grow with your business"
        ]
      },
      "afterService": null,
      "whyUs": {
        "heading": "Why Choose Biz360 Compliance?",
        "items": [
          "Regular accounting discipline throughout the year",
          "Integrated GST, TDS and Income Tax compliance",
          "Clear monthly reporting instead of year-end surprises",
          "Flexible outsourcing models",
          "Scalable accounting support as the business grows"
        ]
      },
      "faqs": [
        {
          "q": "What is monthly accounting?",
          "a": "It involves maintaining, reconciling and reviewing accounting records regularly and closing the books for each month."
        },
        {
          "q": "Is monthly accounting necessary for a small business?",
          "a": "It is not necessarily a statutory requirement in every case, but regular accounting is highly useful for compliance and financial control."
        },
        {
          "q": "Do you provide monthly Profit & Loss statements?",
          "a": "Yes, where included in the agreed reporting scope."
        },
        {
          "q": "Can GST reconciliation be included?",
          "a": "Yes. GST reconciliation can be included where required."
        },
        {
          "q": "Can you take over accounting from an existing accountant?",
          "a": "Yes. We can review the existing books and establish a monthly accounting process."
        },
        {
          "q": "Can monthly accounting include payroll?",
          "a": "Yes. Payroll processing can be added as a separate or integrated service."
        }
      ],
      "extra": null,
      "related": [
        "mis-reporting",
        "virtual-cfo-services",
        "project-reports-cma-data"
      ]
    }
  },
  {
    "slug": "accounts-finalisation",
    "category": "Account & Finance",
    "sub_category": null,
    "icon": "FileBarChart",
    "title": "Accounts Finalisation & Financial Statements",
    "subtitle": "Accurate, organised financial statements prepared from properly maintained books.",
    "read_time": "6 min read",
    "image": "https://images.unsplash.com/photo-1518186285589-2f7649de83e0?crop=entropy&cs=srgb&fm=jpg&q=80&w=1200",
    "intro": "Biz360 Compliance assists businesses with year-end account finalisation, financial statement preparation, schedules and supporting information required for tax, audit, compliance and management purposes. Financial statements bring together your accounting information to show the financial performance and position of your business. The exact format and accounting framework depend on the nature and legal structure of the business and applicable requirements.",
    "sections": {
      "whoNeedsIt": {
        "heading": "Who Needs This Service?",
        "items": [
          "Proprietorships",
          "Partnership Firms",
          "LLPs",
          "Private Limited Companies",
          "Startups",
          "MSMEs",
          "Professionals",
          "Businesses requiring financial statements for loans, investors or compliance"
        ]
      },
      "eligibility": {
        "heading": "Our Financial Statement Services",
        "items": [
          "Year-End Finalisation: review of accounting records and outstanding items before finalising the year's accounts",
          "Profit & Loss Statement: preparation of revenue, expenses and profitability information based on the finalised accounts",
          "Balance Sheet: presentation of assets, liabilities and capital/equity based on the applicable accounting requirements",
          "Supporting Schedules: fixed assets, receivables, payables, loans, investments and other balances",
          "Financial Data for Tax & Audit: organising financial information for Income Tax Return, Tax Audit support, GST annual compliance, statutory/internal audit and management reporting"
        ]
      },
      "documents": {
        "heading": "Documents Generally Required",
        "groups": [
          {
            "title": "Depending on the business",
            "items": [
              "Trial Balance",
              "General Ledger",
              "Bank statements",
              "Fixed asset details",
              "Loan statements",
              "Debtors & creditors schedules",
              "GST records",
              "TDS records",
              "Investment details",
              "Previous-year financial statements",
              "Other relevant accounting information"
            ]
          }
        ]
      },
      "process": {
        "heading": "Our Process",
        "steps": [
          {
            "title": "Review Existing Books",
            "desc": "We review the Trial Balance, ledgers and key accounting records."
          },
          {
            "title": "Reconciliation",
            "desc": "Bank, receivables, payables and other relevant balances are reconciled."
          },
          {
            "title": "Year-End Review",
            "desc": "Outstanding expenses, income, provisions and other required adjustments are considered."
          },
          {
            "title": "Finalisation",
            "desc": "The accounts are finalised based on the applicable accounting requirements."
          },
          {
            "title": "Financial Statements",
            "desc": "The relevant financial statements and supporting schedules are prepared."
          },
          {
            "title": "Compliance Support",
            "desc": "Finalised financial information can then be used for tax, audit and other statutory requirements."
          }
        ]
      },
      "timeline": {
        "heading": "Financial Statements for Different Business Structures",
        "body": "The presentation and reporting requirements can differ depending on whether the business is a proprietorship, partnership, LLP or company. For companies and other entities subject to specific statutory/accounting requirements, the financial statements are prepared in accordance with the applicable framework. Financial statements may also be required when applying for business loans, working capital facilities, bank finance, investor funding, government schemes or business expansion — where required they can be supplemented with project reports, CMA data and financial projections."
      },
      "fees": {
        "heading": "Professional Fees",
        "note": "Fees depend on business structure, volume and complexity of transactions, condition of existing books, number of adjustments/reconciliations, reporting requirements and additional tax/audit support. Get a customised proposal."
      },
      "benefits": {
        "heading": "Why Choose Biz360 Compliance?",
        "items": [
          "Accounts & Tax Connected: financial statements are prepared with subsequent tax and compliance requirements in mind",
          "Reconciliation-Focused: key balances are reviewed rather than simply transferring figures from the accounting software",
          "Business-Friendly Reporting: financial information is presented in a structured format useful for management and external requirements",
          "One Compliance Platform: finalised accounts connected with GST, TDS, Income Tax and audit support requirements"
        ]
      },
      "afterService": null,
      "whyUs": {
        "heading": "Why Choose Biz360 Compliance?",
        "items": [
          "Accounts and tax requirements handled together",
          "Reconciliation-focused finalisation rather than figure transfer",
          "Structured, business-friendly financial reporting",
          "One platform connecting accounts, GST, TDS, Income Tax and audit"
        ]
      },
      "faqs": [
        {
          "q": "Do you prepare financial statements for proprietorships?",
          "a": "Yes. Financial statements can be prepared based on properly maintained and finalised books."
        },
        {
          "q": "Can you prepare accounts from Tally?",
          "a": "Yes, subject to availability and completeness of the accounting data."
        },
        {
          "q": "Do you also finalise the books?",
          "a": "Yes. Year-end finalisation and reconciliation can form part of the engagement."
        },
        {
          "q": "Can financial statements be used for bank loans?",
          "a": "Yes. Financial statements may form part of the financial information required by banks and financial institutions."
        },
        {
          "q": "Can you prepare financial statements if the books are incomplete?",
          "a": "Yes. However, additional accounting clean-up and reconciliation work may be required before finalisation."
        },
        {
          "q": "Do you provide projected financial statements?",
          "a": "Yes. Financial projections and project reports can be provided as a separate service."
        }
      ],
      "extra": null,
      "related": [
        "virtual-cfo-services",
        "project-reports-cma-data",
        "cash-flow-working-capital"
      ]
    }
  },
  {
    "slug": "mis-reporting",
    "category": "Account & Finance",
    "sub_category": null,
    "icon": "PieChart",
    "title": "MIS Reporting & Management Reporting",
    "subtitle": "Turn your accounting data into clear, useful management information.",
    "read_time": "6 min read",
    "image": "https://images.unsplash.com/photo-1444653614773-995cb1ef9efa?crop=entropy&cs=srgb&fm=jpg&q=80&w=1200",
    "intro": "Biz360 Compliance helps business owners convert financial and operational data into structured MIS reports that make it easier to monitor performance, control costs and take timely business decisions. Management Information System (MIS) reporting involves presenting relevant financial and operational information in a structured format for management review, so business owners receive concise reports showing what is happening in the business and where attention is required. The reports can be customised according to the nature and size of the business.",
    "sections": {
      "whoNeedsIt": {
        "heading": "Who Can Benefit?",
        "items": [
          "Growing MSMEs",
          "Startups",
          "Traders",
          "Manufacturers",
          "Service businesses",
          "Multi-location businesses",
          "Businesses with multiple product lines",
          "Promoters who need regular financial visibility"
        ]
      },
      "eligibility": {
        "heading": "Our MIS Reporting Services",
        "items": [
          "Financial MIS: sales analysis, revenue trends, expense analysis, profitability, gross margin, receivables, payables, cash position",
          "Business Performance Reports: product-wise performance, customer-wise sales, branch/location performance, monthly comparison, budget vs actual, key business indicators",
          "Receivables & Payables MIS: customer outstanding, ageing analysis, vendor outstanding, overdue amounts, collection/payment position",
          "Management Dashboards: information presented through concise dashboards and summaries for regular management review"
        ]
      },
      "documents": {
        "heading": "Documents & Data Generally Required",
        "groups": [
          {
            "title": "Depending on the MIS",
            "items": [
              "Accounting data",
              "Sales data",
              "Purchase data",
              "Expense records",
              "Bank information",
              "Debtors & creditors",
              "Inventory data",
              "Budget/targets",
              "Other operational information"
            ]
          }
        ]
      },
      "process": {
        "heading": "How It Works",
        "steps": [
          {
            "title": "Understand Your Business",
            "desc": "We identify the information that management actually needs."
          },
          {
            "title": "Identify Data Sources",
            "desc": "Accounting records, sales data, expenses, inventory and other relevant information are reviewed."
          },
          {
            "title": "Design the MIS",
            "desc": "Reports and KPIs are structured according to the business requirements."
          },
          {
            "title": "Prepare Reports",
            "desc": "The agreed reports are generated periodically."
          },
          {
            "title": "Management Review",
            "desc": "Key movements, variances and areas requiring attention can be highlighted."
          }
        ]
      },
      "timeline": {
        "heading": "MIS vs Financial Statements",
        "body": "Financial Statements primarily present the financial position and performance of the business in a structured accounting format. MIS Reporting goes further by organising financial and operational information specifically for management decision-making — for example, financial statements answer what was the profit, while MIS answers which product generated the profit, where costs increased, which customers are overdue and what needs management attention."
      },
      "fees": {
        "heading": "Professional Fees",
        "note": "Fees depend on the number of reports, reporting frequency, data sources, business complexity, dashboard requirements and level of analysis required. Get a customised MIS proposal."
      },
      "benefits": {
        "heading": "Why Choose Biz360 Compliance?",
        "items": [
          "Business-Specific Reports: we don't recommend the same MIS format for every business",
          "Accounting-Linked MIS: reports prepared from properly maintained accounting information",
          "Decision-Oriented: important business information made easier to understand and act upon",
          "Regular Reporting: MIS can be prepared monthly, quarterly or per the agreed cycle",
          "Scalable: reporting can evolve as your business grows"
        ]
      },
      "afterService": null,
      "whyUs": {
        "heading": "Why Choose Biz360 Compliance?",
        "items": [
          "Business-specific report formats, not one-size-fits-all",
          "MIS linked to properly maintained accounting data",
          "Decision-oriented rather than purely presentational",
          "Regular monthly or quarterly reporting cycles",
          "Scalable as the business grows"
        ]
      },
      "faqs": [
        {
          "q": "What is MIS reporting?",
          "a": "MIS reporting presents financial and operational information in a structured format to assist management in monitoring and decision-making."
        },
        {
          "q": "Is MIS different from a Profit & Loss Account?",
          "a": "Yes. A Profit & Loss Account is a financial statement, while MIS can include financial and operational analysis tailored to management requirements."
        },
        {
          "q": "Can MIS be prepared monthly?",
          "a": "Yes. Monthly MIS is one of the most common reporting arrangements."
        },
        {
          "q": "Can MIS be customised for my business?",
          "a": "Yes. Reports and KPIs can be designed according to the nature of the business."
        },
        {
          "q": "Can you prepare MIS from Tally data?",
          "a": "Yes, subject to availability and quality of the underlying accounting data."
        },
        {
          "q": "Can you prepare Budget vs Actual reports?",
          "a": "Yes. Where budgets or targets are available, actual performance can be compared against them."
        }
      ],
      "extra": {
        "kind": "table",
        "columns": [
          "Report",
          "Purpose"
        ],
        "rows": [
          [
            "Sales MIS",
            "Monitor revenue and sales trends"
          ],
          [
            "Expense MIS",
            "Track major expenses"
          ],
          [
            "Profitability",
            "Understand business margins"
          ],
          [
            "Receivables Ageing",
            "Monitor customer collections"
          ],
          [
            "Payables Ageing",
            "Monitor vendor obligations"
          ],
          [
            "Cash Flow",
            "Track liquidity"
          ],
          [
            "Budget vs Actual",
            "Identify variances"
          ],
          [
            "Business KPI Dashboard",
            "Monitor key performance indicators"
          ]
        ]
      },
      "related": [
        "project-reports-cma-data",
        "cash-flow-working-capital",
        "financial-planning-advisory"
      ]
    }
  },
  {
    "slug": "virtual-cfo-services",
    "category": "Account & Finance",
    "sub_category": null,
    "icon": "Briefcase",
    "title": "Virtual CFO Services",
    "subtitle": "Get strategic finance support without the cost of hiring a full-time CFO.",
    "read_time": "7 min read",
    "image": "https://images.unsplash.com/photo-1519389950473-47ba0277781c?crop=entropy&cs=srgb&fm=jpg&q=80&w=1200",
    "intro": "Biz360 Compliance provides flexible finance and management support to businesses that need better control over cash flow, profitability, financial reporting and business decisions. A Virtual CFO provides businesses with outsourced financial management and decision-support, without the need for a full-time in-house CFO — designed for businesses that have grown beyond basic accounting but may not yet require a permanent senior finance executive. The scope is customised according to the size, complexity and requirements of the business.",
    "sections": {
      "whoNeedsIt": {
        "heading": "Who Can Benefit?",
        "items": [
          "Startups",
          "Growing MSMEs",
          "Family-owned businesses",
          "Businesses expanding into new markets",
          "Companies without a senior finance team",
          "Businesses seeking better financial controls"
        ]
      },
      "eligibility": {
        "heading": "Our Virtual CFO Services",
        "items": [
          "Financial Reporting & MIS: monthly financial review, management dashboards, profitability analysis, budget vs actual analysis, key business metrics",
          "Cash Flow Management: cash-flow monitoring, receivable and payable analysis, cash-flow projections, working capital review, funding requirement assessment",
          "Business Performance Review: revenue analysis, cost analysis, margin monitoring, product/customer profitability, business trend analysis",
          "Budgeting & Forecasting: annual budgets, revenue forecasts, expense budgets, cash-flow projections, scenario analysis",
          "Management Decision Support: financial information to support decisions on business expansion, pricing, cost control, working capital, funding, investment and business restructuring"
        ]
      },
      "documents": {
        "heading": "Documents & Information Generally Required",
        "groups": [
          {
            "title": "Depending on the scope",
            "items": [
              "Financial statements",
              "Accounting data",
              "Bank statements",
              "Sales information",
              "Expense information",
              "Debtors & creditors",
              "Existing MIS",
              "Budgets and targets",
              "Loan/funding information",
              "Business plans"
            ]
          }
        ]
      },
      "process": {
        "heading": "Our Approach",
        "steps": [
          {
            "title": "Understand the Business",
            "desc": "We understand the business model, financial structure and management requirements."
          },
          {
            "title": "Review Financial Information",
            "desc": "Existing accounting records, MIS and financial processes are reviewed."
          },
          {
            "title": "Identify Key Issues",
            "desc": "Cash-flow gaps, profitability concerns, working-capital issues and reporting requirements are identified."
          },
          {
            "title": "Establish Reporting",
            "desc": "A suitable MIS and financial reporting framework is developed."
          },
          {
            "title": "Regular Review",
            "desc": "Financial performance and key indicators are reviewed periodically."
          },
          {
            "title": "Management Support",
            "desc": "Relevant financial information and analysis are provided to support management decisions."
          }
        ]
      },
      "timeline": {
        "heading": "Engagement Structure",
        "body": "Engagements can be structured on a monthly retainer or customised basis, building a structured finance function — accounting data, financial reporting, MIS & analysis, cash flow & working capital, budget & forecast and management review — without requiring a full-time CFO."
      },
      "fees": {
        "heading": "Professional Fees",
        "note": "Virtual CFO fees depend on business size, frequency of review, number of reports, level of financial analysis, cash-flow requirements, management involvement and scope of advisory support."
      },
      "benefits": {
        "heading": "Virtual CFO vs Traditional Accounting",
        "items": [
          "Accounting records transactions; Virtual CFO analyses financial performance",
          "Accounting maintains ledgers; Virtual CFO reviews business trends",
          "Accounting prepares accounts; Virtual CFO supports management decisions",
          "Accounting focuses on historical data; Virtual CFO includes forward-looking analysis",
          "Accounting is compliance-oriented; Virtual CFO is strategy & finance-oriented",
          "The two services can work together"
        ]
      },
      "afterService": null,
      "whyUs": {
        "heading": "Why Choose Biz360 Compliance?",
        "items": [
          "Integrated Accounting & Finance Support: builds upon your existing accounting, MIS and financial reporting systems",
          "Business-Focused Approach: making financial information useful for management, not just producing reports",
          "Flexible Engagement: senior-level finance support without immediately building a full-time finance leadership team",
          "Scalable Support: the scope can increase as the business grows"
        ]
      },
      "faqs": [
        {
          "q": "What is a Virtual CFO?",
          "a": "A Virtual CFO is an outsourced finance function providing financial reporting, analysis, planning and management support."
        },
        {
          "q": "Is a Virtual CFO suitable for a small business?",
          "a": "Yes, particularly where the business needs professional financial oversight but does not require a full-time CFO."
        },
        {
          "q": "Does Virtual CFO include accounting?",
          "a": "Accounting can be included or coordinated separately depending on the engagement."
        },
        {
          "q": "Can you help with cash-flow management?",
          "a": "Yes. Cash-flow monitoring, forecasting and working-capital analysis can be included."
        },
        {
          "q": "Can a Virtual CFO help with business loans?",
          "a": "Yes. Financial analysis, projections, funding requirements and financial documentation can be supported."
        },
        {
          "q": "Is Virtual CFO a replacement for a statutory auditor?",
          "a": "No. Virtual CFO services and statutory audit are different functions and should not be treated as substitutes."
        }
      ],
      "extra": null,
      "related": [
        "cash-flow-working-capital",
        "financial-planning-advisory",
        "bookkeeping-accounting"
      ]
    }
  },
  {
    "slug": "project-reports-cma-data",
    "category": "Account & Finance",
    "sub_category": null,
    "icon": "FileSpreadsheet",
    "title": "Project Reports & CMA Data Services",
    "subtitle": "Prepare practical financial projections and business reports for funding, expansion and financial planning.",
    "read_time": "7 min read",
    "image": "https://images.unsplash.com/photo-1450101499163-c8848c66ca85?crop=entropy&cs=srgb&fm=jpg&q=80&w=1200",
    "intro": "Biz360 Compliance assists entrepreneurs and businesses with project reports, CMA data, financial projections and supporting financial information required for business loans and funding proposals. A well-prepared project report helps lenders and stakeholders understand the business model, project cost, funding requirement, expected revenue and repayment capacity. Our reports are prepared based on the actual business proposal, available quotations and realistic financial assumptions.",
    "sections": {
      "whoNeedsIt": {
        "heading": "Who Can Use This Service?",
        "items": [
          "Entrepreneurs starting a new business",
          "Existing MSMEs",
          "Manufacturers",
          "Traders",
          "Service providers",
          "Startups",
          "Businesses planning expansion",
          "Applicants seeking bank finance",
          "Businesses applying under eligible government schemes"
        ]
      },
      "eligibility": {
        "heading": "Our Services",
        "items": [
          "Business Project Reports: for new business proposals, expansion, new manufacturing units, service and trading businesses, capacity expansion, new product/business lines",
          "Bank Loan Project Reports: for term loans, working capital facilities, business loans, machinery finance, MSME finance, expansion finance",
          "CMA Data: existing financial position, projected Profit & Loss, projected Balance Sheet, Cash Flow, Fund Flow, working capital assessment, key financial ratios, repayment capacity",
          "Government Scheme Project Reports: structured for applicable government-backed financing and subsidy schemes, subject to the requirements of the respective scheme and lending institution"
        ]
      },
      "documents": {
        "heading": "Documents Generally Required",
        "groups": [
          {
            "title": "Depending on the project",
            "items": [
              "Promoter details",
              "Business registration documents",
              "Machinery quotations",
              "Property/rent details",
              "Existing financial statements",
              "Bank statements",
              "Existing loan details",
              "Project cost estimates",
              "Sales assumptions",
              "Raw material/cost information",
              "GST/Income Tax details, where applicable",
              "Government scheme details, if relevant"
            ]
          }
        ]
      },
      "process": {
        "heading": "Our Process",
        "steps": [
          {
            "title": "Understand the Proposal",
            "desc": "We understand the business, project, investment and funding requirement."
          },
          {
            "title": "Collect Information",
            "desc": "Business details, machinery quotations, project costs and other supporting information are collected."
          },
          {
            "title": "Develop Financial Assumptions",
            "desc": "Sales, costs, working capital and other assumptions are developed based on the available information."
          },
          {
            "title": "Prepare Projections",
            "desc": "Projected financial statements, cash flow and relevant financial indicators are prepared."
          },
          {
            "title": "Review & Finalise",
            "desc": "The report is reviewed with the promoter and finalised for the intended purpose."
          }
        ]
      },
      "timeline": {
        "heading": "Important Note",
        "body": "A project report or CMA statement does not guarantee loan approval. The final sanction depends on the lender's assessment, including credit history, banking relationship, promoter profile, collateral/security, project viability and other applicable criteria."
      },
      "fees": {
        "heading": "Professional Fees",
        "note": "Fees depend on the type and size of project, complexity of financial projections, CMA requirements, number of years of projections, existing financial data, government scheme requirements and additional revisions. Share your project details for a customised quotation."
      },
      "benefits": {
        "heading": "Why Choose Biz360 Compliance?",
        "items": [
          "Based on Your Actual Business: available quotations, project costs and business assumptions used rather than generic templates",
          "Financially Structured: the report connects project cost, funding, sales, expenses, profitability and repayment capacity",
          "Bank-Oriented Presentation: information organised in a format suitable for discussion with banks and financial institutions",
          "Integrated Financial Support: project reports can be supported by accounting, financial statements, MIS and Virtual CFO services"
        ]
      },
      "afterService": null,
      "whyUs": {
        "heading": "Why Choose Biz360 Compliance?",
        "items": [
          "Reports built on actual business proposals, not generic templates",
          "Financially structured, connecting cost, funding, sales and repayment capacity",
          "Bank-oriented presentation for lender discussions",
          "Integrated with accounting, financial statements, MIS and Virtual CFO services"
        ]
      },
      "faqs": [
        {
          "q": "What is a project report?",
          "a": "A project report presents the business proposal, project cost, funding requirement, projected financial performance and repayment capacity."
        },
        {
          "q": "What is CMA data?",
          "a": "CMA data is financial information prepared in a structured format generally used by banks for evaluating credit and working-capital requirements."
        },
        {
          "q": "Can you prepare reports for new businesses?",
          "a": "Yes. Project reports can be prepared using promoter information, quotations and reasonable business assumptions."
        },
        {
          "q": "Can you prepare project reports for existing businesses?",
          "a": "Yes. Existing financial statements and actual business performance can be incorporated into the projections."
        },
        {
          "q": "Can you prepare reports for government loan schemes?",
          "a": "Yes, subject to the specific requirements of the scheme and lending institution."
        },
        {
          "q": "Does a project report guarantee loan approval?",
          "a": "No. Loan approval is ultimately subject to the lender's appraisal and applicable conditions."
        }
      ],
      "extra": null,
      "related": [
        "financial-planning-advisory",
        "bookkeeping-accounting",
        "monthly-accounting-closing"
      ]
    }
  },
  {
    "slug": "cash-flow-working-capital",
    "category": "Account & Finance",
    "sub_category": null,
    "icon": "Wallet",
    "title": "Cash Flow & Working Capital Management",
    "subtitle": "Improve control over cash, receivables, payables and day-to-day business funding.",
    "read_time": "6 min read",
    "image": "https://images.unsplash.com/photo-1554224154-26032ffc0d07?crop=entropy&cs=srgb&fm=jpg&q=80&w=1200",
    "intro": "Biz360 Compliance helps businesses monitor their cash position, manage working capital and plan upcoming financial requirements through practical financial analysis and reporting. A profitable business can still face cash-flow pressure when customer collections are delayed, inventory remains blocked or supplier payments become due. Our service helps business owners understand where cash is coming from, where it is being used, what payments are approaching, which receivables require attention and how much working capital may be required.",
    "sections": {
      "whoNeedsIt": {
        "heading": "Who Can Benefit",
        "items": [
          "Trading businesses",
          "Manufacturers",
          "Distributors",
          "Service businesses",
          "Growing MSMEs",
          "Businesses with long customer credit periods",
          "Businesses experiencing cash-flow pressure",
          "Businesses planning expansion"
        ]
      },
      "eligibility": {
        "heading": "Our Services",
        "items": [
          "Cash Flow Monitoring: cash inflow and outflow tracking, short-term cash-flow projections, upcoming payment review, liquidity monitoring",
          "Receivables Management: customer outstanding analysis, ageing reports, collection monitoring, overdue receivable identification",
          "Payables Management: vendor outstanding review, payment scheduling, due-date monitoring, payable ageing",
          "Working Capital Analysis: review of inventory, receivables, payables, operating cycle and working capital requirement",
          "Funding Requirement Analysis: support in assessing requirements for working capital facilities, business expansion, new machinery, additional inventory and seasonal funding"
        ]
      },
      "documents": {
        "heading": "Documents & Information Generally Required",
        "groups": [
          {
            "title": "Depending on the engagement",
            "items": [
              "Financial statements",
              "Accounting data",
              "Bank statements",
              "Debtors ageing",
              "Creditors ageing",
              "Inventory information",
              "Sales and purchase data",
              "Customer/vendor credit terms",
              "Existing loan details",
              "Business expansion plans"
            ]
          }
        ]
      },
      "process": {
        "heading": "Our Process",
        "steps": [
          {
            "title": "Understand the Business Cycle",
            "desc": "Review sales, purchases, credit terms, inventory and payment patterns."
          },
          {
            "title": "Analyse Existing Position",
            "desc": "Review receivables, payables, inventory and available cash."
          },
          {
            "title": "Prepare Cash-Flow View",
            "desc": "Develop an appropriate cash-flow monitoring or projection format."
          },
          {
            "title": "Identify Gaps",
            "desc": "Highlight potential liquidity and working-capital pressure points."
          },
          {
            "title": "Management Review",
            "desc": "Discuss practical areas for improving collections, payments and working-capital utilisation."
          }
        ]
      },
      "timeline": {
        "heading": "Regular Monitoring",
        "body": "Cash flow can be reviewed monthly or at another agreed frequency, working alongside MIS, Virtual CFO, accounting and project-report services for connected finance support."
      },
      "fees": {
        "heading": "Professional Fees",
        "note": "Fees depend on business size, reporting frequency, complexity of operations, number of customers/vendors, inventory requirements and level of financial analysis. Get a customised finance-support proposal."
      },
      "benefits": {
        "heading": "Why Choose Biz360 Compliance",
        "items": [
          "Accounting-Linked Analysis: the analysis can be based on your actual accounting and financial information",
          "Practical Focus: identifying areas that can improve cash availability and financial control",
          "Regular Monitoring: cash flow reviewed monthly or at another agreed frequency",
          "Connected Finance Support: works alongside MIS, Virtual CFO, accounting and project-report services"
        ]
      },
      "afterService": null,
      "whyUs": {
        "heading": "Why Choose Biz360 Compliance?",
        "items": [
          "Analysis linked to your actual accounting data",
          "Practical focus on improving cash availability and control",
          "Regular monitoring at monthly or agreed frequency",
          "Connected with MIS, Virtual CFO, accounting and project-report services"
        ]
      },
      "faqs": [
        {
          "q": "What is working capital management?",
          "a": "It involves managing short-term business assets and liabilities such as cash, receivables, inventory and payables to maintain adequate liquidity."
        },
        {
          "q": "Why can a profitable business face cash-flow problems?",
          "a": "Profit does not necessarily mean cash is immediately available. Credit sales, inventory and payment obligations can create temporary cash shortages."
        },
        {
          "q": "Can you prepare cash-flow projections?",
          "a": "Yes. Short-term and periodic cash-flow projections can be prepared based on available business information."
        },
        {
          "q": "Can you help analyse customer outstanding?",
          "a": "Yes. Receivables ageing and collection patterns can be reviewed."
        },
        {
          "q": "Can you help with bank working-capital requirements?",
          "a": "Yes. Working-capital requirements can be analysed and financial information can be prepared for discussion with lenders."
        },
        {
          "q": "Is this service suitable for small businesses?",
          "a": "Yes. It can be particularly useful for growing businesses where cash is frequently tied up in receivables, inventory or operating expenses."
        }
      ],
      "extra": {
        "kind": "table",
        "columns": [
          "Area",
          "What We Look At"
        ],
        "rows": [
          [
            "Receivables",
            "Collection cycle & overdue amounts"
          ],
          [
            "Payables",
            "Payment obligations & credit period"
          ],
          [
            "Inventory",
            "Stock holding & funds blocked"
          ],
          [
            "Cash",
            "Current & projected liquidity"
          ],
          [
            "Working Capital",
            "Operating funding requirement"
          ],
          [
            "Operating Cycle",
            "Time between payment and collection"
          ]
        ]
      },
      "related": [
        "bookkeeping-accounting",
        "monthly-accounting-closing",
        "accounts-finalisation"
      ]
    }
  },
  {
    "slug": "financial-planning-advisory",
    "category": "Account & Finance",
    "sub_category": null,
    "icon": "TrendingUp",
    "title": "Financial Planning & Advisory",
    "subtitle": "Plan your finances, manage resources and make better-informed business decisions.",
    "read_time": "6 min read",
    "image": "https://images.unsplash.com/photo-1560518883-ce09059eeffa?crop=entropy&cs=srgb&fm=jpg&q=80&w=1200",
    "intro": "Biz360 Compliance helps businesses evaluate their financial position, plan future requirements and make informed decisions around cash flow, profitability, investments, funding and business growth. Business decisions often involve financial questions — can the business afford an expansion, how much working capital will be required, what will be the impact of a new loan, is current pricing generating sufficient margins. Our financial planning service helps convert these questions into structured financial analysis and projections.",
    "sections": {
      "whoNeedsIt": {
        "heading": "Who Can Benefit?",
        "items": [
          "Startups",
          "MSMEs",
          "Growing businesses",
          "Family-owned businesses",
          "Businesses planning expansion",
          "Entrepreneurs evaluating new projects",
          "Businesses planning additional borrowing"
        ]
      },
      "eligibility": {
        "heading": "Our Financial Advisory Services",
        "items": [
          "Financial Planning: revenue and expense planning, profitability projections, cash-flow planning, funding requirement assessment, financial targets",
          "Business Budgeting: annual budgets, revenue budgets, expense budgets, department/product budgets, budget vs actual review",
          "Financial Projections: for business expansion, new projects, funding discussions, management planning, business restructuring",
          "Investment & Expansion Analysis: financial evaluation of new machinery, new locations, new product lines, business expansion, additional manpower, capital expenditure",
          "Funding & Finance Planning: assessment of potential funding requirements for term loans, working capital, business expansion funding, debt servicing and funding projections"
        ]
      },
      "documents": {
        "heading": "Documents Generally Required",
        "groups": [
          {
            "title": "Depending on the assignment",
            "items": [
              "Financial statements",
              "Accounting data",
              "Bank statements",
              "Existing loan details",
              "Sales and expense information",
              "Business projections",
              "Investment plans",
              "Funding requirements",
              "Other relevant financial information"
            ]
          }
        ]
      },
      "process": {
        "heading": "Our Process",
        "steps": [
          {
            "title": "Understand Your Objective",
            "desc": "We understand the business goal or financial decision you are considering."
          },
          {
            "title": "Review Current Financial Position",
            "desc": "Existing financial statements, cash flow and business information are reviewed."
          },
          {
            "title": "Develop Financial Assumptions",
            "desc": "Revenue, costs, funding and other relevant assumptions are structured."
          },
          {
            "title": "Analyse the Options",
            "desc": "Different scenarios can be compared where appropriate."
          },
          {
            "title": "Prepare Financial Plan",
            "desc": "The findings are presented through projections, reports or financial analysis."
          },
          {
            "title": "Review & Support",
            "desc": "The financial plan can be reviewed periodically as business circumstances change."
          }
        ]
      },
      "timeline": {
        "heading": "Financial Planning vs Virtual CFO",
        "body": "Financial planning is one component of broader Virtual CFO support. A Virtual CFO engagement can include ongoing MIS, cash-flow monitoring, budgeting and management support, while financial planning can also be engaged as a standalone assignment focused on a specific decision or objective."
      },
      "fees": {
        "heading": "Professional Fees",
        "note": "Fees depend on the nature of assignment, business complexity, financial information available, number of projections/scenarios, level of analysis required and whether the support is ongoing or one-time. Get a customised advisory proposal."
      },
      "benefits": {
        "heading": "Why Choose Biz360 Compliance?",
        "items": [
          "Based on Your Business Numbers: financial planning starts with your actual financial position and business objectives",
          "Connected With Accounting: your accounting, MIS and financial statements can form the foundation for financial planning",
          "Practical Analysis: focus on helping management understand the financial implications of business decisions",
          "Integrated Finance Support: can be combined with MIS, Virtual CFO, cash-flow management and project-report services"
        ]
      },
      "afterService": null,
      "whyUs": {
        "heading": "Why Choose Biz360 Compliance?",
        "items": [
          "Planning grounded in your actual business numbers",
          "Connected with your accounting and MIS data",
          "Practical, decision-focused financial analysis",
          "Integrated with Virtual CFO, cash-flow and project-report services"
        ]
      },
      "faqs": [
        {
          "q": "What is financial planning for a business?",
          "a": "It involves analysing the current financial position and planning future revenue, expenses, cash flow, funding and investment requirements."
        },
        {
          "q": "Can you prepare financial projections?",
          "a": "Yes. Financial projections can be prepared based on the business objective and reasonable assumptions."
        },
        {
          "q": "Can you help with business expansion decisions?",
          "a": "Yes. Financial implications of expansion, investment and additional funding can be analysed."
        },
        {
          "q": "Can you help prepare budgets?",
          "a": "Yes. Revenue, expense and other business budgets can be prepared and subsequently compared with actual performance."
        },
        {
          "q": "Is this the same as Virtual CFO services?",
          "a": "No. Financial planning is one component of broader Virtual CFO support. A Virtual CFO engagement can include ongoing MIS, cash-flow monitoring, budgeting and management support."
        },
        {
          "q": "Can financial planning be combined with accounting?",
          "a": "Yes. Accounting and financial planning work well together because reliable financial data is essential for meaningful analysis."
        }
      ],
      "extra": null,
      "related": [
        "monthly-accounting-closing",
        "accounts-finalisation",
        "mis-reporting"
      ]
    }
  },
  {
    "slug": "audit-support-services",
    "category": "Other Services",
    "sub_category": null,
    "icon": "ClipboardCheck",
    "title": "Tax Audit Support Services",
    "subtitle": "Get your books, tax records and supporting information organised for a smoother tax audit process.",
    "read_time": "6 min read",
    "image": "https://images.unsplash.com/photo-1554224155-8d04cb21cd6c?crop=entropy&cs=srgb&fm=jpg&q=80&w=1200",
    "intro": "A tax audit requires more than maintaining books of accounts — relevant financial information, tax records and supporting details need to be properly organised before the appointed auditor can complete the applicable reporting requirements. Biz360 Compliance provides tax audit preparation, reconciliation, documentation and coordination support to businesses working with their appointed tax auditor, helping resolve data gaps before the audit process begins.",
    "sections": {
      "whoNeedsIt": {
        "heading": "Who Can Use Tax Audit Support?",
        "items": [
          "Companies subject to tax audit requirements",
          "LLPs",
          "Partnership Firms",
          "Proprietorships",
          "Professionals",
          "Other taxpayers covered by applicable tax-audit provisions"
        ]
      },
      "eligibility": {
        "heading": "Who Can Use Tax Audit Support?",
        "items": [
          "Businesses and professionals subject to tax audit requirements needing help preparing accounting and tax information",
          "Whether tax audit is applicable depends on the taxpayer's facts and the provisions applicable to the relevant assessment year"
        ]
      },
      "documents": {
        "heading": "Information & Records Typically Involved",
        "groups": [
          {
            "title": "Books & Ledger Review",
            "items": [
              "Trial balance",
              "Ledgers",
              "Revenue and expense records",
              "Major account workings"
            ]
          },
          {
            "title": "Tax Reconciliation Data",
            "items": [
              "Turnover",
              "GST records",
              "TDS information",
              "Taxable income",
              "Receivables/payables"
            ]
          },
          {
            "title": "Tax Audit Information",
            "items": [
              "Business turnover",
              "Expenses",
              "Depreciation",
              "Loans and liabilities",
              "Payments requiring specific tax consideration"
            ]
          }
        ]
      },
      "process": {
        "heading": "Our Process",
        "steps": [
          {
            "title": "Understand the Tax Position",
            "desc": "We review the nature of business, books and relevant tax information."
          },
          {
            "title": "Review Accounting Records",
            "desc": "Key ledgers, trial balance and financial information are reviewed."
          },
          {
            "title": "Reconcile Tax Data",
            "desc": "Accounting records are compared with relevant GST, TDS and other available tax information."
          },
          {
            "title": "Prepare Audit Information",
            "desc": "Required schedules, workings and supporting documents are organised."
          },
          {
            "title": "Identify Gaps",
            "desc": "Potential differences or missing information are highlighted for management attention."
          },
          {
            "title": "Coordinate With Auditor",
            "desc": "The required information can be provided to and coordinated with the appointed tax auditor."
          }
        ]
      },
      "timeline": {
        "heading": "Timeline",
        "body": "Timelines depend on the condition of books, volume of transactions and reconciliation requirements; proper preparation helps reduce delays in completing the audit process."
      },
      "fees": {
        "heading": "Professional Fees",
        "note": "Fees depend on the nature and size of business, turnover, volume of transactions, condition of books, reconciliation requirements, complexity of tax information and documentation required. Tax audit support fees are separate from the professional fees of the appointed tax auditor."
      },
      "benefits": {
        "heading": "Why Tax Audit Preparation Matters",
        "items": [
          "Reduce last-minute audit queries",
          "Identify accounting and tax-data differences",
          "Organise supporting documents",
          "Improve reconciliation between books and statutory records",
          "Provide information to the auditor in a structured manner",
          "Reduce delays in completing the audit process"
        ]
      },
      "afterService": null,
      "whyUs": {
        "heading": "Why Choose Biz360 Compliance?",
        "items": [
          "Accounting + Tax Data — we can connect accounting records with GST, TDS and other tax information",
          "Reconciliation-Focused — differences between financial records and statutory data can be identified before the audit",
          "Documentation Support — audit-related schedules and supporting information can be organised systematically",
          "Auditor Coordination — we can assist management in coordinating information requests with the appointed tax auditor"
        ]
      },
      "faqs": [
        {
          "q": "Does Biz360 conduct tax audits?",
          "a": "No. Biz360 provides tax audit preparation and support. The applicable tax audit report is prepared/certified by the appropriately qualified and appointed tax auditor."
        },
        {
          "q": "Can you prepare the books before the tax audit?",
          "a": "Yes. Accounting and year-end finalisation services can be provided separately or along with tax audit support."
        },
        {
          "q": "Can you reconcile GST turnover with books?",
          "a": "Yes. GST and accounting records can be reconciled as part of the preparation process."
        },
        {
          "q": "Can you help with TDS reconciliation?",
          "a": "Yes. TDS information can be compared with accounting records and available statutory data."
        },
        {
          "q": "Can you prepare audit schedules?",
          "a": "Yes. Relevant schedules and supporting workings can be compiled according to the requirements of the engagement and appointed auditor."
        },
        {
          "q": "Can you coordinate with our tax auditor?",
          "a": "Yes. We can assist with providing financial data, schedules and supporting documents requested by the appointed auditor."
        }
      ],
      "extra": null,
      "related": [
        "internal-controls-process-review",
        "certification-documentation-support",
        "startup-india-dpiit-recognition"
      ]
    }
  },
  {
    "slug": "internal-audit-support",
    "category": "Other Services",
    "sub_category": null,
    "icon": "SearchCheck",
    "title": "Internal Audit Support Services",
    "subtitle": "Identify control gaps, process weaknesses and operational risks before they become larger problems.",
    "read_time": "6 min read",
    "image": "https://images.unsplash.com/photo-1521791136064-7986c2920216?crop=entropy&cs=srgb&fm=jpg&q=80&w=1200",
    "intro": "Internal audit is not limited to checking whether accounting entries are correct. Biz360 Compliance provides internal audit support, process review, reconciliation and internal control assessment to help businesses strengthen financial and operational processes, covering data analysis, process review, documentation, testing and reporting support depending on the engagement.",
    "sections": {
      "whoNeedsIt": {
        "heading": "Who Can Benefit?",
        "items": [
          "Growing MSMEs",
          "Private Limited Companies",
          "Family-owned businesses",
          "Multi-location businesses",
          "Businesses with significant inventory",
          "Businesses with multiple employees/departments",
          "Companies looking to strengthen internal controls"
        ]
      },
      "eligibility": {
        "heading": "Who Can Benefit?",
        "items": [
          "Businesses wanting an independent review of selected business processes",
          "Companies at any stage seeking to strengthen financial and operational controls"
        ]
      },
      "documents": {
        "heading": "Areas That Can Be Reviewed",
        "groups": [
          {
            "title": "Financial Process Review",
            "items": [
              "Sales and collections",
              "Purchases and payments",
              "Expenses",
              "Inventory",
              "Banking",
              "Receivables and payables"
            ]
          },
          {
            "title": "Internal Control Review",
            "items": [
              "Authorisation",
              "Segregation of duties",
              "Documentation",
              "Approvals",
              "Access controls",
              "Reconciliation",
              "Exception handling"
            ]
          }
        ]
      },
      "process": {
        "heading": "Our Internal Audit Process",
        "steps": [
          {
            "title": "Understand the Process",
            "desc": "We understand how the selected business process currently operates."
          },
          {
            "title": "Identify Key Controls",
            "desc": "Important approval, documentation and reconciliation controls are mapped."
          },
          {
            "title": "Test & Review",
            "desc": "Selected transactions, records and processes are reviewed based on the agreed scope."
          },
          {
            "title": "Identify Exceptions",
            "desc": "Control gaps, unusual transactions and process weaknesses are documented."
          },
          {
            "title": "Discuss Findings",
            "desc": "Observations are discussed with management to understand the underlying reasons."
          },
          {
            "title": "Action-Oriented Reporting",
            "desc": "Findings and practical recommendations are presented for management consideration."
          }
        ]
      },
      "timeline": {
        "heading": "Timeline",
        "body": "Internal audit reviews can be periodic, including monthly, quarterly or as otherwise agreed, depending on the scope and frequency required by management."
      },
      "fees": {
        "heading": "Professional Fees",
        "note": "Fees depend on the size of the business, scope of audit, number of locations, transaction volume, processes covered, frequency of review and reporting requirements. A customised Internal Audit Support proposal can be provided."
      },
      "benefits": {
        "heading": "Why Internal Audit Matters",
        "items": [
          "Strengthen financial controls",
          "Reduce process errors",
          "Improve documentation",
          "Identify operational inefficiencies",
          "Monitor compliance with internal policies",
          "Improve accountability",
          "Identify areas requiring corrective action"
        ]
      },
      "afterService": null,
      "whyUs": {
        "heading": "Why Choose Biz360 Compliance?",
        "items": [
          "Business-Focused Review — we focus on understanding how the process actually works rather than applying a purely theoretical checklist",
          "Accounting & Compliance Understanding — our review can connect accounting records with GST, TDS, payroll and other compliance processes",
          "Practical Recommendations — observations are presented with an emphasis on actionable improvements",
          "Flexible Scope — reviews can be conducted for the complete business or selected processes/departments"
        ]
      },
      "faqs": [
        {
          "q": "Does Biz360 conduct statutory audits?",
          "a": "No. Biz360 provides audit and internal-review support within the agreed scope. Statutory audit opinions and other regulated professional functions are performed by the appropriately appointed/qualified professional."
        },
        {
          "q": "What is the difference between internal audit and statutory audit?",
          "a": "Statutory audit primarily addresses the applicable statutory reporting and audit requirements. Internal audit focuses more broadly on controls, processes, risks and operational efficiency for management."
        },
        {
          "q": "Can you review only one department?",
          "a": "Yes. The engagement can be limited to specific processes such as purchases, inventory, sales or payroll."
        },
        {
          "q": "Can internal audit be conducted monthly?",
          "a": "Yes. Internal audit reviews can be periodic, including monthly, quarterly or as otherwise agreed."
        },
        {
          "q": "Can you review internal controls?",
          "a": "Yes. Internal control review can be a specific part of the engagement."
        },
        {
          "q": "Can you provide recommendations after the review?",
          "a": "Yes. Findings can be accompanied by practical recommendations and suggested corrective actions."
        }
      ],
      "extra": null,
      "related": [
        "certification-documentation-support",
        "startup-india-dpiit-recognition",
        "msme-advisory"
      ]
    }
  },
  {
    "slug": "internal-controls-process-review",
    "category": "Other Services",
    "sub_category": null,
    "icon": "ShieldCheck",
    "title": "Internal Controls & Process Review",
    "subtitle": "Strengthen business controls, reduce process gaps and improve accountability.",
    "read_time": "6 min read",
    "image": "https://images.unsplash.com/photo-1518186285589-2f7649de83e0?crop=entropy&cs=srgb&fm=jpg&q=80&w=1200",
    "intro": "Internal controls are the policies, procedures and checks used by a business to protect assets, maintain accurate records and reduce operational and financial risks. Biz360 Compliance helps businesses review key financial and operational processes and identify areas where controls, approvals, documentation and monitoring can be improved, with the review tailored to the size and nature of the business.",
    "sections": {
      "whoNeedsIt": {
        "heading": "Who Can Benefit?",
        "items": [
          "Growing MSMEs",
          "Startups",
          "Private Limited Companies",
          "Family-owned businesses",
          "Businesses with multiple employees",
          "Businesses with inventory",
          "Multi-location businesses",
          "Companies implementing ERP/accounting systems"
        ]
      },
      "eligibility": {
        "heading": "Who Can Benefit?",
        "items": [
          "Particularly useful when the business is growing faster than its existing processes"
        ]
      },
      "documents": {
        "heading": "Areas We Can Review",
        "groups": [
          {
            "title": "Financial Controls",
            "items": [
              "Cash and bank controls",
              "Payment approvals",
              "Expense controls",
              "Reconciliations",
              "Receivables and collections",
              "Payables"
            ]
          },
          {
            "title": "Purchase & Vendor Controls",
            "items": [
              "Vendor onboarding",
              "Purchase approvals",
              "Purchase orders",
              "Invoice verification",
              "Payment authorisation"
            ]
          },
          {
            "title": "Sales & Collection Controls",
            "items": [
              "Customer onboarding",
              "Credit limits",
              "Sales invoicing",
              "Receivables monitoring",
              "Collection controls"
            ]
          },
          {
            "title": "Inventory Controls",
            "items": [
              "Stock receipt and issue",
              "Inventory records",
              "Physical verification",
              "Stock adjustments",
              "Slow-moving inventory"
            ]
          },
          {
            "title": "Access & Approval Controls",
            "items": [
              "User access",
              "Approval hierarchy",
              "Segregation of duties",
              "Maker-checker controls",
              "Financial authority limits"
            ]
          }
        ]
      },
      "process": {
        "heading": "Our Process",
        "steps": [
          {
            "title": "Understand the Process",
            "desc": "We understand how the selected process currently operates."
          },
          {
            "title": "Map Key Controls",
            "desc": "Important approval, verification and reconciliation points are identified."
          },
          {
            "title": "Review Existing Practices",
            "desc": "Actual business practices are compared with the defined process or expected control framework."
          },
          {
            "title": "Identify Gaps",
            "desc": "Weaknesses, duplication, missing controls and potential risk areas are documented."
          },
          {
            "title": "Recommend Improvements",
            "desc": "Practical improvements are suggested based on the business's size and operational requirements."
          }
        ]
      },
      "timeline": {
        "heading": "Timeline",
        "body": "Timeline depends on the number of processes reviewed and business size; a customised proposal can be provided after understanding the scope."
      },
      "fees": {
        "heading": "Professional Fees",
        "note": "Fees depend on the number of processes reviewed, business size, transaction volume, number of locations, complexity of existing systems and reporting requirements. A customised proposal can be provided after understanding the scope."
      },
      "benefits": {
        "heading": "Key Benefits",
        "items": [
          "Better Accountability — clear responsibility and approval levels can reduce confusion",
          "Reduced Errors — proper checks can help identify errors before they become larger issues",
          "Stronger Financial Discipline — payment, collection and accounting controls can be improved",
          "Better Process Visibility — management gets a clearer understanding of how important processes operate",
          "Scalable Controls — controls can be designed according to the size and complexity of the business"
        ]
      },
      "afterService": {
        "heading": "Typical Deliverables",
        "items": [
          "Process observations",
          "Control-gap summary",
          "Risk areas",
          "Suggested control improvements",
          "Approval matrix recommendations",
          "Reconciliation/control checklist",
          "Action points for management"
        ]
      },
      "whyUs": {
        "heading": "Why Choose Biz360 Compliance?",
        "items": [
          "Practical Approach — we focus on controls that can actually be implemented in the business",
          "Accounting & Compliance Understanding — controls can be reviewed in connection with accounting, GST, TDS, payroll and statutory processes",
          "MSME-Friendly — the objective is not to create unnecessary bureaucracy but to establish appropriate controls for the size of the business",
          "Action-Oriented — the review focuses on identifying what should be improved and how"
        ]
      },
      "faqs": [
        {
          "q": "What is the difference between internal audit and internal control review?",
          "a": "Internal audit generally involves a broader and more systematic review of risks, controls and processes. A control review focuses specifically on whether key controls are appropriately designed and operating effectively."
        },
        {
          "q": "Can you review only one process?",
          "a": "Yes. For example, we can review only the purchase-to-payment or sales-to-collection process."
        },
        {
          "q": "Can you review accounting controls?",
          "a": "Yes. Bank reconciliation, ledger controls, payment approvals and other accounting controls can be reviewed."
        },
        {
          "q": "Can you review controls in Tally or ERP systems?",
          "a": "Yes. System-based controls and user-access processes can be reviewed within the agreed scope."
        },
        {
          "q": "Is this suitable for small businesses?",
          "a": "Yes. Controls can be designed proportionately according to the business's size and complexity."
        },
        {
          "q": "Do you provide SOP support?",
          "a": "Yes. Process observations can be converted into SOP or process-documentation requirements where included in the engagement."
        }
      ],
      "extra": null,
      "related": [
        "startup-india-dpiit-recognition",
        "msme-advisory",
        "government-scheme-advisory"
      ]
    }
  },
  {
    "slug": "certification-documentation-support",
    "category": "Other Services",
    "sub_category": null,
    "icon": "FileCheck2",
    "title": "Certification & Documentation Support",
    "subtitle": "Prepare accurate financial information and supporting documents for professional certifications and business requirements.",
    "read_time": "6 min read",
    "image": "https://images.unsplash.com/photo-1444653614773-995cb1ef9efa?crop=entropy&cs=srgb&fm=jpg&q=80&w=1200",
    "intro": "Businesses frequently require certificates or professionally certified documents for bank and loan applications, government schemes, tenders, registrations, funding and regulatory submissions. Biz360 Compliance helps organise financial data, supporting schedules, reconciliations and documentation, assisting with preparation and compilation of the underlying information and coordinating with the appropriately authorised professional wherever certification is legally required.",
    "sections": {
      "whoNeedsIt": {
        "heading": "Who Can Use This Service?",
        "items": [
          "MSMEs",
          "Startups",
          "Companies",
          "LLPs",
          "Partnership Firms",
          "Proprietorships",
          "Professionals",
          "Businesses applying for loans or government schemes"
        ]
      },
      "eligibility": {
        "heading": "Who Can Use This Service?",
        "items": [
          "Any business or professional needing financial data prepared for a certificate, attestation or regulatory submission"
        ]
      },
      "documents": {
        "heading": "Document Compilation",
        "groups": [
          {
            "title": "Financial Data Preparation",
            "items": [
              "Turnover details",
              "Profit and loss information",
              "Net worth workings",
              "Financial statements",
              "Bank and loan information",
              "Other financial schedules"
            ]
          },
          {
            "title": "Records We Help Organise",
            "items": [
              "Financial records",
              "GST returns",
              "Income Tax returns",
              "Bank statements",
              "Accounting records",
              "Supporting agreements/documents"
            ]
          }
        ]
      },
      "process": {
        "heading": "Our Process",
        "steps": [
          {
            "title": "Understand the Requirement",
            "desc": "We identify the purpose, period and information required."
          },
          {
            "title": "Collect Records",
            "desc": "Relevant accounting, tax and financial documents are collected."
          },
          {
            "title": "Prepare Workings",
            "desc": "Financial information and supporting schedules are prepared."
          },
          {
            "title": "Reconcile",
            "desc": "Information is cross-checked with available books and statutory records."
          },
          {
            "title": "Professional Review",
            "desc": "Where certification is required by law, the information is provided to the appropriately authorised professional for review and certification."
          },
          {
            "title": "Final Documentation",
            "desc": "The completed documentation is organised for submission or business use."
          }
        ]
      },
      "timeline": {
        "heading": "Timeline",
        "body": "Timelines depend on the type of certificate/document, the period covered and availability of financial records."
      },
      "fees": {
        "heading": "Professional Fees",
        "note": "Fees depend on the type of certificate/document, period covered, availability of financial records, reconciliation requirements and complexity of the assignment. Any statutory/professional certification fee, where applicable, is separate from Biz360's documentation/support fee."
      },
      "benefits": {
        "heading": "Common Requirements We Support",
        "items": [
          "Turnover / Sales Certificate Support",
          "Net Worth Statement Support",
          "Banking & Loan Documentation",
          "Government Scheme Documentation",
          "Business & Commercial Documentation"
        ]
      },
      "afterService": null,
      "whyUs": {
        "heading": "Why Choose Biz360 Compliance?",
        "items": [
          "Records-Based Preparation — we work from available accounting and statutory records rather than unsupported estimates",
          "Reconciliation-Focused — financial information can be checked against GST, Income Tax and accounting records where relevant",
          "Purpose-Specific — documents are prepared according to the actual requirement rather than using a generic format",
          "Professional Coordination — where certification is legally reserved for a specific professional, we support the documentation process without misrepresenting the nature of our role"
        ]
      },
      "faqs": [
        {
          "q": "Does Biz360 issue professional certificates?",
          "a": "Where a certificate is legally required to be issued or signed by a specifically authorised professional, Biz360 provides the underlying preparation and coordination support."
        },
        {
          "q": "Can you prepare a turnover certificate?",
          "a": "We can prepare and reconcile the underlying turnover information and supporting schedules required for the certificate."
        },
        {
          "q": "Can you prepare net worth workings?",
          "a": "Yes. Financial information and supporting workings can be compiled for professional review."
        },
        {
          "q": "Can you support bank loan documentation?",
          "a": "Yes. Financial statements, projections, schedules and supporting information can be prepared according to the requirement."
        },
        {
          "q": "Can GST and accounting records be used for reconciliation?",
          "a": "Yes, where relevant to the particular requirement."
        },
        {
          "q": "Can you support government scheme applications?",
          "a": "Yes. Financial and business documentation can be prepared as part of the applicable project or scheme requirement."
        }
      ],
      "extra": null,
      "related": [
        "msme-advisory",
        "government-scheme-advisory",
        "cmegp-pmegp-assistance"
      ]
    }
  },
  {
    "slug": "startup-india-dpiit-recognition",
    "category": "Other Services",
    "sub_category": null,
    "icon": "Rocket",
    "title": "Startup India / DPIIT Recognition",
    "subtitle": "Get your eligible business recognised as a Startup under the DPIIT Startup India framework.",
    "read_time": "7 min read",
    "image": "https://images.unsplash.com/photo-1519389950473-47ba0277781c?crop=entropy&cs=srgb&fm=jpg&q=80&w=1200",
    "intro": "DPIIT Startup Recognition is an official recognition provided under the Startup India initiative to eligible entities that meet the prescribed conditions. Recognition can help eligible startups access various Startup India benefits, schemes and ecosystem support, subject to the separate eligibility conditions applicable to each benefit. Biz360 Compliance helps eligible startups with DPIIT recognition, eligibility assessment, application preparation and documentation support — recognition itself does not automatically grant every Startup India benefit.",
    "sections": {
      "whoNeedsIt": {
        "heading": "Who Can Apply?",
        "items": [
          "Private Limited Companies",
          "LLPs",
          "Partnership Firms",
          "Other entities permitted under the prevailing Startup India framework"
        ]
      },
      "eligibility": {
        "heading": "Key Eligibility Considerations",
        "items": [
          "The business must satisfy applicable conditions relating to incorporation/registration, age, turnover and business activity",
          "The business must demonstrate innovation or improvement of products/services/processes, or a scalable business model with potential for employment generation or wealth creation",
          "Other prescribed conditions relating to the entity, incorporation date and turnover also need to be satisfied",
          "Eligibility should be checked based on the rules applicable on the date of application"
        ]
      },
      "documents": {
        "heading": "Documents & Information Generally Required",
        "groups": [
          {
            "title": "Depending on the Application",
            "items": [
              "Incorporation/registration details",
              "PAN",
              "Entity details",
              "Business activity description",
              "Product/service information",
              "Innovation or improvement explanation",
              "Website/presentation/business information, where relevant",
              "Details of founders/promoters",
              "Supporting documents relevant to the business model"
            ]
          }
        ]
      },
      "process": {
        "heading": "DPIIT Recognition Process",
        "steps": [
          {
            "title": "Eligibility Review",
            "desc": "We assess whether the business appears to satisfy the applicable recognition conditions."
          },
          {
            "title": "Business Assessment",
            "desc": "The business model, product/service, innovation and scalability are reviewed."
          },
          {
            "title": "Document Preparation",
            "desc": "Required information and supporting documents are organised."
          },
          {
            "title": "Application Submission",
            "desc": "The DPIIT recognition application is submitted through the prescribed Startup India process."
          },
          {
            "title": "Review & Follow-Up",
            "desc": "Application status and any clarification requirements are monitored."
          },
          {
            "title": "Recognition",
            "desc": "Once approved, the startup receives the applicable DPIIT recognition."
          }
        ]
      },
      "timeline": {
        "heading": "Timeline",
        "body": "Timeline depends on the completeness of documentation and the review process under the Startup India framework; application status and clarification requirements are actively monitored and followed up."
      },
      "fees": {
        "heading": "Professional Fees",
        "note": "Fees depend on entity structure, complexity of business model, documentation requirements, application support required and additional advisory requirements. Applicable government/platform charges, if any, are separate from professional fees."
      },
      "benefits": {
        "heading": "What Are the Potential Benefits?",
        "items": [
          "Access to Startup India ecosystem initiatives",
          "Certain intellectual-property support",
          "Government procurement-related benefits",
          "Eligible tax-related incentives where separately available",
          "Access to certain funding/support schemes",
          "Networking and startup ecosystem opportunities"
        ]
      },
      "afterService": null,
      "whyUs": {
        "heading": "Why Choose Biz360 Compliance?",
        "items": [
          "Eligibility Before Application — we first assess whether the business appears suitable for DPIIT recognition",
          "Business Model-Focused — we help present the actual innovation, improvement or scalability aspect of the business clearly",
          "Documentation Support — required information is organised before submission",
          "Integrated Startup Support — after recognition, startups can also access Biz360's accounting, taxation, compliance, project report and funding-support services"
        ]
      },
      "faqs": [
        {
          "q": "What is DPIIT recognition?",
          "a": "It is official recognition under the Startup India initiative for eligible startups meeting the prescribed conditions."
        },
        {
          "q": "Is every newly incorporated company eligible?",
          "a": "No. Incorporation alone does not make an entity eligible. The applicable startup conditions must be satisfied."
        },
        {
          "q": "Can an LLP apply for DPIIT recognition?",
          "a": "Eligible LLPs can apply, subject to satisfying the applicable Startup India criteria."
        },
        {
          "q": "Is DPIIT recognition the same as Startup India registration?",
          "a": "DPIIT recognition is the formal recognition of an eligible startup under the Startup India framework."
        },
        {
          "q": "Does DPIIT recognition automatically provide tax exemption?",
          "a": "No. Tax benefits, where available, have their own statutory eligibility and approval requirements."
        },
        {
          "q": "Does DPIIT recognition guarantee government funding?",
          "a": "No. Funding schemes have separate eligibility, application and approval requirements."
        }
      ],
      "extra": null,
      "related": [
        "government-scheme-advisory",
        "cmegp-pmegp-assistance",
        "funding-subsidy-advisory"
      ]
    }
  },
  {
    "slug": "msme-advisory",
    "category": "Other Services",
    "sub_category": null,
    "icon": "Building2",
    "title": "MSME Advisory Services",
    "subtitle": "Practical guidance for MSMEs on compliance, finance, government schemes and business growth.",
    "read_time": "6 min read",
    "image": "https://images.unsplash.com/photo-1450101499163-c8848c66ca85?crop=entropy&cs=srgb&fm=jpg&q=80&w=1200",
    "intro": "Being registered as an MSME is only the starting point. As a business grows, an MSME may need support with financial planning, statutory compliance, government schemes, funding, payment-related matters and business documentation. Biz360 Compliance helps MSMEs understand and manage their registration, financial, compliance and government-support requirements through a practical advisory approach based on the size, activity and requirements of the business.",
    "sections": {
      "whoNeedsIt": {
        "heading": "Who Can Benefit?",
        "items": [
          "Micro enterprises",
          "Small enterprises",
          "Medium enterprises",
          "Manufacturing businesses",
          "Service businesses",
          "Traders",
          "Startups",
          "Family-owned businesses",
          "Growing MSMEs"
        ]
      },
      "eligibility": {
        "heading": "Who Can Benefit?",
        "items": [
          "The exact benefits and schemes available depend on the enterprise's classification, activity, location and applicable government conditions"
        ]
      },
      "documents": {
        "heading": "MSME Areas We Can Support",
        "groups": [
          {
            "title": "Coverage Areas",
            "items": [
              "Udyam — Registration/status support",
              "Funding — Loan & financial documentation",
              "Project Reports — Project report & projections",
              "CMA Data — Preparation support",
              "Government Schemes — Eligibility assessment",
              "Compliance — GST, tax & statutory compliance",
              "Accounting — Bookkeeping & financial reporting",
              "Growth — Financial & business advisory"
            ]
          }
        ]
      },
      "process": {
        "heading": "Our MSME Advisory Process",
        "steps": [
          {
            "title": "Understand Your Business",
            "desc": "We review your business activity, structure, turnover and current requirements."
          },
          {
            "title": "Identify Applicable Areas",
            "desc": "Potential MSME-related registrations, schemes, funding and compliance requirements are mapped."
          },
          {
            "title": "Assess Eligibility",
            "desc": "Available schemes or support mechanisms are evaluated against the applicable conditions."
          },
          {
            "title": "Prepare Documentation",
            "desc": "Financial and business information is organised where an application or funding proposal is required."
          },
          {
            "title": "Implementation Support",
            "desc": "Required registrations, applications, documentation or compliance work can be coordinated."
          },
          {
            "title": "Ongoing Advisory",
            "desc": "As the business grows, additional finance, compliance or government-support requirements can be reviewed."
          }
        ]
      },
      "timeline": {
        "heading": "Timeline",
        "body": "MSME advisory can be a one-time engagement or an ongoing arrangement, depending on whether the business needs a single review or continued support as it grows."
      },
      "fees": {
        "heading": "Professional Fees",
        "note": "Fees depend on the nature of advisory requirement, business size, complexity of the assignment, financial documentation required, government scheme/application involved and whether support is ongoing or one-time. Government fees and third-party charges, where applicable, are separate from professional fees."
      },
      "benefits": {
        "heading": "Our MSME Advisory Services",
        "items": [
          "MSME Status & Compliance Review",
          "Government Scheme Advisory",
          "Finance & Funding Support (project reports, projections, CMA data, loan documentation, working capital)",
          "MSME Compliance Support (GST, Income Tax, accounting, payroll, labour, corporate compliance)",
          "Business Growth Advisory (expansion, financial planning, cost analysis, working capital management, structuring)"
        ]
      },
      "afterService": null,
      "whyUs": {
        "heading": "Why Choose Biz360 Compliance?",
        "items": [
          "One MSME Advisory Partner — accounting, taxation, compliance and financial requirements can be coordinated through one team",
          "Practical Approach — we focus on the actual business requirement rather than recommending schemes or services simply because they are available",
          "Finance + Compliance Understanding — financial information, statutory compliance and funding requirements can be considered together",
          "Growth-Oriented — the objective is not only to maintain compliance but also to help the business build better financial and operational systems"
        ]
      },
      "faqs": [
        {
          "q": "What is MSME advisory?",
          "a": "MSME advisory covers professional assistance relating to MSME registration, compliance, finance, government schemes, funding and business growth requirements."
        },
        {
          "q": "Is MSME advisory the same as Udyam Registration?",
          "a": "No. Udyam Registration is one specific service. MSME advisory is broader and can cover finance, schemes, compliance and business requirements."
        },
        {
          "q": "Can you help identify government schemes for my business?",
          "a": "Yes. We can assess the business profile and identify schemes that may be relevant, subject to their specific eligibility conditions."
        },
        {
          "q": "Can you help with MSME business loans?",
          "a": "Yes. We can assist with project reports, financial projections, CMA data and related documentation."
        },
        {
          "q": "Can you prepare a project report?",
          "a": "Yes. Project reports can be prepared based on the business model, proposed investment and funding requirement."
        },
        {
          "q": "Does MSME registration automatically qualify a business for every government benefit?",
          "a": "No. Individual schemes have their own eligibility conditions, application procedures and approval requirements."
        }
      ],
      "extra": {
        "kind": "table",
        "columns": [
          "Requirement",
          "Possible Support"
        ],
        "rows": [
          [
            "Udyam",
            "Registration/status support"
          ],
          [
            "Funding",
            "Loan & financial documentation"
          ],
          [
            "Project Reports",
            "Project report & projections"
          ],
          [
            "CMA Data",
            "Preparation support"
          ],
          [
            "Government Schemes",
            "Eligibility assessment"
          ],
          [
            "Compliance",
            "GST, tax & statutory compliance"
          ],
          [
            "Accounting",
            "Bookkeeping & financial reporting"
          ],
          [
            "Growth",
            "Financial & business advisory"
          ]
        ]
      },
      "related": [
        "cmegp-pmegp-assistance",
        "funding-subsidy-advisory",
        "business-structuring-advisory"
      ]
    }
  },
  {
    "slug": "government-scheme-advisory",
    "category": "Other Services",
    "sub_category": null,
    "icon": "Landmark",
    "title": "Government Scheme Advisory Services",
    "subtitle": "Identify suitable government schemes, understand eligibility and prepare your application with the right documentation.",
    "read_time": "7 min read",
    "image": "https://images.unsplash.com/photo-1554224154-26032ffc0d07?crop=entropy&cs=srgb&fm=jpg&q=80&w=1200",
    "intro": "Government schemes differ based on factors such as business activity, enterprise size, location, investment, employment, promoter profile, project cost and funding requirement. Biz360 Compliance helps startups, MSMEs and entrepreneurs assess whether the business appears to meet the relevant eligibility conditions and what documentation may be required — rather than applying for a scheme simply because it is available.",
    "sections": {
      "whoNeedsIt": {
        "heading": "Who Can Benefit?",
        "items": [
          "Entrepreneurs starting a new business",
          "Existing MSMEs",
          "Manufacturing units",
          "Service businesses",
          "Startups",
          "Women entrepreneurs",
          "First-generation entrepreneurs",
          "Businesses planning expansion",
          "Businesses seeking bank finance or government support"
        ]
      },
      "eligibility": {
        "heading": "Important Note",
        "items": [
          "Government scheme advisory does not guarantee sanction, subsidy or financial assistance",
          "Final eligibility, sanction and release of benefits are determined by the concerned government authority, implementing agency or financial institution according to the applicable scheme guidelines"
        ]
      },
      "documents": {
        "heading": "Documents Generally Required",
        "groups": [
          {
            "title": "Depending on the Scheme",
            "items": [
              "PAN & Aadhaar",
              "Business registration documents",
              "Udyam Registration",
              "GST registration, where applicable",
              "Bank details",
              "Promoter details",
              "Project cost information",
              "Machinery/equipment quotations",
              "Business plan",
              "Financial projections",
              "Existing financial statements, where applicable"
            ]
          }
        ]
      },
      "process": {
        "heading": "Our Process",
        "steps": [
          {
            "title": "Understand the Business",
            "desc": "We review your business activity, project, investment and funding requirement."
          },
          {
            "title": "Identify Potential Schemes",
            "desc": "Relevant government schemes are shortlisted based on the available information."
          },
          {
            "title": "Eligibility Review",
            "desc": "Key eligibility conditions and potential restrictions are assessed."
          },
          {
            "title": "Documentation Plan",
            "desc": "We identify the financial and business documents required."
          },
          {
            "title": "Application Support",
            "desc": "Project reports, financial information and other applicable documentation are coordinated."
          },
          {
            "title": "Submission & Follow-Up",
            "desc": "The application process can be supported as per the requirements of the concerned authority or implementing agency."
          }
        ]
      },
      "timeline": {
        "heading": "Timeline",
        "body": "Timelines depend on the nature of the scheme, complexity of the application and the concerned authority's or agency's processing requirements."
      },
      "fees": {
        "heading": "Professional Fees",
        "note": "Fees depend on the nature of the scheme, complexity of application, project size, documentation requirements, project report requirements and follow-up support. Government charges and third-party fees, where applicable, are separate from professional fees."
      },
      "benefits": {
        "heading": "Schemes We Can Help Assess",
        "items": [
          "CMEGP",
          "PMEGP",
          "Startup India-related initiatives",
          "MSME support schemes",
          "Credit and financing schemes",
          "State Government incentives",
          "Industry-specific schemes",
          "Entrepreneurship and employment schemes"
        ]
      },
      "afterService": null,
      "whyUs": {
        "heading": "Why Choose Biz360 Compliance?",
        "items": [
          "Eligibility Before Documentation — we first understand whether the proposed scheme appears relevant before investing effort in the application",
          "Financial & Compliance Understanding — our accounting, taxation and compliance background helps connect the scheme requirement with the business's financial information",
          "Project Documentation Support — where required, project reports, projections and CMA-related information can be coordinated",
          "Practical Approach — we explain the scheme's key conditions and documentation requirements in straightforward business terms"
        ]
      },
      "faqs": [
        {
          "q": "Can Biz360 identify a government scheme for my business?",
          "a": "Yes. We can assess the business profile and identify potentially relevant schemes."
        },
        {
          "q": "Can you guarantee subsidy or loan approval?",
          "a": "No. Approval is subject to the applicable scheme conditions and the decision of the concerned authority or financial institution."
        },
        {
          "q": "Can you prepare the project report?",
          "a": "Yes. Project report preparation can be provided where required."
        },
        {
          "q": "Do you provide CMEGP and PMEGP support?",
          "a": "Yes. These can be handled through the dedicated CMEGP / PMEGP Assistance service."
        },
        {
          "q": "Is Udyam Registration required for every scheme?",
          "a": "Not necessarily. Requirements differ between schemes."
        },
        {
          "q": "Do government schemes change frequently?",
          "a": "Yes. Eligibility, funding limits, procedures and implementing guidelines can change. The applicable conditions should be verified when making an application."
        }
      ],
      "extra": null,
      "related": [
        "funding-subsidy-advisory",
        "business-structuring-advisory",
        "process-system-advisory"
      ]
    }
  },
  {
    "slug": "cmegp-pmegp-assistance",
    "category": "Other Services",
    "sub_category": null,
    "icon": "HandCoins",
    "title": "CMEGP / PMEGP Assistance",
    "subtitle": "Project report, financial projections and documentation support for eligible entrepreneurs seeking government-supported business finance.",
    "read_time": "7 min read",
    "image": "https://images.unsplash.com/photo-1560518883-ce09059eeffa?crop=entropy&cs=srgb&fm=jpg&q=80&w=1200",
    "intro": "CMEGP (Chief Minister Employment Generation Programme) is a Maharashtra Government initiative supporting eligible entrepreneurs in establishing new micro and small enterprises through a credit-linked subsidy framework, while PMEGP (Prime Minister's Employment Generation Programme) is a Central Government credit-linked subsidy scheme implemented through designated agencies for eligible new micro-enterprises. Biz360 Compliance helps entrepreneurs with scheme eligibility assessment, project reports, financial projections, loan documentation and application support for both schemes.",
    "sections": {
      "whoNeedsIt": {
        "heading": "Who Can Consider CMEGP / PMEGP?",
        "items": [
          "First-time entrepreneurs",
          "Individuals starting a new business",
          "Manufacturing units",
          "Service businesses",
          "Eligible rural/urban enterprises",
          "Other eligible applicants under the respective scheme"
        ]
      },
      "eligibility": {
        "heading": "Who Can Consider CMEGP / PMEGP?",
        "items": [
          "The schemes are intended for eligible entrepreneurs establishing qualifying micro-enterprises, subject to applicable scheme conditions",
          "Existing business status, project type, promoter category and other conditions can affect eligibility",
          "Eligibility and scheme conditions should always be checked against the applicable guidelines at the time of application"
        ]
      },
      "documents": {
        "heading": "Documents Generally Required",
        "groups": [
          {
            "title": "Depending on the Scheme and Applicant",
            "items": [
              "Aadhaar",
              "PAN",
              "Address proof",
              "Educational/technical qualification documents, where applicable",
              "Photograph",
              "Business/project details",
              "Machinery quotations",
              "Other supplier quotations",
              "Bank details",
              "Udyam Registration, where applicable/required",
              "Project cost information"
            ]
          }
        ]
      },
      "process": {
        "heading": "Our Process",
        "steps": [
          {
            "title": "Project Discussion",
            "desc": "We understand the proposed business and investment."
          },
          {
            "title": "Eligibility Review",
            "desc": "Basic CMEGP/PMEGP eligibility conditions are assessed."
          },
          {
            "title": "Project Costing",
            "desc": "Machinery, equipment, working capital and other project costs are structured."
          },
          {
            "title": "Project Report",
            "desc": "A bank-oriented project report and financial projections are prepared."
          },
          {
            "title": "Documentation",
            "desc": "Required KYC, quotations and supporting documents are organised."
          },
          {
            "title": "Application Support",
            "desc": "The application process is supported as per the applicable scheme and implementing authority requirements."
          }
        ]
      },
      "timeline": {
        "heading": "Timeline",
        "body": "Timelines depend on project complexity, documentation readiness and the appraisal process of the implementing agency and bank; CMEGP/PMEGP assistance is not an automatic loan or subsidy approval."
      },
      "fees": {
        "heading": "Professional Fees",
        "note": "Fees depend on project cost, nature of business, complexity of project report, financial projection requirements, and documentation and application support required. Government/bank charges, where applicable, are separate from professional fees."
      },
      "benefits": {
        "heading": "Typical Project Report Structure",
        "items": [
          "Business Profile",
          "Promoter Details",
          "Business Activity",
          "Project Cost",
          "Means of Finance",
          "Machinery & Working Capital",
          "Sales & Expense Projections",
          "Profitability",
          "Employment Generation",
          "Repayment / Financial Analysis"
        ]
      },
      "afterService": null,
      "whyUs": {
        "heading": "Why Choose Biz360 Compliance?",
        "items": [
          "Project Report + Financial Understanding — we combine accounting and financial knowledge with project documentation",
          "Practical Project Costing — machinery, working capital, sales and expenses are structured to reflect the proposed business",
          "MSME-Focused Support — our services are designed for entrepreneurs and small businesses",
          "End-to-End Documentation Support — from initial eligibility review to project documentation and application support"
        ]
      },
      "faqs": [
        {
          "q": "What is CMEGP?",
          "a": "CMEGP is a Maharashtra Government employment-generation scheme providing eligible entrepreneurs access to credit-linked subsidy support for qualifying new enterprises."
        },
        {
          "q": "What is PMEGP?",
          "a": "PMEGP is a Central Government credit-linked subsidy programme for eligible new micro-enterprises."
        },
        {
          "q": "Can Biz360 guarantee loan approval?",
          "a": "No. Loan sanction depends on the applicable scheme conditions and the appraisal/decision of the concerned authority and bank."
        },
        {
          "q": "Do you prepare CMEGP/PMEGP project reports?",
          "a": "Yes. Project reports and financial projections can be prepared based on the proposed business and project cost."
        },
        {
          "q": "Can you prepare CMA data?",
          "a": "Where required, CMA data and related financial information can be prepared as part of the funding documentation."
        },
        {
          "q": "Does subsidy mean the entire loan is waived?",
          "a": "No. A credit-linked subsidy is subject to the applicable scheme conditions and is not equivalent to complete loan waiver."
        }
      ],
      "extra": null,
      "related": [
        "business-structuring-advisory",
        "process-system-advisory",
        "audit-support-services"
      ]
    }
  },
  {
    "slug": "funding-subsidy-advisory",
    "category": "Other Services",
    "sub_category": null,
    "icon": "Coins",
    "title": "Funding & Subsidy Advisory",
    "subtitle": "Understand your funding options, prepare the financial information and identify suitable subsidy-linked opportunities.",
    "read_time": "7 min read",
    "image": "https://images.unsplash.com/photo-1554224155-8d04cb21cd6c?crop=entropy&cs=srgb&fm=jpg&q=80&w=1200",
    "intro": "Choosing business finance is not only about obtaining a loan — the funding structure should broadly match the purpose, project cost, repayment capacity and cash-flow position of the business. Biz360 Compliance helps MSMEs and entrepreneurs with funding assessment, project documentation, financial projections, loan documentation and subsidy-related advisory support, preparing the financial information needed for discussions with banks, financial institutions or applicable government schemes.",
    "sections": {
      "whoNeedsIt": {
        "heading": "Who Can Use This Service?",
        "items": [
          "Startups",
          "Micro and small businesses",
          "Established MSMEs",
          "Manufacturing units",
          "Service businesses",
          "Traders",
          "Businesses planning expansion",
          "Entrepreneurs setting up a new project"
        ]
      },
      "eligibility": {
        "heading": "Important Disclaimer",
        "items": [
          "Funding or subsidy approval is not guaranteed",
          "Final sanction, loan terms, subsidy eligibility and disbursement are determined by the concerned bank, financial institution, government department or implementing agency, based on applicable policies and scheme conditions"
        ]
      },
      "documents": {
        "heading": "Loan Documentation Support",
        "groups": [
          {
            "title": "Documents We Help Organise",
            "items": [
              "KYC documents",
              "Financial statements",
              "GST information",
              "Income Tax records",
              "Bank statements",
              "Quotations",
              "Project information"
            ]
          }
        ]
      },
      "process": {
        "heading": "Our Process",
        "steps": [
          {
            "title": "Understand the Requirement",
            "desc": "We understand why funding is required and how much capital the business may need."
          },
          {
            "title": "Financial Assessment",
            "desc": "Available financial statements, turnover, profitability and cash flows are reviewed."
          },
          {
            "title": "Funding Structure",
            "desc": "The proposed requirement is broadly structured between promoter contribution, term finance and working capital, as appropriate."
          },
          {
            "title": "Prepare Financial Documents",
            "desc": "Project reports, projections, CMA data and supporting schedules are prepared where required."
          },
          {
            "title": "Scheme / Subsidy Review",
            "desc": "Potentially relevant government schemes or subsidy mechanisms are identified."
          },
          {
            "title": "Application Support",
            "desc": "Documentation can be coordinated with the concerned bank, financial institution or implementing authority."
          }
        ]
      },
      "timeline": {
        "heading": "Timeline",
        "body": "Timelines depend on funding requirement, project size and financial documentation involved; final sanction timing rests with the concerned bank or agency's appraisal process."
      },
      "fees": {
        "heading": "Professional Fees",
        "note": "Fees depend on funding requirement, project size, financial documentation required, CMA/project report requirements, complexity of the proposal, subsidy/scheme assessment and application support. Bank charges, government fees and other third-party charges, where applicable, are separate."
      },
      "benefits": {
        "heading": "Funding Requirements We Can Support",
        "items": [
          "Business Term Loans",
          "Working Capital Finance",
          "Machinery / Equipment Finance",
          "Business Expansion Finance",
          "Project Finance",
          "Government-Supported Schemes",
          "Subsidy-Linked Finance"
        ]
      },
      "afterService": null,
      "whyUs": {
        "heading": "Why Choose Biz360 Compliance?",
        "items": [
          "Finance + Accounting Understanding — we can connect funding documentation with your actual accounting and financial records",
          "MSME-Focused — our approach is designed for entrepreneurs and growing businesses that may not have an in-house finance team",
          "Project-Based Approach — financial projections are prepared around the actual proposed business or expansion plan",
          "Integrated Support — funding requirements can be connected with project reports, accounting, taxation and government scheme advisory"
        ]
      },
      "faqs": [
        {
          "q": "Can you guarantee a business loan?",
          "a": "No. Loan sanction is solely subject to the lender's appraisal and applicable eligibility criteria."
        },
        {
          "q": "Can you prepare a project report?",
          "a": "Yes. Project reports and financial projections can be prepared based on the proposed business or expansion plan."
        },
        {
          "q": "Do you prepare CMA data?",
          "a": "Yes, where required for the funding proposal."
        },
        {
          "q": "Can you help with working capital requirements?",
          "a": "Yes. Working capital requirements can be assessed based on the business cycle and available financial information."
        },
        {
          "q": "Can you identify subsidy schemes?",
          "a": "We can assess potentially relevant government schemes based on the business and project. Each scheme has separate eligibility and approval conditions."
        },
        {
          "q": "Can you coordinate with the bank?",
          "a": "Yes. Documentation and financial information can be coordinated with the concerned lender within the agreed scope."
        }
      ],
      "extra": null,
      "related": [
        "process-system-advisory",
        "audit-support-services",
        "internal-audit-support"
      ]
    }
  },
  {
    "slug": "business-structuring-advisory",
    "category": "Other Services",
    "sub_category": null,
    "icon": "Network",
    "title": "Business Structuring Advisory",
    "subtitle": "Choose the right business structure before you commit to registration, investment or expansion.",
    "read_time": "6 min read",
    "image": "https://images.unsplash.com/photo-1521791136064-7986c2920216?crop=entropy&cs=srgb&fm=jpg&q=80&w=1200",
    "intro": "The choice between a Proprietorship, Partnership, LLP, OPC or Company can affect taxation, compliance, ownership, liability, funding and future growth. Biz360 Compliance helps entrepreneurs and existing businesses evaluate business structure, ownership, taxation, compliance and operational considerations before implementing a restructuring decision, based on the business's actual requirements.",
    "sections": {
      "whoNeedsIt": {
        "heading": "Who Should Consider This Service?",
        "items": [
          "New entrepreneurs",
          "Startups",
          "Family businesses",
          "Professionals starting a practice/business",
          "Existing proprietorships",
          "Partnership firms considering restructuring",
          "Businesses planning external investment",
          "Businesses preparing for expansion"
        ]
      },
      "eligibility": {
        "heading": "When Restructuring May Be Needed",
        "items": [
          "New partners or investors join",
          "Ownership changes",
          "Business expands",
          "A partnership is converted into another structure",
          "Separate business activities are created",
          "Funding is planned"
        ]
      },
      "documents": {
        "heading": "Common Business Structures",
        "groups": [
          {
            "title": "Structures Compared",
            "items": [
              "Proprietorship — individual-owned small businesses",
              "Partnership — businesses with two or more partners",
              "LLP — partnership-style businesses seeking limited liability",
              "OPC — single-owner business seeking corporate structure",
              "Private Limited Company — growing businesses and investment-oriented ventures",
              "Section 8 Company — eligible non-profit objectives"
            ]
          }
        ]
      },
      "process": {
        "heading": "Our Advisory Process",
        "steps": [
          {
            "title": "Understand the Business",
            "desc": "We understand the activity, ownership, investment and future plans."
          },
          {
            "title": "Identify Options",
            "desc": "Potential business structures are shortlisted."
          },
          {
            "title": "Compare Key Factors",
            "desc": "The options are compared from the perspective of ownership, liability, taxation, compliance, funding and growth."
          },
          {
            "title": "Recommend a Practical Structure",
            "desc": "We explain the relative advantages, limitations and implications."
          },
          {
            "title": "Implementation Support",
            "desc": "If required, Biz360 can coordinate the relevant registration, tax, accounting and compliance services."
          }
        ]
      },
      "timeline": {
        "heading": "Timeline",
        "body": "Timeline depends on the complexity of the proposed structure and the extent of restructuring involved; a customised proposal follows once requirements are understood."
      },
      "fees": {
        "heading": "Professional Fees",
        "note": "Fees depend on the complexity of the proposed structure, number of owners/partners, existing business structure, restructuring requirements and documentation involved. Registration, government fees and implementation services are quoted separately where applicable."
      },
      "benefits": {
        "heading": "Our Business Structuring Services",
        "items": [
          "New Business Structure Advisory — comparison of suitable structures based on ownership, investment, activity, liability, funding plans, compliance and expansion",
          "Existing Business Restructuring — partnership reconstitution, LLP restructuring, business conversion, ownership changes, new investor entry, expansion",
          "Tax & Compliance Considerations — highlighting potential tax and compliance implications",
          "Growth & Funding Considerations — evaluated from the perspective of bank finance, external investment, profit distribution, expansion and continuity"
        ]
      },
      "afterService": null,
      "whyUs": {
        "heading": "Why Choose Biz360 Compliance?",
        "items": [
          "Not Just Registration — we look at what happens after registration, including taxation, accounting and recurring compliance",
          "Integrated View — business structure can be evaluated together with GST, Income Tax, accounting and compliance considerations",
          "Growth-Oriented — the objective is to choose a structure that fits both the present business and its foreseeable growth plans",
          "Practical Advice — we explain the options in business terms rather than only quoting legal provisions"
        ]
      },
      "faqs": [
        {
          "q": "Which structure is best for a new business?",
          "a": "There is no universal answer. The choice depends on ownership, liability, taxation, funding, compliance and future plans."
        },
        {
          "q": "Should I choose LLP or Private Limited Company?",
          "a": "The answer depends on factors such as ownership model, funding plans, compliance expectations and future growth."
        },
        {
          "q": "Can you compare different business structures?",
          "a": "Yes. We can provide a practical comparison based on your business requirements."
        },
        {
          "q": "Can an existing business be restructured?",
          "a": "Yes. Available restructuring options depend on the existing structure and proposed changes."
        },
        {
          "q": "Does business structure affect taxation?",
          "a": "Yes. Different structures may have different tax treatment and compliance requirements."
        },
        {
          "q": "Can you help after deciding the structure?",
          "a": "Yes. Registration/incorporation, GST, accounting and ongoing compliance can be coordinated as required."
        }
      ],
      "extra": {
        "kind": "table",
        "columns": [
          "Structure",
          "Generally Suitable For"
        ],
        "rows": [
          [
            "Proprietorship",
            "Individual-owned small businesses"
          ],
          [
            "Partnership",
            "Businesses with two or more partners"
          ],
          [
            "LLP",
            "Partnership-style businesses seeking limited liability"
          ],
          [
            "OPC",
            "Single-owner business seeking corporate structure"
          ],
          [
            "Private Limited Company",
            "Growing businesses and investment-oriented ventures"
          ],
          [
            "Section 8 Company",
            "Eligible non-profit objectives"
          ]
        ]
      },
      "related": [
        "audit-support-services",
        "internal-audit-support",
        "internal-controls-process-review"
      ]
    }
  },
  {
    "slug": "process-system-advisory",
    "category": "Other Services",
    "sub_category": null,
    "icon": "Settings",
    "title": "Process & System Advisory",
    "subtitle": "Improve workflows, strengthen controls and make your accounting and business systems work better.",
    "read_time": "6 min read",
    "image": "https://images.unsplash.com/photo-1518186285589-2f7649de83e0?crop=entropy&cs=srgb&fm=jpg&q=80&w=1200",
    "intro": "As a business grows, processes that worked initially can become inefficient — repeated manual work, delayed monthly closing, frequent reconciliation differences, lack of approval controls, duplicate data entry, poor MIS visibility and unclear responsibilities are common signs. Biz360 Compliance helps businesses review their accounting processes, workflows, controls, reporting systems and software usage, and identify practical, structured improvements.",
    "sections": {
      "whoNeedsIt": {
        "heading": "Who Can Benefit?",
        "items": [
          "Growing MSMEs",
          "Startups",
          "Family-owned businesses",
          "Businesses shifting from manual accounting",
          "Businesses implementing Tally/ERP",
          "Multi-location businesses",
          "Businesses experiencing rapid growth"
        ]
      },
      "eligibility": {
        "heading": "Common Signs Processes Need Improvement",
        "items": [
          "Repeated manual work",
          "Delayed monthly closing",
          "Frequent reconciliation differences",
          "Lack of approval controls",
          "Duplicate data entry",
          "Poor MIS visibility",
          "Unclear responsibilities",
          "Tally/ERP reports not being effectively used"
        ]
      },
      "documents": {
        "heading": "Our Process & System Services",
        "groups": [
          {
            "title": "Accounting Process Review",
            "items": [
              "Sales",
              "Purchases",
              "Expenses",
              "Banking",
              "Inventory",
              "Receivables",
              "Payables",
              "Month-end closing"
            ]
          },
          {
            "title": "Tally / ERP Process Support",
            "items": [
              "Accounting workflow",
              "Ledger structure",
              "Reporting requirements",
              "User roles and controls",
              "Data flow",
              "Management reports"
            ]
          },
          {
            "title": "MIS & Reporting Systems",
            "items": [
              "Sales MIS",
              "Receivables MIS",
              "Payables MIS",
              "Cash-flow reporting",
              "Profitability reporting"
            ]
          }
        ]
      },
      "process": {
        "heading": "Our Approach",
        "steps": [
          {
            "title": "Understand the Existing Process",
            "desc": "We understand how the business currently records, approves and reports transactions."
          },
          {
            "title": "Identify Gaps",
            "desc": "Process bottlenecks, control weaknesses and reporting gaps are identified."
          },
          {
            "title": "Recommend Improvements",
            "desc": "Practical changes are suggested based on the size and requirements of the business."
          },
          {
            "title": "Implement Where Agreed",
            "desc": "Process formats, checklists, reporting structures or system configurations can be supported within the agreed scope."
          },
          {
            "title": "Review the Result",
            "desc": "The revised process can be reviewed to identify further improvements."
          }
        ]
      },
      "timeline": {
        "heading": "Timeline",
        "body": "Timeline depends on the number of processes reviewed, business size and implementation requirements; a customised proposal follows once the existing process is understood."
      },
      "fees": {
        "heading": "Professional Fees",
        "note": "Fees depend on the number of processes reviewed, business size, software/system used, number of locations, implementation requirements and MIS/reporting requirements. A customised proposal can be provided after understanding the existing process."
      },
      "benefits": {
        "heading": "Key Benefits",
        "items": [
          "Better Workflow — clearer processes and responsibilities",
          "Fewer Errors — improved checks and reduced duplicate data entry",
          "Faster Reporting — better accounting processes can support quicker month-end closing and MIS reporting",
          "Improved Controls — approval and reconciliation mechanisms can be strengthened",
          "Better Management Visibility — relevant information can be made available through structured MIS"
        ]
      },
      "afterService": null,
      "whyUs": {
        "heading": "Why Choose Biz360 Compliance?",
        "items": [
          "Finance-Focused — our approach connects accounting processes with financial reporting and compliance requirements",
          "Practical for MSMEs — we focus on controls and systems that are proportionate to the size of the business",
          "Technology + Accounting Understanding — system improvements are considered from both the software and accounting perspective",
          "Integrated Approach — process advisory can be connected with accounting, MIS, internal controls and Virtual CFO services"
        ]
      },
      "faqs": [
        {
          "q": "Do you provide Tally implementation?",
          "a": "Support can be provided for accounting workflow, configuration requirements and reporting, depending on the engagement. Software implementation requiring specialised technical development may require the relevant technology partner."
        },
        {
          "q": "Can you review our existing accounting process?",
          "a": "Yes. The existing workflow can be reviewed to identify gaps and improvement opportunities."
        },
        {
          "q": "Can you help improve our MIS?",
          "a": "Yes. Management reporting requirements can be mapped and practical MIS formats can be developed."
        },
        {
          "q": "Can you help businesses moving from manual accounting to software?",
          "a": "Yes. Accounting processes and data requirements can be reviewed as part of the transition."
        },
        {
          "q": "Can you review internal controls along with the process?",
          "a": "Yes. Process review can be integrated with an Internal Controls & Process Review engagement."
        },
        {
          "q": "Is this service suitable for small businesses?",
          "a": "Yes. The approach can be scaled according to the business's size and requirements."
        }
      ],
      "extra": null,
      "related": [
        "internal-audit-support",
        "internal-controls-process-review",
        "certification-documentation-support"
      ]
    }
  }
];

export const STATIC_BLOGS = [
  {
    "id": "private-limited-company",
    "slug": "private-limited-company",
    "category": "Company Registration",
    "title": "Private Limited Company Registration in India",
    "subtitle": "Register Your Private Limited Company with Confidence",
    "read_time": "9 min read",
    "image": "https://images.unsplash.com/photo-1554224154-26032ffc0d07?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
    "intro": "A Private Limited Company is one of the most preferred business structures in India for startups, growing businesses and professionally managed enterprises. Registered under the Companies Act, 2013, it provides a separate legal identity, limited liability protection to shareholders and greater credibility with customers, banks and investors. A Private Limited Company can own assets, enter into contracts, raise funds, hire employees and continue its existence irrespective of changes in ownership — an ideal choice for businesses looking for long-term growth and expansion. At Biz360 Compliance, we simplify the incorporation process by handling documentation, regulatory filings and compliance requirements, allowing you to focus on building your business.",
    "sections": {
      "advantages": {
        "heading": "Why Choose a Private Limited Company?",
        "items": [
          "Separate legal entity recognised by law",
          "Limited liability protection for shareholders",
          "Higher credibility among customers, vendors and financial institutions",
          "Easier access to bank finance and investment",
          "Eligible for startup recognition and government schemes, subject to eligibility",
          "Perpetual succession irrespective of ownership changes",
          "Easier transfer of ownership through share transfers",
          "Preferred structure for venture capital and angel investments"
        ]
      },
      "audience": {
        "heading": "Who Should Register a Private Limited Company?",
        "items": [
          "Startups seeking external funding",
          "Technology and software companies",
          "Manufacturing & trading businesses",
          "Service providers and consultants",
          "E-commerce and export-import businesses",
          "Businesses planning rapid expansion",
          "Family-owned businesses seeking structured governance"
        ]
      },
      "eligibility": {
        "heading": "Eligibility Criteria",
        "items": [
          "Minimum two Directors and two Shareholders",
          "At least one Director must be an Indian resident",
          "Registered office address in India",
          "Valid identity and address proof of Directors and Shareholders",
          "Digital Signature Certificate (DSC) for proposed Directors",
          "Proposed company name complying with applicable naming guidelines"
        ]
      },
      "documents": {
        "heading": "Documents Required",
        "groups": [
          {
            "title": "Directors & Shareholders",
            "items": [
              "PAN Card",
              "Aadhaar Card",
              "Passport-size photograph",
              "Mobile number & email ID",
              "Address proof (bank statement / electricity bill)"
            ]
          },
          {
            "title": "Registered Office (Owned)",
            "items": [
              "Property tax receipt or ownership document",
              "Recent utility bill"
            ]
          },
          {
            "title": "Registered Office (Rented)",
            "items": [
              "Rent / Leave & Licence Agreement",
              "No Objection Certificate (NOC) from owner",
              "Recent utility bill"
            ]
          }
        ]
      },
      "process": {
        "heading": "Registration Process",
        "steps": [
          {
            "title": "Initial Consultation",
            "desc": "Understand your business model and recommend the most suitable structure."
          },
          {
            "title": "Name Selection",
            "desc": "Identify and evaluate proposed company names for compliance and availability."
          },
          {
            "title": "Documentation",
            "desc": "Collect and verify all required documents from Directors and Shareholders."
          },
          {
            "title": "Digital Signature & DIN",
            "desc": "Obtain Digital Signature Certificates and Director Identification Numbers."
          },
          {
            "title": "Incorporation Filing",
            "desc": "Prepare and submit incorporation documents through the MCA portal."
          },
          {
            "title": "Certificate of Incorporation",
            "desc": "The Registrar issues the Certificate of Incorporation with the CIN."
          },
          {
            "title": "PAN, TAN & Other Registrations",
            "desc": "Complete statutory registrations and post-incorporation compliances."
          }
        ]
      },
      "timeline": {
        "heading": "Estimated Timeline",
        "body": "Incorporation is generally completed within 7–15 working days, subject to government approvals, name availability and document readiness."
      },
      "fees": {
        "heading": "Government Fees & Professional Fees",
        "govt": [
          "Authorised Share Capital",
          "State of Registration",
          "Applicable Stamp Duty",
          "MCA filing fees"
        ],
        "prof": [
          "Scope of services",
          "Documentation requirements",
          "Additional registrations required",
          "Post-incorporation compliance support"
        ],
        "note": "Contact Biz360 Compliance for a customised quotation based on your business requirements."
      },
      "compliance": {
        "heading": "Post Incorporation Compliance",
        "items": [
          "Opening a company bank account",
          "Appointment of first auditor (where applicable)",
          "Maintenance of statutory registers",
          "Issue of share certificates",
          "Accounting & bookkeeping",
          "Annual financial statements & ROC filings",
          "Income Tax and TDS compliance",
          "GST registration (where applicable)"
        ]
      },
      "whyUs": {
        "heading": "Why Choose Biz360 Compliance?",
        "items": [
          "Experienced professionals handling every engagement",
          "End-to-end documentation support",
          "Transparent pricing with no hidden charges",
          "Dedicated relationship manager",
          "Regular compliance reminders",
          "Fast turnaround, PAN India service delivery"
        ]
      },
      "faqs": [
        {
          "q": "How many people are required to register a Private Limited Company?",
          "a": "A minimum of two Directors and two Shareholders are generally required."
        },
        {
          "q": "Can one person be both Director and Shareholder?",
          "a": "Yes, subject to the minimum statutory requirements."
        },
        {
          "q": "Is a physical office mandatory?",
          "a": "A registered office address in India is mandatory. It may be owned or rented."
        },
        {
          "q": "Can NRIs or foreign nationals become shareholders?",
          "a": "Yes, subject to applicable laws and regulatory requirements."
        },
        {
          "q": "Is GST registration compulsory after incorporation?",
          "a": "GST registration depends on the nature of business, turnover and applicable legal provisions."
        },
        {
          "q": "Can I convert my LLP into a Private Limited Company?",
          "a": "Yes, subject to applicable legal procedures and eligibility."
        },
        {
          "q": "Is annual compliance mandatory?",
          "a": "Yes. Every Private Limited Company must comply with annual filing and other statutory requirements."
        }
      ],
      "related": [
        "llp",
        "one-person-company",
        "partnership-firm"
      ]
    }
  },
  {
    "id": "llp",
    "slug": "llp",
    "category": "Company Registration",
    "title": "LLP Registration in India",
    "subtitle": "Register Your Limited Liability Partnership (LLP) with Ease",
    "read_time": "8 min read",
    "image": "https://images.unsplash.com/photo-1735825764485-93a381fd5779?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODF8MHwxfHNlYXJjaHwzfHxwcm9mZXNzaW9uYWwlMjBmaW5hbmNlJTIwd29ya3NwYWNlfGVufDB8fHx8MTc4MzE3MDIyNHww&ixlib=rb-4.1.0&q=85",
    "intro": "A Limited Liability Partnership (LLP) combines the operational flexibility of a traditional partnership with the legal protection of a corporate entity. Governed by the Limited Liability Partnership Act, 2008, an LLP is a separate legal entity with perpetual succession, and unlike a traditional partnership, it protects partners' personal assets from business liabilities. It is widely preferred by professionals, consultants, service providers and family businesses due to its simplified management and comparatively lower compliance requirements than a company. Biz360 Compliance assists throughout the LLP registration process, ensuring timely incorporation, accurate documentation and continued compliance support.",
    "sections": {
      "advantages": {
        "heading": "Why Choose an LLP?",
        "items": [
          "Separate legal entity recognised by law",
          "Limited liability protection for partners",
          "Perpetual succession irrespective of partner changes",
          "Flexible internal management through the LLP Agreement",
          "Lower compliance burden than corporate structures",
          "No minimum capital contribution requirement",
          "Easy admission or retirement of partners"
        ]
      },
      "audience": {
        "heading": "Who Should Register an LLP?",
        "items": [
          "Chartered Accountants, Company Secretaries and Consultants",
          "Architects, Engineers and legal professionals",
          "IT / software companies & digital agencies",
          "Family-owned businesses",
          "Startups not immediately seeking equity investment",
          "SMEs and joint ventures between businesses"
        ]
      },
      "eligibility": {
        "heading": "Eligibility Criteria",
        "items": [
          "Minimum two Designated Partners",
          "At least one Designated Partner must be an Indian resident",
          "Valid registered office address in India",
          "Digital Signature Certificate for Designated Partners",
          "Proposed LLP name complying with naming guidelines",
          "No prescribed minimum capital contribution"
        ]
      },
      "documents": {
        "heading": "Documents Required",
        "groups": [
          {
            "title": "Indian Partners",
            "items": [
              "PAN Card",
              "Aadhaar Card",
              "Passport-size photograph",
              "Mobile number & email address",
              "Address proof"
            ]
          },
          {
            "title": "Registered Office (Owned)",
            "items": [
              "Ownership proof",
              "Latest utility bill"
            ]
          },
          {
            "title": "Registered Office (Rented)",
            "items": [
              "Rent / Leave & Licence Agreement",
              "NOC from owner",
              "Latest utility bill"
            ]
          }
        ]
      },
      "process": {
        "heading": "LLP Registration Process",
        "steps": [
          {
            "title": "Business Consultation",
            "desc": "Confirm whether an LLP is the appropriate structure for your objectives."
          },
          {
            "title": "Name Reservation",
            "desc": "Identify suitable names and apply for reservation through the MCA portal."
          },
          {
            "title": "Document Collection",
            "desc": "Collect and verify documents of all Designated Partners and the registered office."
          },
          {
            "title": "Digital Signature & Partner ID",
            "desc": "Obtain Digital Signature Certificates and Partner Identification."
          },
          {
            "title": "Incorporation Filing",
            "desc": "Prepare and submit incorporation documents with the Registrar."
          },
          {
            "title": "Certificate of Incorporation",
            "desc": "The Registrar issues the Certificate along with the LLPIN."
          },
          {
            "title": "LLP Agreement",
            "desc": "Draft and file the LLP Agreement within the prescribed timeline."
          },
          {
            "title": "Post Registration Support",
            "desc": "PAN, TAN, GST (if applicable), bank account and other registrations."
          }
        ]
      },
      "timeline": {
        "heading": "Estimated Timeline",
        "body": "LLP registration is generally completed within 7–12 working days, subject to government processing and document verification."
      },
      "fees": {
        "heading": "Government Fees & Professional Fees",
        "govt": [
          "Capital contribution (for filing purposes)",
          "Applicable MCA filing fees",
          "State-wise stamp duty on the LLP Agreement"
        ],
        "prof": [
          "Number of Partners",
          "Scope of work",
          "Drafting of LLP Agreement",
          "Post-registration compliance assistance"
        ],
        "note": "Contact Biz360 Compliance for a customised quotation based on your business requirements."
      },
      "compliance": {
        "heading": "Post Registration Compliance",
        "items": [
          "Execution and filing of the LLP Agreement",
          "PAN and TAN",
          "GST registration (where applicable)",
          "Accounting and bookkeeping",
          "Statement of Account & Solvency",
          "Annual Return filing",
          "TDS compliance (where applicable)"
        ]
      },
      "whyUs": {
        "heading": "Why Choose Biz360 Compliance?",
        "items": [
          "Experienced professionals handling every engagement",
          "Complete documentation assistance",
          "Transparent pricing",
          "Dedicated relationship manager",
          "Fast processing with regular updates",
          "Single platform for taxation, accounting and regulatory services"
        ]
      },
      "faqs": [
        {
          "q": "What is the minimum number of partners required for an LLP?",
          "a": "A minimum of two Designated Partners is required."
        },
        {
          "q": "Is there any minimum capital requirement?",
          "a": "No. There is presently no mandatory minimum capital contribution for LLP registration."
        },
        {
          "q": "Is an LLP different from a Partnership Firm?",
          "a": "Yes. An LLP has a separate legal identity and provides limited liability protection, whereas a traditional partnership firm does not."
        },
        {
          "q": "Can an LLP have foreign partners?",
          "a": "Yes, subject to applicable laws and regulatory approvals."
        },
        {
          "q": "Can an LLP be converted into a Company?",
          "a": "Yes, subject to applicable legal procedures and eligibility."
        },
        {
          "q": "Is annual filing compulsory?",
          "a": "Yes. Every LLP must comply with prescribed annual filing requirements, irrespective of turnover."
        }
      ],
      "related": [
        "private-limited-company",
        "one-person-company",
        "partnership-firm"
      ]
    }
  },
  {
    "id": "one-person-company",
    "slug": "one-person-company",
    "category": "Company Registration",
    "title": "One Person Company (OPC) Registration in India",
    "subtitle": "Start Your Business with the Advantage of a One Person Company",
    "read_time": "7 min read",
    "image": "https://images.unsplash.com/photo-1554224155-6726b3ff858f?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
    "intro": "A One Person Company (OPC) is a unique form of company introduced under the Companies Act, 2013, enabling a single entrepreneur to establish a corporate entity with limited liability and a separate legal identity. An OPC bridges the gap between a sole proprietorship and a private limited company by allowing one individual to own and manage the company while enjoying the legal and financial benefits of a registered corporate structure — ideal for professionals, consultants, freelancers and first-time entrepreneurs who wish to operate independently while enhancing business credibility.",
    "sections": {
      "advantages": {
        "heading": "Why Choose an OPC?",
        "items": [
          "Separate legal identity and limited liability protection",
          "Single ownership and complete control",
          "Enhanced business credibility",
          "Better access to banking and financial services",
          "Perpetual succession through nomination provisions",
          "Opportunity to convert into a Private Limited Company as the business expands"
        ]
      },
      "audience": {
        "heading": "Who Should Register an OPC?",
        "items": [
          "Individual entrepreneurs and freelancers",
          "Consultants and IT professionals",
          "Designers and creative agencies",
          "Online businesses and e-commerce sellers",
          "Small manufacturers",
          "Professionals starting an independent practice"
        ]
      },
      "eligibility": {
        "heading": "Eligibility Criteria",
        "items": [
          "Only one individual (a natural person) can incorporate an OPC",
          "A nominee must be appointed at the time of incorporation",
          "Registered office address in India required",
          "Digital Signature Certificate (DSC) required",
          "Proposed company name must comply with MCA naming guidelines"
        ]
      },
      "documents": {
        "heading": "Documents Required",
        "groups": [
          {
            "title": "Promoter",
            "items": [
              "PAN Card",
              "Aadhaar Card",
              "Passport-size photograph",
              "Mobile number & email address",
              "Address proof"
            ]
          },
          {
            "title": "Registered Office",
            "items": [
              "Ownership proof or rent agreement",
              "NOC (if rented)",
              "Latest utility bill"
            ]
          },
          {
            "title": "Other",
            "items": [
              "Consent of nominee",
              "Declaration and incorporation documents"
            ]
          }
        ]
      },
      "process": {
        "heading": "Registration Process",
        "steps": [
          {
            "title": "Initial Consultation",
            "desc": "Confirm whether an OPC is the most suitable structure for your business."
          },
          {
            "title": "Name Selection",
            "desc": "Select and reserve a unique company name through the MCA portal."
          },
          {
            "title": "Documentation",
            "desc": "Collect and verify documents from the promoter and nominee."
          },
          {
            "title": "Digital Signature & DIN",
            "desc": "Obtain the required DSC and Director Identification Number."
          },
          {
            "title": "Incorporation Filing",
            "desc": "Submit the incorporation application with the Registrar of Companies."
          },
          {
            "title": "Certificate of Incorporation",
            "desc": "The Registrar issues the Certificate along with the CIN."
          },
          {
            "title": "Post Registration Assistance",
            "desc": "PAN, TAN, bank account and GST registration (where applicable)."
          }
        ]
      },
      "timeline": {
        "heading": "Estimated Timeline",
        "body": "An OPC can generally be incorporated within 7–15 working days, subject to MCA processing timelines."
      },
      "fees": {
        "heading": "Government Fees & Professional Fees",
        "govt": [
          "Authorised Share Capital",
          "Applicable MCA filing fees",
          "State-wise stamp duty"
        ],
        "prof": [
          "Scope of services",
          "Documentation requirements",
          "Post-registration compliance support"
        ],
        "note": "Contact Biz360 Compliance for a customised quotation based on your business requirements."
      },
      "compliance": {
        "heading": "Post Registration Compliance",
        "items": [
          "Opening a company bank account",
          "Accounting & bookkeeping, statutory records",
          "Annual financial statements & ROC filings",
          "Income Tax Return filing",
          "GST & TDS compliance (where applicable)"
        ]
      },
      "whyUs": {
        "heading": "Why Choose Biz360 Compliance?",
        "items": [
          "Experienced professionals and end-to-end incorporation support",
          "Transparent pricing and dedicated relationship manager",
          "Secure document management, fast turnaround",
          "Single platform for registration, taxation, accounting and support"
        ]
      },
      "faqs": [
        {
          "q": "Who can register an OPC?",
          "a": "A single eligible individual can incorporate an OPC, subject to applicable legal requirements."
        },
        {
          "q": "Is a nominee mandatory?",
          "a": "Yes. Appointment of a nominee is generally required during incorporation."
        },
        {
          "q": "Can an OPC have more than one shareholder?",
          "a": "No. An OPC is designed for a single member."
        },
        {
          "q": "Can an OPC hire employees?",
          "a": "Yes. An OPC can appoint employees and operate like any other company."
        },
        {
          "q": "Can an OPC be converted into a Private Limited Company?",
          "a": "Yes, in accordance with the applicable legal framework and business requirements."
        },
        {
          "q": "Does an OPC require annual compliance?",
          "a": "Yes. Annual statutory compliances apply even with limited business activity."
        }
      ],
      "related": [
        "private-limited-company",
        "llp",
        "sole-proprietorship"
      ]
    }
  },
  {
    "id": "partnership-firm",
    "slug": "partnership-firm",
    "category": "Traditional Structures",
    "title": "Partnership Firm Registration in India",
    "subtitle": "Register Your Partnership Firm with Confidence",
    "read_time": "7 min read",
    "image": "https://images.unsplash.com/photo-1450101499163-c8848c66ca85?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
    "intro": "A Partnership Firm is one of the most widely adopted business structures in India for small and medium-sized businesses operated by two or more individuals. Governed by the Indian Partnership Act, 1932, it enables partners to jointly own, manage and operate a business while sharing profits and responsibilities on mutually agreed terms. While registration is generally optional, it provides significant legal advantages when enforcing contractual rights or resolving disputes. Biz360 Compliance assists with drafting the Partnership Deed, obtaining registration and securing PAN, GST, Shop & Establishment and Udyam registrations.",
    "sections": {
      "advantages": {
        "heading": "Why Choose a Partnership Firm?",
        "items": [
          "Simple and economical to establish",
          "Easy decision-making and management",
          "Flexible profit-sharing arrangements",
          "Minimal incorporation formalities",
          "Lower compliance requirements compared to companies",
          "Easy admission and retirement of partners",
          "Option to convert into an LLP or Company later"
        ]
      },
      "audience": {
        "heading": "Who Should Register a Partnership Firm?",
        "items": [
          "Family businesses",
          "Retail & wholesale traders, manufacturers",
          "Consultants and contractors",
          "Restaurants, cafés and educational institutions",
          "Local trading businesses, agencies and distributors"
        ]
      },
      "eligibility": {
        "heading": "Eligibility Criteria",
        "items": [
          "Minimum two partners, legally competent to contract",
          "A mutually agreed Partnership Deed",
          "Registered office or business address",
          "No prescribed minimum capital requirement"
        ]
      },
      "documents": {
        "heading": "Documents Required",
        "groups": [
          {
            "title": "Partners",
            "items": [
              "PAN Card",
              "Aadhaar Card",
              "Passport-size photograph",
              "Mobile number & email address",
              "Address proof"
            ]
          },
          {
            "title": "Business Address",
            "items": [
              "Ownership proof or rent agreement + NOC",
              "Latest utility bill"
            ]
          },
          {
            "title": "Additional",
            "items": [
              "Partnership Deed",
              "Affidavits or declarations, wherever required"
            ]
          }
        ]
      },
      "process": {
        "heading": "Registration Process",
        "steps": [
          {
            "title": "Business Consultation",
            "desc": "Confirm whether a Partnership Firm is the most suitable structure."
          },
          {
            "title": "Drafting the Partnership Deed",
            "desc": "Business objectives, capital contribution, profit-sharing, rights and dissolution provisions."
          },
          {
            "title": "Execution of the Deed",
            "desc": "The deed is executed on appropriate stamp paper as per the State Stamp Act."
          },
          {
            "title": "Firm Registration",
            "desc": "Submit the registration application before the Registrar of Firms."
          },
          {
            "title": "Certificate of Registration",
            "desc": "The Registrar issues the Certificate of Registration, where applicable."
          },
          {
            "title": "Post Registration Assistance",
            "desc": "PAN, GST, Shop & Establishment, Udyam and bank account opening."
          }
        ]
      },
      "timeline": {
        "heading": "Estimated Timeline",
        "body": "Partnership Firm registration is generally completed within 5–15 working days, subject to state processing."
      },
      "fees": {
        "heading": "Government Fees & Professional Fees",
        "govt": [
          "State-specific registration charges",
          "Stamp Duty on the Partnership Deed",
          "Registrar of Firms filing fees"
        ],
        "prof": [
          "Number of partners",
          "Nature of Partnership Deed",
          "Additional registrations required"
        ],
        "note": "Contact Biz360 Compliance for a customised quotation based on your business requirements."
      },
      "compliance": {
        "heading": "Recommended Ongoing Compliance",
        "items": [
          "Income Tax Return filing",
          "GST registration & returns (where applicable)",
          "TDS and Professional Tax compliance",
          "Accounting & bookkeeping",
          "Business licence renewals"
        ]
      },
      "whyUs": {
        "heading": "Why Choose Biz360 Compliance?",
        "items": [
          "Professionally drafted Partnership Deed",
          "State-specific registration expertise",
          "Transparent pricing and dedicated relationship manager",
          "Ongoing accounting, taxation and compliance services"
        ]
      },
      "faqs": [
        {
          "q": "Is Partnership Firm registration mandatory?",
          "a": "Registration is generally optional, but it provides important legal advantages, particularly in enforcing contractual rights and resolving disputes."
        },
        {
          "q": "How many partners are required?",
          "a": "A minimum of two partners is required."
        },
        {
          "q": "Is a written Partnership Deed compulsory?",
          "a": "It's strongly recommended — it records rights and obligations and is generally required for registrations, banking and taxation."
        },
        {
          "q": "Can a Partnership Firm obtain GST Registration?",
          "a": "Yes, subject to the applicable provisions of GST law."
        },
        {
          "q": "Can a Partnership Firm be converted into an LLP?",
          "a": "Yes, subject to applicable legal procedures and eligibility conditions."
        }
      ],
      "related": [
        "sole-proprietorship",
        "llp",
        "private-limited-company"
      ]
    }
  },
  {
    "id": "sole-proprietorship",
    "slug": "sole-proprietorship",
    "category": "Traditional Structures",
    "title": "Sole Proprietorship Registration & Business Setup",
    "subtitle": "Start Your Business Quickly with a Sole Proprietorship",
    "read_time": "7 min read",
    "image": "https://images.unsplash.com/photo-1554224154-26032ffc0d07?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
    "intro": "A Sole Proprietorship is the simplest and most commonly adopted form of business in India, owned and managed by a single individual. It's particularly suitable for entrepreneurs who want to start a business with minimal regulatory formalities and complete operational control. Unlike companies and LLPs, a proprietorship has no separate legal identity from its owner — the proprietor is solely responsible for all business decisions, profits, liabilities and statutory compliances. Biz360 Compliance assists entrepreneurs in obtaining all necessary registrations to establish and operate a Proprietorship legally.",
    "sections": {
      "advantages": {
        "heading": "Why Choose a Proprietorship?",
        "items": [
          "Simple and quick to establish",
          "Single ownership and complete control",
          "Minimal legal formalities and lower compliance",
          "Cost-effective business structure",
          "Quick decision-making",
          "Easy business closure compared to corporate entities"
        ]
      },
      "audience": {
        "heading": "Who Should Register a Proprietorship?",
        "items": [
          "First-time entrepreneurs and retail shops",
          "Traders and small manufacturers",
          "Freelancers, consultants and digital service providers",
          "E-commerce sellers and home-based businesses",
          "Local service providers and commission agents"
        ]
      },
      "eligibility": {
        "heading": "Registrations Typically Required",
        "items": [
          "GST Registration",
          "Udyam (MSME) Registration",
          "Shop & Establishment Registration",
          "Professional Tax Registration",
          "Trade Licence / FSSAI Registration",
          "Import Export Code (IEC), where applicable"
        ]
      },
      "documents": {
        "heading": "Documents Required",
        "groups": [
          {
            "title": "Proprietor",
            "items": [
              "PAN Card",
              "Aadhaar Card",
              "Passport-size photograph",
              "Mobile number & email address",
              "Address proof"
            ]
          },
          {
            "title": "Business Address",
            "items": [
              "Ownership proof or rent agreement + NOC",
              "Latest utility bill"
            ]
          }
        ]
      },
      "process": {
        "heading": "Registration Process",
        "steps": [
          {
            "title": "Business Consultation",
            "desc": "Determine the registrations applicable to your business activity."
          },
          {
            "title": "Documentation",
            "desc": "Collect and verify identity, address and business documents."
          },
          {
            "title": "Registration Planning",
            "desc": "Identify mandatory and optional registrations for your business model."
          },
          {
            "title": "Application Filing",
            "desc": "Prepare and submit applications before the respective authorities."
          },
          {
            "title": "Registration Approval",
            "desc": "Obtain registration certificates, licences or approvals."
          },
          {
            "title": "Business Setup Support",
            "desc": "GST, Udyam, Bank Account, Shop Act and Professional Tax assistance."
          }
        ]
      },
      "timeline": {
        "heading": "Estimated Timeline",
        "body": "Most proprietorship businesses can commence operations within 2–10 working days, depending on the applicable registrations (Udyam is typically same-day)."
      },
      "fees": {
        "heading": "Government Fees & Professional Fees",
        "govt": [
          "Nature of registration",
          "State-specific regulations",
          "Applicable departmental charges"
        ],
        "prof": [
          "Number of registrations required",
          "Nature of business",
          "Additional compliance support"
        ],
        "note": "Contact Biz360 Compliance for a customised quotation based on your business requirements."
      },
      "compliance": {
        "heading": "Ongoing Compliance",
        "items": [
          "Income Tax Return and GST Returns",
          "Accounting & bookkeeping",
          "TDS compliance (where applicable)",
          "Shop & Establishment renewal",
          "Labour law compliance, if employees are engaged"
        ]
      },
      "whyUs": {
        "heading": "Why Choose Biz360 Compliance?",
        "items": [
          "Guidance on the most suitable registrations",
          "Complete documentation support and transparent pricing",
          "Fast processing and dedicated relationship manager",
          "Ongoing taxation, accounting and compliance support"
        ]
      },
      "faqs": [
        {
          "q": "Is Proprietorship Registration mandatory?",
          "a": "There is no separate incorporation law — the business is generally recognised through applicable registrations such as GST, Udyam or Shop & Establishment."
        },
        {
          "q": "Is Udyam Registration compulsory?",
          "a": "It's optional but recommended for eligible MSMEs to avail benefits under government schemes."
        },
        {
          "q": "Can I convert my Proprietorship into an LLP or Company?",
          "a": "Yes, subject to applicable legal procedures and business requirements."
        },
        {
          "q": "Can I employ staff under a Proprietorship?",
          "a": "Yes. Applicable labour law compliances must be followed wherever required."
        },
        {
          "q": "How much does Proprietorship Registration cost?",
          "a": "The cost depends upon the registrations required and applicable government fees."
        }
      ],
      "related": [
        "partnership-firm",
        "one-person-company",
        "llp"
      ]
    }
  },
  {
    "id": "section-8-company",
    "slug": "section-8-company",
    "category": "Non-Profit",
    "title": "Section 8 Company Registration in India",
    "subtitle": "Register a Section 8 Company with Expert Professional Guidance",
    "read_time": "9 min read",
    "image": "https://images.unsplash.com/photo-1554224155-6726b3ff858f?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
    "intro": "A Section 8 Company is a non-profit company incorporated under the Companies Act, 2013 for promoting charitable and socially beneficial objectives — education, healthcare, rural development, women empowerment, environmental protection, skill development, research, culture and other public welfare initiatives. Unlike commercial companies, profits must be applied solely towards its stated objectives; dividends cannot be distributed. Many charitable organisations, CSR implementation agencies and social enterprises prefer this model for its transparent governance and wider institutional acceptance. Biz360 Compliance assists with incorporation as well as building a strong legal, financial and compliance framework for long-term sustainability.",
    "sections": {
      "advantages": {
        "heading": "Why Choose a Section 8 Company?",
        "items": [
          "Separate legal identity and limited liability for members",
          "Higher institutional credibility and transparent governance",
          "Perpetual succession",
          "Improved eligibility for grants and CSR collaborations, subject to law",
          "Better acceptance among government authorities, donors and institutions"
        ]
      },
      "audience": {
        "heading": "Who Should Register a Section 8 Company?",
        "items": [
          "NGOs and charitable foundations",
          "Educational and healthcare institutions",
          "CSR implementation agencies",
          "Social enterprises focused on women empowerment, skill development, environment, arts or research"
        ]
      },
      "eligibility": {
        "heading": "Eligibility Criteria",
        "items": [
          "Proposed objectives must be charitable or not-for-profit in nature",
          "Profits must be applied solely towards the organisation's objectives",
          "Members must not intend to receive dividends",
          "Registered office address in India",
          "Minimum prescribed Directors/Members under the Companies Act"
        ]
      },
      "documents": {
        "heading": "Documents Required",
        "groups": [
          {
            "title": "Identity Documents",
            "items": [
              "PAN Card",
              "Aadhaar Card",
              "Passport-size photograph",
              "Mobile number & email address",
              "Address proof"
            ]
          },
          {
            "title": "Registered Office",
            "items": [
              "Ownership proof or rent agreement + NOC",
              "Latest utility bill"
            ]
          },
          {
            "title": "Incorporation Documents",
            "items": [
              "Proposed main objects",
              "Estimated income & expenditure statement",
              "Declarations and consent letters"
            ]
          }
        ]
      },
      "process": {
        "heading": "Registration Process",
        "steps": [
          {
            "title": "Initial Consultation",
            "desc": "Determine whether a Section 8 Company is the most suitable legal structure."
          },
          {
            "title": "Planning & Documentation",
            "desc": "Prepare proposed objects, financial projections and incorporation documents."
          },
          {
            "title": "Name Reservation",
            "desc": "Reserve an appropriate name through the MCA portal."
          },
          {
            "title": "Incorporation & Licence Application",
            "desc": "Submit incorporation together with the Section 8 licence application."
          },
          {
            "title": "Government Review",
            "desc": "The Registrar examines the application and may seek clarifications."
          },
          {
            "title": "Certificate of Incorporation",
            "desc": "Certificate of Incorporation along with the Section 8 licence is issued."
          },
          {
            "title": "Post Incorporation Support",
            "desc": "PAN, TAN, bank account and other statutory registrations."
          }
        ]
      },
      "timeline": {
        "heading": "Estimated Timeline",
        "body": "Incorporation generally takes 10–20 working days, depending on documentation and regulatory approvals."
      },
      "fees": {
        "heading": "Government Fees & Professional Fees",
        "govt": [
          "Authorised share capital, where applicable",
          "MCA filing fees and applicable stamp duty"
        ],
        "prof": [
          "Complexity of proposed objectives",
          "Number of Directors and Subscribers",
          "Additional registrations and advisory services"
        ],
        "note": "Contact Biz360 Compliance for a customised quotation based on your organisation's requirements."
      },
      "compliance": {
        "heading": "Beyond Incorporation — Building a Compliance Framework",
        "items": [
          "Maintenance of statutory registers, board/members' meetings",
          "Books of account and annual financial statements",
          "ROC annual filings and Income Tax Return",
          "Statutory audit and GST compliance, where applicable",
          "12AB and 80G registration for tax exemption / donor benefits, subject to eligibility"
        ]
      },
      "whyUs": {
        "heading": "Why Choose Biz360 Compliance?",
        "items": [
          "Section 8 incorporation, MOA/AOA drafting",
          "12AB & 80G registration assistance",
          "CSR compliance advisory and financial reporting",
          "Ongoing governance support"
        ]
      },
      "faqs": [
        {
          "q": "What is a Section 8 Company?",
          "a": "A non-profit company incorporated under the Companies Act, 2013 for promoting charitable and socially beneficial objectives."
        },
        {
          "q": "Can a Section 8 Company earn income?",
          "a": "Yes, but income must be utilised for the organisation's objectives and cannot be distributed as dividends."
        },
        {
          "q": "Is 12AB registration mandatory?",
          "a": "It's a separate registration under the Income-tax law, required for organisations seeking tax exemptions, subject to eligibility."
        },
        {
          "q": "Is 80G registration automatic?",
          "a": "No. It requires a separate application and approval under the Income-tax law."
        },
        {
          "q": "Is statutory audit compulsory?",
          "a": "Audit requirements are governed by the applicable provisions of the Companies Act and other relevant laws."
        }
      ],
      "related": [
        "trust-registration",
        "producer-company",
        "private-limited-company"
      ]
    }
  },
  {
    "id": "producer-company",
    "slug": "producer-company",
    "category": "Agri & Producer",
    "title": "Producer Company Registration in India",
    "subtitle": "Build a Stronger Future for Farmers Through a Producer Company",
    "read_time": "8 min read",
    "image": "https://images.unsplash.com/photo-1450101499163-c8848c66ca85?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
    "intro": "A Producer Company is a specialised corporate structure incorporated under the Companies Act, 2013, designed to promote the collective interests of primary producers — farmers, agriculturists, dairy producers, fishermen, artisans, weavers and other primary producers. It enables members to improve production, processing, storage, marketing and distribution of agricultural and allied products while enhancing bargaining power and access to markets, technology and financial resources. Unlike traditional cooperative societies, a Producer Company operates under a corporate governance framework, offering greater operational flexibility, transparency and long-term sustainability. Biz360 Compliance assists producer groups through incorporation and ongoing regulatory compliance, accounting and advisory services.",
    "sections": {
      "advantages": {
        "heading": "Why Choose a Producer Company?",
        "items": [
          "Separate legal identity and limited liability for members",
          "Professional corporate governance",
          "Better access to institutional finance and improved market access",
          "Collective procurement and marketing, enhanced bargaining power",
          "Perpetual succession and opportunities for value addition"
        ]
      },
      "audience": {
        "heading": "Who Should Register a Producer Company?",
        "items": [
          "Farmer Producer Organisations (FPOs)",
          "Dairy, poultry and fisheries producers",
          "Horticulture, sericulture and beekeeping collectives",
          "Tribal producer groups and organic farming collectives",
          "Agricultural cooperatives transitioning to a corporate structure"
        ]
      },
      "eligibility": {
        "heading": "Eligibility Criteria",
        "items": [
          "Incorporated by eligible primary producers per the prescribed constitution requirements",
          "Organisation must primarily engage in production, harvesting, procurement, grading, processing, marketing or export of primary produce"
        ]
      },
      "documents": {
        "heading": "Documents Required",
        "groups": [
          {
            "title": "Directors & Members",
            "items": [
              "PAN Card",
              "Aadhaar Card",
              "Passport-size photograph",
              "Mobile number & email address",
              "Address proof"
            ]
          },
          {
            "title": "Registered Office",
            "items": [
              "Ownership proof or rent agreement + NOC",
              "Latest utility bill"
            ]
          },
          {
            "title": "Organisation Documents",
            "items": [
              "Details of proposed business activities",
              "Identity details of eligible producer members",
              "Declarations and incorporation documents"
            ]
          }
        ]
      },
      "process": {
        "heading": "Registration Process",
        "steps": [
          {
            "title": "Business Consultation",
            "desc": "Understand the proposed agricultural activities and evaluate eligibility."
          },
          {
            "title": "Documentation",
            "desc": "Collect and verify documents of Directors and producer members."
          },
          {
            "title": "Name Reservation",
            "desc": "Apply for reservation of the proposed Producer Company name."
          },
          {
            "title": "Incorporation Documents",
            "desc": "Draft MOA, AOA and other statutory incorporation documents."
          },
          {
            "title": "Incorporation Filing",
            "desc": "Submit the incorporation application through the MCA portal."
          },
          {
            "title": "Certificate of Incorporation",
            "desc": "Receive the Certificate of Incorporation and CIN upon approval."
          },
          {
            "title": "Post Registration Support",
            "desc": "PAN, TAN, GST (where applicable) and bank account opening."
          }
        ]
      },
      "timeline": {
        "heading": "Estimated Timeline",
        "body": "Incorporation generally takes 10–20 working days, depending on documentation, regulatory approvals and government processing timelines."
      },
      "fees": {
        "heading": "Government Fees & Professional Fees",
        "govt": [
          "MCA filing fees",
          "Authorised share capital",
          "Applicable stamp duty"
        ],
        "prof": [
          "Number of members",
          "Documentation complexity",
          "Additional registrations required"
        ],
        "note": "Contact Biz360 Compliance for a customised quotation based on your Producer Company's requirements."
      },
      "compliance": {
        "heading": "Beyond Registration — Supporting Producer Organisations",
        "items": [
          "Accounting & bookkeeping, annual financial statements",
          "ROC annual compliance and statutory audit",
          "Income Tax and GST compliance, where applicable",
          "Payroll & labour law compliance",
          "Project report preparation for bank finance and schemes"
        ]
      },
      "whyUs": {
        "heading": "Why Choose Biz360 Compliance?",
        "items": [
          "Producer Company registration and MOA/AOA drafting",
          "GST registration and accounting & bookkeeping",
          "Annual ROC and Income Tax compliance",
          "Project report preparation and business advisory"
        ]
      },
      "faqs": [
        {
          "q": "What is a Producer Company?",
          "a": "A corporate entity formed by eligible primary producers to carry out production, processing, marketing and related activities connected with primary produce."
        },
        {
          "q": "Is a Producer Company different from a Cooperative Society?",
          "a": "Yes. A Producer Company is governed under the Companies Act, 2013 and follows a corporate governance framework."
        },
        {
          "q": "Can a Producer Company obtain bank finance?",
          "a": "Yes, financial institutions may extend credit based on eligibility and lending policies."
        },
        {
          "q": "Can a Producer Company export agricultural products?",
          "a": "Yes, subject to compliance with applicable laws and necessary registrations such as IEC."
        },
        {
          "q": "How long does incorporation take?",
          "a": "Generally 10–20 working days, subject to government approvals."
        }
      ],
      "related": [
        "section-8-company",
        "private-limited-company",
        "trust-registration"
      ]
    }
  },
  {
    "id": "trust-registration",
    "slug": "trust-registration",
    "category": "Non-Profit",
    "title": "Trust Registration in India",
    "subtitle": "Register a Public or Private Trust with Professional Guidance",
    "read_time": "8 min read",
    "image": "https://images.unsplash.com/photo-1735825764485-93a381fd5779?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODF8MHwxfHNlYXJjaHwzfHxwcm9mZXNzaW9uYWwlMjBmaW5hbmNlJTIwd29ya3NwYWNlfGVufDB8fHx8MTc4MzE3MDIyNHww&ixlib=rb-4.1.0&q=85",
    "intro": "A Trust is one of the most widely recognised legal structures in India for managing property or funds for charitable, religious, educational, social or private purposes. A trust is created when the author (settlor) transfers property to trustees, who hold and manage it for the benefit of beneficiaries or specified charitable objectives. Depending on its objectives, a trust may be established as a Public Charitable Trust, Religious Trust or Private Trust. Biz360 Compliance assists with drafting the Trust Deed, completing registration formalities and establishing a sound legal and compliance framework.",
    "sections": {
      "advantages": {
        "heading": "Why Register a Trust?",
        "items": [
          "Legally recognised organisational structure",
          "Clearly defined rights and responsibilities of trustees",
          "Improved credibility with donors and institutions",
          "Ability to hold movable and immovable property",
          "Facilitates opening of bank accounts",
          "Foundation for obtaining further statutory registrations"
        ]
      },
      "audience": {
        "heading": "Who Should Register a Trust?",
        "items": [
          "Charitable organisations and NGOs",
          "Educational and healthcare institutions",
          "Religious organisations",
          "Family trusts and philanthropic foundations",
          "Community development organisations"
        ]
      },
      "eligibility": {
        "heading": "Eligibility",
        "items": [
          "A Settlor (Author of the Trust)",
          "Minimum number of Trustees as applicable under state law",
          "Trust property (movable or immovable)",
          "Registered office / Trust address",
          "A Trust Deed with identity & address proof of Settlor and Trustees"
        ]
      },
      "documents": {
        "heading": "Documents Required",
        "groups": [
          {
            "title": "Settlor & Trustees",
            "items": [
              "PAN Card",
              "Aadhaar Card",
              "Passport-size photograph",
              "Mobile number & email address",
              "Address proof"
            ]
          },
          {
            "title": "Trust Address",
            "items": [
              "Ownership proof or rent agreement + NOC",
              "Latest utility bill"
            ]
          },
          {
            "title": "Trust Documents",
            "items": [
              "Draft Trust Deed",
              "Identity & address proofs of Trustees",
              "Proof of registered office"
            ]
          }
        ]
      },
      "process": {
        "heading": "Registration Process",
        "steps": [
          {
            "title": "Initial Consultation",
            "desc": "Understand the objectives of the proposed trust and recommend the appropriate structure."
          },
          {
            "title": "Drafting the Trust Deed",
            "desc": "Name, objectives, Settlor & Trustee details, powers, duties and dissolution clause."
          },
          {
            "title": "Execution of the Deed",
            "desc": "Executed on appropriate stamp paper as per applicable state laws."
          },
          {
            "title": "Registration",
            "desc": "Submit the Trust Deed and supporting documents to the registering authority."
          },
          {
            "title": "Registration Certificate",
            "desc": "Obtain the registration certificate upon successful completion."
          },
          {
            "title": "Post Registration Support",
            "desc": "PAN, bank account opening and accounting setup."
          }
        ]
      },
      "timeline": {
        "heading": "Estimated Timeline",
        "body": "Trust Registration may generally be completed within 7–20 working days, subject to state-specific procedures and approvals."
      },
      "fees": {
        "heading": "Government Fees & Professional Fees",
        "govt": [
          "Applicable state stamp duty",
          "Registration charges",
          "Local authority fees"
        ],
        "prof": [
          "Complexity of the Trust Deed",
          "Number of Trustees",
          "Additional registrations required"
        ],
        "note": "Contact Biz360 Compliance for a customised quotation based on your Trust's objectives."
      },
      "compliance": {
        "heading": "Beyond Registration — Building a Compliant Trust",
        "items": [
          "Maintenance of trust records and accounting & bookkeeping",
          "Income Tax Return filing and statutory audit, where applicable",
          "GST registration & compliance, where applicable",
          "12AB and 80G registration for tax exemption / donor benefits, subject to eligibility"
        ]
      },
      "whyUs": {
        "heading": "Why Choose Biz360 Compliance?",
        "items": [
          "Trust registration and drafting of the Trust Deed",
          "PAN & TAN assistance, accounting & bookkeeping",
          "12AB & 80G registration assistance",
          "NGO advisory & governance support"
        ]
      },
      "faqs": [
        {
          "q": "What is a Trust?",
          "a": "A legal arrangement where a settlor transfers property to trustees to manage it for beneficiaries or specified charitable/religious purposes."
        },
        {
          "q": "Is Trust Registration mandatory?",
          "a": "It depends on applicable state laws and the nature of the Trust; registration is generally recommended for legal recognition."
        },
        {
          "q": "Is 80G registration mandatory?",
          "a": "No, it's optional but beneficial for eligible organisations offering tax benefits to donors."
        },
        {
          "q": "Can a Trust own property?",
          "a": "Yes, a registered Trust may hold property in accordance with its Trust Deed and applicable laws."
        },
        {
          "q": "How long does Trust Registration take?",
          "a": "Generally 7–20 working days, subject to the procedures of the relevant registration authority."
        }
      ],
      "related": [
        "section-8-company",
        "producer-company",
        "private-limited-company"
      ]
    }
  }
];
